import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // ── Class fees in one request (bulk payments) ──
      "audit_action_fees_class_created": "إنشاء رسوم لقسم كامل",
      "cf_open_btn": "إنشاء رسوم للقسم",
      "cf_title": "إنشاء رسوم لقسم كامل",
      "cf_subtitle": "تُنشأ رسوم واحدة لكل طالب في القسم للسنة الحالية، ثم تظهر مباشرة في قائمة الدفع الجماعي. الطالب الذي لديه نفس الرسوم لنفس الشهر لا تُكرَّر له.",
      "cf_pick_class": "اختر القسم",
      "cf_amount": "المبلغ لكل طالب",
      "cf_due_date": "تاريخ الاستحقاق (اختياري)",
      "cf_review_btn": "معاينة",
      "cf_create_btn": "إنشاء الرسوم ({{count}} طالب)",
      "cf_will_create": "عدد الرسوم التي ستُنشأ",
      "cf_skipped": "لن تُكرَّر لـ {{count}} طالب لديهم هذه الرسوم لهذا الشهر:",
      "cf_nothing_to_create": "كل طلاب القسم لديهم هذه الرسوم لهذا الشهر.",
      "cf_created": "تم إنشاء {{count}} رسوم. يمكنك الآن تسجيل الدفع الجماعي.",
      "cf_error": "تعذّر إنشاء رسوم القسم.",
      "cf_empty_hint": "لا تظهر هنا إلا الرسوم غير المسددة. إذا لم تُنشأ رسوم هذا القسم بعد، أنشئها للقسم كاملًا بضغطة واحدة.",
      "cf_err_class": "اختر القسم.",
      "cf_err_fee_type": "اختر نوع الرسوم.",
      "cf_err_amount": "أدخل مبلغًا صحيحًا أكبر من صفر.",
      "cf_err_month": "اختر الشهر.",
      // ── Activity log: one readable label per audit action ──
      "audit_action_academic_year_rollover": "ترحيل السنة الدراسية",
      "audit_action_academic_year_rollover_failed": "فشل ترحيل السنة الدراسية",
      "audit_action_activate_academic_year": "تفعيل سنة دراسية",
      "audit_action_announcement_created": "نشر إعلان",
      "audit_action_announcement_deleted": "حذف إعلان",
      "audit_action_broadcast_sent": "إرسال رسالة جماعية",
      "audit_action_bulk_attendance": "تسجيل حضور جماعي",
      "audit_action_bulk_payment": "دفع جماعي للرسوم",
      "audit_action_create_academic_year": "إنشاء سنة دراسية",
      "audit_action_create_admin_staff": "إضافة موظف إداري",
      "audit_action_create_assignment": "إضافة واجب",
      "audit_action_create_attendance": "تسجيل حضور",
      "audit_action_create_fee": "إضافة رسوم",
      "audit_action_create_grade": "إضافة درجة",
      "audit_action_create_payment": "تسجيل دفعة",
      "audit_action_deactivate_admin_staff": "تعطيل موظف إداري",
      "audit_action_delete_admin_staff_permanent": "حذف موظف إداري نهائياً",
      "audit_action_delete_assignment": "حذف واجب",
      "audit_action_delete_grade": "حذف درجة",
      "audit_action_expense_added": "إضافة مصروف",
      "audit_action_expense_deleted": "حذف مصروف",
      "audit_action_expense_updated": "تعديل مصروف",
      "audit_action_fee_deleted": "حذف رسوم",
      "audit_action_fee_paid": "دفع رسوم",
      "audit_action_grades_bulk_saved": "حفظ درجات قسم",
      "audit_action_homework_graded": "تصحيح واجب",
      "audit_action_homework_submitted": "تسليم واجب",
      "audit_action_invoice_created": "إنشاء فاتورة",
      "audit_action_login_blocked_subscription": "دخول مرفوض: الاشتراك منتهٍ",
      "audit_action_login_failure": "محاولة دخول فاشلة",
      "audit_action_login_locked": "قفل الدخول بعد محاولات فاشلة",
      "audit_action_login_success": "تسجيل دخول",
      "audit_action_logout": "تسجيل خروج",
      "audit_action_manual_rollover_rollback": "التراجع عن ترحيل السنة",
      "audit_action_message_sent": "إرسال رسالة",
      "audit_action_parent_created": "إضافة ولي أمر",
      "audit_action_parent_deleted": "حذف ولي أمر",
      "audit_action_parent_updated": "تعديل ولي أمر",
      "audit_action_password_changed": "تغيير كلمة المرور",
      "audit_action_payroll_run": "صرف رواتب الشهر",
      "audit_action_payslip_generated": "إصدار كشف راتب",
      "audit_action_payslips_generated": "إصدار كشوف الرواتب",
      "audit_action_pin_generated": "إنشاء رمز دخول تلميذ",
      "audit_action_pin_login_failure": "محاولة دخول بالرمز فاشلة",
      "audit_action_pin_login_locked": "قفل الدخول بالرمز",
      "audit_action_pin_login_success": "دخول تلميذ بالرمز",
      "audit_action_pin_reset": "إعادة تعيين رمز تلميذ",
      "audit_action_pin_settings_updated": "تعديل إعدادات الدخول بالرمز",
      "audit_action_pin_unlocked": "فك قفل رمز تلميذ",
      "audit_action_platform_settings_updated": "تعديل إعدادات المنصة",
      "audit_action_profile_updated": "تعديل الملف الشخصي",
      "audit_action_read_student_medical": "الاطلاع على الملف الطبي لتلميذ",
      "audit_action_receipt_generated": "إصدار إيصال",
      "audit_action_receipts_generated": "إصدار إيصالات",
      "audit_action_register_school": "تسجيل مدرسة",
      "audit_action_reset_password": "إعادة تعيين كلمة المرور",
      "audit_action_salary_deleted": "حذف راتب",
      "audit_action_salary_recorded": "تسجيل راتب",
      "audit_action_salary_updated": "تعديل راتب",
      "audit_action_schedule_bulk_saved": "حفظ جدول قسم",
      "audit_action_school_settings_updated": "تعديل إعدادات المدرسة",
      "audit_action_school_subject_removed": "حذف مادة",
      "audit_action_school_subject_added": "إضافة مادة",
      "audit_action_class_created": "إنشاء فصل",
      "audit_action_class_updated": "تعديل فصل",
      "audit_action_class_deleted": "حذف فصل",
      "audit_action_class_renamed": "إعادة تسمية فصل",
      "audit_action_support_ticket_created": "فتح تذكرة دعم",
      "audit_action_support_ticket_replied": "رد على تذكرة دعم",
      "audit_action_support_ticket_followed_up": "متابعة تذكرة دعم",
      "audit_action_support_ticket_status_changed": "تغيير حالة تذكرة دعم",
      "sa_tab_support": "الدعم الفني",
      "sup_button": "الدعم الفني",
      "sup_title": "الدعم الفني والطوارئ",
      "sup_intro": "اكتب المشكلة وسيصل تنبيه فوري إلى إدارة المنصة. تُرفق بيانات حسابك ومدرستك تلقائيًا لتعرف الإدارة من أنت وكيف تساعدك.",
      "sup_tab_new": "رسالة جديدة",
      "sup_tab_mine": "تذاكري",
      "sup_category": "نوع المشكلة",
      "sup_cat_technical": "خلل تقني",
      "sup_cat_emergency": "طارئ",
      "sup_cat_account": "مشكلة في الحساب",
      "sup_cat_other": "أخرى",
      "sup_urgency": "الأولوية",
      "sup_urgency_normal": "عادي",
      "sup_urgency_urgent": "عاجل",
      "sup_subject": "العنوان",
      "sup_subject_ph": "مثال: الدرجات لا تُحفظ",
      "sup_message": "وصف المشكلة",
      "sup_message_ph": "ماذا كنت تفعل؟ وماذا ظهر لك؟",
      "sup_attached": "يُرفق تلقائيًا: اسمك وحسابك ودورك ومدرستك وهاتفك وبريدك والشاشة التي كنت فيها",
      "sup_send": "إرسال",
      "sup_sending": "جارٍ الإرسال…",
      "sup_sent": "أُرسلت تذكرتك {{number}}. سيصلك الرد هنا وفي الإشعارات.",
      "sup_send_error": "تعذّر إرسال الرسالة",
      "sup_too_short": "اكتب عنوانًا (3 أحرف على الأقل) ووصفًا (10 أحرف على الأقل).",
      "sup_none": "لا توجد تذاكر بعد.",
      "sup_load_error": "تعذّر تحميل التذاكر",
      "sup_status_open": "مفتوحة",
      "sup_status_in_progress": "قيد المعالجة",
      "sup_status_resolved": "تم الحل",
      "sup_support_team": "الدعم الفني",
      "sup_follow_up_ph": "أضف معلومة أو ردًا…",
      "sup_follow_up_send": "إرسال",
      "sup_locked_note": "الردود تظهر هنا. لإضافة شيء الآن افتح تذكرة جديدة.",
      "sup_filter_all": "الكل",
      "sup_urgent_only": "العاجل فقط",
      "sup_search_ph": "رقم التذكرة، المدرسة، الاسم…",
      "sup_counts": "مفتوحة: {{open}} · قيد المعالجة: {{in_progress}} · عاجلة تنتظر: {{urgent}}",
      "sup_select_ticket": "اختر تذكرة لعرض تفاصيلها.",
      "sup_sender": "المرسل",
      "sup_name": "الاسم",
      "sup_username": "اسم المستخدم",
      "sup_role": "الدور",
      "sup_phone": "الهاتف",
      "sup_email": "البريد",
      "sup_teacher_number": "رقم المعلم",
      "sup_permissions": "الصلاحيات",
      "sup_school": "المدرسة",
      "sup_school_number": "رقم المدرسة",
      "sup_plan": "الخطة",
      "sup_status_at_send": "الاشتراك عند الإرسال",
      "sup_status_now": "الاشتراك الآن",
      "sup_sub_active": "نشط",
      "sup_sub_trial": "تجريبي",
      "sup_sub_expired": "منتهٍ",
      "sup_sub_suspended": "موقوف",
      "sup_sub_none": "غير معروف",
      "sup_account_now": "الحساب الآن",
      "sup_account_state": "الحالة",
      "sup_active": "نشط",
      "sup_inactive": "معطّل",
      "sup_account_missing": "الحساب محذوف",
      "sup_last_login": "آخر دخول",
      "sup_context": "السياق",
      "sup_page": "الشاشة",
      "sup_device": "الجهاز",
      "sup_alerts": "التنبيهات",
      "sup_alerts_off": "البريد وتيليجرام غير مفعّلين",
      "sup_alert_email": "البريد",
      "sup_alert_telegram": "تيليجرام",
      "sup_alert_sent": "أُرسل",
      "sup_alert_failed": "فشل",
      "sup_alert_off": "غير مفعّل",
      "sup_reply_ph": "اكتب ردك للمرسل…",
      "sup_reply_send": "إرسال الرد",
      "sup_mark": "تغيير الحالة",
      "sup_call": "اتصال",
      "sup_whatsapp": "واتساب",
      "audit_action_class_subject_assigned": "إسناد مادة في فصل",
      "audit_action_class_subject_removed": "إزالة مادة من فصل",
      "audit_action_student_created": "إضافة تلميذ",
      "audit_action_student_deleted": "حذف تلميذ",
      "audit_action_student_linked": "ربط تلميذ بولي أمر",
      "audit_action_student_updated": "تعديل بيانات تلميذ",
      "audit_action_students_bulk_imported": "استيراد تلاميذ",
      "audit_action_subscription_renewed": "تجديد الاشتراك",
      "audit_action_subscription_suspended": "تعليق الاشتراك",
      "audit_action_subscription_updated": "تعديل الاشتراك",
      "audit_action_superadmin_profile_update": "تعديل حساب مدير المنصة",
      "audit_action_suspend_admin_staff": "إيقاف موظف إداري",
      "audit_action_task_assigned": "إسناد مهمة",
      "audit_action_task_deleted": "حذف مهمة",
      "audit_action_task_reviewed": "مراجعة مهمة",
      "audit_action_task_submitted": "تسليم مهمة",
      "audit_action_task_updated": "تعديل مهمة",
      "audit_action_teacher_created": "إضافة معلم",
      "audit_action_teacher_deleted": "حذف معلم",
      "audit_action_teacher_document_deleted": "حذف وثيقة معلم",
      "audit_action_teacher_document_downloaded": "تنزيل وثيقة معلم",
      "audit_action_teacher_document_types_updated": "تعديل أنواع وثائق المعلمين",
      "audit_action_teacher_document_uploaded": "رفع وثيقة معلم",
      "audit_action_teacher_rated": "تقييم معلم",
      "audit_action_teacher_updated": "تعديل بيانات معلم",
      "audit_action_token_refresh": "تجديد الجلسة",
      "audit_action_transcripts_issued": "إصدار كشوف النقاط",
      "audit_action_update_academic_calendar": "تعديل التقويم الدراسي",
      "audit_action_update_academic_year_status": "تغيير حالة السنة الدراسية",
      "audit_action_update_admin_staff_info": "تعديل بيانات موظف إداري",
      "audit_action_update_admin_staff_permissions": "تعديل صلاحيات موظف إداري",
      "audit_action_update_attendance": "تعديل الحضور",
      "audit_action_update_grade": "تعديل درجة",
      "audit_action_update_notification_preferences": "تعديل تفضيلات الإشعارات",
      "audit_action_schedule_duplicates_resolved": "دمج حصص الجدول المكررة",
      "audit_action_other": "عملية أخرى",
      // ── Sessions, subscription lockout, desktop notice [PHASE-5 2026-10] ──
      "session_notice_max_age": "انتهت جلستك بعد 24 ساعة من تسجيل الدخول. سجّل الدخول من جديد للمتابعة.",
      "session_notice_expired": "انتهت صلاحية جلستك. سجّل الدخول من جديد للمتابعة.",
      "session_notice_revoked": "تم إنهاء جلستك. سجّل الدخول من جديد للمتابعة.",
      "session_notice_subscription": "انتهى اشتراك مدرستك، لذلك لا يمكن الدخول حالياً. يرجى التواصل مع إدارة مدرستك.",
      "session_notice_dismiss": "إغلاق",
      "stw_session_ending_message": "تنتهي الجلسة بعد 24 ساعة من تسجيل الدخول ولا يمكن تمديدها. احفظ عملك ثم سجّل الدخول من جديد.",
      "stw_dismiss": "حسناً",
      "renewal_title": "اشتراك المدرسة منتهٍ",
      "renewal_title_suspended": "اشتراك المدرسة معلَّق",
      "renewal_data_kept": "لم يُحذف أي شيء: كل بيانات المدرسة محفوظة وتعود فور التجديد.",
      "renewal_ended_on": "انتهى في {{date}}",
      "renewal_contact_title": "للتجديد، تواصل مع إدارة المنصة",
      "renewal_phone": "الهاتف",
      "renewal_email": "البريد الإلكتروني",
      "renewal_whatsapp": "واتساب",
      "renewal_no_contact": "لم تُسجَّل بيانات تواصل بعد. تواصل مع مسؤول المنصة.",
      "renewal_check_again": "التحقق مجدداً",
      "renewal_checking": "جارٍ التحقق...",
      "renewal_still_locked": "الاشتراك لم يُجدَّد بعد.",
      "renewal_restored": "تم تجديد الاشتراك. مرحباً بعودتك!",
      "renewal_check_failed": "تعذّر التحقق الآن. حاول مرة أخرى.",
      "renewal_logout": "تسجيل الخروج",
      "desktop_notice_title": "هذه الواجهة مصمَّمة للحاسوب",
      "desktop_notice_body": "لوحة الإدارة غنية بالجداول والنماذج، وتعمل بأفضل شكل على حاسوب محمول أو مكتبي. يمكنك المتابعة على هذا الجهاز، لكن بعض الشاشات قد تكون ضيقة.",
      "desktop_notice_continue": "المتابعة على أي حال",
      "ps_contact_phone": "هاتف التواصل",
      "ps_contact_hint": "يظهر الهاتف والبريد لمدير المدرسة عند انتهاء اشتراك مدرسته.",
      "subscription_call": "اتصال",
      // ── Bulk finance [PHASE-3 2026-10] ──────────
      "fin_tab_bulk_fees": "دفع جماعي",
      "fin_tab_payroll": "رواتب الشهر",
      "bulk_fees_title": "دفع الرسوم جماعيًا",
      "bulk_fees_subtitle": "اختر القسم أو الشهر، حدّد الطلاب الذين دفعوا، ثم أكّد مرة واحدة.",
      "bulk_all_classes": "كل الأقسام",
      "bulk_all_fee_types": "كل أنواع الرسوم",
      "bulk_pick_method": "اختر طريقة الدفع",
      "bulk_refresh": "تحديث",
      "bulk_download_list": "تنزيل القائمة كملف Excel",
      "bulk_import_excel": "استيراد دفعات من Excel",
      "bulk_import_hint": "الأعمدة: رقم الطالب، المبلغ، الشهر، نوع الرسوم، المرجع. الصف الذي لا مبلغ فيه لا يُسجَّل.",
      "bulk_import_skipped": "{{count}} صف بلا مبلغ لم يُسجَّل",
      "fin_unpaid_all_years": "كل السنوات",
      "bulk_list_count": "{{shown}} من {{total}} رسوم غير مسددة",
      "bulk_list_truncated": "القائمة مقتطعة: ضيّق التصفية لرؤية الباقي.",
      "bulk_selected_summary": "المحدد: {{count}} · المجموع",
      "bulk_review_btn": "مراجعة وتأكيد",
      "bulk_select_all": "تحديد الكل",
      "bulk_col_pay_now": "المبلغ المدفوع الآن",
      "bulk_nothing_unpaid": "لا توجد رسوم غير مسددة لهذه التصفية.",
      "bulk_amount_invalid": "بعض المبالغ غير صحيحة أو تتجاوز الباقي (باللون الأحمر).",
      "bulk_import_preview_title": "معاينة الاستيراد",
      "bulk_import_ok_rows": "{{count}} صف صالح",
      "bulk_import_partial_note": "الصفوف التي فيها أخطاء لن تُسجَّل. صحّحها في الملف ثم استوردها لاحقًا.",
      "bulk_import_continue": "متابعة بـ {{count}} صف",
      "bulk_import_no_header": "لم يُعثر على عمود رقم الطالب في الملف.",
      "bulk_import_read_error": "تعذّرت قراءة الملف.",
      "bulk_col_student_number": "رقم الطالب",
      "bulk_col_amount": "المبلغ",
      "bulk_col_month": "الشهر",
      "bulk_col_fee_type": "نوع الرسوم",
      "bulk_col_reference": "المرجع",
      "bulk_col_name_info": "الاسم (للعلم فقط)",
      "bulk_col_row": "الصف",
      "bulk_confirm_title": "تأكيد الدفع الجماعي",
      "bulk_confirm_count": "عدد الدفعات",
      "bulk_confirm_total": "المجموع",
      "bulk_confirm_note": "تُسجَّل كل الدفعات معًا. إن انقطع الاتصال فاضغط التأكيد مجددًا: لن تُسجَّل أي دفعة مرتين.",
      "bulk_confirm_btn": "تسجيل {{count}} دفعة",
      "bulk_recorded": "سُجّلت {{count}} دفعة",
      "bulk_done_title": "تم تسجيل الدفعات",
      "bulk_print_receipts": "طباعة الإيصالات",
      "bulk_rows_with_errors": "{{count}} صف فيه خطأ",
      "bulk_sheet_row": "صف Excel رقم {{row}}",
      "bulk_line": "السطر {{n}}",
      "bulk_load_error": "تعذّر تحميل القائمة",
      "bulk_save_error": "تعذّر التسجيل",
      "bulk_read_only": "هذه سنة مؤرشفة: لا يمكن تسجيل دفعات فيها.",
      "bulk_err_invalid_row": "صف غير صالح",
      "bulk_err_fee_not_found": "الرسوم غير موجودة في هذه المدرسة",
      "bulk_err_student_not_found": "لا يوجد طالب بالرقم {{student_number}}",
      "bulk_err_no_unpaid_fee": "لا توجد رسوم غير مسددة مطابقة لهذا الطالب",
      "bulk_err_ambiguous_fee": "تطابق {{count}} رسوم: حدّد الشهر أو نوع الرسوم",
      "bulk_err_duplicate_fee": "الرسوم نفسها مكررة في الدفعة",
      "bulk_err_year_archived": "رسوم سنة مؤرشفة ({{year}}): لا تقبل الدفع",
      "bulk_err_fee_already_paid": "الرسوم مسددة بالكامل",
      "bulk_err_exceeds_balance": "المبلغ يتجاوز الباقي ({{remaining}})",
      "bulk_err_employee_not_found": "الموظف غير موجود أو غير نشط في هذه المدرسة",
      "bulk_err_duplicate_employee": "الموظف مكرر في الدفعة",
      "bulk_err_already_paid": "راتب هذا الشهر مدفوع مسبقًا",
      "bulk_err_multiple_rows": "{{count}} رواتب مسجلة لهذا الشهر: عالجها من جدول الرواتب",
      "bulk_err_missing_number": "رقم الطالب فارغ",
      "bulk_err_bad_amount": "المبلغ غير صحيح",
      "bulk_err_bad_month": "الشهر غير صحيح (مثال 2026-10)",
      "payroll_title": "رواتب الشهر",
      "payroll_subtitle": "كل المعلمين والإداريين مع مبلغ آخر راتب. عدّل الاستثناءات ثم أكّد مرة واحدة.",
      "payroll_print_month": "طباعة كشوف الشهر المدفوعة",
      "payroll_counts": "{{total}} موظف · {{payable}} قابل للدفع",
      "payroll_col_last": "آخر راتب",
      "payroll_col_amount": "مبلغ هذا الشهر",
      "payroll_no_staff": "لا يوجد موظفون نشطون.",
      "payroll_type_teacher": "معلم",
      "payroll_type_staff": "إداري",
      "payroll_state_new": "غير مسجل",
      "payroll_state_unpaid": "مسجل غير مدفوع",
      "payroll_state_paid": "مدفوع",
      "payroll_state_multiple": "عدة رواتب مسجلة",
      "payroll_amount_missing": "أدخل مبلغًا لكل موظف محدد (باللون الأحمر).",
      "payroll_confirm_title": "تأكيد رواتب شهر {{month}}",
      "payroll_confirm_count": "عدد الموظفين",
      "payroll_confirm_note": "لا يمكن دفع راتب الشهر نفسه مرتين، حتى لو أُعيد التأكيد.",
      "payroll_confirm_btn": "دفع {{count}} راتب",
      "payroll_recorded": "دُفعت {{count}} رواتب",
      "payroll_done_title": "تم دفع الرواتب",
      "payroll_print_payslips": "طباعة كشوف الرواتب",
      "fp_student_number": "رقم الطالب",
      "fp_period": "الفترة",
      "fp_reference": "المرجع",
      "fp_amount_received": "المبلغ المستلم",
      "fp_fee_total": "قيمة الرسوم",
      "fp_paid_to_date": "المدفوع حتى الآن",
      "fp_remaining": "الباقي",
      "fp_fee_status": "حالة الرسوم",
      "fp_signature_stamp": "التوقيع والختم",
      "fp_employee": "الموظف",
      "fp_employee_detail": "التخصص / الوظيفة",
      "fp_employee_signature": "توقيع الموظف",
      "fp_preparing": "جارٍ تجهيز المستندات للطباعة…",
      "fp_popup_blocked": "منع المتصفح نافذة الطباعة. اسمح بالنوافذ المنبثقة لهذا الموقع.",
      // ── Fast schedule builder [FEAT fast-builder 2026-09] ──────────
      "smc_view_builder":           "البناء السريع",
      "sb_title":                   "بناء الجدول بالكتل",
      "sb_subtitle":                "اختر كتلة (مادة + معلم) ثم انقر على الخانات. لا حاجة لكتابة أي وقت، ولا يمكن إنشاء تعارض.",
      "sb_class":                   "الصف",
      "sb_pick_class":              "اختر الصف",
      "sb_pick_class_prompt":       "اختر صفاً للبدء في بناء جدوله.",
      "sb_save":                    "حفظ الجدول",
      "sb_saved":                   "تم حفظ {{count}} حصة في طلب واحد",
      "sb_undo":                    "تراجع",
      "sb_copy_to_class":           "نسخ إلى صف آخر",
      "sb_autofill":                "إكمال الباقي تلقائياً",
      "sb_keyboard_hint":           "اختصارات: الأرقام ١-٩ لاختيار الكتل، Esc لإلغاء الاختيار، Ctrl+Z للتراجع.",
      "sb_palette":                 "الكتل المتاحة لهذا الصف",
      "sb_no_blocks":               "لا يوجد معلمون مسجّلون لهذا الصف ({{cls}}). أضف الصف إلى صفوف المعلمين أولاً من صفحة المعلمين.",
      "sb_block_remaining":         "باقي {{count}}",
      "sb_block_done":              "مكتملة",
      "sb_eraser":                  "ممحاة",
      "sb_teachers_without_subjects": "معلمون بلا مواد مسجّلة ولذلك لا تظهر لهم كتل: {{names}}",
      "sb_pick_block_first":        "اختر كتلة أولاً ثم انقر على الخانة.",
      "sb_period":                  "الحصة",
      "sb_period_n":                "الحصة {{n}}",
      "sb_grid_for":                "جدول {{cls}}",
      "sb_placed":                  "{{count}} حصة موضوعة",
      "sb_locked_tooltip":          "{{teacher}} مشغول في {{cls}} في هذا الوقت",
      "sb_needs_teacher":           "بحاجة إلى معلم",
      "sb_busy_in":                 "مشغول في {{cls}}",
      "sb_problems":                "{{count}} خانة تحتاج إلى معالجة قبل الحفظ.",
      "sb_fix_problems_first":      "عالج {{count}} خانة قبل الحفظ.",
      "sb_server_rejected":         "رفض الخادم الحفظ للأسباب التالية، ولم يتم حفظ أي حصة:",
      "sb_legacy_rows":             "{{count}} حصة محفوظة سابقاً بأوقات لا تطابق جدول الأجراس الحالي، ولا تظهر في الشبكة. راجعها من العرض الأسبوعي.",
      "sb_duplicate_cells":         "لهذا الفصل أكثر من جدول في: {{days}}. تعرض الشبكة نسخة واحدة، والحفظ يُبقي ما تراه فقط. عالج التكرار في التنبيه أعلاه أولاً.",
      "sdup_title":                 "جداول مكررة لنفس الفصل واليوم",
      "sdup_intro":                 "{{count}} خانة (فصل ويوم) لها أكثر من جدول. تظهر حصصها مكدّسة في الجدول الأسبوعي والمطبوع، وتُحسب مرتين في قاموس المدرسة. اختر النسخة التي تبقى.",
      "sdup_version":               "النسخة {{n}} — {{count}} حصة",
      "sdup_keep":                  "إبقاء هذه النسخة",
      "sdup_merge":                 "دمج النسخ",
      "sdup_conflict_slots":        "تختلف النسخ في: {{slots}}",
      "sdup_archived":              "سنة مؤرشفة — للقراءة فقط",
      "sdup_resolved":              "بقي جدول واحد لهذا الفصل واليوم",
      "sdup_confirm_keep":          "ستُحذف النسخ الأخرى من هذا اليوم (تُحفظ نسخة منها في الأرشيف). متابعة؟",
      "sb_autofill_done":           "تم وضع {{count}} حصة. راجعها وعدّلها قبل الحفظ.",
      "sb_autofill_review_hint":    "لم يُحفظ شيء بعد — الحفظ يتم بالزر أعلاه.",
      "sb_unplaced_no_teacher":     "لم أستطع وضع {{count}} حصة {{subject}} — لا يوجد معلم لهذه المادة في هذا الصف.",
      "sb_unplaced_teacher_busy":   "لم أستطع وضع {{count}} حصة {{subject}} — {{names}} مشغول في كل الفترات المتبقية.",
      "sb_unplaced_grid_full":      "لم أستطع وضع {{count}} حصة {{subject}} — لا توجد خانات فارغة في الجدول.",
      "sb_copy_title":              "نسخ الجدول إلى صف آخر",
      "sb_copy_hint":               "سيُنسخ الجدول كاملاً، وستُفرَّغ خانة كل معلم مشغول في الصف الهدف لتختار له بديلاً.",
      "sb_copy_pick_target":        "اختر الصف الهدف",
      "sb_copy_confirm":            "نسخ",
      "sb_copy_needs_teacher":      "{{count}} خانة تحتاج إلى معلم مختلف في هذا الصف:",

      // ── Bell schedule + curriculum settings [2026-09] ──────────────
      "ss_bell_title":              "أوقات الحصص (جدول الأجراس)",
      "ss_bell_hint":               "حدّد أوقات الحصص مرة واحدة لكل المدرسة. بعدها لن يكتب أحد وقتاً عند بناء الجداول. أي وقت بداية وأي مدة وأي عدد حصص.",
      "ss_bell_period_n":           "الحصة {{n}}",
      "ss_bell_start":              "بداية الحصة",
      "ss_bell_end":                "نهاية الحصة",
      "ss_bell_add":                "إضافة حصة",
      "ss_bell_remove":             "حذف الحصة",
      "ss_bell_summary":            "{{count}} حصة — {{minutes}} دقيقة تدريس يومياً",
      "ss_bell_invalid_rows":       "بعض الصفوف غير صالحة (وقت ناقص، أو نهاية قبل البداية، أو تداخل) ولن تُحفظ.",
      "ss_curriculum_title":        "الخطة الدراسية (اختياري)",
      "ss_curriculum_hint":         "عدد الحصص الأسبوعية لكل مادة في كل صف. تُستخدم لعدّاد «الباقي» على الكتل وللإكمال التلقائي. بناء الجداول يعمل كاملاً بدونها.",
      "ss_curriculum_grade":        "الصف",
      "ss_curriculum_subject":      "المادة",
      "ss_curriculum_per_week":     "حصص أسبوعياً",
      "ss_curriculum_add":          "إضافة سطر",
      "ss_curriculum_remove":       "حذف السطر",
      "ss_curriculum_empty":        "لم تُحدَّد خطة دراسية بعد — هذا اختياري تماماً.",

      // ── Teacher documents [FEAT teacher-docs 2026-09] ──────────────
      "td_docs_button":             "وثائق المعلم",
      "td_docs_title":              "وثائق {{name}}",
      "td_docs_privacy_note":       "هذه وثائق شخصية. لا يطّلع عليها إلا إدارة هذه المدرسة والمعلم نفسه، وتُسجَّل كل عمليات الرفع والتنزيل والحذف.",
      "td_docs_type":               "نوع الوثيقة",
      "td_docs_pick_type":          "اختر نوع الوثيقة",
      "td_docs_upload":             "رفع وثيقة",
      "td_docs_uploaded":           "تم رفع الوثيقة",
      "td_docs_upload_error":       "تعذر رفع الوثيقة",
      "td_docs_download_error":     "تعذر تنزيل الوثيقة",
      "td_docs_delete_error":       "تعذر حذف الوثيقة",
      "td_docs_load_error":         "تعذر تحميل الوثائق",
      "td_docs_deleted":            "تم حذف الوثيقة",
      "td_docs_confirm_delete":     "هل تريد حذف «{{name}}» نهائياً؟",
      "td_docs_empty":              "لا توجد وثائق مرفوعة لهذا المعلم بعد.",
      "td_docs_rules":              "PDF أو صورة (JPG/PNG) فقط، بحد أقصى {{max}} للملف. تُضغط الصور تلقائياً عند الرفع.",
      "td_docs_too_big":            "حجم الملف يتجاوز الحد الأقصى ({{max}}).",
      "td_docs_missing_required":   "وثائق مطلوبة ولم تُرفع بعد: {{names}}",
      "td_docs_all_required_present": "جميع الوثائق المطلوبة مرفوعة.",
      "td_docs_type_inactive":      "نوع موقوف",
      "td_docs_compressed_from":    "مضغوطة من {{original}}",
      "ss_doctypes_title":          "أنواع وثائق المعلمين",
      "ss_doctypes_hint":           "حدّد الوثائق التي تطلبها مدرستك من المعلمين. يمكنك التعديل في أي وقت.",
      "ss_doctypes_label_ar":       "الاسم بالعربية",
      "ss_doctypes_label_fr":       "الاسم بالفرنسية",
      "ss_doctypes_label_en":       "الاسم بالإنجليزية",
      "ss_doctypes_required":       "إلزامية",
      "ss_doctypes_add":            "إضافة نوع",
      "ss_doctypes_remove":         "حذف النوع",
      "ss_doctypes_save":           "حفظ الأنواع",
      "ss_doctypes_saved":          "تم حفظ أنواع الوثائق",
      "ss_doctypes_save_error":     "تعذر حفظ أنواع الوثائق",
      "ss_doctypes_empty":          "لم تُحدَّد أنواع بعد.",
      "ss_doctypes_removal_note":   "حذف نوع من القائمة لا يحذف أي ملف مرفوع؛ يبقى الملف باسم نوعه القديم.",
      "ss_storage_title":           "مساحة التخزين",
      "ss_storage_used":            "{{used}} من {{quota}}",
      "ss_storage_documents":       "{{count}} وثيقة",
      "ss_storage_hint":            "الحد الأقصى لحجم الملف الواحد {{max}}. تُضغط الصور تلقائياً لتوفير المساحة.",
      "ssy_disk_title":             "مساحة القرص",
      "ssy_disk_used":              "{{used}} مستخدمة من {{total}} ({{percent}}%)",
      "ssy_disk_free":              "{{free}} متاحة",
      "ssy_disk_warning":           "القرص ممتلئ بنسبة {{percent}}% (الحد {{threshold}}%). امتلاء القرص يوقف قاعدة البيانات والنسخ الاحتياطي، وليس رفع الوثائق فقط.",
      "ssy_disk_by_school":         "الاستهلاك حسب المدرسة",
      "ssy_disk_documents":         "{{count}} وثيقة",

      // Auth
      "exam_schedule_title": "جدول الاختبارات",
      "exam_add": "إضافة اختبار",
      "exam_edit": "تعديل الاختبار",
      "exam_print": "طباعة الجدول",
      "exam_created": "تم إنشاء الاختبار بنجاح",
      "exam_updated": "تم تحديث الاختبار بنجاح",
      "exam_deleted": "تم حذف الاختبار",
      "exam_confirm_delete": "هل أنت متأكد من حذف هذا الاختبار؟",
      "exam_empty": "لا توجد اختبارات مجدولة بعد",
      "exam_readonly_note": "هذا الجدول للعرض فقط",
      "exam_col_time": "الوقت",
      "exam_col_subject": "المادة",
      "exam_col_class": "الصف",
      "exam_col_room": "رقم القاعة",
      "exam_col_invigilator": "المعلم المراقب",
      "exam_col_date": "التاريخ",
      "exam_col_notes": "ملاحظات",
      "exam_pick_subject": "اختر المادة",
      "exam_pick_class": "اختر الصف",
      "exam_pick_teacher": "اختر المعلم المراقب",
      "exam_room_placeholder": "مثال: 101",
      "exam_start_time": "وقت البدء",
      "exam_end_time": "وقت الانتهاء",
      "exam_err_required": "يرجى تعبئة جميع الحقول المطلوبة",
      "exam_err_time_range": "يجب أن يكون وقت الانتهاء بعد وقت البدء",
      "exam_err_save": "تعذر حفظ الاختبار",
      "exam_err_delete": "تعذر حذف الاختبار",
      "exam_popup_blocked": "تم حظر النافذة المنبثقة، يرجى السماح بالنوافذ المنبثقة للطباعة",
      "login": "تسجيل الدخول",
      "logout": "تسجيل الخروج",
      "username": "اسم المستخدم",
      "password": "كلمة المرور",
      "select_role": "اختر الدور",
      "remember_me": "تذكرني",
      "forgot_password": "نسيت كلمة المرور؟",
      "welcome_back": "أهلاً بعودتك",
      "login_subtitle": "EduGate — منصة إدارة المدارس الذكية",
      
      // Roles
      "super_admin": "المدير العام",
      "school_admin": "مدير المدرسة",
      "admin_staff": "موظف إداري",
      "teacher": "معلم",
      "student": "طالب",
      "parent": "ولي الأمر",
      
      // Navigation
      "dashboard": "لوحة التحكم",
      "schools": "المدارس",
      "students": "الطلاب",
      "teachers": "المعلمين",
      "parents": "أولياء الأمور",
      "attendance": "الحضور والغياب",
      "grades": "الدرجات",
      "assignments": "الواجبات",
      "fees": "الرسوم",
      "payments": "المدفوعات",
      "settings": "الإعدادات",
      
      // Actions
      "add": "إضافة",
      "edit": "تعديل",
      "delete": "حذف",
      "save": "حفظ",
      "cancel": "إلغاء",
      "search": "بحث",
      "filter": "تصفية",
      "export": "تصدير",
      "view": "عرض",
      "submit": "إرسال",
      
      // Dashboard
      "total_schools": "إجمالي المدارس",
      "total_students": "إجمالي الطلاب",
      "total_teachers": "إجمالي المعلمين",
      "total_parents": "إجمالي أولياء الأمور",
      "present_today": "حاضر اليوم",
      "absent_today": "غائب اليوم",
      "total_fees": "إجمالي الرسوم",
      "total_paid": "المدفوع",
      "total_pending": "المتبقي",
      
      // School Management
      "add_school": "إضافة مدرسة",
      "school_name": "اسم المدرسة",
      "school_name_ar": "الاسم بالعربية",
      "school_name_fr": "الاسم بالفرنسية",
      "address": "العنوان",
      "phone": "الهاتف",
      "email": "البريد الإلكتروني",
      "admin_info": "معلومات المدير",
      "admin_username": "اسم مستخدم المدير",
      "admin_password": "كلمة مرور المدير",
      "admin_full_name": "الاسم الكامل للمدير",
      
      // Student Management
      "add_student": "إضافة طالب",
      "student_info": "معلومات الطالب",
      "full_name": "الاسم الكامل",
      "class": "الصف",
      "grade": "المرحلة",
      "date_of_birth": "تاريخ الميلاد",
      "medical_info": "المعلومات الطبية",
      
      // Teacher Management
      "add_teacher": "إضافة معلم",
      "teacher_info": "معلومات المعلم",
      "subjects": "المواد",
      "classes": "الصفوف",
      "specialization": "التخصص",
      
      // Attendance
      "mark_attendance": "تسجيل الحضور",
      "date": "التاريخ",
      "status": "الحالة",
      "present": "حاضر",
      "absent": "غائب",
      "late": "متأخر",
      "excused": "غياب بعذر",
      "notes": "ملاحظات",
      
      // Grades
      "add_grade": "إضافة درجة",
      "subject": "المادة",
      "assessment_type": "نوع التقييم",
      "assessment_name": "اسم التقييم",
      "score": "الدرجة",
      "max_score": "الدرجة القصوى",
      "percentage": "النسبة المئوية",
      "exam": "امتحان",
      "quiz": "اختبار قصير",
      "homework": "واجب منزلي",
      "project": "مشروع",
      
      // Assignments
      "add_assignment": "إضافة واجب",
      "title": "العنوان",
      "description": "الوصف",
      "due_date": "تاريخ التسليم",
      "attachment": "المرفقات",
      
      // Fees
      "add_fee": "إضافة رسوم",
      "amount": "المبلغ",
      "fee_type": "نوع الرسوم",
      "academic_year": "السنة الدراسية",
      "semester": "الفصل الدراسي",
      "paid": "مدفوع",
      "pending": "معلق",
      "partial": "مدفوع جزئياً",
      "overdue": "متأخر",
      "tuition": "رسوم دراسية",
      "transport": "نقل",
      "books": "كتب",
      
      // Payments
      "add_payment": "إضافة دفعة",
      "payment_method": "طريقة الدفع",
      "reference_number": "رقم المرجع",
      "payment_date": "تاريخ الدفع",
      "cash": "نقد",
      "bank_transfer": "تحويل بنكي",
      "online": "إلكتروني",
      
      // Messages
      "loading": "جاري التحميل...",
      "no_data": "لا توجد بيانات",
      "success": "نجحت العملية",
      "error": "حدث خطأ",
      "confirm_delete": "هل أنت متأكد من الحذف؟",
      
      // Language
      "language": "اللغة",
      "arabic": "العربية",
      "french": "الفرنسية",
      "english": "الإنجليزية",
      
      // Additional
      "active": "نشط",
      "academic_years": "السنوات الدراسية",
      "archived": "مؤرشف",
      "planned": "مخطط",
      "read_only": "قراءة فقط",
      "ay_label_fees": "سجلات رسوم الطلاب",
      "ay_label_salaries": "سجلات رواتب المعلمين",
      "ay_label_expenses": "سجلات مصروفات المدرسة",
      "ay_label_reports": "التقارير والإحصائيات",
      "ay_label_schedule": "الجداول الدراسية",
      "ay_label_grades": "سجلات الدرجات",
      "ay_label_calendar": "التقويم المدرسي",
      "ay_label_records": "السجلات",
      "ay_year_suffix": "السنة الدراسية {{year}}",
      "ay_archive_banner": "أنت تشاهد بيانات مؤرشفة من السنة الدراسية {{year}} — للقراءة فقط",
      "ay_help_button": "دليل السنة الدراسية",
      "ay_help_title": "دليل استخدام السنوات الدراسية",
      "ay_help_intro_h": "ما هي السنة الدراسية؟",
      "ay_help_intro_p": "السنة الدراسية هي الإطار الزمني الذي تُنظَّم تحته كل بيانات مدرستك (الرسوم، الرواتب، الدرجات، الحضور، الجداول، التقويم). كل سجل يُحفظ منسوباً إلى سنة دراسية محددة، ممّا يبقي بيانات كل عام منفصلة وواضحة.",
      "ay_help_sequence_h": "ترتيب الخطوات المطلوب قبل الترحيل",
      "ay_help_sequence_p": "قبل أن يعمل الترحيل يجب أن يمرّ العام الحالي بالتسلسل التالي عبر أزرار الحالة في جدول الأعوام: (1) «نشط» أثناء العام الدراسي. (2) اضغط «جاهز للترقية» عند نهاية العام. (3) اضغط «اعتماد الترقية». (4) الأهم — اضغط «قفل النتائج»: هذه خطوة منفصلة عن الاعتماد وتعني أن الإدارة اعتمدت النتائج النهائية وقفلتها؛ بدونها يرفض النظام الترحيل برسالة «لم يتم اعتماد وقفل النتائج بعد». يوجد زر «قفل النتائج» بجانب أزرار الحالة وأيضاً داخل معالج الترحيل. (5) اضغط «بدء ترحيل العام». ملاحظة: الاعتماد وقفل النتائج إجراءان منفصلان — الاعتماد لا يقفل النتائج تلقائياً.",
      "ay_help_rollover_h": "ما معنى \"الترحيل\"؟",
      "ay_help_rollover_p": "الترحيل هو الانتقال من سنة دراسية إلى السنة التالية. عند بدء سنة جديدة تختار كيف تُعامَل بيانات السنة السابقة، ولا تُحذف أي بيانات أبداً في كل الأحوال.",
      "ay_help_archive_h": "الوضع الأول: الأرشفة والمتابعة",
      "ay_help_archive_p": "تبقى سجلات العام السابق (المالية، الرسائل، الدرجات...) متاحة للاطلاع في عرض مؤرشف واضح للقراءة فقط، بينما تُسجَّل البيانات الجديدة تحت السنة الجديدة. مناسب إذا أردت الرجوع بسهولة إلى أرقام العام الماضي.",
      "ay_help_fresh_h": "الوضع الثاني: بداية جديدة",
      "ay_help_fresh_p": "تبدأ السنة الجديدة بشاشات نظيفة، وتُؤرشَف بيانات العام السابق دون أن تظهر افتراضياً في العروض الحالية. تبقى الأرشفة قابلة للاسترجاع دائماً عبر منتقي السنة، ولا يحدث أي حذف.",
      "ay_help_separation_h": "كيف تُفصل البيانات بين السنوات؟",
      "ay_help_separation_p": "تُفصل الرسوم والرواتب والمصروفات والدرجات والحضور والجداول والتقويم حسب السنة الدراسية. في السنة الحالية تُعرض بيانات السنة الحالية فقط ولا تختلط ببيانات سنوات سابقة، وتحمل كل شاشة عنواناً يوضّح السنة المعروضة.",
      "ay_help_access_h": "كيف يطّلع الطلاب والمعلمون وأولياء الأمور على بيانات العام الماضي؟",
      "ay_help_access_p": "توجد قائمة منسدلة لاختيار السنة الدراسية في لوحات الطلاب والمعلمين وأولياء الأمور. باختيار سنة سابقة يمكنهم الاطلاع (للقراءة فقط) على درجات وحضور وسجلات ذلك العام التي يحق لهم رؤيتها.",
      "ay_help_lock_h": "لماذا سنة التاريخ مقفلة عند الإدخال؟",
      "ay_help_lock_p": "عند إدخال أي تاريخ (رسوم، رواتب، مصروفات، درجات، حضور، تقويم) تكون السنة مثبتة على السنة الدراسية النشطة، ويمكنك اختيار اليوم والشهر فقط. هذا مقصود لمنع الأخطاء الشائعة مثل تسجيل مبلغ في سنة خاطئة. النظام يرفض أي تاريخ خارج السنة النشطة.",
      "ay_help_steps_h": "خطوات بدء سنة دراسية جديدة",
      "ay_help_step1": "أضِف السنة الدراسية الجديدة (بصيغة YYYY-YYYY) من زر \"إضافة سنة دراسية\".",
      "ay_help_step2": "اضغط \"بدء ترحيل العام\" واختر وضع الترحيل: الأرشفة والمتابعة أو بداية جديدة.",
      "ay_help_step3": "راجِع تعيين الفصول للطلاب المرقّين وأكِّد العملية؛ لا تُحذف بيانات العام السابق.",
      "ay_help_step4": "تصبح السنة الجديدة نشطة تلقائياً، وتُؤرشَف السنة السابقة وتبقى متاحة عبر منتقي السنة.",
      "ay_help_faq_h": "أسئلة شائعة",
      "ay_help_faq_q1": "هل تُحذف بيانات العام الماضي عند الترحيل؟",
      "ay_help_faq_a1": "لا. لا تُحذف أي بيانات مطلقاً في أي وضع؛ يتغيّر فقط ما يُعرض افتراضياً، وتبقى كل السجلات متاحة عبر منتقي السنة.",
      "ay_help_faq_q2": "هل أستطيع تعديل بيانات سنة مؤرشفة؟",
      "ay_help_faq_a2": "لا. السنوات المؤرشفة للقراءة فقط، وتظهر لافتة واضحة تنبّهك بذلك. يمكن الإدخال في السنة النشطة فقط.",
      "ay_help_faq_q3": "أدخلت تاريخاً برُفض من النظام، لماذا؟",
      "ay_help_faq_a3": "لأن سنة التاريخ خارج السنة الدراسية النشطة. اختر يوماً وشهراً ضمن السنة النشطة، أو بدّل السنة النشطة أولاً إن كنت تريد سنة أخرى.",
      // Academic-year manager (AcademicYearManager.jsx) [I18N 2026-10]
      "aym_backups_load_error": "فشل تحميل النسخ الاحتياطية",
      "aym_invalid_year_format": "صيغة السنة غير صالحة. يجب أن تكون YYYY-YYYY",
      "aym_year_created": "تم إنشاء السنة الدراسية بنجاح",
      "aym_confirm_activate": "هل أنت متأكد من تفعيل العام الدراسي {{name}} كعام نشط؟ هذا الإجراء سيقوم بأرشفة أي عام نشط آخر.",
      "aym_year_activated": "تم تفعيل العام الدراسي {{name}} بنجاح",
      "aym_confirm_transition": "هل أنت متأكد من نقل حالة العام الدراسي {{year}} إلى ({{status}})؟",
      "aym_status_updated": "تم تحديث حالة العام الدراسي بنجاح",
      "aym_calendar_saved": "تم حفظ التقويم الدراسي والمراحل بنجاح",
      "aym_results_locked_toast": "تم قفل مرحلة النتائج. يمكنك الآن بدء الترحيل.",
      "aym_confirm_word_wrong": "يرجى كتابة كلمة التأكيد بشكل صحيح",
      "aym_restore_success": "تمت استعادة حالة البيانات السابقة وتجميد التغييرات بنجاح",
      "aym_active_year_required": "يجب تفعيل عام دراسي أولاً",
      "aym_rollover_done": "تم ترحيل العام بنجاح! ترقية {{promoted}} طالباً، وبقاء {{retained}} طلاب.",
      "aym_phase_registration": "تسجيل الطلاب الجدد",
      "aym_phase_study_exams": "الدراسة وجدول الحصص",
      "aym_phase_results": "اعتماد ورصد الدرجات",
      "aym_phase_promotion_ready": "التهيئة للترحيل",
      "aym_status_planned": "مخطط له",
      "aym_status_active": "نشط",
      "aym_status_ready": "جاهز للترقية",
      "aym_status_approved": "معتمد",
      "aym_status_promoting": "جارٍ الترحيل...",
      "aym_status_archived": "مؤرشف وقراءة فقط",
      "aym_title": "إدارة السنوات الدراسية والترحيل",
      "aym_subtitle": "إنشاء وإدارة دورة حياة السنوات الدراسية والتحكم في أقفال التقويم والنسخ الاحتياطي.",
      "aym_add_year": "إضافة سنة دراسية",
      "aym_start_rollover": "بدء ترحيل العام",
      "aym_tab_cycles": "الأعوام الدراسية والتقويم",
      "aym_tab_backups": "النسخ الاحتياطية واستعادة البيانات",
      "aym_cycles_title": "السنوات الدراسية المتاحة",
      "aym_col_year": "السنة الدراسية",
      "aym_start_date": "تاريخ البدء",
      "aym_end_date": "تاريخ الانتهاء",
      "aym_col_actions": "العمليات",
      "aym_btn_activate": "تفعيل كعام نشط",
      "aym_btn_mark_ready": "جاهز للترقية",
      "aym_btn_approve": "اعتماد الترقية",
      "aym_btn_lock_results": "قفل النتائج",
      "aym_btn_archive": "أرشفة",
      "aym_closed_history": "السجل مغلق ومؤرشف",
      "aym_workflow_title": "دورة حياة العام الدراسي",
      "aym_wf_planned": "مخطط",
      "aym_wf_ready": "جاهز للترقية",
      "aym_wf_archived": "مؤرشف",
      "aym_calendar_locks_title": "التقويم الأكاديمي والتحكم في الأقفال",
      "aym_locked": "مغلق",
      "aym_unlocked": "مفتوح",
      "aym_save_calendar": "حفظ إعدادات التقويم",
      "aym_no_years": "لا توجد سنوات دراسية مضافة",
      "aym_guidelines_title": "توجيهات معالجة البيانات",
      "aym_guidelines_isolation": "يسمح لك النظام بإصدار درجات للطلاب وحفظ الحضور وتوزيع الجداول بشكل منفصل تماماً لكل سنة دراسية.",
      "aym_guidelines_phase_locking": "قفل المراحل:",
      "aym_guidelines_lock_registration": "قفل مرحلة التسجيل يمنع إدخال طلاب جدد للعام.",
      "aym_guidelines_lock_study": "قفل الدراسة والامتحانات يقفل تعديل وإعادة توزيع جداول الحصص.",
      "aym_guidelines_lock_grades": "قفل رصد الدرجات يمنع المعلمين تماماً من إدخال أو تعديل درجات الطلاب.",
      "aym_snapshots_title": "لقطات النظام والنسخ الاحتياطية للترحيل",
      "aym_snapshots_desc": "يحتفظ النظام بلقطة كاملة لكل البيانات تلقائياً قبل عمليات الترحيل لضمان عدم ضياعها وإمكانية التراجع.",
      "aym_col_backup_id": "معرف النسخة الاحتياطية",
      "aym_col_timestamp": "التاريخ والوقت",
      "aym_col_old_cycle": "معرف العام القديم",
      "aym_backup_committed": "مخزنة / صالحة",
      "aym_backup_rolled_back": "تم استردادها والتراجع",
      "aym_restore_btn": "استعادة لقطة النظام",
      "aym_already_restored": "مسترجعة بالفعل",
      "aym_no_backups": "لا توجد نسخ احتياطية مسجلة بعد",
      "aym_create_title": "إنشاء عام دراسي جديد",
      "aym_create_desc": "أدخل اسم السنة الدراسية بالصيغة YYYY-YYYY (مثال: 2026-2027) وتواريخ البدء والانتهاء.",
      "aym_year_name_label": "اسم السنة الدراسية (الصيغة: YYYY-YYYY) *",
      "aym_restore_title": "تأكيد أمني حساس لاستعادة البيانات",
      "aym_restore_warning": "تحذير: استعادة لقطة النظام ستؤدي إلى حذف جميع التعديلات التي تمت بعد تاريخ الترحيل بالكامل، وإرجاع الجداول والطلاب لحالتهم المحددة في اللقطة.",
      "aym_restore_type_word": "لكتابة التأكيد، يرجى إدخال الكلمة \"ROLLBACK\" في الحقل أدناه:",
      "aym_restore_proceed": "تأكيد والاستعادة الفورية",
      "aym_wizard_title": "معالج ترحيل العام الدراسي",
      "aym_wizard_desc": "ترحيل المدرسة من العام الحالي {{year}} إلى العام الجديد.",
      "aym_step_years": "الأعوام",
      "aym_step_classes": "الفصول",
      "aym_step_retentions": "الإعادة",
      "aym_step_options": "الخيارات",
      "aym_step_confirm": "التأكيد",
      "aym_target_year_title": "تحديد العام الدراسي المستهدف",
      "aym_requirements_title": "متطلبات بدء الترحيل",
      "aym_req_status": "اعتماد حالة العام (جاهز للترقية أو معتمد) — عبر أزرار الحالة في جدول الأعوام",
      "aym_req_results_locked": "قفل مرحلة النتائج (اعتماد النتائج النهائية)",
      "aym_lock_results_now": "قفل النتائج الآن",
      "aym_current_active_year": "العام الحالي (نشط)",
      "aym_target_year_label": "العام الدراسي الجديد (الصيغة: YYYY-YYYY) *",
      "aym_class_mapping_title": "تعيين ترفيع الفصول",
      "aym_class_mapping_desc": "حدد لكل فصل حالي الفصل المناظر له الذي سينتقل إليه الطلاب الناجحون.",
      "aym_no_classes": "لا توجد فصول لتعيينها",
      "aym_retained_title": "تحديد الطلاب المعيدين (الإعادة)",
      "aym_search_student_placeholder": "البحث بالاسم أو الفصل...",
      "aym_retained_desc": "الطلاب المحددون في القائمة سيبقون في نفس فصولهم للعام الجديد ولن يتم ترفيعهم.",
      "aym_no_search_results": "لا توجد نتائج بحث للطلاب",
      "aym_retained_count": "عدد الطلاب المعيدين المحدد: {{n}} طالباً.",
      "aym_options_title": "خيارات الترحيل الإضافية",
      "aym_copy_schedules": "نسخ جداول الحصص الأسبوعية",
      "aym_copy_schedules_desc": "سيقوم النظام بنسخ جداول الحصص الحالية إلى العام الدراسي الجديد.",
      "aym_schedule_copy_mode_title": "أين يُنسخ جدول كل صف؟",
      "aym_schedule_same_class": "يبقى الجدول مع صفه",
      "aym_schedule_same_class_desc": "جدول الصف الأول أ يُنسخ إلى الصف الأول أ في العام الجديد. مناسب حين يبقى توزيع الحصص لكل صف كما هو.",
      "aym_schedule_follow": "يتبع الجدول الطلاب",
      "aym_schedule_follow_desc": "جدول الصف الأول أ ينتقل إلى الصف الذي يُرفَّع إليه طلابه (الثاني أ)، ويبقى الأول أ الجديد بلا جدول.",
      "aym_enabled": "مفعل",
      "aym_disabled": "معطل",
      "aym_allow_unpaid": "السماح بترفيع الطلاب غير المسددين للمستحقات",
      "aym_allow_unpaid_desc": "تفعيل هذا الخيار يتجاوز فحص الذمم المالية المعلقة ويسمح بنقل جميع الطلاب بغض النظر عن رسومهم.",
      "aym_mode_title": "طريقة بدء العام الجديد",
      "aym_mode_desc": "لا يتم حذف أي بيانات في كلتا الحالتين — يتغير فقط ما يظهر افتراضياً في الشاشات.",
      "aym_mode_archive": "أرشفة ومتابعة",
      "aym_mode_archive_desc": "تبقى سجلات العام الماضي (المالية، الرسائل، الدرجات) ظاهرة للقراءة عبر مُحدد السنة.",
      "aym_mode_fresh": "بداية جديدة",
      "aym_mode_fresh_desc": "تبدأ الشاشات بالعام الجديد فقط؛ البيانات القديمة محفوظة ويمكن الوصول إليها عبر فلتر السنة.",
      "aym_final_review_title": "مراجعة وتأكيد عملية الترحيل النهائية",
      "aym_final_warning": "تحذير: هذه العملية هامة جداً وتقوم بتعديل جماعي على بيانات النظام.",
      "aym_final_archive_current": "سيتم أرشفة العام الدراسي الحالي ({{year}}) كعام مغلق.",
      "aym_final_activate_new": "سيتم تفعيل العام الدراسي الجديد ({{year}}) كعام نشط.",
      "aym_final_students": "سيتم نقل الطلاب الناجحين للفصول الجديدة، وبقاء الطلاب المعيدين في نفس صفوفهم.",
      "aym_promoted_students": "الطلاب المرفعون",
      "aym_retained_students": "الطلاب المعيدون",
      "aym_schedule_copy": "نسخ الجدول",
      "aym_outstanding_fees": "الذمم المالية",
      "aym_allowed": "مسموح",
      "aym_strict": "ممنوع",
      "aym_next_cycle": "العام القادم",
      "aym_start_mode": "طريقة البدء",
      "aym_mode_archive_short": "أرشفة",
      "aym_prev": "السابق",
      "aym_invalid_year_short": "صيغة السنة غير صالحة",
      "aym_next": "التالي",
      "aym_confirm_rollover": "تأكيد الترحيل النهائي",
      "inactive": "غير نشط",
      "relationship": "القرابة",
      "father": "أب",
      "mother": "أم",
      "guardian": "وصي",
      "select_student": "اختر طالباً",
      "select_students": "اختر الطلاب",
      "mark_attendance_for": "تسجيل الحضور لـ",
      "select_date": "اختر التاريخ",
      "today": "اليوم",
      "yesterday": "أمس",
      "this_week": "هذا الأسبوع",
      "this_month": "هذا الشهر",
      "all": "الكل",
      "select_class": "اختر الصف",
      "select_subject": "اختر المادة",
      "enter_score": "أدخل الدرجة",
      "out_of": "من",
      "weight": "الوزن",
      "first_semester": "الفصل الأول",
      "second_semester": "الفصل الثاني",
      "payment_history": "سجل المدفوعات",
      "pay_now": "ادفع الآن",
      "discount": "خصم",
      "scholarship": "منحة دراسية",
      "create_assignment": "إنشاء واجب",
      "due_in": "موعد التسليم",
      "submitted": "تم التسليم",
      "not_submitted": "لم يتم التسليم",
      "graded": "تم التقييم",

      // Announcement Board
      "ann_board_title": "لوحة الإعلانات",
      "ann_board_subtitle": "إعلانات المدرسة والفصول",
      "ann_new": "إعلان جديد",
      "ann_title_placeholder": "عنوان الإعلان",
      "ann_content_placeholder": "محتوى الإعلان...",
      "ann_priority": "الأولوية",
      "ann_priority_normal": "عادي",
      "ann_priority_important": "مهم",
      "ann_priority_urgent": "عاجل",
      "ann_target": "الجمهور المستهدف",
      "ann_target_all": "الجميع",
      "ann_target_parents": "أولياء الأمور",
      "ann_target_students": "الطلاب",
      "ann_target_class": "فصل محدد",
      "ann_select_class": "-- اختر الفصل --",
      "ann_publish": "نشر الإعلان",
      "ann_publishing": "جاري النشر...",
      "ann_empty": "لا توجد إعلانات حالياً",
      "ann_written_by": "كتبه",
      "ann_class_label": "الفصل",
      "ann_delete_success": "تم حذف الإعلان",
      "ann_delete_error": "تعذّر حذف الإعلان",
      "ann_post_success": "تم نشر الإعلان",
      "ann_post_error": "خطأ في نشر الإعلان",
      "ann_load_error": "تعذّر تحميل الإعلانات",
      "ann_validation": "املأ العنوان والمحتوى",

      // Sidebar nav — School Admin
      "nav_dashboard": "لوحة التحكم",
      "nav_students": "الطلاب",
      "nav_teachers": "المعلمون",
      "nav_parents": "أولياء الأمور",
      "nav_attendance": "الحضور والغياب",
      "nav_grades": "الدرجات",
      "nav_fees": "المالية",
      "nav_schedule": "جدول الحصص",
      "nav_excel": "استيراد Excel",
      "nav_reports": "التقارير",
      "nav_pdf_reports": "تقارير PDF",
      "nav_bulk_attendance": "حضور جماعي",
      "nav_staff_attendance": "حضور المعلمين",
      "nav_student_attendance": "حضور الطلاب",
      "nav_announcements": "الإعلانات",
      "nav_homework": "الواجبات",
      "nav_section_people": "الأشخاص",
      "nav_section_academic": "الشؤون الأكاديمية",
      "nav_section_finance": "المالية",
      "nav_section_communication": "التواصل",
      "nav_section_reports": "التقارير",
      "nav_section_control_panel": "لوحة التحكم",
      "nav_group_community": "المجتمع",
      "nav_group_academic": "الأكاديمي",
      "nav_group_communications": "التواصل",
      "nav_group_finance": "المالية",
      "nav_group_scheduling": "الجدول",
      "nav_group_staff": "الكوادر",
      "nav_group_settings": "الإعدادات",
      "dash_total_parents": "أولياء الأمور",
      "dash_attendance_rate": "نسبة الحضور",
      "dash_welcome_admin": "مرحباً {{name}}",
      "dash_welcome_subtitle": "نظرة عامة على مدرستك اليوم",
      "dash_welcome_teacher": "مرحباً {{name}} — أستاذ",
      "dash_welcome_student": "مرحباً {{name}}",
      "dash_welcome_parent": "مرحباً {{name}} — ولي الأمر",
      "empty_no_data_title": "لا توجد بيانات بعد",
      "empty_no_data_action": "ابدأ بإضافة عنصر جديد",
      "dash_unread_messages": "رسائل غير مقروءة",
      "dash_quick_actions": "إجراءات سريعة",
      "dash_quick_add_student": "إضافة طالب",
      "dash_quick_announcement": "إرسال إعلان",
      "dash_quick_add_teacher": "إضافة معلم",
      "dash_quick_attendance": "تسجيل الحضور",
      "dash_weekly_attendance": "حضور الأسبوع",
      "dash_recent_activity": "آخر النشاطات",
      "dash_activity_empty": "لا توجد نشاطات بعد",
      "dash_alerts": "تنبيهات",
      "dash_alert_absences": "طلاب لديهم 3+ أيام غياب",
      "dash_alert_unpaid_fees": "رسوم غير مدفوعة",
      "dash_alert_pending_tasks": "مهام معلمين معلقة",
      "comm_title": "التواصل",
      "comm_tab_direct": "رسائل مباشرة",
      "comm_tab_broadcast": "إذاعة",
      "comm_compose": "إنشاء رسالة",
      "comm_inbox": "الوارد",
      "comm_sent": "المُرسل",
      "comm_recipient_type": "نوع المستقبل",
      "comm_recipient_admin": "إدارة المدرسة",
      "comm_recipient_student": "طالب",
      "comm_recipient_parent": "ولي أمر",
      "comm_pick_student": "اختر الطالب",
      "comm_pick_parent": "اختر ولي الأمر",
      "comm_pick_class": "اختر الفصل",
      "comm_admin_hint": "ستُرسل الرسالة لمدير/مديرة المدرسة مباشرةً.",
      "comm_subject": "الموضوع",
      "comm_subject_placeholder": "موضوع الرسالة (اختياري)",
      "comm_message": "نص الرسالة",
      "comm_message_placeholder": "اكتب رسالتك هنا...",
      "comm_chars": "حرف",
      "comm_notify_parent": "إرسال نسخة لولي الأمر أيضاً",
      "comm_send": "إرسال",
      "comm_sending": "جاري الإرسال...",
      "comm_sent_ok": "تم إرسال الرسالة ✓",
      "comm_broadcast_ok": "تم إرسال الإذاعة ✓",
      "comm_target": "المستهدف",
      "comm_broadcast_class": "فصل",
      "comm_broadcast_student": "طالب محدد",
      "comm_broadcast_admins": "إدارة المدرسة",
      "comm_broadcast_send": "إرسال الإذاعة",
      "comm_broadcast_history": "سجل الإذاعات",
      "comm_broadcast_badge": "إذاعة",
      "comm_history_empty": "لم تُرسل أي إذاعة بعد",
      "comm_inbox_empty": "لا توجد رسائل واردة",
      "comm_sent_empty": "لم ترسل أي رسالة بعد",
      "comm_unknown": "غير معروف",
      "comm_new": "جديد",
      "comm_validation_message": "اكتب نص الرسالة",
      "comm_validation_pick_student": "اختر طالباً",
      "comm_validation_pick_parent": "اختر ولي أمر",
      "comm_validation_pick_class": "اختر فصلاً",
      "acct_title": "إعدادات الحساب",
      "acct_subtitle": "أدر صورتك الشخصية وكلمة المرور من مكان واحد",
      "acct_profile_picture": "الصورة الشخصية",
      "acct_change_password": "تغيير كلمة المرور",
      "acct_image_hint": "انقر على الصورة لاختيار صورة جديدة، ثم اضغط حفظ.",
      "acct_image_size_hint": "JPG أو PNG، بحد أقصى 2 ميجابايت.",
      "acct_image_choose": "اختيار صورة",
      "acct_image_unsaved": "صورة جديدة في الانتظار — اضغط حفظ.",
      "acct_save_image": "حفظ الصورة",
      "acct_image_saved": "تم تحديث الصورة الشخصية ✓",
      "acct_image_too_big": "حجم الصورة يجب أن لا يتجاوز 2 ميجابايت",
      "acct_image_encoded_too_big": "حجم الصورة المشفرة كبير جداً — اختر صورة أصغر",
      "acct_pwd_current": "كلمة المرور الحالية",
      "acct_pwd_new": "كلمة المرور الجديدة",
      "acct_pwd_confirm": "تأكيد كلمة المرور",
      "acct_pwd_min_hint": "8 أحرف على الأقل لكلمة المرور الجديدة.",
      "acct_pwd_all_required": "جميع الحقول مطلوبة",
      "acct_pwd_mismatch": "كلمة المرور الجديدة لا تتطابق",
      "acct_pwd_too_short": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      "acct_pwd_saved": "تم تغيير كلمة المرور ✓",
      "acct_pwd_error": "خطأ في تغيير كلمة المرور",
      "acct_save_password": "حفظ كلمة المرور",
      "acct_saved": "تم الحفظ",
      "acct_saving": "جاري الحفظ...",
      "staff_title": "موظفو الإدارة",
      "staff_subtitle": "أنشئ حسابات لموظفين إداريين ومنحهم صلاحيات محددة",
      "staff_add": "إضافة موظف",
      "staff_save": "حفظ",
      "staff_saving": "جاري الحفظ...",
      "staff_added": "تم إنشاء حساب الموظف ✓",
      "staff_perms_updated": "تم تحديث الصلاحيات ✓",
      "staff_deactivated": "تم تعطيل الحساب",
      "staff_full_name": "الاسم الكامل",
      "staff_username": "اسم المستخدم",
      "staff_password": "كلمة المرور",
      "staff_pwd_hint": "8 أحرف على الأقل",
      "staff_permissions": "الصلاحيات الممنوحة",
      "staff_col_name": "الاسم",
      "staff_col_username": "اسم المستخدم",
      "staff_col_permissions": "الصلاحيات",
      "staff_col_last_active": "آخر نشاط",
      "staff_col_status": "الحالة",
      "staff_col_actions": "إجراءات",
      "staff_active": "نشط",
      "staff_inactive": "معطل",
      "staff_edit_perms": "تعديل الصلاحيات",
      "staff_view_activity": "عرض النشاط",
      "staff_deactivate": "تعطيل",
      "staff_activity": "النشاط",
      "staff_empty": "لا يوجد موظفون بعد — أضف أول موظف",
      "staff_validation_required": "يرجى تعبئة الاسم واسم المستخدم وكلمة المرور",
      "staff_validation_pwd_short": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      "staff_validation_marital": "الحالة الاجتماعية غير صحيحة",
      "staff_phone": "رقم الجوال",
      "staff_position": "المنصب",
      "staff_position_placeholder": "مثال: سكرتير، محاسب",
      "staff_marital_status": "الحالة الاجتماعية",
      "staff_address": "العنوان",
      "staff_col_position": "المنصب",
      "staff_col_phone": "الجوال",
      "staff_email": "البريد الإلكتروني",
      "staff_edit_info": "تعديل البيانات",
      "staff_info_updated": "تم تحديث البيانات ✓",
      "staff_suspend": "تعليق",
      "staff_unsuspend": "تفعيل",
      "staff_suspended": "معلق",
      "staff_unsuspended": "تم تفعيل الحساب ✓",
      "staff_confirm_suspend": "هل تريد تعليق حساب {{name}}؟ لن يستطيع تسجيل الدخول.",
      "staff_confirm_unsuspend": "تفعيل حساب {{name}}؟",
      "staff_delete_permanent": "حذف نهائي",
      "staff_delete_warning": "سيُحذف حساب {{name}} نهائياً.",
      "staff_delete_irreversible": "لا يمكن التراجع عن هذا الإجراء.",
      "staff_delete_confirm": "تأكيد الحذف",
      "staff_deleting": "جاري الحذف...",
      "staff_deleted": "تم الحذف نهائياً",
      "attendance_stats_title": "إحصائيات الحضور",
      "attendance_overall_rate": "نسبة الحضور الإجمالية",
      "attendance_total_days": "أيام الدراسة",
      "attendance_present": "حضور",
      "attendance_absent": "غياب",
      "attendance_late": "تأخر",
      "attendance_excused": "إذن",
      "td_my_students": "طلابي",
      "td_present_today": "حاضرون اليوم",
      "td_absent_today": "غائبون اليوم",
      "td_assignments": "الواجبات",
      "td_my_subjects": "المواد التي أدرسها",
      "td_my_classes": "الصفوف التي أدرسها",
      "td_no_subjects": "لم يتم تحديد مواد لك",
      "td_no_classes": "لم يتم تحديد صفوف لك",
      "td_quick_actions": "إجراءات سريعة",
      "td_choose_class_hint": "يرجى اختيار صف دراسي من القائمة أعلاه لعرض قائمة الطلاب وتسجيل الحضور.",
      "td_record_attendance": "تسجيل الحضور",
      "td_enter_grades": "إدخال الدرجات",
      "td_add_assignment": "إضافة واجب",
      "td_my_schedule": "جدولي",
      "td_my_salaries": "رواتبي",
      "td_load_error": "خطأ في تحميل البيانات",
      "td_attendance_saved": "تم تسجيل الحضور",
      "td_attendance_save_error": "خطأ في تسجيل الحضور",
      "td_all_marked_present": "تم تسجيل جميع الطلاب حاضرين",
      "td_all_marked_absent": "تم تسجيل جميع الطلاب غائبين",
      "marital_single": "أعزب",
      "marital_married": "متزوج",
      "marital_divorced": "مطلق",
      "marital_widowed": "أرمل",
      "id_card_my_card": "بطاقتي",
      "id_card_print": "طباعة البطاقة",
      "id_card_print_hint": "اضغط زر «طباعة البطاقة» أعلاه لطباعتها على بطاقة بحجم بطاقة الائتمان.",
      "id_card_hide_photo": "إخفاء الصورة",
      "id_card_show_photo": "إظهار الصورة",
      "acct_image_remove": "حذف الصورة",
      "acct_image_remove_confirm": "هل أنت متأكد من حذف صورتك الشخصية؟",
      "acct_image_removed": "تم حذف الصورة الشخصية ✓",
      "id_card_academic_year": "العام الدراسي",
      "id_card_student_number": "رقم الطالب",
      "id_card_teacher_number": "رقم الموظف",
      "id_card_position": "المنصب",
      "id_card_subjects": "المواد",
      "id_card_class": "الصف",
      "id_card_grade": "المرحلة",
      "id_card_specialization": "التخصص",
      "staff_confirm_deactivate": "تعطيل حساب {{name}}؟ لن يستطيع تسجيل الدخول بعد ذلك.",
      "staff_welcome": "مرحباً {{name}} — حساب موظف إداري",
      "staff_dashboard_subtitle": "صلاحياتك تحدد ما يمكنك إدارته. تواصل مع مدير المدرسة للحصول على المزيد.",
      "staff_recent_activity": "آخر النشاطات",
      "staff_no_activity": "لا توجد نشاطات حديثة لعرضها",
      "staff_activity_unknown": "نشاط غير محدد",
      "staff_last_login": "آخر تسجيل دخول",
      "staff_menu_title": "القائمة",
      "close_menu": "إغلاق القائمة",
      "staff_role_label": "موظف إداري",
      "staff_no_permissions": "لا توجد صلاحيات ممنوحة بعد",
      "staff_denied": "غير مصرح لك بهذا الإجراء",
      "perm_manage_students": "إدارة الطلاب",
      "perm_manage_teachers": "إدارة المعلمين",
      "perm_manage_parents": "إدارة أولياء الأمور",
      "perm_manage_finance": "الشؤون المالية",
      "perm_manage_schedule": "الجداول الدراسية",
      "perm_manage_attendance": "الحضور والغياب",
      "perm_manage_grades": "الدرجات والتقييمات",
      "perm_manage_assignments": "مهام المعلمين",
      "perm_view_reports": "التقارير والإحصائيات",
      "perm_send_announcements": "الإعلانات",
      "nav_settings": "الإعدادات",
      "nav_my_schedule": "جدولي",
      "nav_my_grades": "درجاتي",
      "nav_my_assignments": "واجباتي",
      "nav_my_attendance": "حضوري",
      "nav_my_fees": "رسومي",
      "nav_my_students": "طلابي",
      "nav_my_parents": "أولياء الأمور",
      "nav_manage_homework": "تسيير الواجبات",
      "nav_change_photo": "تغيير الصورة",
      "nav_change_password": "تغيير كلمة المرور",
      "nav_ratings": "تقييمات المعلمين",
      "nav_teacher_tasks": "مهام المعلمين",
      "nav_profile": "الملف الشخصي",
      "nav_messages": "الرسائل",
      "nav_calendar": "التقويم",
      "nav_reset_codes": "رموز إعادة التعيين",
      "nav_smart_rankings": "الترتيب الذكي",
      "nav_class_analytics": "تحليل الصفوف",

      // Dashboard stats
      "stat_total_students": "إجمالي الطلاب",
      "stat_total_teachers": "إجمالي المعلمين",
      "stat_present_today": "حاضرون اليوم",
      "stat_absent_today": "غائبون اليوم",
      "stat_avg_grade": "المعدل العام",
      "stat_attendance_rate": "نسبة الحضور",
      "stat_total_fees": "إجمالي الرسوم",
      "stat_paid_fees": "المدفوع",
      "stat_pending_fees": "المتبقي",
      "stat_assignments": "الواجبات",
      "stat_warnings": "التحذيرات",

      // Table headers
      "th_name": "الاسم",
      "th_class": "الفصل",
      "th_status": "الحالة",
      "th_date": "التاريخ",
      "th_subject": "المادة",
      "th_score": "الدرجة",
      "th_actions": "الإجراءات",
      "th_amount": "المبلغ",
      "th_phone": "الهاتف",
      "th_email": "البريد",
      "th_type": "النوع",
      "th_month": "الشهر",

      // Common actions & messages
      "add_new": "إضافة جديد",
      "close": "إغلاق",
      "confirm": "تأكيد",
      "back": "رجوع",
      "refresh": "تحديث",
      "no_records": "لا توجد بيانات",
      "welcome": "مرحباً،",
      "your_school": "مدرستك",
      "change_lang": "تغيير اللغة",
      "trial_expires": "ينتهي النظام التجريبي خلال",
      "days": "أيام",
      "upgrade_now": "ترقية الآن ↑",
      "today_schedule": "جدول اليوم",
      "no_classes_today": "لا توجد حصص اليوم",
      "recent_grades": "آخر الدرجات",
      "weekly_schedule": "الجدول الأسبوعي",
      "no_schedule": "لا توجد حصص",
      "my_subjects": "المواد التي أدرسها",
      "send_message": "إرسال رسالة",
      "message_placeholder": "اكتب رسالتك هنا...",
      "sending": "جاري الإرسال...",
      "message_sent": "تم إرسال الرسالة بنجاح",

      // Attendance statuses
      "status_present": "حاضر ✓",
      "status_absent": "غائب ✗",
      "status_late": "متأخر",
      "mark_all_present": "كل حاضر",
      "mark_all_absent": "كل غائب",
      "save_attendance": "حفظ الحضور",
      "select_class_first": "اختر الفصل أولاً",
      "no_students_in_class": "لا يوجد طلاب في هذا الفصل",
      "select_class_to_show": "اختر الفصل لعرض قائمة الطلاب",
      "total_label": "المجموع",

      // Homework
      "hw_title": "الواجبات المنزلية",
      "hw_subtitle": "متابعة الواجبات والمهام الدراسية",
      "hw_new": "واجب جديد",
      "hw_title_ph": "عنوان الواجب *",
      "hw_subject_ph": "المادة",
      "hw_desc_ph": "تفاصيل الواجب...",
      "hw_filter_all": "الكل",
      "hw_filter_pending": "لم ينته",
      "hw_filter_overdue": "منتهي",
      "hw_due_today": "اليوم",
      "hw_days_left": "يوم",
      "hw_overdue_label": "منتهي",
      "hw_add": "إضافة الواجب",
      "hw_saving": "جاري الحفظ...",
      "hw_due_date": "موعد التسليم",
      "hw_empty": "لا توجد واجبات حالياً",

      // Fees
      "fee_total": "إجمالي الرسوم",
      "fee_paid_label": "المدفوع",
      "fee_remaining": "المتبقي",
      "fee_fully_paid": "مدفوع بالكامل",
      "fee_partial": "مدفوع جزئياً",
      "fee_unpaid": "غير مدفوع",
      "cfa_currency": "فرنك CFA",

      // Profile
      "profile_photo": "تغيير الصورة الشخصية",
      "choose_photo": "اختر صورة",
      "uploading": "جاري الرفع...",
      "current_password": "كلمة المرور الحالية",
      "new_password": "كلمة المرور الجديدة",
      "confirm_password": "تأكيد كلمة المرور",

      // Login page — inline strings replaced by t() [M-1]
      "login_access_subtitle": "سجّل دخولك للوصول إلى لوحة التحكم",
      "login_too_many": "تم تجاوز الحد الأقصى لمحاولات الدخول. انتظر دقيقة.",
      "login_attempts_warning": "تحذير: تبقّى لك {{n}} محاولات قبل القفل المؤقت",
      "secure_connection": "اتصال آمن ومشفر",

      // Password reset — inline strings replaced by t() [M-1]
      "reset_title": "استعادة كلمة المرور",
      "reset_step1": "أدخل اسم المستخدم",
      "reset_step2": "أدخل رمز الإعادة وكلمة المرور الجديدة",
      "reset_request": "طلب رمز الإعادة",
      "reset_confirm": "تغيير كلمة المرور",
      "reset_code_ph": "الرمز المؤقت (6 أرقام)",
      "reset_info": "سيتم إنشاء رمز مؤقت. تواصل مع مدير مدرستك للحصول عليه.",
      "reset_success_msg": "تم تغيير كلمة المرور بنجاح!",
      "reset_back": "العودة لتسجيل الدخول",
      "reset_have_code": "لديك رمز بالفعل؟",

      // PWA / Offline
      "skip": "تخطي",
      "offline_banner": "وضع عدم الاتصال — البيانات قد لا تكون محدثة",
      "pwa_install_title": "ثبّت تطبيق EduGate",
      "pwa_install_subtitle": "أضفه لشاشتك الرئيسية وافتحه كأي تطبيق — بدون متجر التطبيقات!",
      "pwa_install_action": "تثبيت التطبيق",
      "pwa_install_browser_hint": "استخدم Chrome أو Edge لتثبيت التطبيق",
      "pwa_ios_title": "ثبّت EduGate على iPhone",
      "pwa_ios_steps": "اضغط على زر المشاركة ثم اختر «إضافة إلى الشاشة الرئيسية»",
      "pwa_ios_share": "مشاركة",
      "pwa_ios_add": "إضافة",
      "pwa_update_available": "تحديث جديد متاح للتطبيق",
      "pwa_update_action": "إعادة التحميل",

      // Mobile / nav
      "menu": "القائمة",
      "open_menu": "فتح القائمة",

      // Excel import/export
      "excel_export_title": "تصدير البيانات",
      "excel_import_title": "استيراد البيانات",
      "excel_export_students": "تصدير الطلاب",
      "excel_export_teachers": "تصدير المعلمين",
      "excel_export_grades": "تصدير الدرجات",
      "excel_export_attendance": "تصدير الحضور",
      "excel_export_fees": "تصدير الرسوم",
      "excel_download_template": "تحميل نموذج Excel",
      "excel_help_toggle":        "ما هي الأعمدة المطلوبة؟",
      "excel_help_title":         "صيغة ملف الاستيراد",
      "excel_help_intro":         "اكتب أسماء الأعمدة في الصف الأول تماماً كما هي أدناه، ثم صفاً واحداً لكل شخص. أسهل طريقة: نزّل النموذج واملأه.",
      "excel_help_col_header":    "اسم العمود",
      "excel_help_col_required":  "إلزامي؟",
      "excel_help_col_format":    "الصيغة",
      "excel_help_col_example":   "مثال",
      "excel_help_required":      "إلزامي",
      "excel_help_optional":      "اختياري",
      "excel_help_note_headers":  "الأعمدة الاختيارية يمكن حذفها بالكامل. ترتيب الأعمدة غير مهم، المهم أسماؤها.",
      "excel_help_note_dates":    "التاريخ: اكتبه بصيغة YYYY-MM-DD (مثال: 2010-05-15). إذا نسّقت الخلية كتاريخ في Excel فسيُقرأ بشكل صحيح أيضاً.",
      "excel_help_note_lists":    "المواد والصفوف: افصل بينها بفاصلة (مثال: الرياضيات, الفيزياء).",
      "excel_help_note_detect":   "يتعرّف النظام تلقائياً على نوع الملف (طلاب أم معلمون) من أسماء الأعمدة، ويعرض النوع قبل الاستيراد لتتأكد.",
      "excel_help_note_duplicates": "اسم المستخدم يجب أن يكون فريداً. الأسماء المكرّرة تظهر كتحذير في المعاينة قبل الاستيراد.",
      "excel_detected_kind":      "نوع الملف المكتشف",
      "excel_detected_kind_hint": "تأكّد من النوع قبل التأكيد — سيتم إنشاء السجلات في هذا القسم.",
      "excel_fmt_text":     "نص",
      "excel_fmt_username": "حروف لاتينية وأرقام، بدون مسافات",
      "excel_fmt_password": "8 أحرف على الأقل",
      "excel_fmt_class":    "اسم الصف كما هو في النظام",
      "excel_fmt_date":     "YYYY-MM-DD",
      "excel_fmt_list":     "قائمة مفصولة بفاصلة",
      "excel_fmt_phone":    "أرقام، ويمكن أن تبدأ بـ +",
      "excel_fmt_email":    "بريد إلكتروني صالح",
      "excel_upload": "رفع ملف Excel",
      "excel_importing": "جاري الاستيراد...",
      "excel_preview": "معاينة قبل الاستيراد",
      "excel_confirm_import": "تأكيد الاستيراد",
      "excel_cancel_import": "إلغاء",
      "excel_empty_file": "الملف فارغ أو تنسيقه غير سليم",
      "excel_file_too_large": "الملف كبير جداً (الحد الأقصى {{max}} ميغابايت). قسّمه إلى ملفات أصغر.",
      "excel_read_error": "خطأ في قراءة الملف",
      "excel_row_incomplete": "صف غير مكتمل",
      "excel_duplicate_warning": "موجود مسبقاً",
      "excel_field_too_long": "الحقل \"{{field}}\" أطول من الحد المسموح ({{length}} من {{max}} حرف)",
      "excel_password_too_short": "كلمة المرور يجب أن تكون {{min}} أحرف على الأقل",
      "excel_password_too_long": "كلمة المرور لا يمكن أن تتجاوز {{max}} حرفاً",
      "excel_invalid_email": "بريد إلكتروني غير صالح: {{value}}",
      "excel_too_many_items": "عدد العناصر في \"{{field}}\" أكبر من الحد المسموح ({{count}} من {{max}})",
      "excel_rate_limited": "تم تجاوز الحد المسموح من الطلبات — انتظر دقيقة ثم أعد المحاولة",
      "excel_no_server_result": "لم يُرجع الخادم نتيجة لهذا الصف",
      "excel_created_count": "تم الإنشاء",
      "excel_skipped_count": "تم التخطي",
      "excel_reason": "السبب",
      "excel_sheet_template": "قالب",
      "excel_sheet_failed": "الأسطر المرفوضة",
      "excel_download_failed_rows": "تنزيل الصفوف الفاشلة",
      "excel_importing_progress": "جاري الاستيراد… {{done}} من {{total}}",
      "excel_teacher_pacing_note": "يتم استيراد المعلمين صفاً تلو الآخر لتفادي تجاوز حد الطلبات، وقد يستغرق ذلك حوالي {{seconds}} ثانية. لا تغلق الصفحة.",
      "excel_success_count": "نجح",
      "excel_failed_count": "فشل",
      "excel_more_errors": "أخطاء أخرى",
      "excel_school_name_header": "اسم المدرسة",
      "excel_export_date": "تاريخ التصدير",
      "excel_col_index": "#",
      "excel_col_student_number": "رقم الطالب",
      "excel_col_teacher_number": "رقم المعلم",
      "excel_col_full_name": "الاسم الكامل",
      "excel_col_username": "اسم المستخدم",
      "excel_col_class": "الصف",
      "excel_col_grade_level": "المرحلة",
      "excel_col_dob": "تاريخ الميلاد",
      "excel_col_status": "الحالة",
      "excel_col_subjects": "المواد",
      "excel_col_classes": "الصفوف",
      "excel_col_specialization": "التخصص",
      "excel_col_student_name": "اسم الطالب",
      "excel_col_subject": "المادة",
      "excel_col_assessment_type": "نوع التقييم",
      "excel_col_assessment_name": "اسم التقييم",
      "excel_col_score": "الدرجة",
      "excel_col_max_score": "الدرجة القصوى",
      "excel_col_percent": "النسبة",
      "excel_col_academic_year": "السنة الدراسية",
      "excel_col_date": "التاريخ",
      "excel_col_attendance_status": "الحالة",
      "excel_col_notes": "ملاحظات",
      "excel_col_amount": "المبلغ",
      "excel_col_paid": "المدفوع",
      "excel_col_remaining": "المتبقي",
      "excel_col_fee_type": "نوع الرسم",

      // Dark mode
      "switch_to_dark": "التبديل إلى الوضع الليلي",
      "switch_to_light": "التبديل إلى الوضع الفاتح",

      // [AUDIT-2026-05 feat: I18N-1] Super-admin platform overview + new SaaS UI.
      // The new components use the t(key, defaultValue) pattern so missing-key
      // warnings are silenced — but defining them here keeps i18next's missing-
      // key detector quiet and lets translators see the canonical Arabic.
      "sa_tab_platform":      "لوحة المنصة",
      "sa_tab_schools":       "المدارس",
      "sa_tab_subscriptions": "الاشتراكات",
      "sa_tab_messages":      "الرسائل",
      "sa_tab_system":        "حالة النظام",
      "sa_tab_reset_codes":   "رموز إعادة التعيين",
      "ay_current_year":      "العام الحالي",
      "ay_archived_label":    "مؤرشف",
      "sa_tab_settings":      "إعدادات المنصة",
      "sa_tab_account":       "إعدادات الحساب",
      "sa_stat_total_schools":  "إجمالي المدارس",
      "sa_stat_total_students": "إجمالي الطلاب",
      "sa_stat_total_teachers": "إجمالي المعلمين",
      "sa_stat_revenue_mtd":    "إيرادات الشهر",
      "sa_active":              "نشطة",
      "sa_trial":               "تجريبية",
      "sa_expired":             "منتهي",
      "sa_suspended":           "موقوف",
      "sa_alerts_title":          "التنبيهات",
      "sa_alert_expiring_7":      "تنتهي خلال 7 أيام",
      "sa_alert_expiring_30":     "تنتهي خلال 30 يوم",
      "sa_alert_new_mtd":         "مدرسة جديدة هذا الشهر",
      "sa_no_alerts":             "لا توجد تنبيهات حالية.",
      "sa_search_school":         "ابحث عن مدرسة...",
      "sa_all_plans":             "كل الخطط",
      "sa_plan_free": "مجاني",
      "sa_plan_basic": "أساسي",
      "sa_plan_pro": "احترافي",
      "sa_plan_enterprise": "مؤسسات",
      "sa_all_status":            "كل الحالات",
      "sa_status_active":    "نشط",
      "sa_status_trial":     "تجريبي",
      "sa_status_expired":   "منتهي",
      "sa_status_suspended": "موقوف",
      "sa_status_cancelled": "ملغى",
      "sa_col_name":      "المدرسة",
      "sa_col_plan":      "الخطة",
      "sa_col_status":    "الحالة",
      "sa_col_students":  "طلاب",
      "sa_col_teachers":  "معلمون",
      "sa_col_end_date":  "انتهاء الاشتراك",
      "sa_col_revenue":   "القيمة",
      "sa_col_actions":   "إجراءات",
      "sa_no_schools":    "لا توجد مدارس مطابقة",

      // Platform settings
      "ps_title":                  "إعدادات المنصة",
      "ps_general":                "عام",
      "ps_subscriptions":          "الاشتراكات والتنبيهات",
      "ps_welcome_email":          "بريد الترحيب",
      "ps_platform_name":          "اسم المنصة",
      "ps_contact_email":          "بريد التواصل",
      "ps_support_whatsapp":       "واتساب الدعم",
      "ps_default_currency":       "العملة الافتراضية للمدارس الجديدة",
      "ps_maintenance_mode":       "تفعيل وضع الصيانة",
      "ps_maintenance_active":     "وضع الصيانة مفعّل — يظهر شريط على لوحات المدارس.",
      "ps_trial_days":             "مدة التجربة (أيام)",
      "ps_trial_reminder_days":    "تذكير قبل انتهاء التجربة (أيام)",
      "ps_payment_reminder_days":  "تذكير الدفع (أيام قبل الاستحقاق)",
      "ps_welcome_subject":        "العنوان",
      "ps_welcome_body":           "النص",
      "ps_save":                   "حفظ الإعدادات",
      "ps_saved":                  "تم حفظ الإعدادات",
      "ps_save_failed":            "فشل الحفظ",
      "ps_load_failed":            "تعذّر تحميل الإعدادات",

      // Invoice
      "invoice_number_label":      "فاتورة رقم",
      "print_invoice":             "طباعة الفاتورة",
      "invoice_subtitle":          "منصة إدارة المدارس",
      "invoice_official":          "فاتورة رسمية",
      "invoice_billed_to":         "إلى",
      "invoice_issued_at":         "تاريخ الإصدار",
      "invoice_due_date":          "تاريخ الاستحقاق",
      "invoice_item_description":  "الخدمة",
      "invoice_item_qty":          "الكمية",
      "invoice_item_unit":         "السعر",
      "invoice_item_total":        "الإجمالي",
      "invoice_subtotal":          "المجموع الفرعي",
      "invoice_tax":               "الضريبة",
      "invoice_total":             "الإجمالي",
      "invoice_payment_methods":   "طرق الدفع",
      "invoice_payment_instructions": "تحويل بنكي · موبايل موني · نقداً عند الاستلام",
      "invoice_thank_you":         "شكراً لثقتكم في EduGate",
      "invoice_status_label":      "الحالة",
      "invoice_print_hint":        "صفحة A4 رأسية واحدة",
      "invoice_load_failed":       "تعذّر تحميل الفاتورة",

      // [I18N-2 2026-05-16] Common UI vocabulary added in the Task 1 audit.
      // Used by ad-hoc t(key, "arabic") calls across many components — the
      // canonical Arabic string lives here so future translators can see them
      // in one place. ~200 keys covering actions, status, educational terms,
      // finance, common messages, form labels, dialog text.

      // ── Actions ────────────────────────────────────────────────────────
      "action_save":         "حفظ",
      "action_cancel":       "إلغاء",
      "action_edit":         "تعديل",
      "action_delete":       "حذف",
      "action_add":          "إضافة",
      "action_create":       "إنشاء",
      "action_update":       "تحديث",
      "action_search":       "بحث",
      "action_confirm":      "تأكيد",
      "action_print":        "طباعة",
      "action_export":       "تصدير",
      "action_download":     "تحميل",
      "action_upload":       "رفع",
      "action_close":        "إغلاق",
      "action_view":         "عرض",
      "action_refresh":      "تحديث",
      "action_submit":       "إرسال",
      "action_send":         "إرسال",
      "action_reset":        "إعادة تعيين",
      "action_back":         "رجوع",
      "action_next":         "التالي",
      "action_previous":     "السابق",
      "action_yes":          "نعم",
      "action_no":           "لا",
      "action_ok":           "موافق",
      "action_select":       "اختر",
      "action_choose":       "اختيار",
      "action_open":         "فتح",
      "action_copy":         "نسخ",
      "action_share":        "مشاركة",
      "action_apply":        "تطبيق",
      "action_clear":        "مسح",

      // ── Status ─────────────────────────────────────────────────────────
      "status_active":       "نشط",
      "status_inactive":     "غير نشط",
      "status_suspended":    "موقوف",
      "status_expired":      "منتهي",
      "status_trial":        "تجريبي",
      "status_paid":         "مدفوع",
      "status_unpaid":       "غير مدفوع",
      "status_pending":      "معلق",
      "status_approved":     "مقبول",
      "status_rejected":     "مرفوض",
      "status_reviewed":     "مراجعة",
      "status_completed":    "مكتمل",
      "status_in_progress":  "قيد التنفيذ",
      "status_overdue":      "منتهي الصلاحية",
      "status_excused":      "مأذون",
      "status_draft":        "مسودة",
      "status_sent":         "مُرسل",
      "status_cancelled":    "ملغى",
      "status_submitted":    "مُسلَّم",
      "status_graded":       "مصحَّح",
      "status_not_submitted":"لم يُسلَّم",

      // ── Educational ────────────────────────────────────────────────────
      "term_student":        "طالب",
      "term_students":       "الطلاب",
      "term_teacher":        "معلم",
      "term_teachers":       "المعلمون",
      "term_parent":         "ولي الأمر",
      "term_parents":        "أولياء الأمور",
      "term_admin":          "مدير",
      "term_staff":          "موظف",
      "term_class":          "الفصل",
      "term_classes":        "الفصول",
      "term_grade":          "الصف",
      "term_subject":        "المادة",
      "term_subjects":       "المواد",
      "term_score":          "الدرجة",
      "term_attendance":     "الحضور",
      "term_absence":        "الغياب",
      "term_homework":       "الواجب",
      "term_assignment":     "الواجب",
      "term_assignments":    "الواجبات",
      "term_schedule":       "الجدول",
      "term_rating":         "التقييم",
      "term_ratings":        "التقييمات",
      "term_task":           "المهمة",
      "term_tasks":          "المهام",
      "term_announcement":   "الإعلان",
      "term_announcements":  "الإعلانات",
      "term_message":        "الرسالة",
      "term_messages":       "الرسائل",
      "term_school":         "المدرسة",
      "term_schools":        "المدارس",
      "term_date":           "التاريخ",
      "term_time":           "الوقت",
      "term_due_date":       "تاريخ الاستحقاق",
      "term_priority":       "الأولوية",
      "term_description":    "الوصف",
      "term_notes":          "ملاحظات",
      "term_title":          "العنوان",
      "term_name":           "الاسم",
      "term_full_name":      "الاسم الكامل",
      "term_phone":          "الهاتف",
      "term_email":          "البريد الإلكتروني",
      "term_address":        "العنوان",
      "term_gender":         "الجنس",
      "term_birth_date":     "تاريخ الميلاد",

      // ── Finance ────────────────────────────────────────────────────────
      "finance_fees":        "الرسوم",
      "finance_fee":         "رسوم",
      "finance_salary":      "الراتب",
      "finance_salaries":    "الرواتب",
      "finance_expense":     "مصروف",
      "finance_expenses":    "المصروفات",
      "finance_invoice":     "الفاتورة",
      "finance_invoices":    "الفواتير",
      "finance_receipt":     "الإيصال",
      "finance_payslip":     "كشف الراتب",
      "finance_subscription":"الاشتراك",
      "finance_payment":     "الدفع",
      "finance_payments":    "المدفوعات",
      "finance_amount":      "المبلغ",
      "finance_total":       "الإجمالي",
      "finance_subtotal":    "المجموع الفرعي",
      "finance_tax":         "الضريبة",
      "finance_currency":    "العملة",
      "finance_paid_amount": "المبلغ المدفوع",
      "finance_due_amount":  "المبلغ المستحق",
      "finance_discount":    "الخصم",

      // ── Messages / Toasts ──────────────────────────────────────────────
      "msg_saved":           "تم الحفظ بنجاح",
      "msg_deleted":         "تم الحذف بنجاح",
      "msg_updated":         "تم التحديث بنجاح",
      "msg_created":         "تم الإنشاء بنجاح",
      "msg_save_error":      "خطأ في الحفظ",
      "msg_delete_error":    "خطأ في الحذف",
      "msg_load_error":      "خطأ في التحميل",
      "msg_generic_error":   "حدث خطأ",
      "msg_fill_required":   "يرجى ملء جميع الحقول المطلوبة",
      "msg_confirm_delete":  "هل أنت متأكد من الحذف؟",
      "msg_confirm_action":  "هل أنت متأكد؟",
      "msg_no_data":         "لا توجد بيانات",
      "msg_loading":         "جار التحميل...",
      "msg_success":         "تم بنجاح",
      "msg_failed":          "فشلت العملية",
      "msg_unauthorized":    "غير مصرّح",
      "msg_not_found":       "غير موجود",
      "msg_network_error":   "خطأ في الاتصال بالشبكة",
      "msg_session_expired": "انتهت صلاحية الجلسة",
      "msg_permission_denied":"ليس لديك صلاحية",

      // ── Form & UI labels ──────────────────────────────────────────────
      "label_required":      "مطلوب",
      "label_optional":      "اختياري",
      "label_search_placeholder": "ابحث...",
      "label_select_option": "اختر...",
      "label_no_results":    "لا توجد نتائج",
      "label_show_more":     "عرض المزيد",
      "label_show_less":     "عرض أقل",
      "label_page":          "صفحة",
      "label_of":            "من",
      "label_total":         "المجموع",
      "label_count":         "العدد",
      "label_filters":       "المرشحات",
      "label_filter_by":     "تصفية حسب",
      "label_sort_by":       "ترتيب حسب",
      "label_all":           "الكل",
      "label_none":          "لا شيء",
      "label_today":         "اليوم",
      "label_yesterday":     "أمس",
      "label_this_week":     "هذا الأسبوع",
      "label_this_month":    "هذا الشهر",
      "label_last_30_days":  "آخر 30 يوم",
      "label_actions":       "إجراءات",
      "label_details":       "التفاصيل",
      "label_summary":       "الملخص",
      "label_overview":      "نظرة عامة",
      "label_settings":      "الإعدادات",
      "label_profile":       "الملف الشخصي",
      "label_logout":        "تسجيل الخروج",
      "label_login":         "تسجيل الدخول",
      "label_dashboard":     "لوحة التحكم",
      "label_reports":       "التقارير",
      "label_notifications": "الإشعارات",

      // ── Days / months ─────────────────────────────────────────────────
      "day_monday":          "الإثنين",
      "day_tuesday":         "الثلاثاء",
      "day_wednesday":       "الأربعاء",
      "day_thursday":        "الخميس",
      "day_friday":          "الجمعة",
      "day_saturday":        "السبت",
      "day_sunday":          "الأحد",

      // ── Common dialog headings ─────────────────────────────────────────
      "dialog_add_title":     "إضافة جديد",
      "dialog_edit_title":    "تعديل",
      "dialog_delete_title":  "تأكيد الحذف",
      "dialog_view_title":    "عرض التفاصيل",

      // ── Component-specific keys ────────────────────────────────────────
      "nav_activity_log":     "سجل النشاط",
      "td_choose_class":        "اختر الصف",
      "td_message_placeholder": "اكتب رسالتك هنا... مثال: لاحظت أن ابنك يحتاج إلى دعم إضافي في مادة الرياضيات...",
      "td_sending":             "جاري الإرسال...",
      "sd_unknown_sender":      "مرسل مجهول",
      "sd_school_admin":        "إدارة المدرسة",
      "pd_link_success":        "تم ربط الابن {{name}} بنجاح!",
      "pd_link_error":          "خطأ: تأكد من صحة رقم الطالب",
      "pd_total_children":      "إجمالي الأبناء",
      "pd_avg_attendance":      "متوسط الحضور",
      "pd_avg_grades":          "متوسط الدرجات",
      "pd_total_unpaid_fees":   "إجمالي الرسوم المتبقية",
      "fin_tab_student_fees":   "رسوم الطلاب",
      "fin_tab_teacher_salaries":"رواتب المعلمين",
      "fin_search_student":     "بحث عن طالب...",
      "fin_search_teacher":     "بحث عن معلم...",
      "fin_issue_receipt":      "إصدار إيصال",
      "fin_issue_payslip":      "إصدار كشف راتب",
      "pd_nav_overview":      "نظرة شاملة",
      "pd_nav_child_summary": "ملخص الابن/البنت",
      "lbl_grades":           "الدرجات",
      "sd_submit_homework":   "تسليم الواجب",
      "ttp_empty":            "لا توجد مهام إدارية حالياً.",
      "ttp_submit_task":      "تسليم المهمة",
      "ttp_submitted_at":     "تم التسليم في",
      "ttp_admin_feedback":   "ملاحظات الإدارة",
      "nav_my_tasks":         "مهامي الإدارية",

      // SchoolAdmin views (Students / Teachers / Parents / Dashboard)
      "sav_student_added":          "تم إضافة الطالب بنجاح! - رقم الطالب: {{number}}",
      "sav_add_student_desc":       "أدخل بيانات الطالب الجديد",
      "sav_student_number":         "رقم الطالب",
      "sav_validation_error":       "خطأ في البيانات:\n{{errors}}",
      "sav_grade_placeholder":      "مثال: التاسعة",
      "sav_confirm_delete_student": "هل أنت متأكد من حذف هذا الطالب؟",
      "sav_teacher_added":          "تم إضافة المعلم بنجاح! - رقم المعلم: {{number}}",
      "sav_add_teacher_desc":       "أدخل بيانات المعلم الجديد",
      "sav_academic_level":         "المستوى العلمي",
      "sav_choose_academic_level":  "اختر المستوى العلمي...",
      "sav_marital_status":         "الحالة الاجتماعية",
      "sav_choose_marital_status":  "اختر الحالة الاجتماعية...",
      "sav_multi_select_hint":      "(يمكن اختيار عدة مواد)",
      "sav_multi_select_classes_hint":"(يمكن اختيار عدة صفوف)",
      "sav_classes_label":          "الصفوف الدراسية",
      "sav_add_custom_subject":     "إضافة مادة غير موجودة بالقائمة...",
      "sav_serial_number":          "الرقم التسلسلي",
      "sav_confirm_delete_teacher": "هل أنت متأكد من حذف هذا المعلم؟",
      "sav_parent_updated":         "تم تحديث ولي الأمر بنجاح!",
      "sav_parent_added":           "تم إضافة ولي الأمر بنجاح!",
      "sav_add_error":              "خطأ في الإضافة",
      "sav_search_parent":          "بحث عن ولي أمر...",
      "sav_add_parent":             "إضافة ولي أمر",
      "sav_edit_parent":            "تعديل ولي أمر",
      "sav_add_parent_desc":        "أدخل بيانات ولي الأمر الجديد",
      "sav_edit_parent_desc":       "تحديث بيانات ولي الأمر وربط أبناء جدد أو تعديلهم",
      "sav_password_unchanged":     "اتركه فارغاً لعدم التغيير",
      "sav_link_children":          "ربط الأبناء (اختر الطلاب)",
      "sav_currently_linked":       "المرتبطون حالياً:",
      "sav_no_number":              "بدون رقم",
      "sav_name":                   "الاسم",
      "sav_children":               "الأبناء",
      "sav_phone":                  "الهاتف",
      "sav_children_count":         "{{count}} أبناء",
      "sav_confirm_delete_parent":  "هل أنت متأكد من حذف ولي الأمر هذا؟",
      "sav_time_now":               "الآن",
      "sav_time_min_ago":           "منذ {{count}} د",
      "sav_time_hour_ago":          "منذ {{count}} س",
      "edu_bachelor":   "بكالوريوس",
      "edu_master":     "ماجستير",
      "edu_phd":        "دكتوراه",
      "edu_diploma":    "دبلوم",
      "edu_other":      "أخرى",

      // Batch 2 admin tools: ResetCodesPanel / ActivityLogViewer / RatingsManager / ScheduleManagerComplete
      "rcp_title":       "طلبات إعادة تعيين كلمة المرور",
      "rcp_subtitle":    "انسخ الرمز وأعطه للمستخدم الذي طلب الإعادة",
      "rcp_empty":       "لا توجد طلبات معلّقة",
      "rcp_expires":     "ينتهي في",
      "rcp_copy":        "نسخ الرمز",
      "rcp_copied":      "تم النسخ!",
      "rcp_refresh":     "تحديث",
      "rcp_user":        "المستخدم",
      "rcp_code":        "الرمز المؤقت",
      "rcp_instruction": "أعطِ هذا الرمز للمستخدم. عليه أن يذهب إلى صفحة الدخول ← نسيت كلمة المرور ← إدخال الرمز.",

      "alv_cat_all":         "الكل",
      "alv_cat_attendance":  "الحضور",
      "alv_cat_grades":      "الدرجات",
      "alv_cat_finance":     "المالية",
      "alv_cat_users":       "المستخدمون",
      "alv_cat_messages":    "الرسائل",
      "alv_cat_settings":    "الإعدادات",
      "alv_cat_submissions": "التسليمات",
      "alv_cat_auth":        "المصادقة",
      "alv_load_error":      "خطأ في تحميل السجل",
      "alv_export_error":    "تعذّر التصدير",
      "alv_verify_ok":       "سجل سليم — الهاش متطابق",
      "alv_verify_fail":     "تحذير: الهاش غير متطابق — السجل قد يكون عُدِّل",
      "alv_verify_error":    "تعذّر التحقق",
      "alv_today_events":    "أحداث اليوم",
      "alv_last_7_days":     "آخر 7 أيام",
      "alv_most_active":     "الأكثر نشاطاً",
      "alv_last_event":      "آخر حدث",
      "alv_from_date":       "من تاريخ",
      "alv_to_date":         "إلى تاريخ",
      "alv_actor":           "المنفّذ",
      "alv_search":          "بحث",
      "alv_search_placeholder":"اسم، إجراء، وصف...",
      "alv_total_summary":   "إجمالي {{total}} حدث — يعرض {{from}}-{{to}}",
      "alv_no_events":       "0 حدث",
      "alv_export_csv":      "تصدير CSV",
      "alv_no_events_filter":"لا توجد أحداث للمعايير الحالية.",
      "alv_th_time":         "الوقت",
      "alv_th_action":       "الإجراء",
      "alv_th_entity":       "الكيان",
      "alv_th_description":  "الوصف",
      "alv_th_details":      "تفاصيل",
      "alv_dt_category":     "الفئة:",
      "alv_dt_before":       "قبل:",
      "alv_dt_after":        "بعد:",
      "alv_dt_hash": "البصمة:",
      "alv_verify":          "تحقّق",
      "alv_prev":            "السابق",
      "alv_next":            "التالي",
      "alv_page":            "صفحة {{num}}",

      "rm_load_error":    "خطأ في تحميل التقييمات",
      "rm_added":         "تم إضافة التقييم بنجاح",
      "rm_cat_teaching":      "التدريس",
      "rm_cat_discipline":    "الانضباط",
      "rm_cat_cooperation":   "التعاون",
      "rm_cat_commitment":    "الالتزام",
      "rm_cat_creativity":    "الإبداع",
      "rm_cat_academic":      "الأداء الأكاديمي",
      "rm_cat_behavior":      "السلوك",
      "rm_cat_participation": "المشاركة",
      "rm_cat_homework":      "الواجبات",
      "rm_cat_attendance":    "الحضور",
      "rm_rating_excellent": "ممتاز",
      "rm_rating_very_good": "جيد جداً",
      "rm_rating_good":      "جيد",
      "rm_rating_fair":      "مقبول",
      "rm_rating_weak":      "ضعيف",
      "rm_title_teachers":   "تقييمات المعلمين",
      "rm_title_students":   "تقييمات الطلاب",
      "rm_search_name":      "بحث بالاسم...",
      "rm_add_rating":       "إضافة تقييم",
      "rm_new_rating":       "تقييم جديد",
      "rm_choose_teacher":   "اختر المعلم",
      "rm_choose_student":   "اختر الطالب",
      "rm_choose":           "اختر...",
      "rm_category":         "الفئة",
      "rm_choose_category":  "اختر الفئة",
      "rm_notes":            "ملاحظات",
      "rm_notes_placeholder":"أضف ملاحظاتك هنا...",
      "rm_save_rating":      "حفظ التقييم",
      "rm_overall_avg":      "المتوسط العام",
      "rm_ratings_count":    "عدد التقييمات",
      "rm_rated_persons":    "الأشخاص المقيمون",
      "rm_ratings_count_label":"عدد التقييمات:",
      "rm_no_ratings_yet":   "لا توجد تقييمات بعد",
      "rm_view_history":     "عرض السجل الكامل ({{count}})",
      "rm_full_history":     "سجل التقييمات الكامل",
      "rm_rater":            "المُقيِّم:",
      "rm_date":             "التاريخ:",
      "rm_no_data":          "لا توجد بيانات للتقييم",

      "smc_updated":         "تم تحديث الجدول بنجاح",
      "smc_added":           "تم إضافة الجدول بنجاح",
      "smc_confirm_delete":  "هل أنت متأكد من حذف هذا الجدول؟",
      "smc_deleted":         "تم حذف الجدول بنجاح!",
      "smc_unspecified":     "غير محدد",
      "smc_conflict_confirm":"تحذير: يوجد {{count}} تعارض في هذا الجدول! هل تريد الحفظ على أي حال؟",
      "smc_conflict_teacher_two":"المعلم {{name}} لديه حصتان في نفس الوقت",
      "smc_conflict_class_two":  "الصف {{name}} لديه حصتان في نفس الوقت",
      "smc_teacher_busy":    "المعلم {{name}} مشغول في {{cls}} - {{subject}}",
      "smc_time_used_twice": "نفس الوقت {{time}} مستخدم في حصتين",
      "smc_pick_class":      "اختر صفاً لعرض جدوله الأسبوعي",
      "smc_conflicts_in":    "تعارضات في جدول {{cls}} ({{count}})",
      "smc_class_weekly":    "جدول {{cls}} الأسبوعي",
      "smc_print":           "طباعة",
      "smc_room":            "غرفة {{num}}",
      "smc_conflict":        "تعارض",
      "smc_title":           "الجداول الدراسية",
      "dir_title": "قاموس المدرسة",
      // [CLASSES-PORTAL 2026-10]
      "nav_classes": "الفصول الدراسية",
      "nav_subjects": "المواد الدراسية",
      "cp_title": "الفصول الدراسية",
      "cp_subtitle": "كل فصول المدرسة: طلابها، ومعلموها، وموادها، وجدولها",
      "cp_search": "ابحث عن فصل...",
      "cp_classes_count": "{{count}} فصل",
      "cp_students_total": "{{count}} طالب",
      "cp_students": "الطلاب",
      "cp_teachers": "المعلمون",
      "cp_subjects": "المواد",
      "cp_periods_week": "حصة في الأسبوع",
      "cp_no_timetable": "بلا جدول",
      "cp_tab_students": "الطلاب",
      "cp_tab_subjects": "المواد والمعلمون",
      "cp_tab_timetable": "الجدول",
      "cp_col_number": "الرقم",
      "cp_col_name": "الاسم",
      "cp_col_subject": "المادة",
      "cp_col_teacher": "المعلم",
      "cp_col_periods": "الحصص في الأسبوع",
      "cp_col_planned": "المخطط في المنهج",
      "cp_no_students": "لا يوجد طلاب في هذا الفصل",
      "cp_no_subjects": "لا توجد مواد لهذا الفصل بعد",
      "cp_no_timetable_long": "لم يُبنَ جدول هذا الفصل بعد",
      "cp_assigned_teachers": "معلمون مسنَدون إلى الفصل",
      "cp_not_scheduled": "ليس في الجدول بعد",
      "cp_load_error": "تعذّر تحميل الفصول",
      "cp_archived_note": "عام دراسي مؤرشف: الطلاب في فصولهم في ذلك العام، والمعلمون من جدوله",
      "cp_empty": "لا توجد فصول بعد",
      "sp_title": "المواد الدراسية",
      "sp_subtitle": "مواد المدرسة: من يدرّسها، وفي أي فصل، وحصصها في الجدول",
      "sp_search": "ابحث عن مادة...",
      "sp_custom": "خاصة بالمدرسة",
      "sp_classes": "الفصول",
      "sp_tab_overview": "المعلمون والفصول",
      "sp_tab_slots": "حصصها في الجدول",
      "sp_col_day": "اليوم",
      "sp_col_period": "الحصة",
      "sp_col_time": "الوقت",
      "sp_col_class": "الفصل",
      "sp_col_room": "القاعة",
      "sp_no_slots": "لا توجد حصص لهذه المادة في الجدول",
      "sp_on_record_only": "في ملفه، وليس في الجدول",
      "sp_no_teachers": "لا يوجد معلمون لهذه المادة",
      "sp_empty": "لا توجد مواد بعد",
      "sp_load_error": "تعذّر تحميل المواد",
      "cp_add_class": "إضافة فصل",
      "cp_new_class": "فصل جديد",
      "cp_new_class_hint": "اختر اسمًا من القائمة أو اكتب اسمًا حرًّا، ثم صِف الفصل إن أردت.",
      "cp_from_list": "من القائمة",
      "cp_free_name": "اسم حر",
      "cp_free_name_ph": "مثال: الأول الابتدائي - ذكور",
      "cp_class_name": "اسم الفصل",
      "cp_choose_class": "اختر الفصل",
      "cp_grade_level": "المرحلة",
      "cp_no_grade": "بدون مرحلة",
      "cp_label": "وصف الفصل",
      "cp_gender_none": "بدون وصف",
      "cp_gender_boys": "ذكور",
      "cp_gender_girls": "إناث",
      "cp_gender_mixed": "مختلط",
      "cp_filter_all": "الكل",
      "cp_create": "إنشاء",
      "cp_created": "تم إنشاء الفصل",
      "cp_saved": "تم الحفظ",
      "cp_save_error": "تعذّر الحفظ",
      "cp_delete_class": "حذف الفصل",
      "cp_delete_confirm": "حذف الفصل «{{name}}»؟",
      "cp_deleted": "تم حذف الفصل",
      "cp_boys_girls": "ذكور {{boys}} · إناث {{girls}}",
      "cp_col_gender": "الجنس",
      "cp_gender_clash": "لا يطابق وصف الفصل",
      "cp_col_assigned": "المعلم المسند",
      "cp_col_scheduled": "في الجدول",
      "cp_no_teacher": "بدون معلم",
      "cp_has_subject": "يدرّسها",
      "cp_add_subject": "إضافة مادة للفصل",
      "cp_choose_subject": "اختر المادة",
      "cp_add": "إضافة",
      "cp_remove": "إزالة",
      "cp_assigned_saved": "تم إسناد المادة",
      "cp_subject_removed": "أُزيلت المادة من الفصل",
      "cp_name_required": "اكتب اسم الفصل",
      "cp_rename": "إعادة التسمية",
      "cp_new_name": "الاسم الجديد للفصل",
      "cp_renamed": "تمت إعادة تسمية الفصل",
      "cp_rename_hint": "يتغيّر الاسم عند الطلاب وفي الجدول والدرجات والحضور والرسوم والواجبات والاختبارات لهذا العام. الأعوام المؤرشفة والكشوف الصادرة تبقى بالاسم القديم.",
      "sp_add_subject": "إضافة مادة",
      "sp_new_subject_ph": "اسم المادة الجديدة",
      "sp_added": "تمت إضافة المادة",
      "sp_delete": "حذف المادة",
      "sp_delete_confirm": "حذف المادة «{{subject}}» من قائمة المدرسة؟",
      "sp_deleted": "تم حذف المادة",
      "gender_unset": "غير محدد",
      "sav_gender_clash": "تنبيه: هذا الفصل موصوف «{{label}}». يمكنك الحفظ، لكن تأكد من الاختيار.",
      "dir_subtitle": "ابحث في الجدول والفصول: من يدرّس مادة ما ولأي فصل ومتى، والمعلم المسند لكل مادة، وماذا يدرّس معلم ما، وما الحصص الجارية في يوم وحصة، وطلاب كل فصل (ذكور وإناث) والمواد التي بلا معلم.",
      "dir_all_labels": "كل الأوصاف",
      "dir_classes_title": "الفصول",
      "dir_classes_count": "{{count}} فصل",
      "dir_col_boys_girls": "ذكور / إناث",
      "dir_col_open_subjects": "مواد بلا معلم",
      "dir_not_timetabled": "ليست في الجدول بعد",
      "dir_assigned_differs": "المعلم المسند غير معلم الجدول",
      "dir_tab_search": "البحث",
      "dir_tab_cover": "معلم بديل",
      "dir_tab_load": "نصاب المعلمين",
      "dir_tab_gaps": "قائمة النواقص",
      "dir_cover_mode_slot": "حصة معيّنة",
      "dir_cover_mode_absent": "معلم غائب",
      "dir_choose_day": "اختر اليوم",
      "dir_choose_period": "اختر الحصة",
      "dir_any_subject": "أي مادة",
      "dir_any_class": "أي فصل",
      "dir_choose_teacher": "اختر المعلم الغائب",
      "dir_cover_hint": "اختر اليوم والحصة لترى المعلمين المتفرغين فيها. اختيار المادة والفصل يقدّم الأنسب.",
      "dir_cover_hint_absent": "اختر اليوم والمعلم الغائب لترى حصصه في ذلك اليوم ومن يمكنه تغطية كل حصة.",
      "dir_cover_free": "المتفرغون: {{count}}",
      "dir_cover_busy": "المشغولون في هذه الحصة: {{count}}",
      "dir_teaches_subject": "يدرّس المادة",
      "dir_teaches_class": "يدرّس هذا الفصل",
      "dir_not_in_today": "ليس لديه حصص هذا اليوم",
      "dir_periods_today": "حصص اليوم: {{n}}",
      "dir_periods_week": "في الأسبوع: {{n}}",
      "dir_no_free": "لا يوجد معلم متفرغ في هذه الحصة",
      "dir_no_lessons": "لا حصص لهذا المعلم في هذا اليوم",
      "dir_show_all": "عرض الكل ({{count}})",
      "dir_show_less": "عرض أقل",
      "dir_load_teachers": "المعلمون",
      "dir_load_total": "مجموع الحصص",
      "dir_load_average": "متوسط الحصص للمعلم",
      "dir_load_heavy": "الأثقل أولاً",
      "dir_load_light": "الأخف أولاً",
      "dir_load_inactive": "غادر",
      "dir_col_periods_week": "حصص الأسبوع",
      "dir_col_classes": "الفصول",
      "dir_col_subjects": "المواد",
      "dir_col_not_timetabled": "مسندة وليست في الجدول",
      "dir_col_issue": "الملاحظة",
      "dir_col_detail": "التفاصيل",
      "dir_filter_all_gaps": "الكل ({{count}})",
      "dir_gaps_none": "لا توجد نواقص: كل مادة لها معلم، وكل فصل له جدول.",
      "dir_gaps_note": "من بيانات الفصول للسنة المختارة. الإسنادات تظهر في السنة النشطة فقط.",
      "dir_gap_no_teacher": "مادة بلا معلم",
      "dir_gap_teacher_mismatch": "المسند غير معلم الجدول",
      "dir_gap_no_timetable": "فصل بلا جدول",
      "dir_gap_periods_short": "حصص أقل من المنهج",
      "dir_gap_periods_over": "حصص أكثر من المنهج",
      "dir_gap_not_timetabled": "مسندة وليست في الجدول",
      "dir_gap_assigned": "المسند: {{name}}",
      "dir_gap_scheduled": "في الجدول: {{names}}",
      "dir_gap_planned": "مخطط {{planned}} · في الجدول {{actual}}",
      "dir_search_placeholder": "ابحث باسم معلم أو مادة أو قسم",
      "dir_all_subjects": "كل المواد",
      "dir_all_teachers": "كل المعلمين",
      "dir_all_classes": "كل الأقسام",
      "dir_all_days": "كل الأيام",
      "dir_all_periods": "كل الحصص",
      "dir_clear": "مسح",
      "dir_slots_title": "الحصص في الجدول",
      "dir_slots_count": "{{count}} حصة",
      "dir_weekly_title": "الحصص الأسبوعية لكل مادة في كل قسم",
      "dir_weekly_note": "عدد حصص الأسبوع كاملاً، لا يتغير باختيار يوم أو حصة.",
      "dir_subject_total": "{{count}} حصة أسبوعياً في المجموع",
      "dir_col_day": "اليوم",
      "dir_col_period": "الحصة",
      "dir_col_class": "القسم",
      "dir_col_subject": "المادة",
      "dir_col_teacher": "المعلم",
      "dir_col_room": "القاعة",
      "dir_col_per_week": "حصص الأسبوع",
      "dir_period_n": "الحصة {{n}}",
      "dir_no_results": "لا توجد حصص مطابقة في الجدول.",
      "dir_truncated": "النتائج كثيرة جداً وعُرض جزء منها فقط. ضيّق البحث.",
      "dir_load_error": "تعذر تحميل قاموس المدرسة",
      "smc_subtitle":        "إدارة شاملة لجداول جميع الفصول | الحصة = ساعة واحدة",
      "smc_conflicts_count": "{{count}} تعارض",
      "smc_no_conflicts":    "لا تعارضات",
      "smc_view_list":       "قائمة",
      "smc_view_weekly":     "جدول أسبوعي",
      "smc_add_schedule":    "إضافة جدول",
      "smc_conflicts_found": "تعارضات مكتشفة في الجداول ({{count}})",
      "smc_teacher_conflict":"تعارض معلم",
      "smc_class_conflict":  "تعارض صف",
      "smc_class_count":     "عدد الصفوف",
      "smc_total_schedules": "إجمالي الجداول",
      "smc_teachers_count":  "عدد المعلمين",
      "smc_week_days":       "أيام الأسبوع",
      "smc_filter_class":    "فلتر حسب الصف:",
      "smc_all_classes":     "جميع الصفوف",
      "smc_clear_filter":    "إلغاء الفلتر",
      "smc_print_schedule":  "طباعة جدول {{cls}}",
      "smc_on_day":          "يوم {{day}}",
      "smc_no_schedules":    "لا توجد جداول مسجلة",
      "smc_schedule_singular":"جدول دراسي",
      "smc_day":             "اليوم",
      "smc_choose_day":      "اختر اليوم",
      "smc_form_warn":       "تحذير: يوجد {{count}} تعارض!",
      "smc_period_n":        "• الحصة {{n}}",
      "smc_periods_header":  "الحصص الدراسية (كل حصة = ساعة)",
      "smc_add_period":      "إضافة حصة",
      "smc_period_num":      "الحصة {{n}}",
      "smc_time_full_hour":  "الوقت (ساعة كاملة)",
      "smc_choose_time":     "اختر الوقت",
      "smc_subject":         "المادة",
      "smc_choose_subject":  "اختر المادة",
      "smc_teacher_label":   "المعلم",
      "smc_choose_teacher":  "اختر معلم",
      "smc_room_number":     "رقم الغرفة",
      "smc_room_placeholder":"مثال: 101",
      "smc_no_periods_yet":  "لم تتم إضافة حصص بعد",
      "smc_save_with_conflict":"حفظ رغم التعارض ({{count}})",
      "smc_save_schedule":   "حفظ الجدول",

      // [I18N-LP 2026-05-16] LandingPage — every visible string.
      "lp_nav_features":      "المميزات",
      "lp_nav_roles":         "الأدوار",
      "lp_nav_pricing":       "الأسعار",
      "lp_nav_faq":           "الأسئلة",
      "lp_nav_login":         "تسجيل الدخول",
      "lp_nav_start_free":    "ابدأ مجاناً",
      "lp_lang_switch_title": "تغيير اللغة",
      "lp_mobile_start_free_90": "ابدأ مجاناً — 90 يوم",
      "lp_hero_badge":        "منصة إدارة المدارس الأولى في المنطقة",
      "lp_hero_title_1":      "إدارة مدرستك",
      "lp_hero_title_2":      "بكل سهولة وذكاء",
      "lp_hero_subtitle":     "منصة EduGate تجمع كل ما تحتاجه مدرستك — الطلاب، المعلمون، الدرجات، الحضور، الرسوم، والتواصل — في مكان واحد، من أي جهاز.",
      "lp_hero_cta_trial":    "ابدأ التجربة المجانية — 90 يوم",
      "lp_hero_cta_login":    "لديّ حساب — دخول",
      "lp_hero_check_1":      "90 يوم مجاناً كاملاً",
      "lp_hero_check_2":      "لا يلزم بطاقة بنكية",
      "lp_hero_check_3":      "إلغاء في أي وقت",
      "lp_stat_schools":      "مدرسة تثق بنا",
      "lp_stat_students":     "طالب مُدار",
      "lp_stat_uptime":       "وقت التشغيل",
      "lp_stat_trial":        "تجربة مجانية",
      "lp_stat_days_suffix":  "يوم",
      "lp_section_features_eyebrow":  "المميزات",
      "lp_section_features_title":    "كل ما تحتاجه في منصة واحدة",
      "lp_section_features_subtitle": "صُممت EduGate لتلبية احتياجات المدارس الحديثة من كل الأحجام.",
      "lp_section_roles_eyebrow":     "لمن هذا النظام؟",
      "lp_section_roles_title":       "منصة لكل أفراد المجتمع المدرسي",
      "lp_section_roles_subtitle":    "كل شخص في المدرسة لديه لوحة تحكم خاصة به، مصمّمة لاحتياجاته تحديداً.",
      "lp_feat_users_title":    "إدارة الطلاب والمعلمين",
      "lp_feat_users_desc":     "سجلات كاملة، ملفات تفصيلية، وربط تلقائي بين الطالب وولي أمره والمعلم.",
      "lp_feat_reports_title":  "تقارير شهرية وسنوية",
      "lp_feat_reports_desc":   "تقارير PDF جاهزة للطباعة: درجات، حضور، ماليات، وإحصائيات أداء فصلية.",
      "lp_feat_schedule_title": "الجداول والتقويم",
      "lp_feat_schedule_desc":  "بناء الجداول تلقائياً مع كشف التعارضات، وتقويم مدرسي شامل للفعاليات.",
      "lp_feat_comm_title":     "التواصل المباشر",
      "lp_feat_comm_desc":      "رسائل فورية بين جميع الأطراف — معلمين، طلاب، وأولياء أمور.",
      "lp_feat_attend_title":   "الحضور الذكي",
      "lp_feat_attend_desc":    "تسجيل الحضور يومياً مع إشعارات فورية لأولياء الأمور عند الغياب.",
      "lp_feat_finance_title":  "النظام المالي",
      "lp_feat_finance_desc":   "إدارة الرسوم والمدفوعات مع تقارير مالية شهرية وسنوية مفصّلة.",
      "lp_feat_export_title":   "تصدير PDF و Excel",
      "lp_feat_export_desc":    "تصدير كشوف الطلاب والدرجات والتقارير بصيغ PDF و Excel بضغطة واحدة.",
      "lp_feat_pwa_title":      "تطبيق موبايل PWA",
      "lp_feat_pwa_desc":       "ثبّت التطبيق على هاتفك مباشرةً — يعمل بدون إنترنت ويُشعرك بكل جديد.",
      "lp_feat_notif_title":    "إشعارات فورية",
      "lp_feat_notif_desc":     "لا يفوتك شيء — إشعارات للدرجات والغياب والرسائل والفعاليات.",
      "lp_role_super_title":    "مدير النظام",
      "lp_role_super_desc":     "يُشرف على النظام بالكامل — يدير المدارس المشتركة ويتابع الاشتراكات والإحصائيات الكلية.",
      "lp_role_super_features": ["عرض وإدارة جميع المدارس", "متابعة الاشتراكات والفترات التجريبية", "إحصائيات عامة للنظام", "إرسال رسائل لمدراء المدارس"],
      "lp_role_admin_title":    "مدير المدرسة",
      "lp_role_admin_desc":     "يُدير مدرسته بشكل كامل — الطلاب، المعلمون، الماليات، والتقارير الشهرية والسنوية.",
      "lp_role_admin_features": ["إضافة وإدارة الطلاب والمعلمين", "تقارير شهرية وسنوية مفصّلة", "إدارة الرسوم والمدفوعات", "التقويم المدرسي والإعلانات"],
      "lp_role_teacher_title":  "المعلم",
      "lp_role_teacher_desc":   "يُركّز على التدريس وإدارة فصله — يُسجّل الدرجات والحضور ويتواصل مع أولياء الأمور مباشرةً.",
      "lp_role_teacher_features":["تسجيل الدرجات والتقييمات", "الحضور والغياب اليومي", "مراسلة أولياء الأمور", "الجدول الأسبوعي الخاص به"],
      "lp_role_student_title":  "الطالب",
      "lp_role_student_desc":   "يتابع دراسته بكل سهولة — يرى درجاته وجداوله ويتواصل مع معلميه من أي جهاز.",
      "lp_role_student_features":["عرض الدرجات والتقييمات", "الجدول الدراسي الأسبوعي", "سجل الحضور الشخصي", "تلقّي إشعارات المعلمين"],
      "lp_role_parent_title":   "ولي الأمر",
      "lp_role_parent_desc":    "يُشارك في مسيرة أبنائه التعليمية — يتابع الدرجات والحضور ويتواصل مع المعلمين مباشرةً.",
      "lp_role_parent_features":["متابعة درجات الأبناء لحظياً", "تنبيهات الغياب فور حدوثه", "مراسلة المعلمين مباشرة", "تأكيد دفع الرسوم المدرسية"],
      "lp_reports_eyebrow":     "التقارير والإحصائيات",
      "lp_reports_title":       "تقارير ذكية لمدير المدرسة",
      "lp_reports_subtitle":    "احصل على صورة كاملة عن مدرستك لحظياً — تقارير شهرية وسنوية تلقائية عن الأداء الأكاديمي، الحضور، والماليات.",
      "lp_report_acad_title":   "تقرير الأداء الأكاديمي",
      "lp_report_acad_desc":    "متوسط الدرجات حسب الفصل والمادة والمعلم",
      "lp_report_attend_title": "تقرير الحضور الشهري",
      "lp_report_attend_desc":  "نسبة الحضور والغياب مع تحديد الطلاب الأكثر غياباً",
      "lp_report_finance_title":"التقرير المالي السنوي",
      "lp_report_finance_desc": "إجمالي الإيرادات، المتأخرات، والرسوم المُحصَّلة",
      "lp_report_top_title":    "تقرير المتميزين",
      "lp_report_top_desc":     "أفضل 10 طلاب وأكثر المعلمين تميّزاً",
      "lp_reports_card_school": "مدرسة النور • أبريل 2025",
      "lp_reports_card_title":  "التقرير الشهري",
      "lp_reports_stat_students":"إجمالي الطلاب",
      "lp_reports_stat_attend": "نسبة الحضور",
      "lp_reports_stat_avg":    "متوسط الدرجات",
      "lp_reports_stat_fees":   "الرسوم المُحصَّلة",
      "lp_reports_this_month":  "هذا الشهر",
      "lp_reports_class_perf":  "أداء الفصول — متوسط الدرجات",
      "lp_reports_export_label":"تصدير فوري",
      "lp_pricing_eyebrow":     "الأسعار",
      "lp_pricing_title":       "أسعار شفافة وبسيطة",
      "lp_pricing_subtitle":    "ابدأ مجاناً 3 أشهر كاملة، ثم اختر ما يناسب مدرستك.",
      "lp_plan_trial_name":     "تجريبي",
      "lp_plan_trial_price":    "مجاني",
      "lp_plan_trial_period":   "90 يوم كاملاً",
      "lp_plan_trial_features": ["حتى 100 طالب", "حتى 10 معلمين", "جميع المميزات الأساسية", "تقارير PDF", "دعم عبر الإيميل"],
      "lp_plan_basic_name":     "أساسي",
      "lp_plan_basic_period":   "/ نصف سنة — 90,000 FCFA / سنة",
      "lp_plan_basic_features": ["حتى 500 طالب", "حتى 30 معلماً", "تقارير شهرية وسنوية", "استيراد Excel", "دعم سريع 24/7"],
      "lp_plan_pro_name":       "احترافي",
      "lp_plan_pro_period":     "/ نصف سنة — 190,000 FCFA / سنة",
      "lp_plan_pro_features":   ["طلاب غير محدودين", "معلمون غير محدودين", "تطبيق موبايل PWA", "تقارير متقدمة", "دعم مخصص على مدار الساعة"],
      "lp_plan_popular_badge":  "الأكثر شيوعاً",
      "lp_plan_cta":            "ابدأ الآن",
      "lp_faq_eyebrow":         "الأسئلة الشائعة",
      "lp_faq_title":           "أسئلة يطرحها الجميع",
      "lp_faq_card_q":          "هل أحتاج بطاقة بنكية للتجربة؟",
      "lp_faq_card_a":          "لا، التجربة المجانية لمدة 90 يوماً كاملاً بدون بطاقة بنكية ولا أي التزام مالي.",
      "lp_faq_limits_q":        "كم عدد الطلاب الذي يدعمه النظام؟",
      "lp_faq_limits_a":        "الخطة الاحترافية تدعم عدداً غير محدود من الطلاب والمعلمين.",
      "lp_faq_secure_q":        "هل البيانات محمية وآمنة؟",
      "lp_faq_secure_a":        "نعم، جميع البيانات مشفّرة ومحفوظة بشكل آمن مع نسخ احتياطية تلقائية يومية.",
      "lp_faq_langs_q":         "هل يعمل النظام باللغة العربية فقط؟",
      "lp_faq_langs_a":         "يدعم النظام العربية والفرنسية والإنجليزية، مع دعم كامل للاتجاه من اليمين لليسار (RTL).",
      "lp_faq_import_q":        "كيف أنقل بيانات مدرستي الحالية؟",
      "lp_faq_import_a":        "يمكنك استيراد بيانات الطلاب من ملفات Excel بضغطة واحدة. فريقنا يساعدك مجاناً.",
      "lp_cta_title":           "ابدأ اليوم — مجاناً 90 يوماً",
      "lp_cta_subtitle":        "انضم للمدارس التي تدار بذكاء مع EduGate.\nلا بطاقة بنكية، لا التزامات.",
      "lp_cta_button":          "سجّل مدرستك الآن — مجاناً",
      "lp_cta_hint":            "يستغرق التسجيل أقل من دقيقتين",
      "lp_footer_rights":       "جميع الحقوق محفوظة. صُنع لمدارس المستقبل.",

      // ─── Batch 3: TaskSubmissionModal ───
      "tsm_max_files":          "الحد الأقصى {{count}} ملفات لكل تسليم",
      "tsm_unsupported_file":   "نوع الملف غير مدعوم: {{name}}",
      "tsm_file_too_large":     "الملف أكبر من 10 ميغابايت: {{name}}",
      "tsm_video_too_long":     "الفيديو أطول من 5 دقائق: {{name}}",
      "tsm_file_read_failed":   "فشل قراءة الملف: {{name}}",
      "tsm_describe_required":  "الرجاء إدخال وصف لما قمت به",
      "tsm_submitted_ok":       "تم التسليم بنجاح",
      "tsm_unexpected_error":   "خطأ غير متوقع",
      "tsm_describe_label":     "وصف ما قمت به *",
      "tsm_answer_label":       "الإجابة أو وصف العمل",
      "tsm_describe_placeholder":"اكتب وصفاً مفصلاً للعمل المُنجَز...",
      "tsm_answer_placeholder": "اكتب إجابتك هنا...",
      "tsm_attachments_label":  "المرفقات (اختياري) — صور / فيديو / PDF",
      "tsm_attachments_hint":   "حد أقصى {{count}} ملفات، حجم كل ملف ≤ 10MB، الفيديو ≤ 5 دقائق",
      "tsm_pick_files":         "اختر ملفات للرفع",
      "tsm_submitting":         "جارٍ التسليم...",
      "tsm_submit":             "تسليم",

      // ─── Batch 3: AssignmentSubmissionsView ───
      "asv_load_error":         "خطأ في التحميل",
      "asv_invalid_grade":      "الدرجة غير صالحة",
      "asv_graded_ok":          "تم تصحيح الواجب",
      "asv_grading_error":      "خطأ في التصحيح",
      "asv_title":              "تسليمات الواجب",
      "asv_stats_summary":      "{{submitted}} من {{total}} طالب سلّموا الواجب",
      "asv_graded_count":       "{{count}} مصحَّح",
      "asv_not_submitted":      "لم يُسلَّم",
      "asv_col_student":        "الطالب",
      "asv_col_status":         "الحالة",
      "asv_col_date":           "تاريخ التسليم",
      "asv_col_grade":          "الدرجة",
      "asv_col_actions":        "إجراءات",
      "asv_detail_title":       "تسليم: {{name}}",
      "asv_text_answer":        "الإجابة النصية",
      "asv_attachments_count":  "المرفقات ({{count}})",
      "asv_grade_label":        "الدرجة",
      "asv_max_label":          "الحد الأقصى",
      "asv_notes":              "ملاحظات",
      "asv_notes_placeholder":  "ملاحظات للطالب...",
      "asv_grade_btn":          "تصحيح",

      // ─── Batch 3: TeacherAssignmentsManager ───
      "tam_update_ok":          "تم تحديث الواجب بنجاح!",
      "tam_add_ok":             "تم إضافة الواجب بنجاح!",
      "tam_save_err":           "خطأ في حفظ الواجب",
      "tam_delete_confirm":     "هل أنت متأكد من حذف هذا الواجب؟",
      "tam_delete_ok":          "تم حذف الواجب بنجاح!",
      "tam_delete_err":         "خطأ في حذف الواجب",
      "tam_page_title":         "الواجبات والتكليفات",
      "tam_add_btn":            "إضافة واجب",
      "tam_view_submissions":   "عرض التسليمات",
      "tam_due":                "تاريخ التسليم: {{date}}",
      "tam_score_unit":         "{{score}} درجة",
      "tam_empty":              "لم تقم بإضافة أي واجبات بعد",
      "tam_edit_title":         "تعديل واجب",
      "tam_add_title":          "إضافة واجب جديد",
      "tam_title_label":        "عنوان الواجب *",
      "tam_title_placeholder":  "مثال: حل تمارين الوحدة الثانية",
      "tam_subject_label":      "المادة *",
      "tam_subject_select":     "اختر المادة",
      "tam_class_label":        "الصف *",
      "tam_class_select":       "اختر الصف",
      "tam_due_label":          "تاريخ التسليم *",
      "tam_score_label":        "الدرجة",
      "tam_desc_label":         "وصف الواجب *",
      "tam_desc_placeholder":   "اكتب تفاصيل الواجب هنا...",

      // ─── Batch 4: AccountSettings (SMS prefs) ───
      "acct_prefs_saved":       "تم حفظ التفضيلات",
      "acct_notification_prefs":"تفضيلات الإشعارات",
      "acct_notification_prefs_desc":"اختر القنوات الإضافية لتلقي إشعارات الغياب، الدرجات، الرسوم، والإعلانات العاجلة. لا تُرسَل أي رسائل بدون موافقتك.",
      "acct_sms_unavailable":   "خدمة الرسائل غير مفعّلة حالياً على الخادم. يمكنك حفظ تفضيلاتك الآن وستُفعَّل تلقائياً عند توفر الخدمة.",
      "acct_pref_sms":          "إشعارات SMS",
      "acct_pref_whatsapp":     "إشعارات واتساب",
      "acct_pref_phone":        "رقم الهاتف (بصيغة دولية، مثال: +21234567890)",
      "acct_pref_optin_note":   "يمكنك إلغاء الاشتراك في أي وقت.",

      // ─── Batch 4: NotificationBell ───
      "nb_title":               "الإشعارات",
      "nb_read_all":            "قراءة الكل",
      "nb_empty":               "لا توجد إشعارات",
      "nb_marked_all_read":     "تم تعليم الكل كمقروء",
      "nb_error":               "حدث خطأ",
      "nb_new_default":         "إشعار جديد",
      "nb_just_now":            "الآن",
      "nb_minutes_ago":         "منذ {{count}} دقيقة",
      "nb_hours_ago":           "منذ {{count}} ساعة",

      // ─── Batch 4: ReceiptCard ───
      "rc_load_failed":         "تعذّر تحميل الإيصال",
      "rc_receipt_number":      "إيصال رقم",
      "rc_print_btn":           "طباعة الإيصال",
      "rc_title":               "إيصال دفع",
      "rc_field_student":       "الطالب",
      "rc_field_class":         "الفصل",
      "rc_field_fee_type":      "نوع الرسوم",
      "rc_field_payment_method":"طريقة الدفع",
      "rc_field_payment_date":  "تاريخ الدفع",
      "rc_issued_by":           "صدر بواسطة",
      "rc_print_hint":          "اضغط طباعة الإيصال: يُطبع في نصف ورقة A4، وتتسع الورقة لإيصالين.",

      // ─── Batch 4: PayslipCard ───
      "slip_load_failed":         "تعذّر تحميل كشف الراتب",
      "slip_payslip_number":      "كشف رقم",
      "slip_print_btn":           "طباعة كشف الراتب",
      "slip_title":               "كشف راتب",
      "slip_field_month":         "الشهر",
      "slip_field_salary_type":   "نوع الراتب",
      "slip_basic_salary":        "الراتب الأساسي",
      "slip_bonuses":             "مكافآت",
      "slip_deductions":          "خصومات",
      "slip_net_salary":          "صافي الراتب",
      "slip_print_hint":          "اضغط طباعة كشف الراتب: يُطبع في نصف ورقة A4، وتتسع الورقة لكشفين.",

      // ─── Batch 5: SuperAdminDashboard ───
      "sad_school_updated_ok":   "تم تحديث المدرسة بنجاح!",
      "sad_update_error":        "خطأ في التحديث",
      "sad_account_required":    "أدخل اسم مستخدم جديد أو كلمة مرور جديدة على الأقل",
      "sad_password_mismatch":   "كلمة المرور وتأكيدها غير متطابقتين",
      "sad_account_updated":     "تم تحديث بيانات الحساب بنجاح",
      "sad_account_error":       "خطأ في تحديث الحساب",
      "sad_search_school":       "بحث عن مدرسة...",
      "sad_add_school_desc":     "أدخل تفاصيل المدرسة الجديدة أدناه.",
      "sad_serial_number":       "الرقم التسلسلي",
      "sad_actions":             "الإجراءات",
      "sad_delete_school_confirm":"هل أنت متأكد من حذف هذه المدرسة؟ سيتم تعطيل جميع المستخدمين المرتبطين بها.",
      "sad_school_deleted":      "تم حذف المدرسة بنجاح!",
      "sad_delete_error":        "خطأ في الحذف",
      "sad_account_settings_title":"إعدادات الحساب",
      "sad_account_settings_desc":"تغيير اسم المستخدم أو كلمة المرور",
      "sad_new_username_label":  "اسم المستخدم الجديد",
      "sad_keep_current_username":"(اتركه فارغاً للإبقاء على الحالي)",
      "sad_current_username_placeholder":"اسم المستخدم الحالي",
      "sad_keep_current_password":"(اتركها فارغة للإبقاء على الحالية)",
      "sad_save_changes":        "حفظ التغييرات",
      "sad_edit_school_title":   "تعديل بيانات المدرسة",
      "sad_edit_school_desc":    "قم بتعديل بيانات المدرسة الحالية واترك حقول كلمة المرور فارغة إذا لم ترد تغييرها.",
      "sad_keep_password_blank": "اتركه فارغاً للاحتفاظ بكلمة المرور الحالية",

      // ─── Batch 6: SchoolAdminClassAnalyticsView ───
      "cav_load_error":         "حدث خطأ أثناء تحميل بيانات الصفوف.",
      "cav_title":              "تحليل وتصنيف أداء الصفوف",
      "cav_desc":               "مقارنة الصفوف بالنتيجة الذكية لطلابها (المعدل السنوي ونسبة الحضور) في السنة الدراسية المختارة.",
      "cav_no_data":            "لا تتوفر بيانات كافية لعرض تحليل الصفوف بعد.",
      "cav_chart_title":        "مخطط مقارنة الصفوف",
      "cav_smart_avg":          "المتوسط الذكي",
      "cav_legend_best":        "قائمة الشرف ({{top}}% فأكثر)",
      "cav_legend_good":        "مستوى جيد",
      "cav_legend_weak":        "يحتاج تحسين (أقل من {{pass}}%)",
      "cav_col_rank":           "المركز",
      "cav_col_class":          "الصف",
      "cav_col_students":       "عدد الطلاب",
      "cav_col_avg":            "المتوسط الذكي",
      "cav_col_category":       "التصنيف",
      "cav_student_unit":       "طالب",
      "cav_badge_best":         "قائمة الشرف",
      "cav_badge_good":         "مستوى جيد",
      "cav_badge_weak":         "يحتاج تحسين",
      "cav_badge_no_data":      "لا توجد بيانات",

      // ─── Batch 6: SchoolAdminStaffAttendanceView ───
      "sav_load_error":         "خطأ",
      "sav_recorded_ok":        "تم تسجيل الحضور",
      "sav_updated_ok":         "تم تحديث الحضور",
      "sav_record_err":         "خطأ في تسجيل الحضور",
      "sav_title":              "حضور وغياب المعلمين",
      "sav_search_placeholder": "بحث عن معلم...",
      "sav_record_btn":         "تسجيل حضور",
      "sav_edit_title":         "تعديل حضور معلم",
      "sav_add_title":          "تسجيل حضور معلم",
      "sav_select_teacher":     "اختر المعلم",
      "sav_label_teacher":      "المعلم",
      "sav_label_date":         "التاريخ",
      "sav_label_status":       "الحالة",
      "sav_status_present":     "حاضر",
      "sav_status_absent":      "غائب",
      "sav_col_teacher":        "المعلم",
      "sav_col_date":           "التاريخ",
      "sav_col_status":         "الحالة",
      "sav_col_notes":          "ملاحظات",
      "sav_col_actions":        "إجراءات",
      "sav_delete_confirm":     "هل أنت متأكد من حذف هذا السجل؟",
      "sav_deleted_ok":         "تم الحذف بنجاح",
      "sav_delete_err":         "خطأ في الحذف",
      "sav_no_records":         "لا توجد سجلات حضور",

      // ─── P1 BATCH: FinanceSystemDetailed ───
      "fin_main_title":            "النظام المالي الشامل",
      "fin_partial_load_error":    "تعذّر تحميل جزء من البيانات المالية — بعض الأقسام قد تكون غير مكتملة.",
      "fin_main_subtitle":         "إدارة كاملة للرواتب والمصروفات والرسوم مع عرض تفصيلي لـ 12 شهراً",
      "fin_expected_fees":         "رسوم الطلاب المتوقعة",
      "fin_currency_franc":        "فرنك",
      "fin_collected_from_students":"المحصّل من الطلاب",
      "fin_total_salaries_card":   "إجمالي الرواتب",
      "fin_total_expenses_card":   "إجمالي المصروفات",
      "fin_summary_title":         "ملخص مالي",
      "fin_expected_revenue":      "إجمالي الإيرادات المتوقعة:",
      "fin_total_outflows":        "إجمالي المصروفات:",
      "fin_expected_net":          "الصافي المتوقع:",
      "fin_unpaid_fees":           "رسوم غير محصلة:",
      "fin_fees_records_title":    "سجلات رسوم الطلاب - السنة الدراسية {{year}}",
      "fin_add_fees_btn":          "إضافة رسوم",
      "fin_col_student":           "الطالب",
      "fin_col_class":             "الصف",
      "fin_col_total":             "الإجمالي",
      "fin_col_paid":              "المدفوع",
      "fin_col_remaining":         "المتبقي",
      "fin_salaries_records_title":"سجلات رواتب المعلمين - السنة الدراسية {{year}}",
      "fin_add_salary_btn":        "إضافة راتب",
      "fin_col_teacher":           "المعلم",
      "fin_col_specialization":    "التخصص",
      "fin_col_salaries_count":    "عدد الرواتب",
      "fin_default_teacher_label": "معلم",
      "fin_total_expenses_inline": "إجمالي المصروفات:",
      "fin_items_count":           "عدد البنود:",
      "fin_print_report":          "طباعة التقرير",
      "fin_add_expense_btn":       "إضافة مصروف",
      "fin_col_date":              "التاريخ",
      "fin_col_expense_type":      "نوع المصروف",
      "fin_col_description":       "الوصف",
      "fin_col_amount":            "المبلغ",
      "fin_col_payment_method":    "طريقة الدفع",
      "fin_col_actions":           "الإجراءات",
      "fin_no_expenses":           "لا توجد مصروفات مسجلة",
      "fin_role_student_label":    "طالب - {{class}}",
      "fin_role_teacher_label":    "معلم - {{spec}}",
      "fin_personal_info":         "المعلومات الشخصية",
      "fin_label_full_name":       "الاسم الكامل",
      "fin_label_email":           "البريد الإلكتروني",
      "fin_label_phone":           "الهاتف",
      "fin_label_class":           "الصف",
      "fin_label_level":           "المستوى",
      "fin_label_dob":             "تاريخ الميلاد",
      "fin_label_specialization":  "التخصص",
      "fin_label_subjects":        "المواد",
      "fin_label_classes":         "الصفوف",
      "fin_summary_card_title":    "الملخص المالي",
      "fin_total_fees":            "إجمالي الرسوم",
      "fin_total_salaries":        "إجمالي الرواتب",
      "fin_salaries_count":        "عدد الرواتب",
      "fin_12months_title":        "سجل الـ 12 شهراً التفصيلي - السنة الدراسية {{year}}",
      "fin_col_month":             "الشهر",
      "fin_col_status":            "الحالة",
      "fin_col_payment_date":      "تاريخ الدفع",
      "fin_col_type":              "النوع",
      "fin_col_notes":             "ملاحظات",
      "fin_current_month":         "الشهر الحالي",
      "fin_status_paid_full":      "مدفوع بالكامل",
      "fin_status_paid_partial":   "مدفوع جزئياً",
      "fin_status_unpaid":         "غير مدفوع",
      "fin_status_disbursed":      "تم الصرف",
      "fin_status_pending":        "معلق",
      "fin_no_record":             "لا يوجد سجل",
      "fin_amount_with_franc":     "{{value}} فرنك",
      "fin_attendance_summary":    "ملخص الحضور",
      "fin_grades_summary":        "ملخص الدرجات",
      "fin_assessment_type":       "نوع التقييم",
      "fin_grade_label":           "الدرجة",
      "fin_percentage":            "النسبة",
      "fin_subject_label":         "المادة",
      "fin_no_grades":             "لا توجد درجات مسجلة",
      "fin_form_employee":         "المعلم/الموظف *",
      "fin_form_salary_type":      "نوع الراتب *",
      "fin_form_amount":           "المبلغ *",
      "fin_form_month":            "الشهر *",
      "fin_form_payment_date":     "تاريخ التسديد",
      "fin_form_payment_method":   "طريقة الدفع",
      "fin_form_notes":            "ملاحظات",
      "fin_form_student":          "الطالب *",
      "fin_form_fee_type":         "نوع الرسوم *",
      "fin_form_total_amount":     "المبلغ الإجمالي *",
      "fin_form_paid_amount":      "المبلغ المدفوع",
      "fin_form_month_opt":        "الشهر",
      "fin_form_due_date":         "تاريخ الاستحقاق",
      "fin_form_expense_type":     "نوع المصروف *",
      "fin_form_amount_required":  "المبلغ *",
      "fin_form_date_required":    "التاريخ *",
      "fin_form_receipt_number":   "رقم الإيصال",
      "fin_form_description":      "الوصف *",

      // ─── Month names (used across finance/dashboards) ───
      // ─── P1 BATCH: ParentDashboard (additional) ───
      "pd_overview_title":         "نظرة شاملة على جميع الأبناء",
      "pd_registered_count":       "{{count}} أبناء مسجلون",
      "pd_sibling_badge":          "أخ/أخت",
      "pd_attendance_short":       "الحضور",
      "pd_avg_short":              "المعدل",
      "pd_remaining_short":        "متبقي",
      "pd_settled_short":          "مسدد",
      "pd_view_details":           "عرض التفاصيل",
      "pd_absences_count":         "{{count}} غياب",
      "pd_overall_summary":        "ملخص إجمالي لجميع الأبناء",
      "pd_single_child":           "ابن/بنت",
      "pd_plural_children":        "أبناء",
      "pd_my_children":            "أبنائي",
      "pd_link_new_child":         "ربط ابن جديد",
      "pd_loading_data":           "جاري تحميل البيانات...",
      "pd_welcome":                "مرحباً بك!",
      "pd_no_children":            "لم يتم ربط أي أبناء بحسابك بعد",
      "pd_msg_from_teachers":      "رسائل المعلمين",
      "pd_no_messages":            "لا توجد رسائل",
      "pd_messages_hint":          "ستظهر هنا رسائل المعلمين المتعلقة بأبنائك",
      "pd_school_teacher":         "معلم المدرسة",
      "pd_new_badge":              "جديد",
      "pd_select_child_hint":      "يرجى اختيار ابن/بنت من القائمة الجانبية",
      "pd_siblings_count":         "{{count}} أشقاء",
      "pd_id_label":               "رقم: {{value}}",
      "pd_overall_avg":            "المعدل العام",
      "pd_attendance_rate":        "نسبة الحضور",
      "pd_absent_days":            "أيام الغياب",
      "pd_remaining_fees":         "الرسوم المتبقية",
      "pd_recent_grades":          "آخر الدرجات",
      "pd_no_grades_short":        "لا توجد درجات",
      "pd_recent_attendance":      "آخر سجلات الحضور",
      "pd_no_records_short":       "لا توجد سجلات",
      "pd_attendance_for":         "سجل حضور {{name}}",
      "pd_attended":               "حضور",
      "pd_missed":                 "غياب",
      "pd_col_date":               "التاريخ",
      "pd_col_status":             "الحالة",
      "pd_col_notes":              "ملاحظات",
      "pd_no_attendance_records":  "لا توجد سجلات حضور",
      "pd_grades_for":             "درجات {{name}}",
      "pd_col_subject":            "المادة",
      "pd_col_assessment":         "التقييم",
      "pd_col_type":               "النوع",
      "pd_col_grade":              "الدرجة",
      "pd_col_percentage":         "النسبة",
      "pd_no_grades_recorded":     "لا توجد درجات مسجلة",
      "pd_fees_for":               "رسوم {{name}}",
      "pd_total_fees":             "إجمالي الرسوم",
      "pd_paid":                   "المدفوع",
      "pd_remaining":              "المتبقي",
      "pd_col_month":              "الشهر",
      "pd_col_amount":             "المبلغ",
      "pd_col_paid":               "المدفوع",
      "pd_fee_status_paid":        "مدفوع",
      "pd_fee_status_partial":     "جزئي",
      "pd_fee_status_unpaid":      "غير مدفوع",
      "pd_no_fees_recorded":       "لا توجد رسوم مسجلة",
      "pd_assignments_for":        "واجبات {{name}}",
      "pd_overdue_badge":          "منتهي",
      "pd_no_assignments":         "لا توجد واجبات حالياً",
      "pd_link_dialog_title":      "ربط ابن/بنت بحسابك",
      "pd_link_dialog_desc":       "أدخل رقم الطالب لربطه بحسابك. يمكنك الحصول على رقم الطالب من إدارة المدرسة.",
      "pd_link_by_school":         "لربط ابن بحسابك، تواصل مع إدارة المدرسة: هي وحدها من يمكنها ربط الطلاب بحسابات أولياء الأمور، حمايةً لبيانات الأطفال.",
      "pd_student_number_label":   "رقم الطالب *",
      "pd_student_number_placeholder":"مثال: 0001234",
      "pd_linking":                "جاري الربط...",
      "pd_link_btn":               "ربط الطالب",

      // ─── P1 BATCH: StudentDashboard ───
      "sd_today_schedule":         "جدول اليوم",
      "sd_no_classes_today":       "لا توجد حصص اليوم",
      "sd_weekly_schedule":        "جدولي الأسبوعي",
      "sd_no_classes":             "لا توجد حصص",
      "sd_no_classes_short":       "لا حصص",
      "sd_today_chip":             "اليوم",
      "sd_free_period":            "فراغ",
      "sd_prev_day":               "اليوم السابق",
      "sd_next_day":               "اليوم التالي",
      "sd_dashboard_subtitle": "إليك نظرة سريعة على أدائك وحضورك وجدولك اليوم.",
      "sd_no_grades_hint": "لا توجد درجات مسجلة لك حالياً في هذا الفصل الدراسي.",
      "sd_no_attendance_hint": "لم يتم العثور على أي سجلات حضور وغياب خاصة بك بعد.",
      "sd_no_fees_hint": "لم يتم العثور على أي رسوم مالية مسجلة باسمك بعد.",
      "sd_my_grades":              "درجاتي",
      "sd_finance_tab_title":      "المالية",
      "sd_teacher_feedback":       "ملاحظات المعلم",
      "sd_awaiting_grading":       "تم التسليم بتاريخ {{date}} — بانتظار التصحيح",
      "sd_print_report":           "طباعة التقرير",
      "sd_loading_short":          "جاري التحميل...",
      "sd_msg_inbox_hint":         "ستظهر هنا الرسائل الواردة من معلميك",
      "student_not_linked_title":  "حسابك غير مرتبط بسجل طالب",
      "student_not_linked_body":   "حسابك ليس مرتبطاً بسجل طالب في قاعدة البيانات. يرجى التواصل مع إدارة المدرسة لإكمال الربط.",
      "student_fetch_failed_body": "حدث خطأ أثناء تحميل بيانات الطالب. يرجى المحاولة مرة أخرى أو التواصل مع الإدارة.",
      "retry":                     "إعادة المحاولة",

      // ─── P1 BATCH: TeacherDashboard (additional) ───
      "td_msg_sent":               "تم إرسال الرسالة بنجاح",
      "td_msg_send_error":         "خطأ في إرسال الرسالة",
      "td_salaries_title":         "سجل الرواتب والمدفوعات",
      "td_view_payslip":           "عرض كشف الراتب",
      "td_issue_payslip":          "إصدار كشف",
      "td_no_salaries":            "لا توجد سجلات رواتب متاحة حالياً",
      "td_salaries_hint":          "عند إضافة راتب لك سيظهر هنا",
      "td_record_attendance_title":"تسجيل الحضور",
      "td_all_present":            "الكل حاضر",
      "td_all_absent":             "الكل غائب",
      "td_not_recorded":           "لم يسجل",
      "td_no_students_in_class":   "لا يوجد طلاب في هذا الصف",
      "td_subjects_i_teach":       "المواد التي أدرسها:",
      "td_col_day":                "اليوم",
      "td_col_time":               "الوقت",
      "td_no_schedule_yet":        "لم يتم تعيين جدول لك بعد",
      "td_schedule_admin_creates": "يقوم المدير بإنشاء الجدول وتعيينه",
      "td_my_students_title":      "طلابي",
      "td_message_parent":         "مراسلة ولي الأمر ({{name}})",
      "td_parent_not_linked":      "ولي الأمر غير مرتبط",
      "td_msg_to":                 "رسالة إلى: {{name}}",
      "td_msg_re":                 "بشأن: {{children}}",
      "td_msg_text":               "نص الرسالة",
      "td_previous_msgs":          "رسائل سابقة:",
      "td_send_msg":               "إرسال الرسالة",
      "teacher_no_classes_assigned":"لم يتم تخصيص أي صف لك بعد. يرجى التواصل مع إدارة المدرسة لإسناد الصفوف، ثم انقر على «تحديث».",

      // ─── P1 BATCH: GradesViewOnly ───
      "gvo_title":                 "سجل الدرجات",
      "gvo_subtitle":              "عرض شامل لدرجات الطلاب حسب الصف والمادة والاختبار والسنة الدراسية",
      "gvo_count":                 "عدد الدرجات",
      "gvo_passed":                "الناجحون",
      "gvo_filter_results":        "تصفية النتائج",
      "gvo_search_by_name":        "بحث باسم الطالب...",
      "gvo_all_classes":           "جميع الصفوف",
      "gvo_all_subjects":          "جميع المواد",
      "gvo_exam":                  "الاختبار",
      "gvo_all_exams":             "جميع الاختبارات",
      "gvo_academic_year_label":   "السنة الدراسية",
      "gvo_all_years":             "جميع السنوات",
      "gvo_view_for":              "عرض شامل: جميع طلاب {{cls}} في مادة {{subject}} — {{exam}}{{year}}",
      "gvo_not_entered":           "لم تُدخل بعد",
      "gvo_no_match":              "لا توجد درجات مطابقة للبحث",
      "gvo_try_filters":           "حاول تغيير الفلاتر أو اختر \"جميع\" لعرض الكل",
      "gvo_print_title":           "كشف الدرجات",
      "gvo_print_class":           "الصف",
      "gvo_print_subject":         "المادة",
      "gvo_print_exam":            "الاختبار",
      "gvo_print_year":            "السنة",
      "gvo_print_col_name":        "اسم الطالب",
      "gvo_print_col_score":       "الدرجة",
      "gvo_print_col_max":         "من",
      "gvo_print_col_pct":         "النسبة",
      "gvo_print_footer":          "تم الطباعة: {{date}}",

      // ─── P1 BATCH: DetailViews ───
      "dv_img_max_5mb":            "حجم الصورة يجب أن يكون أقل من 5MB",
      "dv_img_encoded_too_big":    "حجم الصورة المشفرة كبير جداً — الرجاء اختيار صورة أصغر",
      "dv_student_updated":        "تم تحديث بيانات الطالب بنجاح!",
      "dv_update_error":           "خطأ في تحديث البيانات",
      "dv_student_role_subtitle":  "طالب - {{cls}} - {{grade}}",
      "dv_username_readonly":      "اسم المستخدم (للقراءة فقط)",
      "dv_address":                "العنوان",
      "dv_medical_info":           "معلومات طبية",
      "dv_school_qr_card":         "البطاقة المدرسية الـ QR",
      "dv_qr_hint":                "استخدم هذا الرمز السريع (QR) لتسجيل الحضور، أو في الكافتيريا، أو استعارة الكتب من المكتبة. يمكن طباعته على البطاقة المدرسية.",
      "dv_student_card_print":     "بطاقة الطالب",
      "dv_id_print":               "الرقم: {{value}}",
      "dv_print_card":             "طباعة البطاقة",
      "dv_teacher_updated":        "تم تحديث بيانات المعلم بنجاح!",
      "dv_teacher_role_subtitle":  "معلم - {{spec}}",
      "dv_salaries_paid":          "رواتب مدفوعة",
      "dv_academic_subjects":      "المواد الدراسية",
      "dv_add_custom_subject":     "إضافة مادة غير موجودة بالقائمة...",
      "dv_academic_classes":       "الصفوف الدراسية",
      "dv_no_subjects":            "لم يتم تحديد المواد",
      "dv_no_classes_assigned":    "لم يتم تحديد الصفوف",
      "dv_no_notes":               "بدون ملاحظات",
      "dv_parent_updated":         "تم تحديث بيانات ولي الأمر بنجاح!",
      "dv_rel_father":             "أب",
      "dv_rel_mother":             "أم",
      "dv_rel_guardian":           "ولي أمر",
      "dv_default_parent_label":   "ولي أمر",
      "dv_children_count":         "{{count}} أبناء",
      "dv_relationship":           "صلة القرابة",
      "dv_link_more_children":     "ربط أبناء إضافيين (اختر الطلاب)",
      // [PHASE-4 2026-10] Profile drawers
      "pf_loading": "جارٍ تحميل الملف…",
      "pf_load_error": "تعذّر تحميل هذا الملف.",
      "pf_retry": "إعادة المحاولة",
      "pf_attendance_rate": "نسبة الحضور",
      "pf_attendance_breakdown": "حاضر {{present}} · متأخر {{late}} · غائب {{absent}} · بعذر {{excused}}",
      "pf_student_number": "رقم الطالب",
      "pf_guardians": "أولياء الأمور",
      "pf_no_guardians": "لا يوجد ولي أمر مرتبط",
      "pf_no_recent_grades": "لا توجد درجات لهذه السنة",
      "pf_periods_per_week": "حصص في الأسبوع",
      "pf_load_sub": "{{classes}} صفوف · {{subjects}} مواد",
      "pf_latest_rating": "آخر تقييم",
      "pf_no_rating": "لا يوجد تقييم بعد",
      "pf_documents": "الوثائق المحفوظة",
      "pf_timetable": "الجدول الأسبوعي",
      "pf_no_timetable": "لا توجد حصص مجدولة لهذه السنة",
      "pf_period": "الحصة {{n}}",
      "pf_room": "القاعة {{room}}",
      "dv_no_number":              "بدون رقم",
      "dv_children_label":         "الأبناء ({{count}})",
      "dv_no_children_linked":     "لم يتم ربط أي أبناء",

      // ─── P2 BATCH: SchoolAdminTeacherTasksView ───
      "sattv_status_reviewed":     "مراجعة",
      "sattv_load_submission_error":"خطأ في تحميل التسليم",
      "sattv_submission_approved": "تم قبول التسليم",
      "sattv_submission_rejected": "تم رفض التسليم",
      "sattv_review_error":        "خطأ في المراجعة",
      "sattv_task_added":          "تم إضافة المهمة بنجاح",
      "sattv_title":               "مهام المعلمين",
      "sattv_search_placeholder":  "بحث عن معلم أو مهمة...",
      "sattv_add_task":            "إضافة مهمة",
      "sattv_add_task_for_teacher":"إضافة مهمة للمعلم",
      "sattv_add_task_desc":       "أدخل تفاصيل المهمة الجديدة للمعلم",
      "sattv_pick_teacher":        "اختر المعلم *",
      "sattv_task_title_label":    "عنوان المهمة *",
      "sattv_task_title_placeholder":"مثال: تحضير خطة الدروس للأسبوع القادم",
      "sattv_task_desc_label":     "الوصف",
      "sattv_task_desc_placeholder":"تفاصيل المهمة...",
      "sattv_due_date":            "تاريخ الاستحقاق",
      "sattv_priority":            "الأولوية",
      "sattv_priority_low":        "منخفضة",
      "sattv_priority_medium":     "متوسطة",
      "sattv_priority_high":       "عالية",
      "sattv_add_task_btn":        "إضافة المهمة",
      "sattv_admin_note":          "ملاحظة: هنا تقوم بإعطاء مهام إدارية للمعلمين. أما الواجبات للطلاب فيديرها المعلم مباشرة.",
      "sattv_col_task":            "المهمة",
      "sattv_no_tasks":            "لا توجد مهام حالياً",
      "sattv_view_submission":     "عرض التسليم",
      "sattv_delete_confirm":      "هل أنت متأكد من حذف هذه المهمة؟",
      "sattv_submission_desc":     "وصف التسليم",
      "sattv_no_desc":             "(بدون وصف)",
      "sattv_admin_feedback":      "ملاحظات الإدارة",
      "sattv_admin_feedback_placeholder":"اكتب ملاحظاتك للمعلم...",
      "sattv_btn_reject":          "رفض",
      "sattv_btn_approve":         "قبول",
      "sattv_task_details":        "تفاصيل المهمة",
      "sattv_task_title_field":    "عنوان المهمة",
      "sattv_submission_status":   "حالة التسليم",
      "sattv_submitted_at":        "تم التسليم في",
      "sattv_open_review":         "فتح المراجعة",

      // ─── P2 BATCH: MessagingSystem ───
      "ms_load_error":             "خطأ في تحميل الرسائل",
      "ms_sent_to":                "تم إرسال الرسالة إلى {{name}}",
      "ms_send_error":             "خطأ في الإرسال",
      "ms_broadcast_default_subject":"رسالة جماعية",
      "ms_broadcast_ok":           "تم الإرسال الجماعي",
      "ms_broadcast_error":        "خطأ في الإرسال الجماعي",
      "ms_title":                  "الرسائل",
      "ms_unread_badge":           "{{count}} جديد",
      "ms_subtitle":               "تواصل مع أي شخص في النظام",
      "ms_compose":                "رسالة جديدة",
      "ms_sent_tab":               "المُرسَل",
      "ms_broadcast_tab":          "رسالة جماعية",
      "ms_inbox_empty":            "لا توجد رسائل في صندوق الوارد",
      "ms_broadcast_badge":        "جماعية",
      "ms_contacts":               "جهات الاتصال",
      "ms_search":                 "بحث...",
      "ms_no_contacts":            "لا توجد جهات اتصال",
      "ms_to_with_name":           "إلى: {{name}}",
      "ms_pick_contact":           "اختر جهة اتصال",
      "ms_subject_optional":       "الموضوع (اختياري)",
      "ms_subject_placeholder":    "موضوع الرسالة...",
      "ms_message_required":       "نص الرسالة *",
      "ms_message_placeholder":    "اكتب رسالتك هنا...",
      "ms_char_count":             "{{count}} حرف",
      "ms_no_sent":                "لا توجد رسائل مُرسلة",
      "ms_to_short":               "إلى:",
      "ms_broadcast_title":        "رسالة جماعية",
      "ms_broadcast_desc":         "أرسل رسالة واحدة لجميع أفراد مجموعة محددة",
      "ms_target_group":           "المجموعة المستهدفة *",
      "ms_pick_group":             "اختر المجموعة...",
      "ms_role_all":               "{{role}} (جميع)",
      "ms_broadcast_reach":        "ستصل هذه الرسالة لجميع {{role}} في مدرستك",
      "ms_subject":                "الموضوع",
      "ms_subject_example":        "مثال: اجتماع أولياء الأمور",
      "ms_broadcast_placeholder":  "اكتب نص الرسالة الجماعية هنا...",
      "ms_send_broadcast":         "إرسال الرسالة الجماعية",

      // ─── P2 BATCH: TeacherGradesEntry ───
      "tge_grade_updated":         "تم تحديث الدرجة بنجاح!",
      "tge_grade_added":           "تم إضافة الدرجة بنجاح!",
      "tge_save_error":            "خطأ في حفظ الدرجة",
      "tge_delete_confirm":        "هل أنت متأكد من حذف هذه الدرجة؟",
      "tge_grade_deleted":         "تم حذف الدرجة بنجاح!",
      "tge_delete_error":          "خطأ في حذف الدرجة",
      "tge_title":                 "إدخال الدرجات",
      "tge_add_grade":             "إضافة درجة",
      "tge_edit_grade_title":      "تعديل درجة",
      "tge_add_grade_title":       "إضافة درجة جديدة",
      "tge_student_required":      "الطالب *",
      "tge_pick_student":          "اختر الطالب",
      "tge_subject_required":      "المادة *",
      "tge_assessment_type_required":"نوع التقييم *",
      "tge_type_quiz":             "اختبار قصير",
      "tge_type_exam":             "امتحان",
      "tge_type_homework":         "واجب",
      "tge_type_project":          "مشروع",
      "assess_name_exam1":         "الاختبار الأول",
      "assess_name_exam2":         "الاختبار الثاني",
      "assess_name_exam3":         "الاختبار الثالث",
      "assess_name_oral":          "اختبار شفهي",
      "assess_name_project":       "مشروع",
      "assess_name_homework":      "واجب",
      "class_grade1_primary":      "الأول الابتدائي",
      "class_grade2_primary":      "الثاني الابتدائي",
      "class_grade3_primary":      "الثالث الابتدائي",
      "class_grade4_primary":      "الرابع الابتدائي",
      "class_grade5_primary":      "الخامس الابتدائي",
      "class_grade6_primary":      "السادس الابتدائي",
      "class_grade1_middle":       "الأول المتوسط",
      "class_grade2_middle":       "الثاني المتوسط",
      "class_grade3_middle":       "الثالث المتوسط",
      "class_grade1_high":         "الأول الثانوي",
      "class_grade2_high":         "الثاني الثانوي",
      "class_grade3_high":         "الثالث الثانوي",
      "day_sunday_full":           "الأحد",
      "day_monday_full":           "الإثنين",
      "day_tuesday_full":          "الثلاثاء",
      "day_wednesday_full":        "الأربعاء",
      "day_thursday_full":         "الخميس",
      "day_friday_full":           "الجمعة",
      "day_saturday_full":         "السبت",
      "subject_math":              "الرياضيات",
      "subject_arabic":            "اللغة العربية",
      "subject_french":            "اللغة الفرنسية",
      "subject_english":           "اللغة الإنجليزية",
      "subject_science":           "العلوم",
      "subject_history":           "التاريخ والجغرافيا",
      "subject_islamic":           "التربية الإسلامية",
      "subject_pe":                "التربية البدنية",
      "subject_art":               "التربية الفنية",
      "subject_computer":          "الإعلام الآلي",
      "val_paid":                  "مدفوع",
      "val_unpaid":                "غير مدفوع",
      "val_partial":               "جزئي",
      "val_present":               "حاضر",
      "val_absent":                "غائب",
      "val_late":                  "متأخر",
      "val_excused":               "بعذر",
      "val_single":                "أعزب",
      "val_married":               "متزوج",
      "val_divorced":              "مطلق",
      "val_widowed":               "أرمل",
      "val_bachelor":              "بكالوريوس",
      "val_master":                "ماجستير",
      "val_phd":                   "دكتوراه",
      "val_diploma":               "دبلوم",
      "val_highschool":            "ثانوية عامة",
      "val_father":                "أب",
      "val_mother":                "أم",
      "val_guardian":              "ولي أمر",
      "gr_title":                  "ترتيب الطلاب",
      "gr_tab":                    "ترتيب الفصل",
      "gr_select_class":           "اختر الفصل",
      "gr_select_year":            "كل السنوات",
      "gr_all_types":              "كل الأنواع",
      "gr_show":                   "عرض الترتيب",
      "gr_rank":                   "الترتيب",
      "gr_student":                "الطالب",
      "gr_subjects":               "المواد",
      "gr_overall":                "المعدل العام",
      "gr_no_data":                "لا توجد بيانات للترتيب",
      "gr_load_failed":            "فشل تحميل الترتيب",
      "tge_type_participation":    "مشاركة",
      "tge_assessment_name_required":"اسم التقييم *",
      "tge_pick_assessment_name":  "اختر اسم الاختبار",
      "tge_academic_year_required":"السنة الدراسية *",
      "tge_semester_required":     "الفصل الدراسي *",
      "tge_semester_1":            "الفصل الأول",
      "tge_semester_2":            "الفصل الثاني",
      "tge_semester_3":            "الفصل الثالث",
      "tge_score_required":        "الدرجة *",
      "tge_max_score_required":    "الدرجة الكاملة *",
      "tge_notes":                 "ملاحظات",

      // ─── P2 BATCH: SubscriptionManager ───
      "sm_plan_trial":             "تجريبي",
      "sm_plan_basic":             "أساسي",
      "sm_plan_professional":      "احترافي",
      "sm_plan_suspended":         "موقوف",
      "sm_inactive":               "غير نشط",
      "sm_trial_ended":            "انتهت التجربة",
      "sm_days_left":              "{{count}} أيام متبقية",
      "sm_trial_with_days":        "تجريبي ({{days}} يوم)",
      "sm_edit_title":             "تحديث اشتراك — {{name}}",
      "sm_plan_type":              "نوع الخطة",
      "sm_free":                   "مجاني",
      "sm_billing_cycle":          "مدة الاشتراك",
      "sm_semi_annual":            "نصف سنوي (6 أشهر)",
      "sm_annual":                 "سنوي (12 شهر)",
      "sm_extend_trial_label":     "تمديد التجربة (أيام إضافية)",
      "sm_max_students_label":     "حد الطلاب",
      "sm_max_teachers_label":     "حد المعلمين",
      "sm_account_status":         "حالة الحساب",
      "sm_updated":                "تم تحديث الاشتراك بنجاح",
      "sm_update_failed":          "فشل تحديث الاشتراك",
      "sm_extended_90":            "تم تمديد الفترة التجريبية 90 يوماً",
      "sm_extend_failed":          "فشل التمديد",
      "sm_kpi_total":              "إجمالي المدارس",
      "sm_kpi_trial":              "في فترة تجريبية",
      "sm_kpi_paid":               "اشتراك مدفوع",
      "sm_kpi_expiring_soon":      "تنتهي قريباً",
      "sm_kpi_expired":            "انتهت تجربتها",
      "sm_kpi_revenue":            "إيرادات نصف سنوية",
      "sm_filter_all":             "الكل",
      "sm_col_school":             "المدرسة",
      "sm_col_plan":               "الخطة",
      "sm_col_trial_end":          "انتهاء التجربة",
      "sm_col_limits":             "الحدود",
      "sm_no_results":             "لا توجد نتائج",
      "sm_days_left_d":            "{{count}} يوم متبقٍ",
      "sm_expired_ago":            "انتهت منذ {{count}} يوم",
      "sm_limits_inline":          "{{students}} طالب · {{teachers}} معلم",
      "sm_edit_btn":               "تعديل الاشتراك",
      "sm_extend_btn_title":       "تمديد 90 يوم",
      "sm_extend_short":           "تمديد",

      // ─── P2 BATCH: TeacherMessaging ───
      "tm_pick_student_error":     "اختر طالبًا",
      "tm_content_error":          "اكتب محتوى الرسالة",
      "tm_sent_to_student_parent": "تم إرسال الرسالة للطالب وولي أمره ✓",
      "tm_sent_to_student":        "تم إرسال الرسالة للطالب ✓",
      "tm_pick_class_error":       "اختر الفصل",
      "tm_sent_ok":                "تم الإرسال بنجاح",
      "tm_send_error":             "خطأ في الإرسال",
      "tm_target_all_students":    "كل الطلاب",
      "tm_target_all_parents":     "كل أولياء الأمور",
      "tm_target_class":           "فصل محدد",
      "tm_title":                  "إرسال رسالة",
      "tm_subtitle":               "أرسل رسالة لطالب محدد أو لمجموعة من الطلاب وأولياء أمورهم",
      "tm_mode_individual":        "طالب محدد",
      "tm_mode_bulk":              "رسالة جماعية",
      "tm_pick_student":           "اختر الطالب *",
      "tm_pick_student_option":    "-- اختر طالبًا --",
      "tm_notify_parent":          "إرسال نسخة لولي الأمر أيضًا",
      "tm_subject_label":          "الموضوع",
      "tm_subject_placeholder":    "موضوع الرسالة (اختياري)",
      "tm_message_text_label":     "نص الرسالة *",
      "tm_message_placeholder":    "اكتب رسالتك هنا...",
      "tm_char_count":             "{{count}} حرف",
      "tm_sending":                "جاري الإرسال...",
      "tm_send_btn":               "إرسال الرسالة",
      "tm_targets":                "المستهدفون",
      "tm_pick_class_option":      "-- اختر الفصل --",

      // ─── P2 BATCH: SchoolSettings ───
      "ss_no_school_id":           "خطأ: لم يتم العثور على معرّف المدرسة",
      "ss_saved":                  "تم حفظ إعدادات المدرسة بنجاح",
      "ss_unknown_error":          "خطأ غير معروف",
      "ss_save_error":             "خطأ في حفظ الإعدادات: {{detail}}",
      "ss_title":                  "إعدادات المدرسة",
      "ss_subtitle":               "خصص مدرستك واجعلها تعكس هويتك",
      "ss_currency_title":         "عملة المدرسة",
      "ss_currency_label":         "اختر العملة المستخدمة في المدرسة",
      "ss_currency_hint":          "سيتم استخدام هذه العملة في الرسوم والرواتب والمصاريف والإيصالات وكشوف الرواتب والفواتير ولوحات المعلومات.",
      "ss_second_language_title": "اللغة الثانية للوثائق",
      "ss_second_language_label": "اللغة التي تظهر بجانب العربية في كشوف الدرجات والشهادات",
      "ss_second_language_choose": "اختر اللغة الثانية",
      "ss_second_language_fr": "الفرنسية",
      "ss_second_language_en": "الإنجليزية",
      "ss_second_language_hint": "ستُطبع كشوف الدرجات والشهادات بالعربية وبهذه اللغة.",
      "ss_second_language_unset": "لم تُختر لغة ثانية بعد: ستُطبع كشوف الدرجات والشهادات بالعربية فقط حتى تختارها.",
      "ss_week_title":            "أيام الدوام الدراسي",
      "ss_week_hint":             "اختر الأيام التي تُدرَّس فيها الحصص في مدرستك. ستظهر هذه الأيام فقط عند إنشاء الجداول والاختبارات وتسجيل الحضور. يمكنك اختيار أي تركيبة، بما في ذلك الأنماط غير المنتظمة (مثل: الجمعة عطلة والسبت دوام).",
      "ss_week_presets":          "أنماط شائعة",
      "ss_week_days_label":       "أيام الدوام",
      "ss_week_none_selected":    "لم تختر أي يوم — لن يتم حفظ التغيير حتى تختار يوماً واحداً على الأقل.",
      "wd_preset_sat_wed":        "السبت – الأربعاء",
      "wd_preset_sun_thu":        "الأحد – الخميس",
      "wd_preset_mon_fri":        "الإثنين – الجمعة",
      "wd_preset_mon_sat":        "الإثنين – السبت",
      "smc_time_range":           "وقت الحصة (من – إلى)",
      "smc_time_start":           "من",
      "smc_time_end":             "إلى",
      "smc_time_suggestions":     "أوقات مقترحة",
      "smc_time_invalid":         "وقت غير صالح ({{time}}) — تأكد أن وقت النهاية بعد وقت البداية.",
      "smc_subject_add_new":      "إضافة مادة جديدة",
      "smc_subject_custom_placeholder": "اكتب اسم المادة",
      "ss_saved_short":            "تم الحفظ",
      "ss_saving":                 "جاري الحفظ...",
      "ss_default_name":           "اسم المدرسة",
      "ss_default_address":        "العنوان",
      "ss_basic_info":             "المعلومات الأساسية",
      "ss_name_ar":                "اسم المدرسة (عربي)",
      "ss_name_ar_placeholder":    "مدرسة النور الابتدائية",
      "ss_name_fr":                "اسم المدرسة (فرنسي)",
      "ss_name_fr_placeholder":    "École Primaire Al-Nour",
      "ss_email":                  "البريد الإلكتروني",
      "ss_phone":                  "رقم الهاتف",
      "ss_address":                "العنوان",
      "ss_address_placeholder":    "باماكو، مالي",
      "ss_theme_colors":           "ألوان الواجهة",
      "ss_primary_color":          "اللون الأساسي",
      "ss_preview_label":          "معاينة الألوان:",
      "ss_btn_primary":            "زر أساسي",
      "ss_btn_outline":            "زر خارجي",
      "ss_tips_title":             "نصائح لتخصيص مدرستك",
      "ss_tip_logo":               "• استخدم شعاراً واضحاً بخلفية شفافة (PNG)",
      "ss_tip_colors":             "• اللون الأساسي يظهر لوناً مميزاً في الإيصالات وكشوف الرواتب",
      // [PHASE-1b 2026-10] Settings audit
      "ss_section_identity": "هوية المدرسة والوثائق المطبوعة",
      "ss_section_money_language": "العملة واللغة",
      "ss_section_timetable": "أسبوع الدراسة والجدول",
      "ss_section_teacher_files": "ملفات المعلمين",
      "ss_address_on_receipt": "يُطبع العنوان على إيصالات الرسوم.",
      "ss_custom_subjects_title": "المواد المضافة",
      "ss_custom_subjects_hint": "تُضاف المادة هنا تلقائياً عند إسنادها لمعلم. يمكن حذفها فقط إذا لم يعد أي معلم يدرّسها.",
      "ss_custom_subjects_empty": "لا توجد مواد مضافة بعد.",
      "ss_custom_subjects_remove": "حذف المادة",
      "ss_custom_subjects_confirm": "حذف المادة «{{subject}}» من قائمة المدرسة؟",
      "ss_custom_subjects_removed": "حُذفت المادة.",
      "ss_primary_color_hint": "يُستخدم لوناً مميزاً في الإيصالات وكشوف الرواتب. لا يغيّر ألوان التطبيق.",
      "ss_logo_used_on": "يظهر الشعار والاسم العربي في الإيصالات وكشوف الرواتب وبطاقات الهوية.",

      // ─── P2 BATCH: AdminProfile ───
      "ap_profile_updated":        "تم تحديث الملف الشخصي بنجاح",
      "ap_unknown_error":          "خطأ غير معروف",
      "ap_save_error":             "خطأ في تحديث الملف الشخصي: {{detail}}",
      "ap_pwd_mismatch":           "كلمة المرور الجديدة غير متطابقة",
      "ap_pwd_too_short":          "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      "ap_pwd_changed":            "تم تغيير كلمة المرور بنجاح",
      "ap_pwd_change_error":       "خطأ في تغيير كلمة المرور",
      "ap_title":                  "الملف الشخصي",
      "ap_subtitle":               "إدارة معلوماتك الشخصية وإعدادات الأمان",
      "ap_personal_info":          "المعلومات الشخصية",
      "ap_full_name":              "الاسم الكامل",
      "ap_email":                  "البريد الإلكتروني",
      "ap_phone":                  "رقم الهاتف",
      "ap_role":                   "الدور",
      "ap_change_password":        "تغيير كلمة المرور",
      "ap_current_password":       "كلمة المرور الحالية",
      "ap_new_password":           "كلمة المرور الجديدة",
      "ap_confirm_password":       "تأكيد كلمة المرور",
      "ap_security_tips_title":    "🔐 نصائح أمنية",
      "ap_tip_strong":             "• استخدم كلمة مرور قوية تحتوي على أحرف وأرقام ورموز",
      "ap_tip_no_share":           "• لا تشارك كلمة المرور مع أي شخص",
      "ap_tip_rotate":             "• قم بتغيير كلمة المرور بشكل دوري",
      "ap_tip_logout":             "• تأكد من تسجيل الخروج عند استخدام أجهزة مشتركة",

      // ─── P2 BATCH: ReportsManager ───
      "rpm_load_error":            "خطأ في تحميل بيانات التقرير",
      "rpm_export_pdf_toast":      "جاري إعداد تقرير PDF...",
      "rpm_export_pdf_desc":       "سيُنزَّل الملف خلال ثوانٍ",
      "rpm_title":                 " التقارير والإحصائيات",
      "rpm_subtitle":              "تقارير شاملة عن أداء مدرستك",
      "rpm_period_monthly":        "شهري",
      "rpm_period_annual":         "سنوي",
      "rpm_export_pdf":            "تصدير PDF",
      "rpm_kpi_students":          "إجمالي الطلاب",
      "rpm_kpi_teachers":          "إجمالي المعلمين",
      "rpm_kpi_attendance":        "نسبة الحضور",
      "rpm_attendance_sub":        "{{present}} حاضر • {{absent}} غائب",
      "rpm_kpi_avg":               "متوسط الدرجات",
      "rpm_avg_sub":               "من {{count}} تقييم",
      "rpm_kpi_revenue":           "الإيرادات",
      "rpm_kpi_expenses":          "المصروفات",
      "rpm_kpi_net":               "صافي الربح",
      "rpm_class_perf_title":      "أداء الفصول",
      "rpm_class_perf_sub":        "متوسط الدرجات حسب الفصل",
      "rpm_no_grades_recorded":    "لا توجد درجات مسجّلة",
      "rpm_subject_perf_title":    "أداء المواد",
      "rpm_subject_perf_sub":      "متوسط الدرجات حسب المادة",
      "rpm_top_students_title":    "أفضل الطلاب",
      "rpm_top_students_sub":      "الطلاب الأعلى أداءً في هذه الفترة",
      "rpm_col_name":              "اسم الطالب",
      "rpm_col_avg":               "متوسط الدرجات",
      "rpm_col_rating":            "التقييم",
      "rpm_rating_excellent":      "ممتاز",
      "rpm_rating_very_good":      "جيد جداً",
      "rpm_rating_good":           "جيد",
      "rpm_warn_attendance":       "تحذير: نسبة الحضور منخفضة ({{rate}}%)",
      "rpm_warn_attendance_desc":  "يُنصح بمتابعة الحالات الغائبة ومراسلة أولياء الأمور المعنيين.",
      "rpm_warn_finance":          "تنبيه: المصروفات تتجاوز الإيرادات",
      "rpm_warn_finance_desc":     "راجع التقرير المالي التفصيلي وتحقق من المتأخرات في دفع الرسوم.",

      // ─── P2 BATCH: SchoolRegister ───
      "sr_school_name_required":   "اسم المدرسة مطلوب",
      "sr_pwd_mismatch":           "كلمتا المرور غير متطابقتين",
      "sr_pwd_too_short":          "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      "sr_generic_error":          "حدث خطأ، حاول مرة أخرى",
      "sr_tagline":                "سجّل مدرستك وابدأ التجربة المجانية",
      "sr_step_school":            "معلومات المدرسة",
      "sr_step_admin":             "حساب المدير",
      "sr_school_name":            "اسم المدرسة *",
      "sr_school_name_placeholder":"مثال: مدرسة النجاح الابتدائية",
      "sr_phone_optional":         "رقم الهاتف (اختياري)",
      "sr_trial_banner":           "90 يوماً مجاناً — بدون بطاقة بنكية",
      "sr_next":                   "التالي",
      "sr_back_landing":           "← العودة للصفحة الرئيسية",
      "sr_admin_full_name":        "الاسم الكامل للمدير *",
      "sr_admin_full_name_placeholder":"الاسم الكامل",
      "sr_admin_username":         "اسم المستخدم *",
      "sr_username_placeholder": "اسم المستخدم",
      "sr_admin_email":            "البريد الإلكتروني",
      "sr_admin_password":         "كلمة المرور *",
      "sr_admin_password_placeholder":"8 أحرف على الأقل",
      "sr_admin_password_confirm": "تأكيد كلمة المرور *",
      "sr_admin_password_confirm_placeholder":"أعد كتابة كلمة المرور",
      "sr_previous":               "← السابق",
      "sr_creating":               "جاري التسجيل...",
      "sr_create_account":         "إنشاء الحساب",
      "sr_success_title":          "تم التسجيل بنجاح",
      "sr_success_welcome":        "مرحباً بمدرستك في <strong>EduGate</strong>!",
      "sr_success_trial":          "تمتع بـ <strong>90 يوماً مجانياً</strong> كاملاً بدون أي قيود.",
      "sr_login_info":             "بيانات الدخول:",
      "sr_login_username":         "اسم المستخدم: <strong>{{username}}</strong>",
      "sr_login_role":             "الدور: <strong>مدير المدرسة</strong>",
      "sr_goto_login":             "انتقل لتسجيل الدخول",

      // SchoolCalendar
      "sc_title":                  "التقويم المدرسي",
      "sc_subtitle":               "اختبارات • إجازات • اجتماعات • أنشطة",
      "sc_type_exam":              "اختبار",
      "sc_type_holiday":           "إجازة",
      "sc_type_meeting":           "اجتماع",
      "sc_type_activity":          "نشاط",
      "sc_type_other":             "أخرى",
      "sc_title_required":         "العنوان مطلوب",
      "sc_event_added":            "تم إضافة الحدث",
      "sc_event_deleted":          "تم حذف الحدث",
      "sc_event_save_error":       "تعذّر حفظ الحدث — تحقق من الاتصال وحاول مرة أخرى",
      "sc_more_events":            "+{{count}} أخرى",
      "sc_event_types":            "أنواع الأحداث",
      "sc_upcoming":               "القادم",
      "sc_no_upcoming":            "لا توجد أحداث قادمة",
      "sc_add_event_header":       "إضافة حدث — {{day}} {{month}} {{year}}",
      "sc_event_title_label":      "عنوان الحدث *",
      "sc_event_title_placeholder":"مثال: اختبار الرياضيات",
      "sc_event_type_label":       "النوع",
      "sc_event_desc_label":       "وصف (اختياري)",
      "sc_event_desc_placeholder": "تفاصيل إضافية...",
      "day_sun_short":             "أح",
      "day_mon_short":             "اث",
      "day_tue_short":             "ث",
      "day_wed_short":             "أر",
      "day_thu_short":             "خ",
      "day_fri_short":             "ج",
      "day_sat_short":             "س",

      // PrintableReport
      "pr_title":                  "كشف النتائج المدرسي",
      "pr_student":                "الطالب",
      "pr_class":                  "الفصل",
      "pr_student_no": "الرقم",
      "pr_print_date":             "تاريخ الطباعة",
      "pr_grades":                 "الدرجات",
      "pr_subject":                "المادة",
      "pr_score":                  "الدرجة",
      "pr_type":                   "النوع",
      "pr_avg":                    "المعدل العام",
      "pr_attendance":             "سجل الحضور",
      "pr_att_rate":               "نسبة الحضور",
      "pr_fees":                   "المالية",
      "pr_total_fees":             "إجمالي الرسوم",
      "pr_paid":                   "المدفوع",
      "pr_remaining":              "المتبقي",
      "pr_edugete_tagline":        "EduGate — إدارة المدرسة",

      // SchoolAdminTrialBanner
      "tb_trial_expired":          "انتهت فترة التجربة المجانية! تواصل معنا لتفعيل الاشتراك.",
      "tb_trial_remaining":        "تبقّى {{count}} يوم من فترة التجربة المجانية (90 يوم).",
      "tb_trial_remaining_plural": "تبقّى {{count}} أيام من فترة التجربة المجانية (90 يوم).",
      "tb_upgrade":                "ترقية الحساب",
      "subscription_readonly_banner": "اشتراك مدرستك منتهٍ — وضع القراءة فقط. تواصل مع إدارة المنصة لتجديد الاشتراك.",
      "subscription_renew":           "تجديد الاشتراك",
      "subscription_readonly_tooltip":"غير متاح — اشتراك منتهٍ",
      // App-wide messages: axios interceptors, API errors, password rules [I18N 2026-10]
      "app_rate_limited": "لقد قمت بمحاولات كثيرة. الرجاء الانتظار قليلاً ثم المحاولة لاحقاً.",
      "app_server_unreachable": "تعذّر الاتصال بالخادم بعد عدة محاولات — تحقق من اتصالك ثم أعد المحاولة.",
      "app_readonly_toast": "اشتراك مدرستك منتهٍ — وضع القراءة فقط.",
      "app_offline_queued": "أنت غير متصل — سيتم إرسال هذا الإجراء عند عودة الاتصال",
      "app_queued_sent": "تم إرسال إجراء كان معلقاً ✓",
      "app_queued_failed": "فشل إرسال إجراء كان معلقاً — تم تجاهله",
      "api_err_generic": "حدث خطأ، يرجى المحاولة مجدداً",
      "api_err_network": "تعذّر الاتصال بالخادم — تأكد من تشغيل النظام",
      "api_err_401": "انتهت جلستك — يرجى إعادة تسجيل الدخول",
      "api_err_403": "ليس لديك صلاحية للقيام بهذا الإجراء",
      "api_err_404": "لم يتم العثور على البيانات المطلوبة",
      "api_err_422": "البيانات المُرسلة غير صحيحة — تحقق من الحقول",
      "api_err_429": "طلبات كثيرة جداً — انتظر لحظة وحاول مجدداً",
      "api_err_5xx": "خطأ في الخادم — يرجى المحاولة لاحقاً",
      "pwd_rule_min_length": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      "pwd_rule_letter": "يجب أن تحتوي كلمة المرور على حرف لاتيني واحد على الأقل",
      "pwd_rule_digit": "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",

      // PasswordStrength
      "pwd_strength_weak":         "ضعيف",
      "pwd_strength_fair":         "متوسط",
      "pwd_strength_good":         "جيد",
      "pwd_strength_strong":       "قوي جداً",

      // ErrorBoundary
      "eb_title":                  "حدث خطأ غير متوقع",
      "eb_message":                "نعتذر عن هذا الخطأ. يمكنك إعادة تحميل الصفحة أو العودة للصفحة الرئيسية.",
      "eb_reload":                 "إعادة التحميل",
      "eb_home":                   "الصفحة الرئيسية",

      // SessionTimeoutWarning
      "stw_expiring_now":          "ستنتهي جلستك الآن!",
      "stw_warning_title":         "تحذير: انتهاء الجلسة",
      "stw_urgent_message":        "ستُغلق الجلسة تلقائياً خلال ثوانٍ. احفظ عملك فوراً.",
      "stw_logout":                "خروج",

      // PDFReports
      "pdfr_title":                "تصدير تقارير PDF",
      "pdfr_subtitle":             "اطبع أو احفظ التقارير بصيغة PDF",
      "pdfr_roster":               "كشف الطلاب",
      "pdfr_grades":               "تقرير الدرجات",
      "pdfr_attendance":           "تقرير الحضور",
      "pdfr_generating":           "جاري إنشاء الملف...",
      "pdfr_roster_hint": "قائمة طلاب الصف (PDF)",
      "pdfr_grades_hint": "كشف الدرجات (PDF)",
      "pdfr_attendance_hint": "تقرير الحضور (PDF)",
      "pdfr_attendance_none": "لا يوجد حضور مسجّل لهذا الفصل في هذا اليوم.",

      // ProgressChart

      // BulkMessaging
      "bm_title":                  "رسائل جماعية",
      "bm_subtitle":               "أرسل رسالة واحدة إلى مئات المستخدمين",
      "bm_target_all_parents":     "كل أولياء الأمور",
      "bm_target_all_teachers":    "كل المعلمين",
      "bm_target_all_students":    "كل الطلاب",
      "bm_target_class":           "فصل محدد",
      "bm_subject":                "الموضوع",
      "bm_target":                 "المستهدفون",
      "bm_message":                "نص الرسالة",
      "bm_send":                   "إرسال الرسالة",
      "bm_sending":                "جاري الإرسال...",
      "bm_sent_to":                "أُرسلت إلى {{count}} مستخدم",
      "bm_chars":                  "حرف",

      // GlobalSearch
      "gs_quick_search":           "بحث سريع...",
      "gs_placeholder":            "ابحث عن أرقام، أسماء، مُعرفات...",
      "gs_start_typing":           "اكتب للبحث السريع في النظام...",
      "gs_no_results":             "لا توجد نتائج مطابقة لـ \"{{query}}\"",
      "gs_check_spelling":         "تأكد من كتابة الاسم أو المعرف بشكل صحيح.",
      "gs_students":               "الطلاب",
      "gs_teachers":               "المعلمون",
      "gs_parents":                "أولياء الأمور",
      "gs_schools":                "المدارس",
      "gs_class_label":            "الفصل",

      // StudentAnalyticsChart
      "sac_error_fetch":           "حدث خطأ أثناء جلب بيانات تحليل الطالب.",
      "sac_no_data":               "لم يتم العثور على بيانات",
      "sac_back":                  "عودة",
      "sac_class_label":           "الصف",
      "sac_continuous_eval":       "التقييم الذكي المستمر",
      "sac_back_to_list":          "رجوع للقائمة",
      "sac_grades_analysis":       "تحليل مستوى الامتحانات والواجبات",
      "sac_attendance_level":      "مستوى الحضور والانضباط",
      "sac_grade":                 "الدرجة",
      "sac_attendance_points":     "نقاط الحضور",
      "sac_not_enough":            "لا تتوفر أرقام أو سجلات كافية لرسم منحنى الأداء لهذا الطالب حتى الآن.",

      // SystemStatus
      "ssy_fetch_error":           "فشل في جلب حالة النظام",
      "ssy_checking":              "جاري فحص حالة النظام...",
      "ssy_retry":                 "إعادة المحاولة",
      "ssy_health_label":          "حالة النظام",
      "ssy_stable":                "مستقر",
      "ssy_problem":               "توجد مشكلة",
      "ssy_last_update":           "آخر تحديث",
      "ssy_db":                    "قاعدة البيانات",
      "ssy_db_connected":          "متصلة",
      "ssy_db_disconnected":       "غير متصلة",
      "ssy_logins_24h":            "تسجيل الدخول (24س)",
      "ssy_logins_success":        "{{count}} ناجحة",
      "ssy_failed_24h":            "محاولات فاشلة (24س)",
      "ssy_logins_failed":         "{{count}} محاولة",
      "ssy_locked_24h":            "حسابات مقفلة (24س)",
      "ssy_locked_accounts":       "{{count}} حساب",
      "ssy_totals_title":          "إحصائيات النظام الشاملة",
      "ssy_total_schools":         "إجمالي المدارس النشطة",
      "ssy_total_students":        "إجمالي الطلبة",
      "ssy_total_teachers":        "إجمالي المعلمين",
      "ssy_total_users":           "إجمالي المستخدمين",

      // EarlyWarningPanel — نظام الإنذار المبكر [FEAT-2026-09]
      "nav_early_warning":         "الإنذار المبكر",
      "ew_title":                  "نظام الإنذار المبكر",
      "ew_subtitle":               "الطلاب الذين يحتاجون متابعة الآن — مرتّبون حسب الأولوية، مع الأسباب والأرقام الفعلية وراء كل تنبيه.",
      "ew_search":                 "ابحث باسم الطالب أو الصف...",
      "ew_error":                  "تعذّر جلب قائمة الإنذار المبكر. يرجى المحاولة لاحقاً.",
      "ew_level_high":             "أولوية عالية",
      "ew_level_medium":           "أولوية متوسطة",
      "ew_level_low":              "للمتابعة",
      "ew_count_high":             "{{n}} حالة ذات أولوية عالية",
      "ew_count_medium":           "{{n}} حالة ذات أولوية متوسطة",
      "ew_empty_title":            "لا توجد حالات تستدعي المتابعة",
      "ew_empty_hint":             "لم يظهر أي طالب مؤشرات غياب أو تراجع دراسي في السنة الدراسية الحالية. تظهر الحالات هنا تلقائياً فور رصدها.",
      "ew_no_match":               "لا توجد نتائج مطابقة لبحثك.",
      "ew_unnamed":                "طالب",
      "ew_reason_absence_rate":    "نسبة غياب {{rate}}% ({{absent}} من أصل {{total}} يوم مسجّل).",
      "ew_reason_absence_streak":  "{{days}} أيام غياب متتالية منذ {{since}}.",
      "ew_reason_failing_average":"المعدل السنوي {{average}}% — دون حدّ النجاح {{pass}}%.",
      "ew_reason_declining":       "تراجع بمقدار {{drop}} نقطة: من {{before}}% في الفصل {{from}} إلى {{after}}% في الفصل {{to}}.",
      "ew_reason_unpaid_fees":     "رسوم غير مسدّدة بقيمة {{amount}}.",

      // SmartRankings
      "smr_rankings_error":        "حدث خطأ أثناء جلب قائمة الترتيب. يرجى المحاولة لاحقاً.",
      "smr_honor_roll":            "قائمة الشرف",
      "smr_needs_improvement":     "يحتاج تحسين",
      "smr_good_level":            "مستوى جيد",
      "smr_title":                 "النظام الذكي لتقييم وترتيب الطلاب",
      "smr_subtitle":              "ترتيب يجمع المعدل السنوي من دفتر الدرجات ونسبة الحضور، بالأرقام نفسها التي تُطبع في كشف الدرجات.",
      "smr_students_list":         "قائمة الطلاب",
      "smr_search_student_class":  "ابحث عن طالب أو صف...",
      "smr_rank":                  "المركز",
      "smr_student_name":          "اسم الطالب",
      "smr_class":                 "الصف",
      "smr_category":              "التصنيف",
      "smr_smart_pct":             "النسبة الذكية",
      "smr_no_rankings":           "لا يوجد طلاب متاحين للترتيب حالياً",
      // [PHASE-4 2026-10] Analytics: "How this is calculated"
      "an_how_title": "كيف تُحسب هذه الأرقام؟",
      "an_how_grades": "الدرجات: المعدل السنوي للطالب من دفتر الدرجات، وهو الرقم نفسه الذي يُطبع في كشف الدرجات (درجات موزونة، كل درجة من علامتها القصوى، والدرجة الغائبة ليست صفراً)، محوَّلاً إلى نسبة مئوية من سلّم /{{scale}}.",
      "an_how_attendance": "نسبة الحضور: (حاضر + متأخر) ÷ (حاضر + متأخر + غائب). أيام الغياب بعذر لا تُحتسب، ومن لا يوم محسوباً له لا نسبة له.",
      "an_how_smart": "النتيجة الذكية = {{gw}}% للدرجات + {{aw}}% للحضور. إذا غاب أحدهما احتُسب الآخر وحده. تُقرَّب إلى منزلتين عشريتين.",
      "an_how_labels": "التصنيف من سلّم تقديرات المدرسة: قائمة الشرف من {{top}}%، ويحتاج تحسيناً دون حدّ النجاح {{pass}}%.",
      "an_how_ranks": "النتائج المتساوية تتقاسم المركز نفسه (1، 2، 2، 4). الطلاب بلا بيانات يُعرضون في الآخر بلا مركز وبعلامة «—».",
      "an_no_data": "لا توجد بيانات",
      "smr_col_grades": "المعدل السنوي",
      "smr_col_attendance": "الحضور",
      "cav_how_class": "رقم الصف هو متوسط النتائج الذكية لطلابه الذين لديهم بيانات، والصف هو صف الطالب في تلك السنة الدراسية. الصف بلا بيانات لا مركز له.",
      "cav_col_grades": "معدل الدرجات",
      "cav_col_attendance": "نسبة الحضور",
      "cav_scored": "{{n}} لديهم بيانات",
      "ew_how_absence_rate": "نسبة الغياب: أيام الغياب ÷ الأيام المحسوبة (حاضر، متأخر، غائب) — {{rate}}% فأكثر تضيف {{w}} نقطة.",
      "ew_how_streak": "{{n}} أيام غياب أو أكثر منذ آخر يوم حضور تضيف {{w}} نقطة.",
      "ew_how_failing": "معدل سنوي (من دفتر الدرجات) دون حدّ النجاح {{pass}}% يضيف {{w}} نقطة.",
      "ew_how_decline": "آخر فصل فيه درجات أقل من الفصل الذي قبله بـ {{points}} نقاط مئوية أو أكثر يضيف {{w}} نقطة.",
      "ew_how_fees": "رسوم غير مسدّدة (تظهر لموظفي المالية فقط) تضيف {{w}} نقاط.",
      "ew_how_levels": "الخطورة عالية من {{high}} نقطة، ومتوسطة من {{medium}} نقطة.",
      "gr_how_subject": "معدل المادة في الفصل هو المتوسط الموزون لدرجاتها، كل درجة من علامتها القصوى، على سلّم /{{scale}}. الدرجة الغائبة ليست صفراً.",
      "gr_how_overall": "المعدل العام هو متوسط معدلات المواد بعد تقريبها، والمعدل السنوي هو متوسط الفصول. التقريب إلى منزلتين عشريتين (نصف إلى الأعلى).",
      "gr_how_ranks": "المعدلات المتساوية تتقاسم المركز نفسه (1، 2، 2، 4)، والطلاب بلا درجات بلا مركز وفي آخر القائمة.",

      // Generic joiner
      "term_and":                  "و",

      "month_jan": "يناير",
      "month_feb": "فبراير",
      "month_mar": "مارس",
      "month_apr": "أبريل",
      "month_may": "مايو",
      "month_jun": "يونيو",
      "month_jul": "يوليو",
      "month_aug": "أغسطس",
      "month_sep": "سبتمبر",
      "month_oct": "أكتوبر",
      "month_nov": "نوفمبر",
      "month_dec": "ديسمبر"
    ,
      // [TASK-2 2026-06] Domain-specific translation keys.
      // === Fee types ===
      "fee_type_tuition": "رسوم دراسية",
      "fee_type_registration": "رسوم تسجيل",
      "fee_type_transport": "رسوم نقل",
      "fee_type_meals": "رسوم وجبات",
      "fee_type_uniform": "رسوم زي مدرسي",
      "fee_type_books": "رسوم كتب",
      "fee_type_activities": "رسوم أنشطة",
      "fee_type_exam": "رسوم امتحانات",
      "fee_type_other": "رسوم أخرى",
      // === Salary types ===
      "salary_type_monthly": "راتب شهري",
      "salary_type_bonus": "مكافأة",
      "salary_type_overtime": "عمل إضافي",
      "salary_type_advance": "سلفة",
      "salary_type_allowance": "بدل",
      "salary_type_deduction": "خصم",
      "salary_type_annual": "مكافأة سنوية",
      // === Payment methods ===
      "payment_cash": "نقداً",
      "payment_bank_transfer": "تحويل بنكي",
      "payment_mobile_money": "موبايل موني",
      "payment_check": "شيك",
      "payment_card": "بطاقة بنكية",
      "payment_online": "دفع إلكتروني",
      // === Expense types ===
      "expense_type_maintenance": "صيانة",
      "expense_type_electricity": "كهرباء",
      "expense_type_water": "ماء",
      "expense_type_internet": "إنترنت",
      "expense_type_supplies": "لوازم مكتبية",
      "expense_type_furniture": "أثاث",
      "expense_type_cleaning": "نظافة",
      "expense_type_security": "أمن وحراسة",
      "expense_type_printing": "طباعة وتصوير",
      "expense_type_events": "فعاليات ومناسبات",
      "expense_type_other": "مصروفات أخرى",
      // === Subjects (extra) ===
      "subject_physics": "الفيزياء",
      "subject_chemistry": "الكيمياء",
      "subject_biology": "الأحياء",
      "subject_music": "التربية الموسيقية",
      "subject_philosophy": "الفلسفة",
      "subject_economics": "الاقتصاد",
      "subject_accounting": "المحاسبة",
      "subject_civic": "التربية المدنية",
      // === Academic specializations ===
      "spec_science": "علوم",
      "spec_literature": "آداب",
      "spec_math": "رياضيات",
      "spec_technical": "تقني",
      "spec_economics": "اقتصاد وتسيير",
      "spec_islamic": "علوم إسلامية",
      "spec_languages": "لغات أجنبية",
      // === Education levels ===
      "edu_primary": "ابتدائي",
      "edu_middle": "متوسط",
      "edu_high": "ثانوي",
      "edu_university": "جامعي",
      "edu_kindergarten": "روضة",
      // === Assessment types ===
      "assess_type_exam": "اختبار",
      "assess_type_quiz": "اختبار قصير",
      "assess_type_homework": "واجب",
      "assess_type_project": "مشروع",
      "assess_type_oral": "شفهي",
      "assess_type_practical": "عملي",
      "assess_type_participation": "مشاركة",
      "assess_type_midterm": "نصف الفصل",
      "assess_type_final": "نهاية الفصل",
      // === Terms / semesters ===
      "term_first": "الفصل الأول",
      "term_second": "الفصل الثاني",
      "term_third": "الفصل الثالث",
      "term_annual": "سنوي",
      // === Gender ===
      "gender_male": "ذكر",
      "gender_female": "أنثى",
      // === Blood types ===
      "blood_a_pos": "A+",
      "blood_a_neg": "A-",
      "blood_b_pos": "B+",
      "blood_b_neg": "B-",
      "blood_ab_pos": "AB+",
      "blood_ab_neg": "AB-",
      "blood_o_pos": "O+",
      "blood_o_neg": "O-",
      // === Notification types ===
      "notif_type_grade": "درجة جديدة",
      "notif_type_absence": "غياب",
      "notif_type_payment": "دفعة مالية",
      "notif_type_announcement": "إعلان",
      "notif_type_homework": "واجب جديد",
      "notif_type_task": "مهمة جديدة",
      "notif_type_system": "إشعار النظام",
      // === Common UI buttons / labels / messages ===
      "btn_view_all": "عرض الكل",
      "btn_load_more": "تحميل المزيد",
      "btn_go_back": "رجوع",
      "btn_next": "التالي",
      "btn_previous": "السابق",
      "btn_finish": "إنهاء",
      "btn_skip": "تخطي",
      "btn_retry": "إعادة المحاولة",
      "msg_connection_error": "خطأ في الاتصال",
      "msg_try_again": "حاول مرة أخرى",
      "msg_changes_saved": "تم حفظ التغييرات",
      "msg_are_you_sure": "هل أنت متأكد؟",
      "msg_cannot_undo": "لا يمكن التراجع عن هذا الإجراء",
      "lbl_optional": "اختياري",
      "lbl_required": "مطلوب",
      "lbl_all": "الكل",
      "lbl_none": "لا شيء",
      "lbl_other": "أخرى",
      "lbl_unknown": "غير معروف",
      "lbl_not_available": "غير متاح",
      "lbl_yes": "نعم",
      "lbl_no": "لا",
      // Shared labels, alt texts and shadcn/ui screen-reader text [I18N 2026-10]
      "lbl_na": "غير متوفر",
      "list_separator": "، ",
      "alt_profile_photo": "الصورة الشخصية",
      "alt_student_qr": "رمز QR للطالب",
      "alt_school_logo": "شعار المدرسة",
      "idc_no_id": "— بدون رقم —",
      "ui_breadcrumb": "مسار التنقل",
      "ui_more": "المزيد",
      "ui_previous_slide": "الشريحة السابقة",
      "ui_next_slide": "الشريحة التالية",
      "ui_pagination": "ترقيم الصفحات",
      "ui_previous_page": "الانتقال إلى الصفحة السابقة",
      "ui_next_page": "الانتقال إلى الصفحة التالية",
      "ui_previous": "السابق",
      "ui_next": "التالي",
      "ui_more_pages": "صفحات أخرى",
    
      // [WIRE-2026-06] Backend-catalog mappings for finance dropdowns.
      // === Fee types — backend catalog (constants.FEE_TYPES) ===
      "fee_type_tuition_term1": "رسوم دراسية - فصل أول",
      "fee_type_tuition_term2": "رسوم دراسية - فصل ثاني",
      "fee_type_tuition_term3": "رسوم دراسية - فصل ثالث",
      "fee_type_labs": "رسوم المختبرات",
      "fee_type_exam_retake": "رسوم إعادة الامتحان",
      "fee_type_certificates": "رسوم الشهادات",
      "fee_type_late_fee": "رسوم التأخير",
      // === Salary types — backend catalog (constants.SALARY_TYPES) ===
      "salary_type_teacher": "راتب معلم",
      "salary_type_admin": "راتب إداري",
      "salary_type_cleaner": "راتب عامل نظافة",
      "salary_type_guard": "راتب حارس",
      "salary_type_driver": "راتب سائق",
      "salary_type_supervisor": "راتب مشرف",
      "salary_type_librarian": "راتب أمين مكتبة",
      "salary_type_counselor": "راتب مرشد طلابي",
      "salary_type_accountant": "راتب محاسب",
      "salary_type_secretary": "راتب سكرتير",
      // === Expense types — backend catalog (constants.EXPENSE_TYPES) ===
      "expense_type_salaries": "رواتب",
      "expense_type_maintenance_building": "صيانة مباني",
      "expense_type_maintenance_equipment": "صيانة أجهزة",
      "expense_type_communications": "إنترنت واتصالات",
      "expense_type_school_equipment": "تجهيزات مدرسية",
      "expense_type_teaching_materials": "مواد تعليمية",
      "expense_type_books": "كتب ومراجع",
      "expense_type_fuel_transport": "وقود ونقل",
      "expense_type_health_insurance": "تأمين صحي",
      "expense_type_training": "تدريب ومؤتمرات",
      "expense_type_advertising": "إعلانات وتسويق",
      // === Payment methods — backend catalog (constants.PAYMENT_METHODS) ===
      "payment_installment": "تقسيط",
      "payment_salary_deduction": "خصم من الراتب",
      // === [PHASE-5 2026-10] Student PIN login (WP-B) ===
      "pin_card_doc_title": "بطاقات دخول التلاميذ",
      "pin_card_title": "بطاقة الدخول",
      "pin_card_school_code": "رمز المدرسة",
      "pin_card_student_number": "رقم الطالب",
      "pin_card_pin": "الرمز السري",
      "pin_card_keep_secret": "احتفظ بالبطاقة ولا تُطلع أحداً على رمزك",
      "pin_login_mode_password": "اسم المستخدم وكلمة المرور",
      "pin_login_mode_pin": "رقم الطالب والرمز السري",
      "pin_login_help": "لتلاميذ الابتدائي والمتوسط: استعمل البطاقة التي سلّمتها لك المدرسة.",
      "pin_login_school_code": "رمز المدرسة",
      "pin_login_school_code_hint": "مكتوب على بطاقتك، ويُحفظ على هذا الجهاز.",
      "pin_login_change_school": "تغيير المدرسة",
      "pin_login_student_number": "رقم الطالب",
      "pin_login_pin": "الرمز السري (4 أرقام)",
      "pin_login_show_pin": "إظهار الرمز",
      "pin_login_hide_pin": "إخفاء الرمز",
      "pin_login_submit": "دخول",
      "pin_login_err_school_code": "أدخل رمز المدرسة (أرقام فقط).",
      "pin_login_err_student_number": "أدخل رقم الطالب (أرقام فقط).",
      "pin_login_err_pin": "الرمز السري يتكون من 4 أرقام.",
      "pin_login_invalid": "البيانات غير صحيحة. تحقق من رمز المدرسة ورقم الطالب والرمز السري.",
      "pin_login_locked": "محاولات خاطئة كثيرة. حاول بعد {{minutes}} دقيقة، أو اطلب من إدارة المدرسة فتح الحساب.",
      "pin_login_too_many": "محاولات كثيرة. انتظر قليلاً ثم أعد المحاولة.",
      "nav_student_pins": "رموز دخول التلاميذ",
      "pin_mgr_title": "رموز دخول التلاميذ",
      "pin_mgr_subtitle": "يدخل تلاميذ الابتدائي والمتوسط برمز المدرسة ورقم الطالب ورمز سري من 4 أرقام. يظهر الرمز مرة واحدة فقط عند إنشائه، فاطبع البطاقات فوراً.",
      "pin_mgr_school_code": "رمز المدرسة: {{code}}",
      "pin_mgr_class": "الفصل",
      "pin_mgr_all_classes": "كل الفصول",
      "pin_mgr_generate": "إنشاء الرموز الناقصة",
      "pin_mgr_regenerate_all": "تجديد كل رموز الفصل",
      "pin_mgr_regenerate_confirm": "ستُستبدل كل رموز هذا الفصل وتُغلق جلسات التلاميذ المعنيين. هل تريد المتابعة؟",
      "pin_mgr_pick_class": "اختر فصلاً أولاً.",
      "pin_mgr_col_student": "التلميذ",
      "pin_mgr_col_number": "الرقم",
      "pin_mgr_col_class": "الفصل",
      "pin_mgr_col_status": "الحالة",
      "pin_mgr_col_actions": "إجراءات",
      "pin_mgr_status_set": "لديه رمز",
      "pin_mgr_status_none": "بدون رمز",
      "pin_mgr_status_locked": "مقفل حتى {{time}}",
      "pin_mgr_status_not_enabled": "كلمة المرور (صف لا يستعمل الرموز)",
      "pin_mgr_reset": "رمز جديد",
      "pin_mgr_reset_confirm": "إنشاء رمز جديد لـ {{name}}؟ سيتوقف الرمز القديم وتُغلق جلساته.",
      "pin_mgr_unlock": "فتح القفل",
      "pin_mgr_unlocked": "تم فتح القفل.",
      "pin_mgr_generated": "تم إنشاء {{count}} رمز.",
      "pin_mgr_nothing_generated": "لم يُنشأ أي رمز: لكل التلاميذ رموز أو أن صفهم لا يستعمل الرموز.",
      "pin_mgr_skipped": "تم تخطي {{count}} تلميذ.",
      "pin_mgr_reason_has_pin": "لديه رمز",
      "pin_mgr_reason_grade_not_enabled": "صف بلا رموز",
      "pin_mgr_reason_no_account": "بلا حساب نشط",
      "pin_mgr_reason_inactive": "غير نشط",
      "pin_mgr_new_pins_title": "الرموز الجديدة — تظهر مرة واحدة فقط",
      "pin_mgr_new_pins_hint": "اطبع البطاقات الآن. بعد مغادرة هذه الصفحة لا يمكن عرض هذه الرموز مجدداً، ويلزم إنشاء رموز جديدة.",
      "pin_mgr_print": "طباعة البطاقات",
      "pin_mgr_dismiss": "إخفاء الرموز",
      "pin_mgr_popup_blocked": "منع المتصفح نافذة الطباعة. اسمح بالنوافذ المنبثقة ثم أعد المحاولة.",
      "pin_mgr_empty": "لا يوجد تلاميذ.",
      "pin_mgr_more": "عرض المزيد",
      "pin_mgr_count": "{{shown}} من {{total}}",
      "pin_settings_title": "الدخول برقم الطالب والرمز السري",
      "pin_settings_hint": "اختر الصفوف التي يدخل تلاميذها بالرمز السري (عادة الابتدائي والمتوسط). بقية التلاميذ يستعملون اسم المستخدم وكلمة المرور. يُحفظ هذا الإعداد وحده بزر الحفظ أدناه.",
      "pin_settings_default_note": "الإعداد الافتراضي مستعمل: الابتدائي والمتوسط.",
      "pin_settings_none_note": "لم يُختر أي صف: الدخول بالرمز السري متوقف.",
      "pin_settings_add_placeholder": "صف آخر كما هو مكتوب في أسماء الفصول",
      "pin_settings_add": "إضافة",
      "pin_settings_save": "حفظ صفوف الرمز السري",
      "pin_settings_saved": "تم حفظ صفوف الرمز السري.",
      "pin_settings_use_default": "العودة إلى الافتراضي",
      // ─── [PHASE-2 2026-10] Grade grid, grading settings, transcripts, verification ───
      "gb_add": "إضافة",
      "gb_add_column": "إضافة تقييم",
      "gb_change_count": "{{n}} تغيير غير محفوظ",
      "gb_column_name": "اسم التقييم",
      "gb_discard": "تراجع",
      "gb_discard_confirm": "لديك درجات غير محفوظة. هل تريد تركها؟",
      "gb_err_above_max": "الدرجة أكبر من الدرجة العظمى",
      "gb_err_bad_max": "الدرجة العظمى غير صالحة",
      "gb_err_bad_weight": "المعامل غير صالح",
      "gb_err_decimals": "رقمان بعد الفاصلة على الأكثر",
      "gb_err_duplicate_column": "يوجد تقييم بالاسم والنوع نفسيهما",
      "gb_err_name_required": "اكتب اسم التقييم",
      "gb_err_not_a_number": "ليست درجة صالحة",
      "gb_err_not_in_class": "التلميذ ليس في هذا القسم",
      "gb_error_count": "{{n}} خانة فيها خطأ",
      "gb_fix_errors_first": "صحّح الخانات الحمراء قبل الحفظ",
      "gb_keyboard_hint": "Enter للنزول في العمود، Tab للانتقال إلى التقييم التالي، Ctrl+S للحفظ. يمكنك لصق عمود أو جدول من Excel. الخانة الفارغة تعني لا درجة، وليست صفرا.",
      "gb_load_failed": "تعذر تحميل الدرجات",
      "gb_locked_archived": "سنة مؤرشفة: الدرجات للاطلاع فقط.",
      "gb_locked_results": "أقفلت الإدارة النتائج: لا يمكن تعديل الدرجات.",
      "gb_max_score": "الدرجة العظمى",
      "gb_mixed_max": "درجات هذا العمود مسجلة على درجات عظمى مختلفة",
      "gb_no_students": "لا يوجد تلاميذ في هذا القسم لهذه السنة.",
      "gb_out_of": "من",
      "gb_paste_clipped": "تجاوز اللصق حدود الجدول؛ أُهملت {{n}} خانة",
      "gb_pick_class_subject": "اختر القسم والمادة.",
      "gb_save_failed": "لم تُحفظ الدرجات",
      "gb_saved": "حُفظت الدرجات ({{n}})",
      "gb_saving": "جارٍ الحفظ...",
      "gb_student_left": "غادر",
      "gb_term_average": "معدل الفصل",
      "gb_unsaved": "تغييرات غير محفوظة",
      "gb_weight": "المعامل",
      "gr_term": "الفترة",
      "gs_band_add": "إضافة تقدير",
      "gs_band_bad_min": "الحد الأدنى بين 0 و100",
      "gs_band_duplicate": "حد أدنى مكرر",
      "gs_band_label_required": "اكتب التقدير بالعربية",
      "gs_band_min": "الحد الأدنى بالنسبة المئوية",
      "gs_band_need_zero": "يجب أن يبدأ أحد التقديرات من 0%",
      "gs_band_remove": "حذف التقدير",
      "gs_bands": "التقديرات",
      "gs_bands_hint": "كل تقدير يبدأ من نسبة مئوية؛ تُحسب على المعدل بعد تقريبه، والمقابل على سلم /{{scale}} معروض بجانبه.",
      "gs_certificate_grades": "الصفوف التي تُمنح فيها شهادة",
      "gs_certificate_hint": "نهاية كل مرحلة عادة. تظهر الشهادة في شاشة الكشوف لهذه الصفوف فقط.",
      "gs_from": "من",
      "gs_intro": "تُطبَّق على شبكة الدرجات والترتيب والكشوف والشهادات.",
      "gs_rules_title": "كيف تُحسب المعدلات",
      "gs_rules_1": "الخانة الفارغة ليست صفرًا: لا تدخل في الحساب. المادة التي لا درجات لها لا تُحتسب، والمعدل الذي لا بيانات له يظهر «—».",
      "gs_rules_2": "تُحسب كل درجة نسبةً من علامتها القصوى (15/20 تساوي 7.5/10) مع وزنها، ثم تُعرض على سلّم المدرسة.",
      "gs_rules_3": "المعدل العام للفصل هو متوسط معدلات المواد بعد تقريبها، فيمكن لأي أحد إعادة حسابه من الأسطر المطبوعة.",
      "gs_rules_4": "معدل السنة في كل مادة هو متوسط معدلاتها الفصلية الموجودة، والمعدل العام للسنة يُحسب من معدلات المواد السنوية.",
      "gs_rules_5": "التقريب إلى منزلتين، والنصف يُقرَّب إلى الأعلى (12.345 تصبح 12.35)، والتقدير يُقرأ من الرقم المقرَّب.",
      "gs_rules_6": "الطلاب المتساوون يأخذون الرتبة نفسها (1، 2، 2، 4)، ومن لا معدل له لا يُرتَّب.",
      "gs_label_ar": "بالعربية",
      "gs_label_en": "بالإنجليزية",
      "gs_label_fr": "بالفرنسية",
      "gs_principal": "اسم المدير",
      "gs_principal_hint": "يُطبع تحت التوقيع في الكشوف والشهادات.",
      "gs_save": "حفظ إعدادات الدرجات",
      "gs_save_failed": "لم تُحفظ إعدادات الدرجات",
      "gs_saved": "حُفظت إعدادات الدرجات",
      "gs_scale": "سلم التنقيط",
      "gs_terms": "عدد الفصول في السنة",
      "gs_terms_2": "فصلان",
      "gs_terms_3": "ثلاثة فصول",
      "gs_title": "الدرجات والوثائق",
      "ss_section_grades": "الدرجات والوثائق",
      "tr_archived_year": "سنة {{year}} مؤرشفة: يمكن إصدار كشوفها وطباعتها، ولا يمكن تعديل درجاتها.",
      "tr_certificate_class": "صف شهادة",
      "tr_doc_certificate": "شهادة",
      "tr_doc_transcript": "كشف النقاط",
      "tr_doc_type": "نوع الوثيقة",
      "tr_failed": "تعذر إعداد الوثيقة",
      "tr_intro": "لكل وثيقة صادرة رمز تحقق. إعادة طباعة وثيقة لم تتغير تحتفظ برمزها؛ وإذا تغيرت الدرجات يصدر رمز جديد ويصبح القديم «مستبدلا».",
      "tr_issue_print": "إصدار وطباعة ({{n}})",
      "tr_issued": "جديد: {{created}} · دون تغيير: {{reused}} · مستبدل: {{superseded}}",
      "tr_load_failed": "تعذر تحميل الأقسام",
      "tr_no_classes": "لا توجد أقسام فيها تلاميذ لهذه السنة.",
      "tr_popup_blocked": "منع المتصفح نافذة الطباعة؛ اسمح بالنوافذ المنبثقة لهذا الموقع.",
      "tr_preview": "معاينة",
      "tr_select_all": "الكل ({{n}} من {{total}})",
      "tr_term_year": "السنة كاملة",
      "tr_title": "الكشوف والشهادات",
      "tr_print_appreciation": "التقدير",
      "tr_print_average": "المعدل",
      "tr_print_birth": "تاريخ الميلاد",
      "tr_print_cert_text": "تشهد إدارة {{school}} بأن التلميذ(ة) {{name}}، المولود(ة) بتاريخ {{birth}}، قد أتمّ(ت) صف {{className}} خلال السنة الدراسية {{year}} بمعدل عام {{average}} من {{scale}}، بتقدير:",
      "tr_print_certificate": "شهادة",
      "tr_print_class": "القسم",
      "tr_print_draft": "معاينة — ليست وثيقة صادرة ولا تحمل رمز تحقق",
      "tr_print_issued_on": "تاريخ الإصدار",
      "tr_print_number": "الرقم",
      "tr_print_overall": "المعدل العام",
      "tr_print_partial": "ملاحظة: بعض المواد أو الفصول بلا درجات؛ المعدل محسوب على المتوفر فقط.",
      "tr_print_principal": "المدير",
      "tr_print_stamp": "التوقيع والختم",
      "tr_print_student": "التلميذ(ة)",
      "tr_print_subject": "المادة",
      "tr_print_transcript": "كشف النقاط",
      "tr_print_verify": "للتحقق من صحة الوثيقة امسح الرمز أو افتح الرابط:",
      "tr_print_year": "السنة الدراسية",
      "vd_check": "تحقق",
      "vd_code_label": "رمز التحقق",
      "vd_code_placeholder": "رمز التحقق المطبوع على الوثيقة",
      "vd_compare_hint": "قارن هذه البيانات بالوثيقة التي بين يديك. لا تُعرض الدرجات هنا.",
      "vd_failed": "تعذر التحقق الآن. أعد المحاولة بعد دقيقة.",
      "vd_genuine": "وثيقة صحيحة",
      "vd_not_found": "رمز غير معروف",
      "vd_not_found_hint": "لم تصدر المدرسة وثيقة بهذا الرمز. تأكد من كتابته كما هو مطبوع.",
      "vd_school": "المدرسة",
      "vd_student": "التلميذ(ة)",
      "vd_subtitle": "تحقق من كشف نقاط أو شهادة صادرة عن مدرسة تستخدم EduGate.",
      "vd_superseded": "وثيقة مستبدلة",
      "vd_superseded_hint": "أصدرت المدرسة نسخة أحدث من هذه الوثيقة؛ هذه النسخة لم تعد معتمدة. اطلب النسخة الحالية من المدرسة.",
      "vd_title": "التحقق من وثيقة",
      "vd_year": "السنة الدراسية",
      "tt_print_class_kicker": "الجدول الأسبوعي للصف",
      "tt_print_teacher_kicker": "الجدول الأسبوعي للأستاذ(ة)",
      "tt_print_class_title": "جدول {{cls}}",
      "tt_print_teacher_title": "جدول {{name}}",
      "tt_print_school_title": "جداول المدرسة",
      "tt_print_year": "السنة الدراسية {{year}}",
      "tt_lesson_col": "الحصة",
      "tt_lesson_n": "الحصة {{n}}",
      "tt_break_default": "استراحة",
      "tt_room": "القاعة {{room}}",
      "tt_weekly_total": "{{count}} حصة في الأسبوع",
      "tt_teacher_load": "النصاب: {{count}} حصة في الأسبوع",
      "tt_other_times": "حصص خارج جدول الأجراس:",
      "tt_printed_on": "طُبع في {{date}}",
      "tt_print_class": "طباعة جدول الصف",
      "tt_print_school": "طباعة جداول المدرسة كلها",
      "tt_print_teacher": "طباعة جدول أستاذ",
      "tt_pick_teacher": "اختر الأستاذ(ة)",
      "tt_print_mine": "طباعة جدولي",
      "tt_popup_blocked": "منع المتصفح نافذة الطباعة. اسمح بالنوافذ المنبثقة لهذا الموقع ثم أعد المحاولة.",
      "tt_nothing_to_print": "لا يوجد جدول للطباعة بعد.",
      "ss_break_title": "الاستراحات",
      "ss_break_hint": "الاستراحة الصباحية، الغداء… الاستراحة لا تحمل رقماً: إضافتها أو تغيير وقتها لا يغيّر أرقام الحصص ولا الجداول المحفوظة.",
      "ss_break_name": "الاسم",
      "ss_break_name_placeholder": "استراحة",
      "ss_break_start": "بداية الاستراحة",
      "ss_break_end": "نهاية الاستراحة",
      "ss_break_remove": "حذف الاستراحة",
      "ss_break_add": "إضافة استراحة",
      "ss_break_none": "لا توجد استراحات.",
      "ss_break_max": "{{max}} استراحات كحد أقصى.",
      "ss_break_err_invalid": "وقت غير صالح: يجب أن تكون النهاية بعد البداية.",
      "ss_break_err_lesson": "تتداخل مع الحصة {{n}}.",
      "ss_break_err_break": "تتداخل مع استراحة أخرى.",
      "ss_break_preview": "اليوم الدراسي",
      "ss_bell_err_BELL_INVALID": "كل حصة تحتاج وقت بداية ووقت نهاية صحيحين، والنهاية بعد البداية.",
      "ss_bell_err_BELL_OVERLAP": "حصتان تتداخلان في الوقت.",
      "ss_bell_err_BELL_ORDER_MISMATCH": "يجب أن تبدأ كل حصة بعد التي قبلها. عدّل الأوقات بدل إعادة ترتيب الحصص.",
      "ss_bell_only_last_removable": "يمكن حذف الحصة الأخيرة فقط: حذف حصة في الوسط يغيّر أرقام الحصص التي بعدها. عدّل وقتها بدلاً من ذلك.",
      "ss_bell_blocked": "صحّح جدول الأجراس أو الاستراحات قبل الحفظ.",
      "sb_conflict_unknown_period": "هذه الحصة غير موجودة في جدول الأجراس.",
      "sb_conflict_unknown_teacher": "هذا الأستاذ لا ينتمي إلى المدرسة.",
      "sb_conflict_duplicate_cell": "للصف حصتان في هذا الوقت.",
      "sb_conflict_teacher_busy": "الأستاذ مشغول في {{cls}} في هذا الوقت.",
      "sb_conflict_room_busy": "القاعة مشغولة بـ {{cls}} في هذا الوقت.",
      "sb_conflict_on_break": "هذا الوقت استراحة وليس حصة.",
      "sb_conflict_bad_time": "وقت الحصة غير صالح.",
      "sb_break_row": "استراحة، لا يمكن وضع حصة فيها",
      "rm_cat_school_events": "المشاركة في فعاليات المدرسة وبرامجها (تطوعي)",
      "rm_cat_school_events_hint": "معيار تطوعي: يُحتسب فقط عند وجود تقييم، ولا يُنقص غيابه من المعدل.",
      "rm_cat_legacy": "(فئة قديمة)",
      "rm_voluntary": "تطوعي",
      "rm_subtitle_scale": "متابعة الأداء والتحسين المستمر (من 1 إلى {{scale}})",
      "rm_rating_label_scale": "التقييم (1-{{scale}})",
      "rm_pick_required": "اختر الشخص والفئة أولاً",
      "rm_overall_avg_sub": "تقييمات الإدارة لهذه السنة",
      "rm_history_error": "تعذّر تحميل سجل التقييمات",
      "rm_role_school_admin": "مدير المدرسة",
      "rm_role_admin_staff": "موظف إداري",
      "rm_role_teacher": "معلم",
      "pf_rt_by_category": "التقييم حسب الفئة",
      "pf_rt_count": "عدد التقييمات: {{count}}",
      "pf_rt_latest": "الأخير: {{value}} · {{date}}",
      "pf_rt_none": "لا توجد تقييمات لهذه السنة",
      "rpt_te_title": "تقييمات المعلمين",
      "rpt_te_subtitle": "تقييمات الإدارة للسنة الدراسية {{year}}، من {{scale}}",
      "rpt_te_teacher": "المعلم",
      "rpt_te_overall": "الإجمالي",
      "rpt_te_other": "فئات قديمة",
      "rpt_te_unnamed": "معلم غير موجود",
      "rpt_te_empty": "لا يوجد معلمون لعرضهم",
      "rpt_te_count": "عدد التقييمات: {{count}}",
      "rpt_te_load_error": "تعذّر تحميل تقييمات المعلمين",
      "rpt_te_method_scale": "كل تقييم يُقرأ على سلّمه الخاص ويُعبَّر عنه من {{scale}} (التقييمات القديمة بلا سلّم تُقرأ من {{legacy}}).",
      "rpt_te_method_raters": "تُحتسب تقييمات إدارة المدرسة فقط؛ تقييم معلم لزميله لا يُحتسب.",
      "rpt_te_method_overall": "الإجمالي = متوسط معدلات الفئات الموجودة لدى المعلم (بعد تقريبها). الفئة التي لا تقييم فيها تظهر «—» ولا تُحتسب صفراً.",
      "rpt_te_method_voluntary": "المشاركة في فعاليات المدرسة تطوعية: تُحتسب عند وجودها فقط، وغيابها لا يُنقص الإجمالي.",
      "rpt_te_method_rounding": "التقريب إلى منزلتين عشريتين، والنصف يُقرَّب إلى الأعلى.",
    }
  },
  fr: {
    translation: {
      // ── Class fees in one request (bulk payments) ──
      "audit_action_fees_class_created": "Frais créés pour une classe",
      "cf_open_btn": "Créer les frais de la classe",
      "cf_title": "Créer les frais d'une classe entière",
      "cf_subtitle": "Un frais est créé pour chaque élève de la classe pour l'année en cours, puis apparaît aussitôt dans la liste du paiement groupé. Un élève qui a déjà ce frais pour ce mois n'est pas facturé deux fois.",
      "cf_pick_class": "Choisir la classe",
      "cf_amount": "Montant par élève",
      "cf_due_date": "Date d'échéance (facultatif)",
      "cf_review_btn": "Aperçu",
      "cf_create_btn": "Créer les frais ({{count}} élèves)",
      "cf_will_create": "Frais qui seront créés",
      "cf_skipped": "Pas de doublon pour {{count}} élève(s) qui ont déjà ce frais ce mois-ci :",
      "cf_nothing_to_create": "Tous les élèves de la classe ont déjà ce frais pour ce mois.",
      "cf_created": "{{count}} frais créés. Vous pouvez maintenant enregistrer le paiement groupé.",
      "cf_error": "Impossible de créer les frais de la classe.",
      "cf_empty_hint": "Seuls les frais impayés apparaissent ici. Si les frais de cette classe n'ont pas encore été créés, créez-les pour toute la classe en un clic.",
      "cf_err_class": "Choisissez la classe.",
      "cf_err_fee_type": "Choisissez le type de frais.",
      "cf_err_amount": "Saisissez un montant valide supérieur à zéro.",
      "cf_err_month": "Choisissez le mois.",
      // ── Activity log: one readable label per audit action ──
      "audit_action_academic_year_rollover": "Passage à l'année suivante",
      "audit_action_academic_year_rollover_failed": "Échec du passage d'année",
      "audit_action_activate_academic_year": "Activation d'une année scolaire",
      "audit_action_announcement_created": "Annonce publiée",
      "audit_action_announcement_deleted": "Annonce supprimée",
      "audit_action_broadcast_sent": "Message groupé envoyé",
      "audit_action_bulk_attendance": "Présences enregistrées en lot",
      "audit_action_bulk_payment": "Paiement groupé des frais",
      "audit_action_create_academic_year": "Année scolaire créée",
      "audit_action_create_admin_staff": "Employé administratif ajouté",
      "audit_action_create_assignment": "Devoir ajouté",
      "audit_action_create_attendance": "Présence enregistrée",
      "audit_action_create_fee": "Frais ajoutés",
      "audit_action_create_grade": "Note ajoutée",
      "audit_action_create_payment": "Paiement enregistré",
      "audit_action_deactivate_admin_staff": "Employé administratif désactivé",
      "audit_action_delete_admin_staff_permanent": "Employé administratif supprimé",
      "audit_action_delete_assignment": "Devoir supprimé",
      "audit_action_delete_grade": "Note supprimée",
      "audit_action_expense_added": "Dépense ajoutée",
      "audit_action_expense_deleted": "Dépense supprimée",
      "audit_action_expense_updated": "Dépense modifiée",
      "audit_action_fee_deleted": "Frais supprimés",
      "audit_action_fee_paid": "Frais payés",
      "audit_action_grades_bulk_saved": "Notes d'une classe enregistrées",
      "audit_action_homework_graded": "Devoir corrigé",
      "audit_action_homework_submitted": "Devoir rendu",
      "audit_action_invoice_created": "Facture créée",
      "audit_action_login_blocked_subscription": "Connexion refusée : abonnement expiré",
      "audit_action_login_failure": "Échec de connexion",
      "audit_action_login_locked": "Connexion bloquée après des échecs",
      "audit_action_login_success": "Connexion",
      "audit_action_logout": "Déconnexion",
      "audit_action_manual_rollover_rollback": "Annulation du passage d'année",
      "audit_action_message_sent": "Message envoyé",
      "audit_action_parent_created": "Parent ajouté",
      "audit_action_parent_deleted": "Parent supprimé",
      "audit_action_parent_updated": "Parent modifié",
      "audit_action_password_changed": "Mot de passe modifié",
      "audit_action_payroll_run": "Paie du mois versée",
      "audit_action_payslip_generated": "Bulletin de paie émis",
      "audit_action_payslips_generated": "Bulletins de paie émis",
      "audit_action_pin_generated": "Code PIN d'élève créé",
      "audit_action_pin_login_failure": "Échec de connexion par PIN",
      "audit_action_pin_login_locked": "Connexion par PIN bloquée",
      "audit_action_pin_login_success": "Connexion d'élève par PIN",
      "audit_action_pin_reset": "Code PIN d'élève réinitialisé",
      "audit_action_pin_settings_updated": "Réglages PIN modifiés",
      "audit_action_pin_unlocked": "Code PIN débloqué",
      "audit_action_platform_settings_updated": "Réglages de la plateforme modifiés",
      "audit_action_profile_updated": "Profil modifié",
      "audit_action_read_student_medical": "Consultation du dossier médical d'un élève",
      "audit_action_receipt_generated": "Reçu émis",
      "audit_action_receipts_generated": "Reçus émis",
      "audit_action_register_school": "École inscrite",
      "audit_action_reset_password": "Mot de passe réinitialisé",
      "audit_action_salary_deleted": "Salaire supprimé",
      "audit_action_salary_recorded": "Salaire enregistré",
      "audit_action_salary_updated": "Salaire modifié",
      "audit_action_schedule_bulk_saved": "Emploi du temps d'une classe enregistré",
      "audit_action_school_settings_updated": "Réglages de l'école modifiés",
      "audit_action_school_subject_removed": "Matière supprimée",
      "audit_action_school_subject_added": "Matière ajoutée",
      "audit_action_class_created": "Classe créée",
      "audit_action_class_updated": "Classe modifiée",
      "audit_action_class_deleted": "Classe supprimée",
      "audit_action_class_renamed": "Classe renommée",
      "audit_action_support_ticket_created": "Ticket de support ouvert",
      "audit_action_support_ticket_replied": "Réponse à un ticket de support",
      "audit_action_support_ticket_followed_up": "Suivi d'un ticket de support",
      "audit_action_support_ticket_status_changed": "Statut d'un ticket de support modifié",
      "sa_tab_support": "Support",
      "sup_button": "Support",
      "sup_title": "Support technique et urgences",
      "sup_intro": "Décrivez le problème : l'administration de la plateforme est alertée tout de suite. Les informations de votre compte et de votre école sont jointes automatiquement.",
      "sup_tab_new": "Nouveau message",
      "sup_tab_mine": "Mes tickets",
      "sup_category": "Type de problème",
      "sup_cat_technical": "Panne technique",
      "sup_cat_emergency": "Urgence",
      "sup_cat_account": "Problème de compte",
      "sup_cat_other": "Autre",
      "sup_urgency": "Priorité",
      "sup_urgency_normal": "Normale",
      "sup_urgency_urgent": "Urgente",
      "sup_subject": "Objet",
      "sup_subject_ph": "Ex. : les notes ne s'enregistrent pas",
      "sup_message": "Description",
      "sup_message_ph": "Que faisiez-vous ? Qu'est-ce qui s'est affiché ?",
      "sup_attached": "Joint automatiquement : votre nom, compte, rôle, école, téléphone, e-mail et l'écran où vous étiez",
      "sup_send": "Envoyer",
      "sup_sending": "Envoi…",
      "sup_sent": "Ticket {{number}} envoyé. La réponse arrivera ici et dans les notifications.",
      "sup_send_error": "Impossible d'envoyer le message",
      "sup_too_short": "Écrivez un objet (3 caractères au moins) et une description (10 au moins).",
      "sup_none": "Aucun ticket pour l'instant.",
      "sup_load_error": "Impossible de charger les tickets",
      "sup_status_open": "Ouvert",
      "sup_status_in_progress": "En cours",
      "sup_status_resolved": "Résolu",
      "sup_support_team": "Support",
      "sup_follow_up_ph": "Ajoutez une information ou une réponse…",
      "sup_follow_up_send": "Envoyer",
      "sup_locked_note": "Les réponses s'affichent ici. Pour ajouter quelque chose maintenant, ouvrez un nouveau ticket.",
      "sup_filter_all": "Tous",
      "sup_urgent_only": "Urgents seulement",
      "sup_search_ph": "N° de ticket, école, nom…",
      "sup_counts": "Ouverts : {{open}} · En cours : {{in_progress}} · Urgents en attente : {{urgent}}",
      "sup_select_ticket": "Choisissez un ticket pour voir le détail.",
      "sup_sender": "Expéditeur",
      "sup_name": "Nom",
      "sup_username": "Identifiant",
      "sup_role": "Rôle",
      "sup_phone": "Téléphone",
      "sup_email": "E-mail",
      "sup_teacher_number": "N° d'enseignant",
      "sup_permissions": "Permissions",
      "sup_school": "École",
      "sup_school_number": "N° d'école",
      "sup_plan": "Formule",
      "sup_status_at_send": "Abonnement à l'envoi",
      "sup_status_now": "Abonnement maintenant",
      "sup_sub_active": "Actif",
      "sup_sub_trial": "Essai",
      "sup_sub_expired": "Expiré",
      "sup_sub_suspended": "Suspendu",
      "sup_sub_none": "Inconnu",
      "sup_account_now": "Le compte maintenant",
      "sup_account_state": "État",
      "sup_active": "Actif",
      "sup_inactive": "Désactivé",
      "sup_account_missing": "Compte supprimé",
      "sup_last_login": "Dernière connexion",
      "sup_context": "Contexte",
      "sup_page": "Écran",
      "sup_device": "Appareil",
      "sup_alerts": "Alertes",
      "sup_alerts_off": "E-mail et Telegram non configurés",
      "sup_alert_email": "E-mail",
      "sup_alert_telegram": "Telegram",
      "sup_alert_sent": "envoyée",
      "sup_alert_failed": "échec",
      "sup_alert_off": "non configurée",
      "sup_reply_ph": "Votre réponse à l'expéditeur…",
      "sup_reply_send": "Répondre",
      "sup_mark": "Changer le statut",
      "sup_call": "Appeler",
      "sup_whatsapp": "WhatsApp",
      "audit_action_class_subject_assigned": "Matière attribuée dans une classe",
      "audit_action_class_subject_removed": "Matière retirée d'une classe",
      "audit_action_student_created": "Élève ajouté",
      "audit_action_student_deleted": "Élève supprimé",
      "audit_action_student_linked": "Élève lié à un parent",
      "audit_action_student_updated": "Élève modifié",
      "audit_action_students_bulk_imported": "Élèves importés",
      "audit_action_subscription_renewed": "Abonnement renouvelé",
      "audit_action_subscription_suspended": "Abonnement suspendu",
      "audit_action_subscription_updated": "Abonnement modifié",
      "audit_action_superadmin_profile_update": "Compte super administrateur modifié",
      "audit_action_suspend_admin_staff": "Employé administratif suspendu",
      "audit_action_task_assigned": "Tâche assignée",
      "audit_action_task_deleted": "Tâche supprimée",
      "audit_action_task_reviewed": "Tâche examinée",
      "audit_action_task_submitted": "Tâche rendue",
      "audit_action_task_updated": "Tâche modifiée",
      "audit_action_teacher_created": "Enseignant ajouté",
      "audit_action_teacher_deleted": "Enseignant supprimé",
      "audit_action_teacher_document_deleted": "Document d'enseignant supprimé",
      "audit_action_teacher_document_downloaded": "Document d'enseignant téléchargé",
      "audit_action_teacher_document_types_updated": "Types de documents modifiés",
      "audit_action_teacher_document_uploaded": "Document d'enseignant ajouté",
      "audit_action_teacher_rated": "Enseignant évalué",
      "audit_action_teacher_updated": "Enseignant modifié",
      "audit_action_token_refresh": "Session prolongée",
      "audit_action_transcripts_issued": "Relevés de notes émis",
      "audit_action_update_academic_calendar": "Calendrier scolaire modifié",
      "audit_action_update_academic_year_status": "Statut de l'année scolaire modifié",
      "audit_action_update_admin_staff_info": "Employé administratif modifié",
      "audit_action_update_admin_staff_permissions": "Permissions d'un employé modifiées",
      "audit_action_update_attendance": "Présence modifiée",
      "audit_action_update_grade": "Note modifiée",
      "audit_action_update_notification_preferences": "Préférences de notification modifiées",
      "audit_action_schedule_duplicates_resolved": "Doublons de l'emploi du temps fusionnés",
      "audit_action_other": "Autre opération",
      // ── Sessions, subscription lockout, desktop notice [PHASE-5 2026-10] ──
      "session_notice_max_age": "Votre session s'est terminée 24 heures après la connexion. Reconnectez-vous pour continuer.",
      "session_notice_expired": "Votre session a expiré. Reconnectez-vous pour continuer.",
      "session_notice_revoked": "Votre session a été fermée. Reconnectez-vous pour continuer.",
      "session_notice_subscription": "L'abonnement de votre école a expiré : la connexion est impossible pour le moment. Contactez l'administration de votre école.",
      "session_notice_dismiss": "Fermer",
      "stw_session_ending_message": "La session se termine 24 heures après la connexion et ne peut pas être prolongée. Enregistrez votre travail, puis reconnectez-vous.",
      "stw_dismiss": "Compris",
      "renewal_title": "Abonnement de l'école expiré",
      "renewal_title_suspended": "Abonnement de l'école suspendu",
      "renewal_data_kept": "Rien n'a été supprimé : toutes les données de l'école sont conservées et reviennent dès le renouvellement.",
      "renewal_ended_on": "Terminé le {{date}}",
      "renewal_contact_title": "Pour renouveler, contactez l'administration de la plateforme",
      "renewal_phone": "Téléphone",
      "renewal_email": "E-mail",
      "renewal_whatsapp": "WhatsApp",
      "renewal_no_contact": "Aucun contact n'est encore enregistré. Contactez le responsable de la plateforme.",
      "renewal_check_again": "Vérifier à nouveau",
      "renewal_checking": "Vérification...",
      "renewal_still_locked": "L'abonnement n'est pas encore renouvelé.",
      "renewal_restored": "Abonnement renouvelé. Bon retour !",
      "renewal_check_failed": "Vérification impossible pour le moment. Réessayez.",
      "renewal_logout": "Se déconnecter",
      "desktop_notice_title": "Cette interface est conçue pour un ordinateur",
      "desktop_notice_body": "Le tableau de bord d'administration est riche en tableaux et formulaires et fonctionne au mieux sur un ordinateur portable ou de bureau. Vous pouvez continuer sur cet appareil, mais certains écrans peuvent être étroits.",
      "desktop_notice_continue": "Continuer quand même",
      "ps_contact_phone": "Téléphone de contact",
      "ps_contact_hint": "Le téléphone et l'e-mail sont affichés au directeur d'une école dont l'abonnement a expiré.",
      "subscription_call": "Appeler",
      // ── Bulk finance [PHASE-3 2026-10] ──────────
      "fin_tab_bulk_fees": "Paiement groupé",
      "fin_tab_payroll": "Paie du mois",
      "bulk_fees_title": "Paiement groupé des frais",
      "bulk_fees_subtitle": "Choisissez la classe ou le mois, cochez les élèves qui ont payé, puis confirmez une seule fois.",
      "bulk_all_classes": "Toutes les classes",
      "bulk_all_fee_types": "Tous les types de frais",
      "bulk_pick_method": "Choisissez le mode de paiement",
      "bulk_refresh": "Actualiser",
      "bulk_download_list": "Télécharger la liste (Excel)",
      "bulk_import_excel": "Importer des paiements (Excel)",
      "bulk_import_hint": "Colonnes : numéro élève, montant, mois, type de frais, référence. Une ligne sans montant n'est pas enregistrée.",
      "bulk_import_skipped": "{{count}} ligne(s) sans montant ignorée(s)",
      "fin_unpaid_all_years": "Toutes années",
      "bulk_list_count": "{{shown}} sur {{total}} frais impayés",
      "bulk_list_truncated": "Liste tronquée : affinez le filtre pour voir le reste.",
      "bulk_selected_summary": "Sélection : {{count}} · total",
      "bulk_review_btn": "Vérifier et confirmer",
      "bulk_select_all": "Tout sélectionner",
      "bulk_col_pay_now": "Montant payé maintenant",
      "bulk_nothing_unpaid": "Aucun frais impayé pour ce filtre.",
      "bulk_amount_invalid": "Certains montants sont invalides ou dépassent le reste dû (en rouge).",
      "bulk_import_preview_title": "Aperçu de l'import",
      "bulk_import_ok_rows": "{{count}} ligne(s) valide(s)",
      "bulk_import_partial_note": "Les lignes en erreur ne seront pas enregistrées. Corrigez-les dans le fichier et importez-les plus tard.",
      "bulk_import_continue": "Continuer avec {{count}} ligne(s)",
      "bulk_import_no_header": "Colonne « numéro élève » introuvable dans le fichier.",
      "bulk_import_read_error": "Impossible de lire le fichier.",
      "bulk_col_student_number": "numéro élève",
      "bulk_col_amount": "montant",
      "bulk_col_month": "mois",
      "bulk_col_fee_type": "type de frais",
      "bulk_col_reference": "référence",
      "bulk_col_name_info": "nom (pour information)",
      "bulk_col_row": "Ligne",
      "bulk_confirm_title": "Confirmer le paiement groupé",
      "bulk_confirm_count": "Nombre de paiements",
      "bulk_confirm_total": "Total",
      "bulk_confirm_note": "Tous les paiements sont enregistrés ensemble. Si la connexion coupe, confirmez à nouveau : aucun paiement ne sera compté deux fois.",
      "bulk_confirm_btn": "Enregistrer {{count}} paiement(s)",
      "bulk_recorded": "{{count}} paiement(s) enregistré(s)",
      "bulk_done_title": "Paiements enregistrés",
      "bulk_print_receipts": "Imprimer les reçus",
      "bulk_rows_with_errors": "{{count}} ligne(s) en erreur",
      "bulk_sheet_row": "Ligne Excel {{row}}",
      "bulk_line": "Ligne {{n}}",
      "bulk_load_error": "Impossible de charger la liste",
      "bulk_save_error": "Échec de l'enregistrement",
      "bulk_read_only": "Année archivée : aucun paiement ne peut y être enregistré.",
      "bulk_err_invalid_row": "Ligne invalide",
      "bulk_err_fee_not_found": "Frais introuvables dans cette école",
      "bulk_err_student_not_found": "Aucun élève avec le numéro {{student_number}}",
      "bulk_err_no_unpaid_fee": "Aucun frais impayé correspondant pour cet élève",
      "bulk_err_ambiguous_fee": "{{count}} frais correspondent : précisez le mois ou le type",
      "bulk_err_duplicate_fee": "Les mêmes frais figurent deux fois",
      "bulk_err_year_archived": "Frais d'une année archivée ({{year}}) : paiement impossible",
      "bulk_err_fee_already_paid": "Frais déjà entièrement payés",
      "bulk_err_exceeds_balance": "Le montant dépasse le reste dû ({{remaining}})",
      "bulk_err_employee_not_found": "Employé introuvable ou inactif dans cette école",
      "bulk_err_duplicate_employee": "Employé présent deux fois",
      "bulk_err_already_paid": "Le salaire de ce mois est déjà payé",
      "bulk_err_multiple_rows": "{{count}} salaires enregistrés ce mois : traitez-les depuis le tableau des salaires",
      "bulk_err_missing_number": "Numéro d'élève manquant",
      "bulk_err_bad_amount": "Montant invalide",
      "bulk_err_bad_month": "Mois invalide (ex. 2026-10)",
      "payroll_title": "Paie du mois",
      "payroll_subtitle": "Tous les enseignants et le personnel avec le dernier salaire. Ajustez les exceptions puis confirmez une seule fois.",
      "payroll_print_month": "Imprimer les bulletins payés du mois",
      "payroll_counts": "{{total}} employé(s) · {{payable}} à payer",
      "payroll_col_last": "Dernier salaire",
      "payroll_col_amount": "Montant du mois",
      "payroll_no_staff": "Aucun employé actif.",
      "payroll_type_teacher": "Enseignant",
      "payroll_type_staff": "Personnel administratif",
      "payroll_state_new": "Non enregistré",
      "payroll_state_unpaid": "Enregistré, non payé",
      "payroll_state_paid": "Payé",
      "payroll_state_multiple": "Plusieurs salaires enregistrés",
      "payroll_amount_missing": "Saisissez un montant pour chaque employé coché (en rouge).",
      "payroll_confirm_title": "Confirmer la paie de {{month}}",
      "payroll_confirm_count": "Employés",
      "payroll_confirm_note": "Un même mois ne peut jamais être payé deux fois, même si la confirmation est répétée.",
      "payroll_confirm_btn": "Payer {{count}} salaire(s)",
      "payroll_recorded": "{{count}} salaire(s) payé(s)",
      "payroll_done_title": "Salaires payés",
      "payroll_print_payslips": "Imprimer les bulletins",
      "fp_student_number": "N° élève",
      "fp_period": "Période",
      "fp_reference": "Référence",
      "fp_amount_received": "Montant reçu",
      "fp_fee_total": "Montant des frais",
      "fp_paid_to_date": "Payé à ce jour",
      "fp_remaining": "Reste dû",
      "fp_fee_status": "Statut des frais",
      "fp_signature_stamp": "Signature et cachet",
      "fp_employee": "Employé",
      "fp_employee_detail": "Spécialité / fonction",
      "fp_employee_signature": "Signature de l'employé",
      "fp_preparing": "Préparation des documents à imprimer…",
      "fp_popup_blocked": "Le navigateur a bloqué la fenêtre d'impression. Autorisez les fenêtres pop-up pour ce site.",
      // ── Fast schedule builder [FEAT fast-builder 2026-09] ──────────
      "smc_view_builder":           "Construction rapide",
      "sb_title":                   "Construction par blocs",
      "sb_subtitle":                "Choisissez un bloc (matière + enseignant) puis cliquez sur les cases. Aucune heure à saisir, et aucun conflit possible.",
      "sb_class":                   "Classe",
      "sb_pick_class":              "Choisir la classe",
      "sb_pick_class_prompt":       "Choisissez une classe pour commencer à construire son emploi du temps.",
      "sb_save":                    "Enregistrer l'emploi du temps",
      "sb_saved":                   "{{count}} cours enregistrés en une seule requête",
      "sb_undo":                    "Annuler",
      "sb_copy_to_class":           "Copier vers une autre classe",
      "sb_autofill":                "Compléter automatiquement",
      "sb_keyboard_hint":           "Raccourcis : touches 1-9 pour choisir un bloc, Échap pour désélectionner, Ctrl+Z pour annuler.",
      "sb_palette":                 "Blocs disponibles pour cette classe",
      "sb_no_blocks":               "Aucun enseignant n'est rattaché à cette classe ({{cls}}). Ajoutez d'abord la classe aux enseignants concernés.",
      "sb_block_remaining":         "reste {{count}}",
      "sb_block_done":              "Complet",
      "sb_eraser":                  "Gomme",
      "sb_teachers_without_subjects": "Enseignants sans matière enregistrée, donc sans bloc : {{names}}",
      "sb_pick_block_first":        "Choisissez d'abord un bloc, puis cliquez sur la case.",
      "sb_period":                  "Cours",
      "sb_period_n":                "Cours {{n}}",
      "sb_grid_for":                "Emploi du temps de {{cls}}",
      "sb_placed":                  "{{count}} cours placés",
      "sb_locked_tooltip":          "{{teacher}} est déjà en cours avec {{cls}} à cette heure",
      "sb_needs_teacher":           "Enseignant à choisir",
      "sb_busy_in":                 "occupé avec {{cls}}",
      "sb_problems":                "{{count}} case(s) à corriger avant l'enregistrement.",
      "sb_fix_problems_first":      "Corrigez {{count}} case(s) avant d'enregistrer.",
      "sb_server_rejected":         "Le serveur a refusé l'enregistrement pour les raisons suivantes ; aucun cours n'a été enregistré :",
      "sb_legacy_rows":             "{{count}} cours enregistrés avec des horaires qui ne correspondent pas à la grille actuelle et n'apparaissent donc pas ici. Consultez-les dans la vue hebdomadaire.",
      "sb_duplicate_cells":         "Cette classe a plus d'un emploi du temps le(s) : {{days}}. La grille n'en montre qu'une version, et l'enregistrement ne garde que ce que vous voyez. Réglez d'abord les doublons signalés plus haut.",
      "sdup_title":                 "Emplois du temps en double pour une même classe et un même jour",
      "sdup_intro":                 "{{count}} case(s) (classe et jour) ont plus d'un emploi du temps. Leurs cours s'empilent dans la vue hebdomadaire et à l'impression, et comptent deux fois dans l'annuaire de l'école. Choisissez la version à garder.",
      "sdup_version":               "Version {{n}} — {{count}} cours",
      "sdup_keep":                  "Garder cette version",
      "sdup_merge":                 "Fusionner les versions",
      "sdup_conflict_slots":        "Les versions diffèrent sur : {{slots}}",
      "sdup_archived":              "Année archivée — lecture seule",
      "sdup_resolved":              "Un seul emploi du temps reste pour cette classe et ce jour",
      "sdup_confirm_keep":          "Les autres versions de ce jour seront supprimées (une copie est archivée). Continuer ?",
      "sb_autofill_done":           "{{count}} cours placés. Vérifiez et ajustez avant d'enregistrer.",
      "sb_autofill_review_hint":    "Rien n'est encore enregistré — utilisez le bouton ci-dessus.",
      "sb_unplaced_no_teacher":     "Impossible de placer {{count}} cours de {{subject}} — aucun enseignant de cette matière pour cette classe.",
      "sb_unplaced_teacher_busy":   "Impossible de placer {{count}} cours de {{subject}} — {{names}} est occupé sur tous les créneaux restants.",
      "sb_unplaced_grid_full":      "Impossible de placer {{count}} cours de {{subject}} — plus aucune case libre.",
      "sb_copy_title":              "Copier vers une autre classe",
      "sb_copy_hint":               "Tout l'emploi du temps est copié ; chaque case dont l'enseignant est déjà occupé dans la classe cible est vidée pour que vous choisissiez un remplaçant.",
      "sb_copy_pick_target":        "Choisir la classe cible",
      "sb_copy_confirm":            "Copier",
      "sb_copy_needs_teacher":      "{{count}} case(s) nécessitent un autre enseignant dans cette classe :",

      // ── Bell schedule + curriculum settings [2026-09] ──────────────
      "ss_bell_title":              "Horaires des cours (sonnerie)",
      "ss_bell_hint":               "Définissez les horaires une seule fois pour toute l'école. Ensuite, plus personne ne saisit d'heure en construisant un emploi du temps. N'importe quelle heure de début, durée ou nombre de cours.",
      "ss_bell_period_n":           "Cours {{n}}",
      "ss_bell_start":              "Début du cours",
      "ss_bell_end":                "Fin du cours",
      "ss_bell_add":                "Ajouter un cours",
      "ss_bell_remove":             "Supprimer le cours",
      "ss_bell_summary":            "{{count}} cours — {{minutes}} minutes d'enseignement par jour",
      "ss_bell_invalid_rows":       "Certaines lignes sont invalides (heure manquante, fin avant le début, ou chevauchement) et ne seront pas enregistrées.",
      "ss_curriculum_title":        "Programme hebdomadaire (facultatif)",
      "ss_curriculum_hint":         "Nombre de cours par semaine et par matière pour chaque niveau. Sert au compteur « reste » sur les blocs et au remplissage automatique. La construction fonctionne entièrement sans.",
      "ss_curriculum_grade":        "Niveau",
      "ss_curriculum_subject":      "Matière",
      "ss_curriculum_per_week":     "Cours/semaine",
      "ss_curriculum_add":          "Ajouter une ligne",
      "ss_curriculum_remove":       "Supprimer la ligne",
      "ss_curriculum_empty":        "Aucun programme défini — c'est entièrement facultatif.",

      // ── Teacher documents [FEAT teacher-docs 2026-09] ──────────────
      "td_docs_button":             "Documents de l'enseignant",
      "td_docs_title":              "Documents de {{name}}",
      "td_docs_privacy_note":       "Documents personnels. Seules la direction de cette école et la personne concernée y ont accès ; chaque dépôt, téléchargement et suppression est journalisé.",
      "td_docs_type":               "Type de document",
      "td_docs_pick_type":          "Choisir le type",
      "td_docs_upload":             "Téléverser",
      "td_docs_uploaded":           "Document téléversé",
      "td_docs_upload_error":       "Échec du téléversement",
      "td_docs_download_error":     "Échec du téléchargement",
      "td_docs_delete_error":       "Échec de la suppression",
      "td_docs_load_error":         "Impossible de charger les documents",
      "td_docs_deleted":            "Document supprimé",
      "td_docs_confirm_delete":     "Supprimer définitivement « {{name}} » ?",
      "td_docs_empty":              "Aucun document pour cet enseignant.",
      "td_docs_rules":              "PDF ou image (JPG/PNG) uniquement, {{max}} maximum par fichier. Les images sont compressées automatiquement.",
      "td_docs_too_big":            "Le fichier dépasse la taille maximale ({{max}}).",
      "td_docs_missing_required":   "Documents obligatoires manquants : {{names}}",
      "td_docs_all_required_present": "Tous les documents obligatoires sont présents.",
      "td_docs_type_inactive":      "Type désactivé",
      "td_docs_compressed_from":    "compressé depuis {{original}}",
      "ss_doctypes_title":          "Types de documents des enseignants",
      "ss_doctypes_hint":           "Définissez les documents que votre école exige de ses enseignants. Modifiable à tout moment.",
      "ss_doctypes_label_ar":       "Libellé en arabe",
      "ss_doctypes_label_fr":       "Libellé en français",
      "ss_doctypes_label_en":       "Libellé en anglais",
      "ss_doctypes_required":       "Obligatoire",
      "ss_doctypes_add":            "Ajouter un type",
      "ss_doctypes_remove":         "Supprimer le type",
      "ss_doctypes_save":           "Enregistrer les types",
      "ss_doctypes_saved":          "Types de documents enregistrés",
      "ss_doctypes_save_error":     "Échec de l'enregistrement des types",
      "ss_doctypes_empty":          "Aucun type défini.",
      "ss_doctypes_removal_note":   "Retirer un type de la liste ne supprime aucun fichier déjà téléversé ; celui-ci conserve son ancien libellé.",
      "ss_storage_title":           "Espace de stockage",
      "ss_storage_used":            "{{used}} sur {{quota}}",
      "ss_storage_documents":       "{{count}} document(s)",
      "ss_storage_hint":            "Taille maximale par fichier : {{max}}. Les images sont compressées automatiquement pour économiser l'espace.",
      "ssy_disk_title":             "Espace disque",
      "ssy_disk_used":              "{{used}} utilisés sur {{total}} ({{percent}} %)",
      "ssy_disk_free":              "{{free}} disponibles",
      "ssy_disk_warning":           "Le disque est rempli à {{percent}} % (seuil {{threshold}} %). Un disque plein arrête la base de données et les sauvegardes, pas seulement les téléversements.",
      "ssy_disk_by_school":         "Consommation par école",
      "ssy_disk_documents":         "{{count}} document(s)",

      // Auth
      "exam_schedule_title": "Calendrier des examens",
      "exam_add": "Ajouter un examen",
      "exam_edit": "Modifier l'examen",
      "exam_print": "Imprimer le calendrier",
      "exam_created": "Examen créé avec succès",
      "exam_updated": "Examen mis à jour avec succès",
      "exam_deleted": "Examen supprimé",
      "exam_confirm_delete": "Voulez-vous vraiment supprimer cet examen ?",
      "exam_empty": "Aucun examen programmé pour le moment",
      "exam_readonly_note": "Ce calendrier est en lecture seule",
      "exam_col_time": "Heure",
      "exam_col_subject": "Matière",
      "exam_col_class": "Classe",
      "exam_col_room": "N° de salle",
      "exam_col_invigilator": "Enseignant surveillant",
      "exam_col_date": "Date",
      "exam_col_notes": "Remarques",
      "exam_pick_subject": "Choisir la matière",
      "exam_pick_class": "Choisir la classe",
      "exam_pick_teacher": "Choisir le surveillant",
      "exam_room_placeholder": "ex : 101",
      "exam_start_time": "Heure de début",
      "exam_end_time": "Heure de fin",
      "exam_err_required": "Veuillez remplir tous les champs obligatoires",
      "exam_err_time_range": "L'heure de fin doit être postérieure à l'heure de début",
      "exam_err_save": "Impossible d'enregistrer l'examen",
      "exam_err_delete": "Impossible de supprimer l'examen",
      "exam_popup_blocked": "Fenêtre contextuelle bloquée, veuillez autoriser les pop-ups pour imprimer",
      "login": "Connexion",
      "logout": "Déconnexion",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "select_role": "Sélectionner le rôle",
      "remember_me": "Se souvenir de moi",
      "forgot_password": "Mot de passe oublié?",
      "welcome_back": "Bienvenue",
      "login_subtitle": "EduGate — Plateforme intelligente de gestion scolaire",
      
      // Roles
      "super_admin": "Super Admin",
      "school_admin": "Directeur d'école",
      "admin_staff": "Personnel administratif",
      "teacher": "Enseignant",
      "student": "Étudiant",
      "parent": "Parent",
      
      // Navigation
      "dashboard": "Tableau de bord",
      "schools": "Écoles",
      "students": "Étudiants",
      "teachers": "Enseignants",
      "parents": "Parents",
      "attendance": "Présence",
      "grades": "Notes",
      "assignments": "Devoirs",
      "fees": "Frais",
      "payments": "Paiements",
      "settings": "Paramètres",
      
      // Actions
      "add": "Ajouter",
      "edit": "Modifier",
      "delete": "Supprimer",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "search": "Rechercher",
      "filter": "Filtrer",
      "export": "Exporter",
      "view": "Voir",
      "submit": "Soumettre",
      
      // Dashboard
      "total_schools": "Total écoles",
      "total_students": "Total étudiants",
      "total_teachers": "Total enseignants",
      "total_parents": "Total parents",
      "present_today": "Présent aujourd'hui",
      "absent_today": "Absent aujourd'hui",
      "total_fees": "Total frais",
      "total_paid": "Payé",
      "total_pending": "En attente",
      
      // School Management
      "add_school": "Ajouter une école",
      "school_name": "Nom de l'école",
      "school_name_ar": "Nom en arabe",
      "school_name_fr": "Nom en français",
      "address": "Adresse",
      "phone": "Téléphone",
      "email": "E-mail",
      "admin_info": "Informations administrateur",
      "admin_username": "Nom d'utilisateur admin",
      "admin_password": "Mot de passe admin",
      "admin_full_name": "Nom complet admin",
      
      // Student Management
      "add_student": "Ajouter un étudiant",
      "student_info": "Informations étudiant",
      "full_name": "Nom complet",
      "class": "Classe",
      "grade": "Niveau",
      "date_of_birth": "Date de naissance",
      "medical_info": "Informations médicales",
      
      // Teacher Management
      "add_teacher": "Ajouter un enseignant",
      "teacher_info": "Informations enseignant",
      "subjects": "Matières",
      "classes": "Classes",
      "specialization": "Spécialisation",
      
      // Attendance
      "mark_attendance": "Marquer la présence",
      "date": "Date",
      "status": "Statut",
      "present": "Présent",
      "absent": "Absent",
      "late": "En retard",
      "excused": "Absence excusée",
      "notes": "Notes",
      
      // Grades
      "add_grade": "Ajouter une note",
      "subject": "Matière",
      "assessment_type": "Type d'évaluation",
      "assessment_name": "Nom de l'évaluation",
      "score": "Score",
      "max_score": "Score maximum",
      "percentage": "Pourcentage",
      "exam": "Examen",
      "quiz": "Quiz",
      "homework": "Devoir",
      "project": "Projet",
      
      // Assignments
      "add_assignment": "Ajouter un devoir",
      "title": "Titre",
      "description": "Description",
      "due_date": "Date limite",
      "attachment": "Pièces jointes",
      
      // Fees
      "add_fee": "Ajouter des frais",
      "amount": "Montant",
      "fee_type": "Type de frais",
      "academic_year": "Année académique",
      "semester": "Semestre",
      "paid": "Payé",
      "pending": "En attente",
      "partial": "Partiel",
      "overdue": "En retard",
      "tuition": "Scolarité",
      "transport": "Transport",
      "books": "Livres",
      
      // Payments
      "add_payment": "Ajouter un paiement",
      "payment_method": "Méthode de paiement",
      "reference_number": "Numéro de référence",
      "payment_date": "Date de paiement",
      "cash": "Espèces",
      "bank_transfer": "Virement bancaire",
      "online": "En ligne",
      
      // Messages
      "loading": "Chargement...",
      "no_data": "Aucune donnée",
      "success": "Succès",
      "error": "Erreur",
      "confirm_delete": "Confirmer la suppression?",
      
      // Language
      "language": "Langue",
      "arabic": "Arabe",
      "french": "Français",
      "english": "Anglais",
      
      // Additional
      "active": "Actif",
      "academic_years": "Années scolaires",
      "archived": "Archivée",
      "planned": "Planifiée",
      "read_only": "Lecture seule",
      "ay_label_fees": "Registres des frais des élèves",
      "ay_label_salaries": "Registres des salaires des enseignants",
      "ay_label_expenses": "Registres des dépenses de l'école",
      "ay_label_reports": "Rapports et statistiques",
      "ay_label_schedule": "Emplois du temps",
      "ay_label_grades": "Registres des notes",
      "ay_label_calendar": "Calendrier scolaire",
      "ay_label_records": "Registres",
      "ay_year_suffix": "Année scolaire {{year}}",
      "ay_archive_banner": "Vous consultez des données archivées de l'année scolaire {{year}} — lecture seule",
      "ay_help_button": "Guide de l'année scolaire",
      "ay_help_title": "Guide des années scolaires",
      "ay_help_intro_h": "Qu'est-ce qu'une année scolaire ?",
      "ay_help_intro_p": "L'année scolaire est le cadre temporel qui organise toutes les données de votre école (frais, salaires, notes, présences, emplois du temps, calendrier). Chaque enregistrement est rattaché à une année précise, ce qui garde les données de chaque année séparées et claires.",
      "ay_help_sequence_h": "Ordre des étapes requis avant le passage d'année",
      "ay_help_sequence_p": "Avant que le passage d'année ne fonctionne, l'année en cours doit suivre cette séquence via les boutons de statut du tableau des années : (1) « Active » pendant l'année. (2) Cliquez « Prête pour la promotion » en fin d'année. (3) Cliquez « Approuver ». (4) Le plus important — cliquez « Verrouiller les résultats » : c'est une étape distincte de l'approbation, qui signifie que l'administration a approuvé et verrouillé les résultats finaux ; sans elle, le système refuse le passage avec le message « les résultats ne sont pas encore approuvés et verrouillés ». Le bouton « Verrouiller les résultats » se trouve à côté des boutons de statut et aussi dans l'assistant de passage. (5) Cliquez « Démarrer l'assistant de passage ». Note : approuver et verrouiller les résultats sont deux actions distinctes — approuver ne verrouille pas automatiquement les résultats.",
      "ay_help_rollover_h": "Que signifie le « passage d'année » (rollover) ?",
      "ay_help_rollover_p": "Le passage d'année est la transition d'une année scolaire à la suivante. Au démarrage d'une nouvelle année, vous choisissez comment traiter les données de l'année précédente — aucune donnée n'est jamais supprimée, quel que soit le mode.",
      "ay_help_archive_h": "Mode 1 : Archiver et continuer",
      "ay_help_archive_p": "Les enregistrements de l'année précédente (finances, messages, notes…) restent consultables dans une vue archivée, clairement en lecture seule, tandis que les nouvelles données sont saisies sous la nouvelle année. Idéal pour retrouver facilement les chiffres de l'an dernier.",
      "ay_help_fresh_h": "Mode 2 : Nouveau départ",
      "ay_help_fresh_p": "La nouvelle année démarre avec des écrans vierges ; les données de l'année précédente sont archivées et ne s'affichent pas par défaut dans les vues courantes. L'archive reste toujours accessible via le sélecteur d'année, et rien n'est supprimé.",
      "ay_help_separation_h": "Comment les données sont-elles séparées entre les années ?",
      "ay_help_separation_p": "Les frais, salaires, dépenses, notes, présences, emplois du temps et le calendrier sont séparés par année scolaire. Pendant l'année en cours, seules les données de l'année en cours s'affichent — jamais mélangées avec d'anciennes années — et chaque écran porte une étiquette indiquant l'année affichée.",
      "ay_help_access_h": "Comment les élèves, enseignants et parents consultent-ils les données de l'an dernier ?",
      "ay_help_access_p": "Un menu déroulant de sélection d'année est présent sur les tableaux de bord des élèves, enseignants et parents. En choisissant une année passée, ils consultent (en lecture seule) les notes, présences et enregistrements de cette année auxquels ils ont droit.",
      "ay_help_lock_h": "Pourquoi l'année d'une date est-elle verrouillée à la saisie ?",
      "ay_help_lock_p": "À la saisie de toute date (frais, salaires, dépenses, notes, présences, calendrier), l'année est fixée sur l'année scolaire active ; vous ne choisissez que le jour et le mois. C'est intentionnel, pour éviter des erreurs courantes comme enregistrer un montant dans la mauvaise année. Le système refuse toute date hors de l'année active.",
      "ay_help_steps_h": "Étapes pour démarrer une nouvelle année scolaire",
      "ay_help_step1": "Ajoutez la nouvelle année scolaire (au format AAAA-AAAA) via le bouton « Ajouter une année scolaire ».",
      "ay_help_step2": "Cliquez sur « Démarrer l'assistant de passage » et choisissez le mode : Archiver et continuer ou Nouveau départ.",
      "ay_help_step3": "Vérifiez l'affectation des classes pour les élèves promus et confirmez ; les données de l'année précédente ne sont pas supprimées.",
      "ay_help_step4": "La nouvelle année devient active automatiquement ; l'année précédente est archivée et reste accessible via le sélecteur d'année.",
      "ay_help_faq_h": "Questions fréquentes",
      "ay_help_faq_q1": "Les données de l'an dernier sont-elles supprimées lors du passage ?",
      "ay_help_faq_a1": "Non. Aucune donnée n'est jamais supprimée, quel que soit le mode ; seul ce qui s'affiche par défaut change, et tous les enregistrements restent accessibles via le sélecteur d'année.",
      "ay_help_faq_q2": "Puis-je modifier les données d'une année archivée ?",
      "ay_help_faq_a2": "Non. Les années archivées sont en lecture seule, avec une bannière claire qui vous en avertit. La saisie n'est possible que dans l'année active.",
      "ay_help_faq_q3": "J'ai saisi une date et le système l'a refusée, pourquoi ?",
      "ay_help_faq_a3": "Parce que l'année de la date est hors de l'année scolaire active. Choisissez un jour et un mois dans l'année active, ou changez d'abord l'année active si vous visez une autre année.",
      // Academic-year manager (AcademicYearManager.jsx) [I18N 2026-10]
      "aym_backups_load_error": "Échec du chargement des sauvegardes",
      "aym_invalid_year_format": "Format d'année scolaire invalide. Il doit être AAAA-AAAA",
      "aym_year_created": "Année scolaire créée avec succès",
      "aym_confirm_activate": "Voulez-vous vraiment activer l'année scolaire {{name}} comme année active ? Toute autre année active sera archivée.",
      "aym_year_activated": "L'année scolaire {{name}} est maintenant active",
      "aym_confirm_transition": "Voulez-vous vraiment faire passer l'année scolaire {{year}} au statut ({{status}}) ?",
      "aym_status_updated": "Statut de l'année scolaire mis à jour avec succès",
      "aym_calendar_saved": "Calendrier scolaire et phases enregistrés avec succès",
      "aym_results_locked_toast": "Phase des résultats verrouillée. Vous pouvez maintenant démarrer le passage d'année.",
      "aym_confirm_word_wrong": "Veuillez saisir correctement le mot de confirmation",
      "aym_restore_success": "L'état précédent des données a été restauré avec succès depuis l'instantané",
      "aym_active_year_required": "Une année scolaire active est d'abord requise",
      "aym_rollover_done": "Passage d'année terminé ! {{promoted}} élève(s) promu(s), {{retained}} redoublant(s).",
      "aym_phase_registration": "Inscription des nouveaux élèves",
      "aym_phase_study_exams": "Études et emploi du temps",
      "aym_phase_results": "Saisie finale des notes et résultats",
      "aym_phase_promotion_ready": "Préparation du passage d'année",
      "aym_status_planned": "Planifiée",
      "aym_status_active": "Active",
      "aym_status_ready": "Prête pour la promotion",
      "aym_status_approved": "Approuvée",
      "aym_status_promoting": "Passage en cours...",
      "aym_status_archived": "Archivée (lecture seule)",
      "aym_title": "Années scolaires et passage d'année",
      "aym_subtitle": "Créez et gérez le cycle de vie des années scolaires, les verrous du calendrier et les sauvegardes.",
      "aym_add_year": "Ajouter une année scolaire",
      "aym_start_rollover": "Démarrer l'assistant de passage",
      "aym_tab_cycles": "Années scolaires et calendrier",
      "aym_tab_backups": "Sauvegardes et récupération des données",
      "aym_cycles_title": "Années scolaires disponibles",
      "aym_col_year": "Année scolaire",
      "aym_start_date": "Date de début",
      "aym_end_date": "Date de fin",
      "aym_col_actions": "Actions",
      "aym_btn_activate": "Activer comme année active",
      "aym_btn_mark_ready": "Prête pour la promotion",
      "aym_btn_approve": "Approuver",
      "aym_btn_lock_results": "Verrouiller les résultats",
      "aym_btn_archive": "Archiver",
      "aym_closed_history": "Historique clôturé",
      "aym_workflow_title": "Cycle de vie de l'année scolaire",
      "aym_wf_planned": "Planifiée",
      "aym_wf_ready": "Prête",
      "aym_wf_archived": "Archivée",
      "aym_calendar_locks_title": "Calendrier scolaire et verrouillage des phases",
      "aym_locked": "Verrouillée",
      "aym_unlocked": "Ouverte",
      "aym_save_calendar": "Enregistrer les paramètres du calendrier",
      "aym_no_years": "Aucune année scolaire configurée",
      "aym_guidelines_title": "Consignes de traitement des données",
      "aym_guidelines_isolation": "Le système sépare entièrement les notes, les emplois du temps et les présences des élèves pour chaque année scolaire.",
      "aym_guidelines_phase_locking": "Verrouillage des phases :",
      "aym_guidelines_lock_registration": "Verrouiller l'inscription empêche l'ajout de nouveaux élèves pour l'année.",
      "aym_guidelines_lock_study": "Verrouiller les études et examens empêche la modification des emplois du temps.",
      "aym_guidelines_lock_grades": "Verrouiller la saisie des notes empêche totalement les enseignants de saisir ou de modifier les notes.",
      "aym_snapshots_title": "Instantanés et sauvegardes du passage d'année",
      "aym_snapshots_desc": "Le système enregistre automatiquement un instantané complet des données avant chaque passage d'année, pour qu'elles ne soient jamais perdues et qu'un retour arrière reste possible.",
      "aym_col_backup_id": "ID de la sauvegarde",
      "aym_col_timestamp": "Date et heure",
      "aym_col_old_cycle": "ID de l'ancienne année",
      "aym_backup_committed": "Enregistrée / valide",
      "aym_backup_rolled_back": "Restaurée (annulée)",
      "aym_restore_btn": "Restaurer l'instantané",
      "aym_already_restored": "Déjà restaurée",
      "aym_no_backups": "Aucune sauvegarde de passage d'année enregistrée pour l'instant",
      "aym_create_title": "Créer une nouvelle année scolaire",
      "aym_create_desc": "Saisissez le nom de l'année scolaire au format AAAA-AAAA (ex. : 2026-2027) ainsi que ses dates de début et de fin.",
      "aym_year_name_label": "Nom de l'année scolaire (format : AAAA-AAAA) *",
      "aym_restore_title": "Confirmation de sécurité avant restauration des données",
      "aym_restore_warning": "Attention : restaurer l'instantané supprimera toutes les modifications faites après le passage d'année et ramènera les emplois du temps et les élèves à l'état de l'instantané.",
      "aym_restore_type_word": "Pour confirmer, saisissez le mot « ROLLBACK » dans le champ ci-dessous :",
      "aym_restore_proceed": "Confirmer et restaurer immédiatement",
      "aym_wizard_title": "Assistant de passage d'année scolaire",
      "aym_wizard_desc": "Passage de l'école de l'année en cours {{year}} à la nouvelle année.",
      "aym_step_years": "Années",
      "aym_step_classes": "Classes",
      "aym_step_retentions": "Redoublements",
      "aym_step_options": "Options",
      "aym_step_confirm": "Confirmation",
      "aym_target_year_title": "Année scolaire cible",
      "aym_requirements_title": "Conditions pour démarrer le passage d'année",
      "aym_req_status": "Statut de l'année validé (Prête pour la promotion ou Approuvée) — via les boutons de statut du tableau des années",
      "aym_req_results_locked": "Phase des résultats verrouillée (résultats finaux approuvés)",
      "aym_lock_results_now": "Verrouiller les résultats maintenant",
      "aym_current_active_year": "Année en cours (active)",
      "aym_target_year_label": "Nouvelle année scolaire (format : AAAA-AAAA) *",
      "aym_class_mapping_title": "Règles de passage des classes",
      "aym_class_mapping_desc": "Pour chaque classe actuelle, indiquez la classe dans laquelle passeront les élèves admis.",
      "aym_no_classes": "Aucune classe à associer",
      "aym_retained_title": "Sélection des élèves redoublants",
      "aym_search_student_placeholder": "Rechercher par nom ou classe...",
      "aym_retained_desc": "Les élèves sélectionnés resteront dans leur classe actuelle pour la nouvelle année et ne seront pas promus.",
      "aym_no_search_results": "Aucun élève ne correspond à la recherche",
      "aym_retained_count": "Nombre d'élèves redoublants sélectionnés : {{n}}.",
      "aym_options_title": "Options supplémentaires du passage d'année",
      "aym_copy_schedules": "Dupliquer les emplois du temps hebdomadaires",
      "aym_copy_schedules_desc": "Le système copiera les emplois du temps actuels dans la nouvelle année scolaire.",
      "aym_schedule_copy_mode_title": "Où copier l'emploi du temps de chaque classe ?",
      "aym_schedule_same_class": "Chaque classe garde le sien",
      "aym_schedule_same_class_desc": "L'emploi du temps de la 1re A est copié vers la 1re A de la nouvelle année. Adapté quand la répartition des cours par classe ne change pas.",
      "aym_schedule_follow": "Il suit les élèves",
      "aym_schedule_follow_desc": "L'emploi du temps de la 1re A passe à la classe où ses élèves sont promus (2e A) ; la nouvelle 1re A reste sans emploi du temps.",
      "aym_enabled": "Activé",
      "aym_disabled": "Désactivé",
      "aym_allow_unpaid": "Autoriser la promotion des élèves ayant des frais impayés",
      "aym_allow_unpaid_desc": "Activer cette option ignore la vérification des impayés et permet de faire passer tous les élèves, quels que soient leurs frais.",
      "aym_mode_title": "Comment démarrer la nouvelle année ?",
      "aym_mode_desc": "Aucune donnée n'est jamais supprimée, quel que soit le mode — seul l'affichage par défaut des écrans change.",
      "aym_mode_archive": "Archiver et continuer",
      "aym_mode_archive_desc": "Les dossiers de l'an dernier (finances, messages, notes) restent consultables en lecture seule via le sélecteur d'année.",
      "aym_mode_fresh": "Nouveau départ",
      "aym_mode_fresh_desc": "Les écrans n'affichent que la nouvelle année ; les anciennes données restent stockées et accessibles via le filtre d'année.",
      "aym_final_review_title": "Vérification et confirmation finale du passage d'année",
      "aym_final_warning": "Attention : cette opération est importante et modifie en masse les données du système.",
      "aym_final_archive_current": "L'année scolaire en cours ({{year}}) sera archivée et clôturée.",
      "aym_final_activate_new": "La nouvelle année scolaire ({{year}}) sera activée.",
      "aym_final_students": "Les élèves admis passeront dans leurs nouvelles classes ; les redoublants resteront dans la même classe.",
      "aym_promoted_students": "Élèves promus",
      "aym_retained_students": "Élèves redoublants",
      "aym_schedule_copy": "Copie de l'emploi du temps",
      "aym_outstanding_fees": "Impayés",
      "aym_allowed": "Autorisé",
      "aym_strict": "Interdit",
      "aym_next_cycle": "Année suivante",
      "aym_start_mode": "Mode de démarrage",
      "aym_mode_archive_short": "Archivage",
      "aym_prev": "Précédent",
      "aym_invalid_year_short": "Format d'année invalide",
      "aym_next": "Suivant",
      "aym_confirm_rollover": "Confirmer le passage d'année",
      "inactive": "Inactif",
      "relationship": "Relation",
      "father": "Père",
      "mother": "Mère",
      "guardian": "Tuteur",
      "select_student": "Sélectionner un étudiant",
      "select_students": "Sélectionner les étudiants",
      "mark_attendance_for": "Marquer la présence pour",
      "select_date": "Sélectionner la date",
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "this_week": "Cette semaine",
      "this_month": "Ce mois-ci",
      "all": "Tous",
      "select_class": "Sélectionner la classe",
      "select_subject": "Sélectionner la matière",
      "enter_score": "Entrer la note",
      "out_of": "sur",
      "weight": "Poids",
      "first_semester": "Premier semestre",
      "second_semester": "Deuxième semestre",
      "payment_history": "Historique des paiements",
      "pay_now": "Payer maintenant",
      "discount": "Réduction",
      "scholarship": "Bourse",
      "create_assignment": "Créer un devoir",
      "due_in": "Date limite",
      "submitted": "Soumis",
      "not_submitted": "Non soumis",
      "graded": "Noté",

      // Announcement Board
      "ann_board_title": "Tableau d'annonces",
      "ann_board_subtitle": "Annonces de l'école et des classes",
      "ann_new": "Nouvelle annonce",
      "ann_title_placeholder": "Titre de l'annonce",
      "ann_content_placeholder": "Contenu de l'annonce...",
      "ann_priority": "Priorité",
      "ann_priority_normal": "Normal",
      "ann_priority_important": "Important",
      "ann_priority_urgent": "Urgent",
      "ann_target": "Public cible",
      "ann_target_all": "Tous",
      "ann_target_parents": "Parents",
      "ann_target_students": "Étudiants",
      "ann_target_class": "Classe spécifique",
      "ann_select_class": "-- Choisir la classe --",
      "ann_publish": "Publier l'annonce",
      "ann_publishing": "Publication en cours...",
      "ann_empty": "Aucune annonce pour le moment",
      "ann_written_by": "Par",
      "ann_class_label": "Classe",
      "ann_delete_success": "Annonce supprimée",
      "ann_delete_error": "Échec de la suppression",
      "ann_post_success": "Annonce publiée",
      "ann_post_error": "Erreur lors de la publication",
      "ann_load_error": "Impossible de charger les annonces",
      "ann_validation": "Remplissez le titre et le contenu",

      // Sidebar nav
      "nav_dashboard": "Tableau de bord",
      "nav_students": "Étudiants",
      "nav_teachers": "Enseignants",
      "nav_parents": "Parents",
      "nav_attendance": "Présence",
      "nav_grades": "Notes",
      "nav_fees": "Frais scolaires",
      "nav_schedule": "Emploi du temps",
      "nav_excel": "Import Excel",
      "nav_reports": "Rapports",
      "nav_pdf_reports": "Rapports PDF",
      "nav_bulk_attendance": "Présence en masse",
      "nav_staff_attendance": "Présence des enseignants",
      "nav_student_attendance": "Présence des élèves",
      "nav_announcements": "Annonces",
      "nav_homework": "Devoirs",
      "nav_section_people": "Personnes",
      "nav_section_academic": "Académique",
      "nav_section_finance": "Finances",
      "nav_section_communication": "Communication",
      "nav_section_reports": "Rapports",
      "nav_section_control_panel": "Panneau de contrôle",
      "nav_group_community": "Communauté",
      "nav_group_academic": "Académique",
      "nav_group_communications": "Communication",
      "nav_group_finance": "Finances",
      "nav_group_scheduling": "Emploi du temps",
      "nav_group_staff": "Personnel",
      "nav_group_settings": "Paramètres",
      "dash_total_parents": "Parents",
      "dash_attendance_rate": "Taux de présence",
      "dash_welcome_admin": "Bienvenue {{name}}",
      "dash_welcome_subtitle": "Vue d'ensemble de votre école aujourd'hui",
      "dash_welcome_teacher": "Bienvenue {{name}} — enseignant",
      "dash_welcome_student": "Bienvenue {{name}}",
      "dash_welcome_parent": "Bienvenue {{name}} — parent",
      "empty_no_data_title": "Aucune donnée pour l'instant",
      "empty_no_data_action": "Commencez par ajouter un élément",
      "dash_unread_messages": "Messages non lus",
      "dash_quick_actions": "Actions rapides",
      "dash_quick_add_student": "Ajouter un élève",
      "dash_quick_announcement": "Envoyer une annonce",
      "dash_quick_add_teacher": "Ajouter un enseignant",
      "dash_quick_attendance": "Saisir la présence",
      "dash_weekly_attendance": "Présence de la semaine",
      "dash_recent_activity": "Activité récente",
      "dash_activity_empty": "Aucune activité pour l'instant",
      "dash_alerts": "Alertes",
      "dash_alert_absences": "Élèves avec 3+ absences",
      "dash_alert_unpaid_fees": "Frais impayés",
      "dash_alert_pending_tasks": "Tâches enseignants en attente",
      "comm_title": "Communication",
      "comm_tab_direct": "Messages directs",
      "comm_tab_broadcast": "Diffusion",
      "comm_compose": "Composer",
      "comm_inbox": "Boîte de réception",
      "comm_sent": "Envoyés",
      "comm_recipient_type": "Type de destinataire",
      "comm_recipient_admin": "Direction",
      "comm_recipient_student": "Élève",
      "comm_recipient_parent": "Parent",
      "comm_pick_student": "Choisir un élève",
      "comm_pick_parent": "Choisir un parent",
      "comm_pick_class": "Choisir une classe",
      "comm_admin_hint": "Le message sera envoyé directement au principal de l'école.",
      "comm_subject": "Objet",
      "comm_subject_placeholder": "Objet du message (facultatif)",
      "comm_message": "Contenu du message",
      "comm_message_placeholder": "Écrivez votre message ici...",
      "comm_chars": "caractères",
      "comm_notify_parent": "Envoyer aussi une copie au parent",
      "comm_send": "Envoyer",
      "comm_sending": "Envoi...",
      "comm_sent_ok": "Message envoyé ✓",
      "comm_broadcast_ok": "Diffusion envoyée ✓",
      "comm_target": "Cible",
      "comm_broadcast_class": "Classe",
      "comm_broadcast_student": "Élève précis",
      "comm_broadcast_admins": "Direction",
      "comm_broadcast_send": "Envoyer la diffusion",
      "comm_broadcast_history": "Historique des diffusions",
      "comm_broadcast_badge": "Diffusion",
      "comm_history_empty": "Aucune diffusion envoyée",
      "comm_inbox_empty": "Aucun message reçu",
      "comm_sent_empty": "Aucun message envoyé",
      "comm_unknown": "Inconnu",
      "comm_new": "Nouveau",
      "comm_validation_message": "Saisissez le contenu du message",
      "comm_validation_pick_student": "Choisissez un élève",
      "comm_validation_pick_parent": "Choisissez un parent",
      "comm_validation_pick_class": "Choisissez une classe",
      "acct_title": "Paramètres du compte",
      "acct_subtitle": "Gérez votre photo et votre mot de passe au même endroit",
      "acct_profile_picture": "Photo de profil",
      "acct_change_password": "Changer le mot de passe",
      "acct_image_hint": "Cliquez sur l'image pour en choisir une nouvelle, puis appuyez sur Enregistrer.",
      "acct_image_size_hint": "JPG ou PNG, 2 Mo max.",
      "acct_image_choose": "Choisir une image",
      "acct_image_unsaved": "Nouvelle image en attente — cliquez sur Enregistrer.",
      "acct_save_image": "Enregistrer la photo",
      "acct_image_saved": "Photo mise à jour ✓",
      "acct_image_too_big": "La photo ne doit pas dépasser 2 Mo",
      "acct_image_encoded_too_big": "L'image encodée est trop grande — choisissez plus petite",
      "acct_pwd_current": "Mot de passe actuel",
      "acct_pwd_new": "Nouveau mot de passe",
      "acct_pwd_confirm": "Confirmer le mot de passe",
      "acct_pwd_min_hint": "8 caractères minimum pour le nouveau mot de passe.",
      "acct_pwd_all_required": "Tous les champs sont requis",
      "acct_pwd_mismatch": "Les nouveaux mots de passe ne correspondent pas",
      "acct_pwd_too_short": "Le mot de passe doit contenir au moins 8 caractères",
      "acct_pwd_saved": "Mot de passe modifié ✓",
      "acct_pwd_error": "Erreur lors du changement",
      "acct_save_password": "Enregistrer le mot de passe",
      "acct_saved": "Enregistré",
      "acct_saving": "Enregistrement...",
      "staff_title": "Personnel administratif",
      "staff_subtitle": "Créez des comptes pour le personnel administratif avec des permissions spécifiques",
      "staff_add": "Ajouter un membre",
      "staff_save": "Enregistrer",
      "staff_saving": "Enregistrement...",
      "staff_added": "Compte créé ✓",
      "staff_perms_updated": "Permissions mises à jour ✓",
      "staff_deactivated": "Compte désactivé",
      "staff_full_name": "Nom complet",
      "staff_username": "Identifiant",
      "staff_password": "Mot de passe",
      "staff_pwd_hint": "8 caractères minimum",
      "staff_permissions": "Permissions accordées",
      "staff_col_name": "Nom",
      "staff_col_username": "Identifiant",
      "staff_col_permissions": "Permissions",
      "staff_col_last_active": "Dernière activité",
      "staff_col_status": "Statut",
      "staff_col_actions": "Actions",
      "staff_active": "Actif",
      "staff_inactive": "Désactivé",
      "staff_edit_perms": "Modifier les permissions",
      "staff_view_activity": "Voir l'activité",
      "staff_deactivate": "Désactiver",
      "staff_activity": "Activité",
      "staff_empty": "Aucun membre pour l'instant — ajoutez-en un",
      "staff_validation_required": "Veuillez renseigner nom, identifiant et mot de passe",
      "staff_validation_pwd_short": "Le mot de passe doit faire au moins 8 caractères",
      "staff_validation_marital": "Statut familial invalide",
      "staff_phone": "Téléphone",
      "staff_position": "Poste",
      "staff_position_placeholder": "Ex : secrétaire, comptable",
      "staff_marital_status": "Statut familial",
      "staff_address": "Adresse",
      "staff_col_position": "Poste",
      "staff_col_phone": "Téléphone",
      "staff_email": "E-mail",
      "staff_edit_info": "Modifier les informations",
      "staff_info_updated": "Informations mises à jour ✓",
      "staff_suspend": "Suspendre",
      "staff_unsuspend": "Réactiver",
      "staff_suspended": "Suspendu",
      "staff_unsuspended": "Compte réactivé ✓",
      "staff_confirm_suspend": "Suspendre le compte de {{name}} ? Cette personne ne pourra plus se connecter.",
      "staff_confirm_unsuspend": "Réactiver le compte de {{name}} ?",
      "staff_delete_permanent": "Suppression définitive",
      "staff_delete_warning": "Le compte de {{name}} sera supprimé définitivement.",
      "staff_delete_irreversible": "Cette action est irréversible.",
      "staff_delete_confirm": "Confirmer la suppression",
      "staff_deleting": "Suppression...",
      "staff_deleted": "Supprimé définitivement",
      "attendance_stats_title": "Statistiques de présence",
      "attendance_overall_rate": "Taux de présence global",
      "attendance_total_days": "Jours d'école",
      "attendance_present": "Présent",
      "attendance_absent": "Absent",
      "attendance_late": "En retard",
      "attendance_excused": "Excusé",
      "td_my_students": "Mes élèves",
      "td_present_today": "Présents aujourd'hui",
      "td_absent_today": "Absents aujourd'hui",
      "td_assignments": "Devoirs",
      "td_my_subjects": "Matières que j'enseigne",
      "td_my_classes": "Classes que j'enseigne",
      "td_no_subjects": "Aucune matière assignée",
      "td_no_classes": "Aucune classe assignée",
      "td_quick_actions": "Actions rapides",
      "td_choose_class_hint": "Veuillez choisir une classe dans la liste ci-dessus pour afficher les élèves et saisir les présences.",
      "td_record_attendance": "Saisir la présence",
      "td_enter_grades": "Saisir les notes",
      "td_add_assignment": "Ajouter un devoir",
      "td_my_schedule": "Mon emploi du temps",
      "td_my_salaries": "Mes salaires",
      "td_load_error": "Erreur lors du chargement",
      "td_attendance_saved": "Présence enregistrée",
      "td_attendance_save_error": "Erreur d'enregistrement",
      "td_all_marked_present": "Tous les élèves marqués présents",
      "td_all_marked_absent": "Tous les élèves marqués absents",
      "marital_single": "Célibataire",
      "marital_married": "Marié(e)",
      "marital_divorced": "Divorcé(e)",
      "marital_widowed": "Veuf/Veuve",
      "id_card_my_card": "Ma carte",
      "id_card_print": "Imprimer la carte",
      "id_card_print_hint": "Cliquez sur « Imprimer la carte » ci-dessus pour l'imprimer au format carte de crédit.",
      "id_card_hide_photo": "Masquer la photo",
      "id_card_show_photo": "Afficher la photo",
      "acct_image_remove": "Supprimer la photo",
      "acct_image_remove_confirm": "Voulez-vous vraiment supprimer votre photo de profil ?",
      "acct_image_removed": "Photo de profil supprimée ✓",
      "id_card_academic_year": "Année scolaire",
      "id_card_student_number": "N° d'élève",
      "id_card_teacher_number": "N° d'employé",
      "id_card_position": "Poste",
      "id_card_subjects": "Matières",
      "id_card_class": "Classe",
      "id_card_grade": "Niveau",
      "id_card_specialization": "Spécialité",
      "staff_confirm_deactivate": "Désactiver le compte {{name}} ? Il ne pourra plus se connecter.",
      "staff_welcome": "Bienvenue {{name}} — compte personnel administratif",
      "staff_dashboard_subtitle": "Vos permissions déterminent ce que vous pouvez gérer. Contactez la direction pour en demander davantage.",
      "staff_recent_activity": "Activité récente",
      "staff_no_activity": "Aucune activité récente à afficher",
      "staff_activity_unknown": "Activité inconnue",
      "staff_last_login": "Dernière connexion",
      "staff_menu_title": "Menu",
      "close_menu": "Fermer le menu",
      "staff_role_label": "Personnel administratif",
      "staff_no_permissions": "Aucune permission accordée pour l'instant",
      "staff_denied": "Vous n'êtes pas autorisé à effectuer cette action",
      "perm_manage_students": "Gestion des élèves",
      "perm_manage_teachers": "Gestion des enseignants",
      "perm_manage_parents": "Gestion des parents",
      "perm_manage_finance": "Finances",
      "perm_manage_schedule": "Emploi du temps",
      "perm_manage_attendance": "Présence",
      "perm_manage_grades": "Notes et évaluations",
      "perm_manage_assignments": "Tâches des enseignants",
      "perm_view_reports": "Rapports et statistiques",
      "perm_send_announcements": "Annonces",
      "nav_settings": "Paramètres",
      "nav_my_schedule": "Mon emploi du temps",
      "nav_my_grades": "Mes notes",
      "nav_my_assignments": "Mes devoirs",
      "nav_my_attendance": "Ma présence",
      "nav_my_fees": "Mes frais",
      "nav_my_students": "Mes étudiants",
      "nav_my_parents": "Parents d'élèves",
      "nav_manage_homework": "Gérer les devoirs",
      "nav_change_photo": "Changer la photo",
      "nav_change_password": "Changer le mot de passe",

      // Dashboard stats
      "stat_total_students": "Total étudiants",
      "stat_total_teachers": "Total enseignants",
      "stat_present_today": "Présents aujourd'hui",
      "stat_absent_today": "Absents aujourd'hui",
      "stat_avg_grade": "Moyenne générale",
      "stat_attendance_rate": "Taux de présence",
      "stat_total_fees": "Total frais",
      "stat_paid_fees": "Payé",
      "stat_pending_fees": "Restant",
      "stat_assignments": "Devoirs",
      "stat_warnings": "Avertissements",

      // Table headers
      "th_name": "Nom",
      "th_class": "Classe",
      "th_status": "Statut",
      "th_date": "Date",
      "th_subject": "Matière",
      "th_score": "Note",
      "th_actions": "Actions",
      "th_amount": "Montant",
      "th_phone": "Téléphone",
      "th_email": "E-mail",
      "th_type": "Type",
      "th_month": "Mois",

      // Common
      "add_new": "Ajouter nouveau",
      "close": "Fermer",
      "confirm": "Confirmer",
      "back": "Retour",
      "refresh": "Actualiser",
      "no_records": "Aucune donnée",
      "welcome": "Bienvenue,",
      "your_school": "Votre école",
      "change_lang": "Changer la langue",
      "trial_expires": "L'essai expire dans",
      "days": "jours",
      "upgrade_now": "Mettre à niveau ↑",
      "today_schedule": "Emploi du temps d'aujourd'hui",
      "no_classes_today": "Pas de cours aujourd'hui",
      "recent_grades": "Dernières notes",
      "weekly_schedule": "Emploi du temps hebdomadaire",
      "no_schedule": "Pas de cours",
      "my_subjects": "Mes matières",
      "send_message": "Envoyer un message",
      "message_placeholder": "Écrivez votre message ici...",
      "sending": "Envoi en cours...",
      "message_sent": "Message envoyé avec succès",

      // Attendance statuses
      "status_present": "Présent ✓",
      "status_absent": "Absent ✗",
      "status_late": "En retard",
      "status_excused": "Excusé",
      "mark_all_present": "Tous présents",
      "mark_all_absent": "Tous absents",
      "save_attendance": "Enregistrer la présence",
      "select_class_first": "Sélectionner une classe d'abord",
      "no_students_in_class": "Aucun étudiant dans cette classe",
      "select_class_to_show": "Sélectionner une classe pour afficher les étudiants",
      "total_label": "Total",

      // Homework
      "hw_title": "Devoirs à la maison",
      "hw_subtitle": "Suivi des devoirs et tâches scolaires",
      "hw_new": "Nouveau devoir",
      "hw_title_ph": "Titre du devoir *",
      "hw_subject_ph": "Matière",
      "hw_desc_ph": "Détails du devoir...",
      "hw_filter_all": "Tous",
      "hw_filter_pending": "En cours",
      "hw_filter_overdue": "En retard",
      "hw_due_today": "Aujourd'hui",
      "hw_days_left": "jour(s)",
      "hw_overdue_label": "En retard",
      "hw_add": "Ajouter le devoir",
      "hw_saving": "Enregistrement...",
      "hw_due_date": "Date limite",
      "hw_empty": "Aucun devoir pour le moment",

      // Fees
      "fee_total": "Total des frais",
      "fee_paid_label": "Payé",
      "fee_remaining": "Restant",
      "fee_fully_paid": "Entièrement payé",
      "fee_partial": "Partiellement payé",
      "fee_unpaid": "Non payé",
      "cfa_currency": "FCFA",

      // Profile
      "profile_photo": "Changer la photo de profil",
      "choose_photo": "Choisir une photo",
      "uploading": "Envoi en cours...",
      "current_password": "Mot de passe actuel",
      "new_password": "Nouveau mot de passe",
      "confirm_password": "Confirmer le mot de passe",

      // Login page — inline strings replaced by t() [M-1]
      "login_access_subtitle": "Connectez-vous pour accéder au tableau de bord",
      "login_too_many": "Trop de tentatives de connexion. Attendez une minute.",
      "login_attempts_warning": "Attention : {{n}} tentatives restantes avant le verrouillage",
      "secure_connection": "Connexion sécurisée et chiffrée",

      // Password reset — inline strings replaced by t() [M-1]
      "reset_title": "Récupération du mot de passe",
      "reset_step1": "Nom d'utilisateur",
      "reset_step2": "Entrez le code de réinitialisation",
      "reset_request": "Demander le code",
      "reset_confirm": "Changer le mot de passe",
      "reset_code_ph": "Code temporaire (6 chiffres)",
      "reset_info": "Un code temporaire sera généré. Contactez votre directeur pour l'obtenir.",
      "reset_success_msg": "Mot de passe changé avec succès !",
      "reset_back": "Retour à la connexion",
      "reset_have_code": "Vous avez déjà un code ?",

      // Extra sidebar keys (were inline ternaries)
      "nav_ratings": "Évaluations des enseignants",
      "nav_teacher_tasks": "Tâches enseignants",
      "nav_profile": "Profil",
      "nav_messages": "Messages",
      "nav_calendar": "Calendrier",
      "nav_reset_codes": "Codes de réinitialisation",
      "nav_smart_rankings": "Classement intelligent",
      "nav_class_analytics": "Analyse des classes",

      // PWA / Offline
      "skip": "Passer",
      "offline_banner": "Mode hors ligne — les données peuvent être obsolètes",
      "pwa_install_title": "Installer EduGate",
      "pwa_install_subtitle": "Ajoutez-le à votre écran d'accueil et utilisez-le comme une application — sans passer par un store !",
      "pwa_install_action": "Installer",
      "pwa_install_browser_hint": "Utilisez Chrome ou Edge pour installer l'application",
      "pwa_ios_title": "Installer EduGate sur iPhone",
      "pwa_ios_steps": "Appuyez sur le bouton Partager puis choisissez « Sur l'écran d'accueil »",
      "pwa_ios_share": "Partager",
      "pwa_ios_add": "Ajouter",
      "pwa_update_available": "Une nouvelle version est disponible",
      "pwa_update_action": "Recharger",

      // Mobile / nav
      "menu": "Menu",
      "open_menu": "Ouvrir le menu",

      // Excel import/export
      "excel_export_title": "Exporter les données",
      "excel_import_title": "Importer les données",
      "excel_export_students": "Exporter les étudiants",
      "excel_export_teachers": "Exporter les enseignants",
      "excel_export_grades": "Exporter les notes",
      "excel_export_attendance": "Exporter la présence",
      "excel_export_fees": "Exporter les frais",
      "excel_download_template": "Télécharger le modèle Excel",
      "excel_help_toggle":        "Quelles colonnes faut-il ?",
      "excel_help_title":         "Format du fichier d'import",
      "excel_help_intro":         "Écrivez les noms de colonnes en première ligne exactement comme ci-dessous, puis une ligne par personne. Le plus simple : téléchargez le modèle et remplissez-le.",
      "excel_help_col_header":    "Nom de colonne",
      "excel_help_col_required":  "Obligatoire ?",
      "excel_help_col_format":    "Format",
      "excel_help_col_example":   "Exemple",
      "excel_help_required":      "Obligatoire",
      "excel_help_optional":      "Facultatif",
      "excel_help_note_headers":  "Les colonnes facultatives peuvent être omises. L'ordre des colonnes n'a pas d'importance, seuls leurs noms comptent.",
      "excel_help_note_dates":    "Date : au format AAAA-MM-JJ (ex. 2010-05-15). Une cellule formatée en date dans Excel est également lue correctement.",
      "excel_help_note_lists":    "Matières et classes : séparez-les par une virgule (ex. Mathématiques, Physique).",
      "excel_help_note_detect":   "Le type de fichier (élèves ou enseignants) est détecté automatiquement d'après les noms de colonnes et affiché avant l'import pour vérification.",
      "excel_help_note_duplicates": "Le nom d'utilisateur doit être unique. Les doublons apparaissent en avertissement dans l'aperçu avant l'import.",
      "excel_detected_kind":      "Type de fichier détecté",
      "excel_detected_kind_hint": "Vérifiez le type avant de confirmer — les enregistrements seront créés dans cette section.",
      "excel_fmt_text":     "Texte",
      "excel_fmt_username": "Lettres latines et chiffres, sans espaces",
      "excel_fmt_password": "8 caractères minimum",
      "excel_fmt_class":    "Nom de la classe tel qu'enregistré",
      "excel_fmt_date":     "AAAA-MM-JJ",
      "excel_fmt_list":     "Liste séparée par des virgules",
      "excel_fmt_phone":    "Chiffres, peut commencer par +",
      "excel_fmt_email":    "Adresse e-mail valide",
      "excel_upload": "Téléverser un fichier Excel",
      "excel_importing": "Importation en cours...",
      "excel_preview": "Aperçu avant import",
      "excel_confirm_import": "Confirmer l'import",
      "excel_cancel_import": "Annuler",
      "excel_empty_file": "Le fichier est vide ou mal formé",
      "excel_file_too_large": "Fichier trop volumineux (maximum {{max}} Mo). Divisez-le en fichiers plus petits.",
      "excel_read_error": "Erreur de lecture du fichier",
      "excel_row_incomplete": "Ligne incomplète",
      "excel_duplicate_warning": "Existe déjà",
      "excel_field_too_long": "Le champ « {{field}} » dépasse la limite ({{length}} sur {{max}} caractères)",
      "excel_password_too_short": "Le mot de passe doit contenir au moins {{min}} caractères",
      "excel_password_too_long": "Le mot de passe ne peut pas dépasser {{max}} caractères",
      "excel_invalid_email": "Adresse e-mail invalide : {{value}}",
      "excel_too_many_items": "Trop d'éléments dans « {{field}} » ({{count}} sur {{max}})",
      "excel_rate_limited": "Limite de requêtes atteinte — attendez une minute puis réessayez",
      "excel_no_server_result": "Le serveur n'a renvoyé aucun résultat pour cette ligne",
      "excel_created_count": "Créés",
      "excel_skipped_count": "Ignorés",
      "excel_reason": "Motif",
      "excel_sheet_template": "Modèle",
      "excel_sheet_failed": "Lignes rejetées",
      "excel_download_failed_rows": "Télécharger les lignes en échec",
      "excel_importing_progress": "Import en cours… {{done}} sur {{total}}",
      "excel_teacher_pacing_note": "Les enseignants sont importés ligne par ligne pour ne pas dépasser la limite de requêtes ; cela prendra environ {{seconds}} secondes. Ne fermez pas la page.",
      "excel_success_count": "Réussis",
      "excel_failed_count": "Échoués",
      "excel_more_errors": "autres erreurs",
      "excel_school_name_header": "École",
      "excel_export_date": "Date d'export",
      "excel_col_index": "#",
      "excel_col_student_number": "N° étudiant",
      "excel_col_teacher_number": "N° enseignant",
      "excel_col_full_name": "Nom complet",
      "excel_col_username": "Nom d'utilisateur",
      "excel_col_class": "Classe",
      "excel_col_grade_level": "Niveau",
      "excel_col_dob": "Date de naissance",
      "excel_col_status": "Statut",
      "excel_col_subjects": "Matières",
      "excel_col_classes": "Classes",
      "excel_col_specialization": "Spécialisation",
      "excel_col_student_name": "Nom étudiant",
      "excel_col_subject": "Matière",
      "excel_col_assessment_type": "Type d'évaluation",
      "excel_col_assessment_name": "Nom de l'évaluation",
      "excel_col_score": "Note",
      "excel_col_max_score": "Note max",
      "excel_col_percent": "Pourcentage",
      "excel_col_academic_year": "Année scolaire",
      "excel_col_date": "Date",
      "excel_col_attendance_status": "Statut",
      "excel_col_notes": "Notes",
      "excel_col_amount": "Montant",
      "excel_col_paid": "Payé",
      "excel_col_remaining": "Restant",
      "excel_col_fee_type": "Type de frais",

      // Dark mode
      "switch_to_dark": "Passer en mode sombre",
      "switch_to_light": "Passer en mode clair",

      // Super-admin platform overview
      "sa_tab_platform":      "Tableau de bord",
      "sa_tab_schools":       "Écoles",
      "sa_tab_subscriptions": "Abonnements",
      "sa_tab_messages":      "Messages",
      "sa_tab_system":        "État du système",
      "sa_tab_reset_codes":   "Codes de réinitialisation",
      "ay_current_year":      "Année en cours",
      "ay_archived_label":    "archivée",
      "sa_tab_settings":      "Paramètres plateforme",
      "sa_tab_account":       "Mon compte",
      "sa_stat_total_schools":  "Total écoles",
      "sa_stat_total_students": "Total élèves",
      "sa_stat_total_teachers": "Total enseignants",
      "sa_stat_revenue_mtd":    "Revenus du mois",
      "sa_active":              "actives",
      "sa_trial":               "essai",
      "sa_expired":             "expirées",
      "sa_suspended":           "suspendues",
      "sa_alerts_title":          "Alertes",
      "sa_alert_expiring_7":      "expirent dans 7 jours",
      "sa_alert_expiring_30":     "expirent dans 30 jours",
      "sa_alert_new_mtd":         "nouvelle(s) école(s) ce mois",
      "sa_no_alerts":             "Aucune alerte en cours.",
      "sa_search_school":         "Rechercher une école...",
      "sa_all_plans":             "Tous les plans",
      "sa_plan_free": "Gratuit",
      "sa_plan_basic": "Basique",
      "sa_plan_pro": "Pro",
      "sa_plan_enterprise": "Entreprise",
      "sa_all_status":            "Tous les statuts",
      "sa_status_active":    "Actif",
      "sa_status_trial":     "Essai",
      "sa_status_expired":   "Expiré",
      "sa_status_suspended": "Suspendu",
      "sa_status_cancelled": "Annulé",
      "sa_col_name":      "École",
      "sa_col_plan":      "Plan",
      "sa_col_status":    "Statut",
      "sa_col_students":  "Élèves",
      "sa_col_teachers":  "Enseignants",
      "sa_col_end_date":  "Fin d'abonnement",
      "sa_col_revenue":   "Montant",
      "sa_col_actions":   "Actions",
      "sa_no_schools":    "Aucune école correspondante",

      // Platform settings
      "ps_title":                  "Paramètres de la plateforme",
      "ps_general":                "Général",
      "ps_subscriptions":          "Abonnements et rappels",
      "ps_welcome_email":          "Email de bienvenue",
      "ps_platform_name":          "Nom de la plateforme",
      "ps_contact_email":          "Email de contact",
      "ps_support_whatsapp":       "WhatsApp du support",
      "ps_default_currency":       "Devise par défaut pour les nouvelles écoles",
      "ps_maintenance_mode":       "Activer le mode maintenance",
      "ps_maintenance_active":     "Mode maintenance actif — bandeau affiché sur les tableaux de bord.",
      "ps_trial_days":             "Durée d'essai (jours)",
      "ps_trial_reminder_days":    "Rappel avant fin d'essai (jours)",
      "ps_payment_reminder_days":  "Rappel paiement (jours avant échéance)",
      "ps_welcome_subject":        "Sujet",
      "ps_welcome_body":           "Corps",
      "ps_save":                   "Enregistrer",
      "ps_saved":                  "Paramètres enregistrés",
      "ps_save_failed":            "Échec de l'enregistrement",
      "ps_load_failed":            "Impossible de charger les paramètres",

      // Invoice
      "invoice_number_label":      "Facture n°",
      "print_invoice":             "Imprimer la facture",
      "invoice_subtitle":          "Plateforme de gestion scolaire",
      "invoice_official":          "Facture officielle",
      "invoice_billed_to":         "Destinataire",
      "invoice_issued_at":         "Date d'émission",
      "invoice_due_date":          "Date d'échéance",
      "invoice_item_description":  "Service",
      "invoice_item_qty":          "Quantité",
      "invoice_item_unit":         "Prix unitaire",
      "invoice_item_total":        "Total",
      "invoice_subtotal":          "Sous-total",
      "invoice_tax":               "Taxe",
      "invoice_total":             "Total",
      "invoice_payment_methods":   "Modes de paiement",
      "invoice_payment_instructions": "Virement bancaire · Mobile money · Espèces à la livraison",
      "invoice_thank_you":         "Merci de votre confiance en EduGate",
      "invoice_status_label":      "Statut",
      "invoice_print_hint":        "Une page A4 portrait",
      "invoice_load_failed":       "Impossible de charger la facture",

      // ── Actions ─────────────────────────────────────────────────────
      "action_save":     "Enregistrer",   "action_cancel":   "Annuler",
      "action_edit":     "Modifier",      "action_delete":   "Supprimer",
      "action_add":      "Ajouter",       "action_create":   "Créer",
      "action_update":   "Mettre à jour", "action_search":   "Rechercher",
      "action_confirm":  "Confirmer",     "action_print":    "Imprimer",
      "action_export":   "Exporter",      "action_download": "Télécharger",
      "action_upload":   "Téléverser",    "action_close":    "Fermer",
      "action_view":     "Afficher",      "action_refresh":  "Actualiser",
      "action_submit":   "Soumettre",     "action_send":     "Envoyer",
      "action_reset":    "Réinitialiser", "action_back":     "Retour",
      "action_next":     "Suivant",       "action_previous": "Précédent",
      "action_yes":      "Oui",           "action_no":       "Non",
      "action_ok":       "OK",            "action_select":   "Sélectionner",
      "action_choose":   "Choisir",       "action_open":     "Ouvrir",
      "action_copy":     "Copier",        "action_share":    "Partager",
      "action_apply":    "Appliquer",     "action_clear":    "Effacer",

      // ── Status ──────────────────────────────────────────────────────
      "status_active":   "Actif",         "status_inactive": "Inactif",
      "status_suspended":"Suspendu",      "status_expired":  "Expiré",
      "status_trial":    "Essai",         "status_paid":     "Payé",
      "status_unpaid":   "Non payé",      "status_pending":  "En attente",
      "status_approved": "Accepté",       "status_rejected": "Rejeté",
      "status_reviewed": "Examiné",       "status_completed":"Terminé",
      "status_in_progress":"En cours",
      "status_overdue":  "Échu",
      "status_draft":    "Brouillon",     "status_sent":     "Envoyé",
      "status_cancelled":"Annulé",        "status_submitted":"Soumis",
      "status_graded":   "Noté",          "status_not_submitted":"Non soumis",

      // ── Educational ─────────────────────────────────────────────────
      "term_student":    "Élève",         "term_students":   "Élèves",
      "term_teacher":    "Enseignant",    "term_teachers":   "Enseignants",
      "term_parent":     "Parent",        "term_parents":    "Parents",
      "term_admin":      "Administrateur","term_staff":      "Personnel",
      "term_class":      "Classe",        "term_classes":    "Classes",
      "term_grade":      "Niveau",        "term_subject":    "Matière",
      "term_subjects":   "Matières",      "term_score":      "Note",
      "term_attendance": "Présence",      "term_absence":    "Absence",
      "term_homework":   "Devoir",        "term_assignment": "Devoir",
      "term_assignments":"Devoirs",       "term_schedule":   "Emploi du temps",
      "term_rating":     "Évaluation",    "term_ratings":    "Évaluations",
      "term_task":       "Tâche",         "term_tasks":      "Tâches",
      "term_announcement":"Annonce",      "term_announcements":"Annonces",
      "term_message":    "Message",       "term_messages":   "Messages",
      "term_school":     "École",         "term_schools":    "Écoles",
      "term_date":       "Date",          "term_time":       "Heure",
      "term_due_date":   "Date d'échéance","term_priority":  "Priorité",
      "term_description":"Description",   "term_notes":      "Notes",
      "term_title":      "Titre",         "term_name":       "Nom",
      "term_full_name":  "Nom complet",   "term_phone":      "Téléphone",
      "term_email":      "Email",         "term_address":    "Adresse",
      "term_gender":     "Genre",         "term_birth_date": "Date de naissance",

      // ── Finance ─────────────────────────────────────────────────────
      "finance_fees":    "Frais",         "finance_fee":     "Frais",
      "finance_salary":  "Salaire",       "finance_salaries":"Salaires",
      "finance_expense": "Dépense",       "finance_expenses":"Dépenses",
      "finance_invoice": "Facture",       "finance_invoices":"Factures",
      "finance_receipt": "Reçu",          "finance_payslip": "Bulletin de salaire",
      "finance_subscription":"Abonnement","finance_payment": "Paiement",
      "finance_payments":"Paiements",     "finance_amount":  "Montant",
      "finance_total":   "Total",         "finance_subtotal":"Sous-total",
      "finance_tax":     "Taxe",          "finance_currency":"Devise",
      "finance_paid_amount":"Montant payé","finance_due_amount":"Montant dû",
      "finance_discount":"Remise",

      // ── Messages / Toasts ───────────────────────────────────────────
      "msg_saved":       "Enregistré avec succès",
      "msg_deleted":     "Supprimé avec succès",
      "msg_updated":     "Mis à jour avec succès",
      "msg_created":     "Créé avec succès",
      "msg_save_error":  "Erreur lors de l'enregistrement",
      "msg_delete_error":"Erreur lors de la suppression",
      "msg_load_error":  "Erreur de chargement",
      "msg_generic_error":"Une erreur s'est produite",
      "msg_fill_required":"Veuillez remplir tous les champs requis",
      "msg_confirm_delete":"Confirmer la suppression ?",
      "msg_confirm_action":"Êtes-vous sûr ?",
      "msg_no_data":     "Aucune donnée",
      "msg_loading":     "Chargement...",
      "msg_success":     "Succès",
      "msg_failed":      "L'opération a échoué",
      "msg_unauthorized":"Non autorisé",
      "msg_not_found":   "Introuvable",
      "msg_network_error":"Erreur réseau",
      "msg_session_expired":"Session expirée",
      "msg_permission_denied":"Permission refusée",

      // ── Form & UI labels ────────────────────────────────────────────
      "label_required":  "Requis",        "label_optional":  "Optionnel",
      "label_search_placeholder":"Rechercher...",
      "label_select_option":"Sélectionner...",
      "label_no_results":"Aucun résultat", "label_show_more": "Voir plus",
      "label_show_less": "Voir moins",     "label_page":      "Page",
      "label_of":        "sur",            "label_total":     "Total",
      "label_count":     "Nombre",         "label_filters":   "Filtres",
      "label_filter_by": "Filtrer par",    "label_sort_by":   "Trier par",
      "label_all":       "Tous",           "label_none":      "Aucun",
      "label_today":     "Aujourd'hui",    "label_yesterday": "Hier",
      "label_this_week": "Cette semaine",  "label_this_month":"Ce mois-ci",
      "label_last_30_days":"30 derniers jours",
      "label_actions":   "Actions",        "label_details":   "Détails",
      "label_summary":   "Résumé",         "label_overview":  "Vue d'ensemble",
      "label_settings":  "Paramètres",     "label_profile":   "Profil",
      "label_logout":    "Déconnexion",    "label_login":     "Connexion",
      "label_dashboard": "Tableau de bord","label_reports":   "Rapports",
      "label_notifications":"Notifications",

      // ── Days ────────────────────────────────────────────────────────
      "day_monday":    "Lundi",     "day_tuesday":  "Mardi",
      "day_wednesday": "Mercredi",  "day_thursday": "Jeudi",
      "day_friday":    "Vendredi",  "day_saturday": "Samedi",
      "day_sunday":    "Dimanche",

      // ── Dialog headings ─────────────────────────────────────────────
      "dialog_add_title":   "Ajouter",
      "dialog_edit_title":  "Modifier",
      "dialog_delete_title":"Confirmer la suppression",
      "dialog_view_title":  "Détails",

      // ── Component-specific keys ─────────────────────────────────────
      "nav_activity_log":   "Journal d'activité",
      "td_choose_class":        "Sélectionner la classe",
      "td_message_placeholder": "Écrivez votre message ici... Exemple : J'ai remarqué que votre enfant a besoin d'un soutien supplémentaire en mathématiques...",
      "td_sending":             "Envoi en cours...",
      "sd_unknown_sender":      "Expéditeur inconnu",
      "sd_school_admin":        "Direction de l'école",
      "pd_link_success":        "Enfant {{name}} associé avec succès !",
      "pd_link_error":          "Erreur : vérifiez le numéro d'élève",
      "pd_total_children":      "Total enfants",
      "pd_avg_attendance":      "Présence moyenne",
      "pd_avg_grades":          "Note moyenne",
      "pd_total_unpaid_fees":   "Total frais restants",
      "fin_tab_student_fees":   "Frais des élèves",
      "fin_tab_teacher_salaries":"Salaires des enseignants",
      "fin_search_student":     "Rechercher un élève...",
      "fin_search_teacher":     "Rechercher un enseignant...",
      "fin_issue_receipt":      "Émettre un reçu",
      "fin_issue_payslip":      "Émettre un bulletin de salaire",
      "pd_nav_overview":    "Vue d'ensemble",
      "pd_nav_child_summary":"Résumé de l'enfant",
      "lbl_grades":         "Notes",
      "sd_submit_homework": "Soumettre le devoir",
      "ttp_empty":          "Aucune tâche administrative pour le moment.",
      "ttp_submit_task":    "Soumettre la tâche",
      "ttp_submitted_at":   "Soumis le",
      "ttp_admin_feedback": "Commentaires de l'administration",
      "nav_my_tasks":       "Mes tâches administratives",

      // SchoolAdmin views (Students / Teachers / Parents / Dashboard)
      "sav_student_added":          "Élève ajouté avec succès ! - Numéro d'élève : {{number}}",
      "sav_add_student_desc":       "Saisissez les informations du nouvel élève",
      "sav_student_number":         "Numéro d'élève",
      "sav_validation_error":       "Erreur de validation :\n{{errors}}",
      "sav_grade_placeholder":      "Exemple : 9e année",
      "sav_confirm_delete_student": "Confirmer la suppression de cet élève ?",
      "sav_teacher_added":          "Enseignant ajouté avec succès ! - Numéro : {{number}}",
      "sav_add_teacher_desc":       "Saisissez les informations du nouvel enseignant",
      "sav_academic_level":         "Niveau d'études",
      "sav_choose_academic_level":  "Choisir le niveau d'études...",
      "sav_marital_status":         "Situation matrimoniale",
      "sav_choose_marital_status":  "Choisir la situation matrimoniale...",
      "sav_multi_select_hint":      "(sélection multiple possible)",
      "sav_multi_select_classes_hint":"(sélection multiple possible)",
      "sav_classes_label":          "Classes",
      "sav_add_custom_subject":     "Ajouter une matière non listée...",
      "sav_serial_number":          "Numéro de série",
      "sav_confirm_delete_teacher": "Confirmer la suppression de cet enseignant ?",
      "sav_parent_updated":         "Parent mis à jour avec succès !",
      "sav_parent_added":           "Parent ajouté avec succès !",
      "sav_add_error":              "Erreur lors de l'ajout",
      "sav_search_parent":          "Rechercher un parent...",
      "sav_add_parent":             "Ajouter un parent",
      "sav_edit_parent":            "Modifier un parent",
      "sav_add_parent_desc":        "Saisissez les informations du nouveau parent",
      "sav_edit_parent_desc":       "Mettre à jour le parent et lier ou modifier ses enfants",
      "sav_password_unchanged":     "Laissez vide pour ne pas changer",
      "sav_link_children":          "Lier les enfants (sélectionner les élèves)",
      "sav_currently_linked":       "Actuellement liés :",
      "sav_no_number":              "Sans numéro",
      "sav_name":                   "Nom",
      "sav_children":               "Enfants",
      "sav_phone":                  "Téléphone",
      "sav_children_count":         "{{count}} enfants",
      "sav_confirm_delete_parent":  "Confirmer la suppression de ce parent ?",
      "sav_time_now":               "à l'instant",
      "sav_time_min_ago":           "il y a {{count}} min",
      "sav_time_hour_ago":          "il y a {{count}} h",
      "edu_bachelor":   "Licence",
      "edu_master":     "Master",
      "edu_phd":        "Doctorat",
      "edu_diploma":    "Diplôme",
      "edu_other":      "Autre",

      // Batch 2 admin tools (FR)
      "rcp_title":       "Demandes de réinitialisation de mot de passe",
      "rcp_subtitle":    "Partagez ce code avec l'utilisateur qui a demandé la réinitialisation",
      "rcp_empty":       "Aucune demande en attente",
      "rcp_expires":     "Expire le",
      "rcp_copy":        "Copier le code",
      "rcp_copied":      "Copié !",
      "rcp_refresh":     "Actualiser",
      "rcp_user":        "Utilisateur",
      "rcp_code":        "Code temporaire",
      "rcp_instruction": "Communiquez ce code à l'utilisateur. Il doit aller sur la page de connexion → Mot de passe oublié → Entrer le code.",

      "alv_cat_all":         "Tout",
      "alv_cat_attendance":  "Présence",
      "alv_cat_grades":      "Notes",
      "alv_cat_finance":     "Finances",
      "alv_cat_users":       "Utilisateurs",
      "alv_cat_messages":    "Messages",
      "alv_cat_settings":    "Paramètres",
      "alv_cat_submissions": "Soumissions",
      "alv_cat_auth":        "Authentification",
      "alv_load_error":      "Erreur de chargement du journal",
      "alv_export_error":    "Échec de l'export",
      "alv_verify_ok":       "Entrée valide — hachage correspondant",
      "alv_verify_fail":     "Attention : le hachage ne correspond pas — l'entrée pourrait avoir été modifiée",
      "alv_verify_error":    "Échec de la vérification",
      "alv_today_events":    "Événements d'aujourd'hui",
      "alv_last_7_days":     "7 derniers jours",
      "alv_most_active":     "Plus actif",
      "alv_last_event":      "Dernier événement",
      "alv_from_date":       "Du",
      "alv_to_date":         "Au",
      "alv_actor":           "Auteur",
      "alv_search":          "Recherche",
      "alv_search_placeholder":"nom, action, description...",
      "alv_total_summary":   "Total {{total}} événements — affiche {{from}}-{{to}}",
      "alv_no_events":       "0 événement",
      "alv_export_csv":      "Exporter CSV",
      "alv_no_events_filter":"Aucun événement pour ces critères.",
      "alv_th_time":         "Heure",
      "alv_th_action":       "Action",
      "alv_th_entity":       "Entité",
      "alv_th_description":  "Description",
      "alv_th_details":      "Détails",
      "alv_dt_category":     "Catégorie :",
      "alv_dt_before":       "Avant :",
      "alv_dt_after":        "Après :",
      "alv_dt_hash": "Empreinte :",
      "alv_verify":          "Vérifier",
      "alv_prev":            "Précédent",
      "alv_next":            "Suivant",
      "alv_page":            "Page {{num}}",

      "rm_load_error":       "Erreur de chargement des évaluations",
      "rm_added":            "Évaluation ajoutée avec succès",
      "rm_cat_teaching":      "Enseignement",
      "rm_cat_discipline":    "Discipline",
      "rm_cat_cooperation":   "Coopération",
      "rm_cat_commitment":    "Engagement",
      "rm_cat_creativity":    "Créativité",
      "rm_cat_academic":      "Performance académique",
      "rm_cat_behavior":      "Comportement",
      "rm_cat_participation": "Participation",
      "rm_cat_homework":      "Devoirs",
      "rm_cat_attendance":    "Présence",
      "rm_rating_excellent": "Excellent",
      "rm_rating_very_good": "Très bien",
      "rm_rating_good":      "Bien",
      "rm_rating_fair":      "Acceptable",
      "rm_rating_weak":      "Faible",
      "rm_title_teachers":   "Évaluations des enseignants",
      "rm_title_students":   "Évaluations des élèves",
      "rm_search_name":      "Rechercher par nom...",
      "rm_add_rating":       "Ajouter une évaluation",
      "rm_new_rating":       "Nouvelle évaluation",
      "rm_choose_teacher":   "Choisir l'enseignant",
      "rm_choose_student":   "Choisir l'élève",
      "rm_choose":           "Choisir...",
      "rm_category":         "Catégorie",
      "rm_choose_category":  "Choisir la catégorie",
      "rm_notes":            "Notes",
      "rm_notes_placeholder":"Ajoutez vos notes ici...",
      "rm_save_rating":      "Enregistrer l'évaluation",
      "rm_overall_avg":      "Moyenne générale",
      "rm_ratings_count":    "Nombre d'évaluations",
      "rm_rated_persons":    "Personnes évaluées",
      "rm_ratings_count_label":"Nombre d'évaluations :",
      "rm_no_ratings_yet":   "Aucune évaluation pour le moment",
      "rm_view_history":     "Voir l'historique complet ({{count}})",
      "rm_full_history":     "Historique complet des évaluations",
      "rm_rater":            "Évaluateur :",
      "rm_date":             "Date :",
      "rm_no_data":          "Aucune donnée à évaluer",

      "smc_updated":         "Emploi du temps mis à jour avec succès",
      "smc_added":           "Emploi du temps ajouté avec succès",
      "smc_confirm_delete":  "Confirmer la suppression de cet emploi du temps ?",
      "smc_deleted":         "Emploi du temps supprimé avec succès !",
      "smc_unspecified":     "Non spécifié",
      "smc_conflict_confirm":"Attention : {{count}} conflit(s) dans cet emploi du temps ! Enregistrer quand même ?",
      "smc_conflict_teacher_two":"L'enseignant {{name}} a deux cours en même temps",
      "smc_conflict_class_two":  "La classe {{name}} a deux cours en même temps",
      "smc_teacher_busy":    "L'enseignant {{name}} est occupé dans {{cls}} - {{subject}}",
      "smc_time_used_twice": "Le même horaire {{time}} est utilisé pour deux cours",
      "smc_pick_class":      "Sélectionnez une classe pour afficher son emploi du temps",
      "smc_conflicts_in":    "Conflits dans l'emploi du temps de {{cls}} ({{count}})",
      "smc_class_weekly":    "Emploi du temps hebdomadaire de {{cls}}",
      "smc_print":           "Imprimer",
      "smc_room":            "Salle {{num}}",
      "smc_conflict":        "Conflit",
      "smc_title":           "Emplois du temps",
      "dir_title": "Annuaire de l'école",
      // [CLASSES-PORTAL 2026-10]
      "nav_classes": "Classes",
      "nav_subjects": "Matières",
      "cp_title": "Les classes",
      "cp_subtitle": "Toutes les classes de l'école : élèves, enseignants, matières et emploi du temps",
      "cp_search": "Rechercher une classe...",
      "cp_classes_count": "{{count}} classes",
      "cp_students_total": "{{count}} élèves",
      "cp_students": "Élèves",
      "cp_teachers": "Enseignants",
      "cp_subjects": "Matières",
      "cp_periods_week": "séances par semaine",
      "cp_no_timetable": "Sans emploi du temps",
      "cp_tab_students": "Élèves",
      "cp_tab_subjects": "Matières et enseignants",
      "cp_tab_timetable": "Emploi du temps",
      "cp_col_number": "N°",
      "cp_col_name": "Nom",
      "cp_col_subject": "Matière",
      "cp_col_teacher": "Enseignant",
      "cp_col_periods": "Séances / semaine",
      "cp_col_planned": "Prévu au programme",
      "cp_no_students": "Aucun élève dans cette classe",
      "cp_no_subjects": "Aucune matière pour cette classe",
      "cp_no_timetable_long": "L'emploi du temps de cette classe n'est pas encore construit",
      "cp_assigned_teachers": "Enseignants affectés à la classe",
      "cp_not_scheduled": "pas encore à l'emploi du temps",
      "cp_load_error": "Impossible de charger les classes",
      "cp_archived_note": "Année archivée : les élèves dans leur classe de cette année-là, les enseignants selon son emploi du temps",
      "cp_empty": "Aucune classe pour l'instant",
      "sp_title": "Les matières",
      "sp_subtitle": "Les matières de l'école : qui les enseigne, dans quelle classe, et leurs séances",
      "sp_search": "Rechercher une matière...",
      "sp_custom": "Propre à l'école",
      "sp_classes": "Classes",
      "sp_tab_overview": "Enseignants et classes",
      "sp_tab_slots": "Ses séances",
      "sp_col_day": "Jour",
      "sp_col_period": "Séance",
      "sp_col_time": "Heure",
      "sp_col_class": "Classe",
      "sp_col_room": "Salle",
      "sp_no_slots": "Aucune séance de cette matière à l'emploi du temps",
      "sp_on_record_only": "dans son dossier, pas à l'emploi du temps",
      "sp_no_teachers": "Aucun enseignant pour cette matière",
      "sp_empty": "Aucune matière pour l'instant",
      "sp_load_error": "Impossible de charger les matières",
      "cp_add_class": "Ajouter une classe",
      "cp_new_class": "Nouvelle classe",
      "cp_new_class_hint": "Choisissez un nom dans la liste ou saisissez un nom libre, puis décrivez la classe si vous le souhaitez.",
      "cp_from_list": "Dans la liste",
      "cp_free_name": "Nom libre",
      "cp_free_name_ph": "Ex. : CP1 - Garçons",
      "cp_class_name": "Nom de la classe",
      "cp_choose_class": "Choisir la classe",
      "cp_grade_level": "Niveau",
      "cp_no_grade": "Sans niveau",
      "cp_label": "Type de classe",
      "cp_gender_none": "Non précisé",
      "cp_gender_boys": "Garçons",
      "cp_gender_girls": "Filles",
      "cp_gender_mixed": "Mixte",
      "cp_filter_all": "Toutes",
      "cp_create": "Créer",
      "cp_created": "Classe créée",
      "cp_saved": "Enregistré",
      "cp_save_error": "Enregistrement impossible",
      "cp_delete_class": "Supprimer la classe",
      "cp_delete_confirm": "Supprimer la classe « {{name}} » ?",
      "cp_deleted": "Classe supprimée",
      "cp_boys_girls": "Garçons {{boys}} · Filles {{girls}}",
      "cp_col_gender": "Sexe",
      "cp_gender_clash": "Ne correspond pas au type de la classe",
      "cp_col_assigned": "Enseignant attribué",
      "cp_col_scheduled": "Dans l'emploi du temps",
      "cp_no_teacher": "Sans enseignant",
      "cp_has_subject": "enseigne cette matière",
      "cp_add_subject": "Ajouter une matière à la classe",
      "cp_choose_subject": "Choisir la matière",
      "cp_add": "Ajouter",
      "cp_remove": "Retirer",
      "cp_assigned_saved": "Matière attribuée",
      "cp_subject_removed": "Matière retirée de la classe",
      "cp_name_required": "Saisissez le nom de la classe",
      "cp_rename": "Renommer",
      "cp_new_name": "Nouveau nom de la classe",
      "cp_renamed": "Classe renommée",
      "cp_rename_hint": "Le nom change pour les élèves, l'emploi du temps, les notes, les présences, les frais, les devoirs et les examens de cette année. Les années archivées et les bulletins délivrés gardent l'ancien nom.",
      "sp_add_subject": "Ajouter une matière",
      "sp_new_subject_ph": "Nom de la nouvelle matière",
      "sp_added": "Matière ajoutée",
      "sp_delete": "Supprimer la matière",
      "sp_delete_confirm": "Retirer la matière « {{subject}} » de la liste de l'école ?",
      "sp_deleted": "Matière supprimée",
      "gender_unset": "Non précisé",
      "sav_gender_clash": "Attention : cette classe est de type « {{label}} ». Vous pouvez enregistrer, mais vérifiez le choix.",
      "dir_subtitle": "Interrogez l'emploi du temps et les classes : qui enseigne une matière, à quelles classes et quand ; l'enseignant attribué à chaque matière ; les cours d'un jour et d'une heure ; les élèves de chaque classe (garçons et filles) et les matières sans enseignant.",
      "dir_all_labels": "Tous les types",
      "dir_classes_title": "Classes",
      "dir_classes_count": "{{count}} classe(s)",
      "dir_col_boys_girls": "Garçons / Filles",
      "dir_col_open_subjects": "Matières sans enseignant",
      "dir_not_timetabled": "pas encore à l'emploi du temps",
      "dir_assigned_differs": "L'enseignant attribué n'est pas celui de l'emploi du temps",
      "dir_tab_search": "Recherche",
      "dir_tab_cover": "Remplaçant",
      "dir_tab_load": "Charge des enseignants",
      "dir_tab_gaps": "Points à régler",
      "dir_cover_mode_slot": "Un cours précis",
      "dir_cover_mode_absent": "Un enseignant absent",
      "dir_choose_day": "Choisir le jour",
      "dir_choose_period": "Choisir l'heure",
      "dir_any_subject": "Toute matière",
      "dir_any_class": "Toute classe",
      "dir_choose_teacher": "Choisir l'enseignant absent",
      "dir_cover_hint": "Choisissez le jour et l'heure pour voir les enseignants libres. La matière et la classe affinent le classement.",
      "dir_cover_hint_absent": "Choisissez le jour et l'enseignant absent pour voir ses cours et qui peut remplacer chacun.",
      "dir_cover_free": "Libres : {{count}}",
      "dir_cover_busy": "Occupés à cette heure : {{count}}",
      "dir_teaches_subject": "Enseigne la matière",
      "dir_teaches_class": "Enseigne cette classe",
      "dir_not_in_today": "Aucun cours ce jour-là",
      "dir_periods_today": "Cours du jour : {{n}}",
      "dir_periods_week": "Par semaine : {{n}}",
      "dir_no_free": "Aucun enseignant libre à cette heure",
      "dir_no_lessons": "Aucun cours de cet enseignant ce jour-là",
      "dir_show_all": "Tout afficher ({{count}})",
      "dir_show_less": "Afficher moins",
      "dir_load_teachers": "Enseignants",
      "dir_load_total": "Total des heures",
      "dir_load_average": "Moyenne par enseignant",
      "dir_load_heavy": "Les plus chargés",
      "dir_load_light": "Les moins chargés",
      "dir_load_inactive": "parti",
      "dir_col_periods_week": "Heures par semaine",
      "dir_col_classes": "Classes",
      "dir_col_subjects": "Matières",
      "dir_col_not_timetabled": "Attribuées, hors emploi du temps",
      "dir_col_issue": "Constat",
      "dir_col_detail": "Détail",
      "dir_filter_all_gaps": "Tout ({{count}})",
      "dir_gaps_none": "Rien à régler : chaque matière a un enseignant et chaque classe un emploi du temps.",
      "dir_gaps_note": "D'après les classes de l'année choisie. Les attributions n'apparaissent que pour l'année active.",
      "dir_gap_no_teacher": "Matière sans enseignant",
      "dir_gap_teacher_mismatch": "Attribué ≠ emploi du temps",
      "dir_gap_no_timetable": "Classe sans emploi du temps",
      "dir_gap_periods_short": "Moins d'heures que prévu",
      "dir_gap_periods_over": "Plus d'heures que prévu",
      "dir_gap_not_timetabled": "Attribuée, hors emploi du temps",
      "dir_gap_assigned": "Attribué : {{name}}",
      "dir_gap_scheduled": "Emploi du temps : {{names}}",
      "dir_gap_planned": "Prévu {{planned}} · emploi du temps {{actual}}",
      "dir_search_placeholder": "Rechercher un enseignant, une matière ou une classe",
      "dir_all_subjects": "Toutes les matières",
      "dir_all_teachers": "Tous les enseignants",
      "dir_all_classes": "Toutes les classes",
      "dir_all_days": "Tous les jours",
      "dir_all_periods": "Toutes les heures",
      "dir_clear": "Effacer",
      "dir_slots_title": "Cours dans l'emploi du temps",
      "dir_slots_count": "{{count}} cours",
      "dir_weekly_title": "Heures hebdomadaires par matière et par classe",
      "dir_weekly_note": "Nombre d'heures sur toute la semaine ; ne change pas selon le jour ou l'heure choisis.",
      "dir_subject_total": "{{count}} heures par semaine au total",
      "dir_col_day": "Jour",
      "dir_col_period": "Heure",
      "dir_col_class": "Classe",
      "dir_col_subject": "Matière",
      "dir_col_teacher": "Enseignant",
      "dir_col_room": "Salle",
      "dir_col_per_week": "Heures / semaine",
      "dir_period_n": "Heure {{n}}",
      "dir_no_results": "Aucun cours correspondant dans l'emploi du temps.",
      "dir_truncated": "Trop de résultats : seule une partie est affichée. Affinez la recherche.",
      "dir_load_error": "Impossible de charger l'annuaire de l'école",
      "smc_subtitle":        "Gestion complète des emplois du temps | Cours = 1 heure",
      "smc_conflicts_count": "{{count}} conflit(s)",
      "smc_no_conflicts":    "Aucun conflit",
      "smc_view_list":       "Liste",
      "smc_view_weekly":     "Hebdomadaire",
      "smc_add_schedule":    "Ajouter un emploi du temps",
      "smc_conflicts_found": "Conflits détectés ({{count}})",
      "smc_teacher_conflict":"Conflit enseignant",
      "smc_class_conflict":  "Conflit classe",
      "smc_class_count":     "Nombre de classes",
      "smc_total_schedules": "Total emplois du temps",
      "smc_teachers_count":  "Nombre d'enseignants",
      "smc_week_days":       "Jours de la semaine",
      "smc_filter_class":    "Filtrer par classe :",
      "smc_all_classes":     "Toutes les classes",
      "smc_clear_filter":    "Effacer le filtre",
      "smc_print_schedule":  "Imprimer l'emploi du temps de {{cls}}",
      "smc_on_day":          "Jour {{day}}",
      "smc_no_schedules":    "Aucun emploi du temps enregistré",
      "smc_schedule_singular":"emploi du temps",
      "smc_day":             "Jour",
      "smc_choose_day":      "Choisir le jour",
      "smc_form_warn":       "Attention : {{count}} conflit(s) !",
      "smc_period_n":        "• Cours {{n}}",
      "smc_periods_header":  "Cours (chaque cours = 1 heure)",
      "smc_add_period":      "Ajouter un cours",
      "smc_period_num":      "Cours {{n}}",
      "smc_time_full_hour":  "Heure (heure pleine)",
      "smc_choose_time":     "Choisir l'heure",
      "smc_subject":         "Matière",
      "smc_choose_subject":  "Choisir la matière",
      "smc_teacher_label":   "Enseignant",
      "smc_choose_teacher":  "Choisir un enseignant",
      "smc_room_number":     "Numéro de salle",
      "smc_room_placeholder":"Ex : 101",
      "smc_no_periods_yet":  "Aucun cours ajouté",
      "smc_save_with_conflict":"Enregistrer malgré le conflit ({{count}})",
      "smc_save_schedule":   "Enregistrer l'emploi du temps",

      // LandingPage
      "lp_nav_features":      "Fonctionnalités",
      "lp_nav_roles":         "Rôles",
      "lp_nav_pricing":       "Tarifs",
      "lp_nav_faq":           "FAQ",
      "lp_nav_login":         "Connexion",
      "lp_nav_start_free":    "Commencer gratuitement",
      "lp_lang_switch_title": "Changer de langue",
      "lp_mobile_start_free_90": "Commencer gratuitement — 90 jours",
      "lp_hero_badge":        "La première plateforme de gestion scolaire dans la région",
      "lp_hero_title_1":      "Gérez votre école",
      "lp_hero_title_2":      "avec simplicité et intelligence",
      "lp_hero_subtitle":     "La plateforme EduGate réunit tout ce dont votre école a besoin — élèves, enseignants, notes, présence, frais et communication — en un seul endroit, depuis n'importe quel appareil.",
      "lp_hero_cta_trial":    "Essai gratuit — 90 jours",
      "lp_hero_cta_login":    "J'ai un compte — Connexion",
      "lp_hero_check_1":      "90 jours gratuits",
      "lp_hero_check_2":      "Sans carte bancaire",
      "lp_hero_check_3":      "Annulation à tout moment",
      "lp_stat_schools":      "Écoles nous font confiance",
      "lp_stat_students":     "Élèves gérés",
      "lp_stat_uptime":       "Disponibilité",
      "lp_stat_trial":        "Essai gratuit",
      "lp_stat_days_suffix":  "jours",
      "lp_section_features_eyebrow":  "FONCTIONNALITÉS",
      "lp_section_features_title":    "Tout ce dont vous avez besoin en une seule plateforme",
      "lp_section_features_subtitle": "EduGate est conçu pour répondre aux besoins des écoles modernes de toutes tailles.",
      "lp_section_roles_eyebrow":     "POUR QUI ?",
      "lp_section_roles_title":       "Une plateforme pour toute la communauté scolaire",
      "lp_section_roles_subtitle":    "Chaque membre de l'école a son propre tableau de bord, conçu pour ses besoins.",
      "lp_feat_users_title":    "Gestion élèves et enseignants",
      "lp_feat_users_desc":     "Dossiers complets, fiches détaillées et liens automatiques entre l'élève, son parent et l'enseignant.",
      "lp_feat_reports_title":  "Rapports mensuels et annuels",
      "lp_feat_reports_desc":   "Rapports PDF prêts à imprimer : notes, présence, finances et statistiques de performance par classe.",
      "lp_feat_schedule_title": "Emplois du temps et calendrier",
      "lp_feat_schedule_desc":  "Construction automatique des emplois du temps avec détection de conflits et un calendrier scolaire complet.",
      "lp_feat_comm_title":     "Communication directe",
      "lp_feat_comm_desc":      "Messagerie instantanée entre toutes les parties — enseignants, élèves et parents.",
      "lp_feat_attend_title":   "Présence intelligente",
      "lp_feat_attend_desc":    "Saisie quotidienne de la présence avec alertes immédiates aux parents en cas d'absence.",
      "lp_feat_finance_title":  "Système financier",
      "lp_feat_finance_desc":   "Gestion des frais et paiements avec rapports financiers mensuels et annuels détaillés.",
      "lp_feat_export_title":   "Export PDF et Excel",
      "lp_feat_export_desc":    "Exporter les listes d'élèves, notes et rapports au format PDF et Excel en un clic.",
      "lp_feat_pwa_title":      "Application mobile PWA",
      "lp_feat_pwa_desc":       "Installez l'application directement sur votre téléphone — fonctionne hors-ligne et vous notifie.",
      "lp_feat_notif_title":    "Notifications instantanées",
      "lp_feat_notif_desc":     "Ne manquez rien — notifications pour les notes, absences, messages et événements.",
      "lp_role_super_title":    "Super Admin",
      "lp_role_super_desc":     "Supervise tout le système — gère les écoles abonnées, suit les abonnements et les statistiques globales.",
      "lp_role_super_features": ["Gérer toutes les écoles", "Suivre les abonnements et essais", "Statistiques système globales", "Messagerie vers les directeurs"],
      "lp_role_admin_title":    "Directeur d'école",
      "lp_role_admin_desc":     "Gère son école entièrement — élèves, enseignants, finances et rapports mensuels et annuels.",
      "lp_role_admin_features": ["Gestion des élèves et enseignants", "Rapports mensuels et annuels détaillés", "Gestion des frais et paiements", "Calendrier scolaire et annonces"],
      "lp_role_teacher_title":  "Enseignant",
      "lp_role_teacher_desc":   "Se concentre sur l'enseignement — saisit les notes et la présence et communique directement avec les parents.",
      "lp_role_teacher_features":["Saisie des notes et évaluations", "Présence et absences quotidiennes", "Messagerie avec les parents", "Emploi du temps hebdomadaire"],
      "lp_role_student_title":  "Élève",
      "lp_role_student_desc":   "Suit sa scolarité facilement — consulte ses notes et son emploi du temps et communique avec ses enseignants depuis n'importe quel appareil.",
      "lp_role_student_features":["Consulter les notes et évaluations", "Emploi du temps hebdomadaire", "Historique de présence personnel", "Recevoir les notifications enseignants"],
      "lp_role_parent_title":   "Parent",
      "lp_role_parent_desc":    "Participe au parcours scolaire de ses enfants — suit les notes et la présence et échange directement avec les enseignants.",
      "lp_role_parent_features":["Suivi des notes en temps réel", "Alertes immédiates en cas d'absence", "Messagerie directe avec les enseignants", "Confirmation du paiement des frais"],
      "lp_reports_eyebrow":     "Rapports et statistiques",
      "lp_reports_title":       "Rapports intelligents pour le directeur",
      "lp_reports_subtitle":    "Obtenez une vue complète de votre école en temps réel — rapports mensuels et annuels automatiques sur la performance académique, la présence et les finances.",
      "lp_report_acad_title":   "Rapport de performance académique",
      "lp_report_acad_desc":    "Moyennes par classe, matière et enseignant",
      "lp_report_attend_title": "Rapport de présence mensuel",
      "lp_report_attend_desc":  "Taux de présence/absence avec identification des élèves les plus absents",
      "lp_report_finance_title":"Rapport financier annuel",
      "lp_report_finance_desc": "Revenus totaux, impayés et frais collectés",
      "lp_report_top_title":    "Rapport des excellents",
      "lp_report_top_desc":     "Top 10 élèves et enseignants les plus performants",
      "lp_reports_card_school": "École Al-Nour • Avril 2025",
      "lp_reports_card_title":  "Rapport mensuel",
      "lp_reports_stat_students":"Total élèves",
      "lp_reports_stat_attend": "Taux de présence",
      "lp_reports_stat_avg":    "Moyenne générale",
      "lp_reports_stat_fees":   "Frais collectés",
      "lp_reports_this_month":  "ce mois",
      "lp_reports_class_perf":  "Performance par classe — moyenne",
      "lp_reports_export_label":"Export instantané",
      "lp_pricing_eyebrow":     "TARIFS",
      "lp_pricing_title":       "Des tarifs transparents et simples",
      "lp_pricing_subtitle":    "Commencez gratuitement pendant 3 mois complets, puis choisissez ce qui convient à votre école.",
      "lp_plan_trial_name":     "Essai",
      "lp_plan_trial_price":    "Gratuit",
      "lp_plan_trial_period":   "90 jours complets",
      "lp_plan_trial_features": ["Jusqu'à 100 élèves", "Jusqu'à 10 enseignants", "Toutes les fonctionnalités de base", "Rapports PDF", "Support par email"],
      "lp_plan_basic_name":     "Basique",
      "lp_plan_basic_period":   "/ 6 mois — 90,000 FCFA / an",
      "lp_plan_basic_features": ["Jusqu'à 500 élèves", "Jusqu'à 30 enseignants", "Rapports mensuels et annuels", "Import Excel", "Support rapide 24/7"],
      "lp_plan_pro_name":       "Professionnel",
      "lp_plan_pro_period":     "/ 6 mois — 190,000 FCFA / an",
      "lp_plan_pro_features":   ["Élèves illimités", "Enseignants illimités", "Application mobile PWA", "Rapports avancés", "Support dédié 24/7"],
      "lp_plan_popular_badge":  "Le plus populaire",
      "lp_plan_cta":            "Commencer",
      "lp_faq_eyebrow":         "FAQ",
      "lp_faq_title":           "Questions fréquemment posées",
      "lp_faq_card_q":          "Ai-je besoin d'une carte bancaire pour l'essai ?",
      "lp_faq_card_a":          "Non, l'essai gratuit de 90 jours est complet, sans carte bancaire ni engagement financier.",
      "lp_faq_limits_q":        "Combien d'élèves le système supporte-t-il ?",
      "lp_faq_limits_a":        "Le plan professionnel supporte un nombre illimité d'élèves et d'enseignants.",
      "lp_faq_secure_q":        "Les données sont-elles protégées et sécurisées ?",
      "lp_faq_secure_a":        "Oui, toutes les données sont chiffrées et sauvegardées avec des sauvegardes automatiques quotidiennes.",
      "lp_faq_langs_q":         "Le système fonctionne-t-il uniquement en arabe ?",
      "lp_faq_langs_a":         "Le système supporte l'arabe, le français et l'anglais, avec un support complet RTL.",
      "lp_faq_import_q":        "Comment transférer les données de mon école ?",
      "lp_faq_import_a":        "Vous pouvez importer les données des élèves depuis des fichiers Excel en un clic. Notre équipe vous aide gratuitement.",
      "lp_cta_title":           "Commencez aujourd'hui — 90 jours gratuits",
      "lp_cta_subtitle":        "Rejoignez les écoles gérées intelligemment avec EduGate.\nSans carte bancaire, sans engagement.",
      "lp_cta_button":          "Inscrivez votre école maintenant — Gratuit",
      "lp_cta_hint":            "L'inscription prend moins de 2 minutes",
      "lp_footer_rights":       "Tous droits réservés. Conçu pour les écoles de demain.",

      // ─── Batch 3: TaskSubmissionModal ───
      "tsm_max_files":          "Maximum de {{count}} fichiers par soumission",
      "tsm_unsupported_file":   "Type de fichier non pris en charge : {{name}}",
      "tsm_file_too_large":     "Fichier dépasse 10 Mo : {{name}}",
      "tsm_video_too_long":     "Vidéo plus longue que 5 minutes : {{name}}",
      "tsm_file_read_failed":   "Échec de la lecture du fichier : {{name}}",
      "tsm_describe_required":  "Veuillez saisir une description de ce que vous avez fait",
      "tsm_submitted_ok":       "Soumis avec succès",
      "tsm_unexpected_error":   "Erreur inattendue",
      "tsm_describe_label":     "Décrivez ce que vous avez fait *",
      "tsm_answer_label":       "Réponse ou description du travail",
      "tsm_describe_placeholder":"Décrivez en détail le travail accompli...",
      "tsm_answer_placeholder": "Écrivez votre réponse ici...",
      "tsm_attachments_label":  "Pièces jointes (facultatif) — images / vidéo / PDF",
      "tsm_attachments_hint":   "Jusqu'à {{count}} fichiers, max 10 Mo chacun, vidéos ≤ 5 minutes",
      "tsm_pick_files":         "Choisir les fichiers à téléverser",
      "tsm_submitting":         "Soumission en cours...",
      "tsm_submit":             "Soumettre",

      // ─── Batch 3: AssignmentSubmissionsView ───
      "asv_load_error":         "Erreur de chargement",
      "asv_invalid_grade":      "Note invalide",
      "asv_graded_ok":          "Devoir noté",
      "asv_grading_error":      "Erreur de notation",
      "asv_title":              "Soumissions du devoir",
      "asv_stats_summary":      "{{submitted}} sur {{total}} élèves ont soumis",
      "asv_graded_count":       "{{count}} noté(s)",
      "asv_not_submitted":      "Non soumis",
      "asv_col_student":        "Élève",
      "asv_col_status":         "Statut",
      "asv_col_date":           "Date de soumission",
      "asv_col_grade":          "Note",
      "asv_col_actions":        "Actions",
      "asv_detail_title":       "Soumission : {{name}}",
      "asv_text_answer":        "Réponse textuelle",
      "asv_attachments_count":  "Pièces jointes ({{count}})",
      "asv_grade_label":        "Note",
      "asv_max_label":          "Maximum",
      "asv_notes":              "Notes",
      "asv_notes_placeholder":  "Notes pour l'élève...",
      "asv_grade_btn":          "Noter",

      // ─── Batch 3: TeacherAssignmentsManager ───
      "tam_update_ok":          "Devoir mis à jour !",
      "tam_add_ok":             "Devoir ajouté !",
      "tam_save_err":           "Erreur lors de l'enregistrement du devoir",
      "tam_delete_confirm":     "Voulez-vous vraiment supprimer ce devoir ?",
      "tam_delete_ok":          "Devoir supprimé !",
      "tam_delete_err":         "Erreur lors de la suppression du devoir",
      "tam_page_title":         "Devoirs",
      "tam_add_btn":            "Ajouter un devoir",
      "tam_view_submissions":   "Voir les soumissions",
      "tam_due":                "Échéance : {{date}}",
      "tam_score_unit":         "{{score}} points",
      "tam_empty":              "Aucun devoir ajouté pour le moment",
      "tam_edit_title":         "Modifier le devoir",
      "tam_add_title":          "Ajouter un nouveau devoir",
      "tam_title_label":        "Titre du devoir *",
      "tam_title_placeholder":  "Ex. : Résoudre les exercices de l'unité 2",
      "tam_subject_label":      "Matière *",
      "tam_subject_select":     "Choisir la matière",
      "tam_class_label":        "Classe *",
      "tam_class_select":       "Choisir la classe",
      "tam_due_label":          "Date d'échéance *",
      "tam_score_label":        "Note",
      "tam_desc_label":         "Description du devoir *",
      "tam_desc_placeholder":   "Écrivez les détails du devoir ici...",

      // ─── Batch 4: AccountSettings (SMS prefs) ───
      "acct_prefs_saved":       "Préférences enregistrées",
      "acct_notification_prefs":"Préférences de notification",
      "acct_notification_prefs_desc":"Choisissez les canaux supplémentaires pour recevoir les notifications d'absence, de notes, de frais et d'annonces urgentes. Aucun message n'est envoyé sans votre accord.",
      "acct_sms_unavailable":   "Le service de messagerie n'est pas activé sur le serveur. Vous pouvez enregistrer vos préférences maintenant, elles seront activées dès que le service sera disponible.",
      "acct_pref_sms":          "Notifications SMS",
      "acct_pref_whatsapp":     "Notifications WhatsApp",
      "acct_pref_phone":        "Numéro de téléphone (format international, ex. +21234567890)",
      "acct_pref_optin_note":   "Vous pouvez vous désabonner à tout moment.",

      // ─── Batch 4: NotificationBell ───
      "nb_title":               "Notifications",
      "nb_read_all":            "Tout marquer lu",
      "nb_empty":               "Aucune notification",
      "nb_marked_all_read":     "Tout marqué comme lu",
      "nb_error":               "Une erreur s'est produite",
      "nb_new_default":         "Nouvelle notification",
      "nb_just_now":            "À l'instant",
      "nb_minutes_ago":         "Il y a {{count}} min",
      "nb_hours_ago":           "Il y a {{count}} h",

      // ─── Batch 4: ReceiptCard ───
      "rc_load_failed":         "Impossible de charger le reçu",
      "rc_receipt_number":      "Reçu n°",
      "rc_print_btn":           "Imprimer le reçu",
      "rc_title":               "Reçu de paiement",
      "rc_field_student":       "Élève",
      "rc_field_class":         "Classe",
      "rc_field_fee_type":      "Type de frais",
      "rc_field_payment_method":"Mode de paiement",
      "rc_field_payment_date":  "Date de paiement",
      "rc_issued_by":           "Émis par",
      "rc_print_hint":          "Cliquez sur Imprimer : le reçu occupe une demi-feuille A4, deux reçus par feuille.",

      // ─── Batch 4: PayslipCard ───
      "slip_load_failed":         "Impossible de charger le bulletin",
      "slip_payslip_number":      "Bulletin n°",
      "slip_print_btn":           "Imprimer le bulletin",
      "slip_title":               "Bulletin de salaire",
      "slip_field_month":         "Mois",
      "slip_field_salary_type":   "Type de salaire",
      "slip_basic_salary":        "Salaire de base",
      "slip_bonuses":             "Primes",
      "slip_deductions":          "Retenues",
      "slip_net_salary":          "Salaire net",
      "slip_print_hint":          "Cliquez sur Imprimer : le bulletin occupe une demi-feuille A4, deux par feuille.",

      // ─── Batch 5: SuperAdminDashboard ───
      "sad_school_updated_ok":   "École mise à jour avec succès !",
      "sad_update_error":        "Erreur lors de la mise à jour",
      "sad_account_required":    "Saisissez au moins un nouveau nom d'utilisateur ou mot de passe",
      "sad_password_mismatch":   "Le mot de passe et sa confirmation ne correspondent pas",
      "sad_account_updated":     "Informations du compte mises à jour",
      "sad_account_error":       "Erreur lors de la mise à jour du compte",
      "sad_search_school":       "Rechercher une école...",
      "sad_add_school_desc":     "Saisissez les détails de la nouvelle école ci-dessous.",
      "sad_serial_number":       "Numéro de série",
      "sad_actions":             "Actions",
      "sad_delete_school_confirm":"Voulez-vous vraiment supprimer cette école ? Tous les utilisateurs liés seront désactivés.",
      "sad_school_deleted":      "École supprimée avec succès !",
      "sad_delete_error":        "Erreur lors de la suppression",
      "sad_account_settings_title":"Paramètres du compte",
      "sad_account_settings_desc":"Modifier le nom d'utilisateur ou le mot de passe",
      "sad_new_username_label":  "Nouveau nom d'utilisateur",
      "sad_keep_current_username":"(laissez vide pour conserver l'actuel)",
      "sad_current_username_placeholder":"Nom d'utilisateur actuel",
      "sad_keep_current_password":"(laissez vide pour conserver l'actuel)",
      "sad_save_changes":        "Enregistrer les modifications",
      "sad_edit_school_title":   "Modifier les informations de l'école",
      "sad_edit_school_desc":    "Modifiez les informations de l'école. Laissez les champs mot de passe vides pour les conserver.",
      "sad_keep_password_blank": "Laissez vide pour conserver le mot de passe actuel",

      // ─── Batch 6: SchoolAdminClassAnalyticsView ───
      "cav_load_error":         "Une erreur s'est produite lors du chargement des classes.",
      "cav_title":              "Analyse et classement des performances",
      "cav_desc":               "Comparaison des classes par le score intelligent de leurs élèves (moyenne annuelle et présence) pour l'année scolaire choisie.",
      "cav_no_data":            "Pas encore assez de données pour afficher l'analyse des classes.",
      "cav_chart_title":        "Graphique comparatif des classes",
      "cav_smart_avg":          "Moyenne intelligente",
      "cav_legend_best":        "Tableau d'honneur ({{top}} % et plus)",
      "cav_legend_good":        "Bon niveau",
      "cav_legend_weak":        "À améliorer (moins de {{pass}} %)",
      "cav_col_rank":           "Rang",
      "cav_col_class":          "Classe",
      "cav_col_students":       "Nombre d'élèves",
      "cav_col_avg":            "Moyenne intelligente",
      "cav_col_category":       "Catégorie",
      "cav_student_unit":       "élève(s)",
      "cav_badge_best":         "Tableau d'honneur",
      "cav_badge_good":         "Bon niveau",
      "cav_badge_weak":         "À améliorer",
      "cav_badge_no_data":      "Pas de données",

      // ─── Batch 6: SchoolAdminStaffAttendanceView ───
      "sav_load_error":         "Erreur",
      "sav_recorded_ok":        "Présence enregistrée",
      "sav_updated_ok":         "Présence mise à jour",
      "sav_record_err":         "Erreur lors de l'enregistrement",
      "sav_title":              "Présence des enseignants",
      "sav_search_placeholder": "Rechercher un enseignant...",
      "sav_record_btn":         "Enregistrer la présence",
      "sav_edit_title":         "Modifier la présence",
      "sav_add_title":          "Enregistrer la présence",
      "sav_select_teacher":     "Choisir un enseignant",
      "sav_label_teacher":      "Enseignant",
      "sav_label_date":         "Date",
      "sav_label_status":       "Statut",
      "sav_status_present":     "Présent",
      "sav_status_absent":      "Absent",
      "sav_col_teacher":        "Enseignant",
      "sav_col_date":           "Date",
      "sav_col_status":         "Statut",
      "sav_col_notes":          "Notes",
      "sav_col_actions":        "Actions",
      "sav_delete_confirm":     "Voulez-vous vraiment supprimer cet enregistrement ?",
      "sav_deleted_ok":         "Supprimé avec succès",
      "sav_delete_err":         "Erreur lors de la suppression",
      "sav_no_records":         "Aucun enregistrement de présence",

      // ─── P1 BATCH: FinanceSystemDetailed ───
      "fin_main_title":            "Système financier complet",
      "fin_partial_load_error":    "Une partie des données financières n'a pas pu être chargée — certaines sections peuvent être incomplètes.",
      "fin_main_subtitle":         "Gestion complète des salaires, dépenses et frais avec vue détaillée sur 12 mois",
      "fin_expected_fees":         "Frais attendus des élèves",
      "fin_currency_franc":        "Franc",
      "fin_collected_from_students":"Encaissé des élèves",
      "fin_total_salaries_card":   "Total des salaires",
      "fin_total_expenses_card":   "Total des dépenses",
      "fin_summary_title":         "Résumé financier",
      "fin_expected_revenue":      "Total des revenus attendus :",
      "fin_total_outflows":        "Total des dépenses :",
      "fin_expected_net":          "Net attendu :",
      "fin_unpaid_fees":           "Frais non encaissés :",
      "fin_fees_records_title":    "Frais des élèves - Année scolaire {{year}}",
      "fin_add_fees_btn":          "Ajouter des frais",
      "fin_col_student":           "Élève",
      "fin_col_class":             "Classe",
      "fin_col_total":             "Total",
      "fin_col_paid":              "Payé",
      "fin_col_remaining":         "Restant",
      "fin_salaries_records_title":"Salaires des enseignants - Année scolaire {{year}}",
      "fin_add_salary_btn":        "Ajouter un salaire",
      "fin_col_teacher":           "Enseignant",
      "fin_col_specialization":    "Spécialité",
      "fin_col_salaries_count":    "Nombre de salaires",
      "fin_default_teacher_label": "Enseignant",
      "fin_total_expenses_inline": "Total des dépenses :",
      "fin_items_count":           "Nombre d'éléments :",
      "fin_print_report":          "Imprimer le rapport",
      "fin_add_expense_btn":       "Ajouter une dépense",
      "fin_col_date":              "Date",
      "fin_col_expense_type":      "Type de dépense",
      "fin_col_description":       "Description",
      "fin_col_amount":            "Montant",
      "fin_col_payment_method":    "Mode de paiement",
      "fin_col_actions":           "Actions",
      "fin_no_expenses":           "Aucune dépense enregistrée",
      "fin_role_student_label":    "Élève - {{class}}",
      "fin_role_teacher_label":    "Enseignant - {{spec}}",
      "fin_personal_info":         "Informations personnelles",
      "fin_label_full_name":       "Nom complet",
      "fin_label_email":           "Email",
      "fin_label_phone":           "Téléphone",
      "fin_label_class":           "Classe",
      "fin_label_level":           "Niveau",
      "fin_label_dob":             "Date de naissance",
      "fin_label_specialization":  "Spécialité",
      "fin_label_subjects":        "Matières",
      "fin_label_classes":         "Classes",
      "fin_summary_card_title":    "Résumé financier",
      "fin_total_fees":            "Total des frais",
      "fin_total_salaries":        "Total des salaires",
      "fin_salaries_count":        "Nombre de salaires",
      "fin_12months_title":        "Détail sur 12 mois - Année scolaire {{year}}",
      "fin_col_month":             "Mois",
      "fin_col_status":            "Statut",
      "fin_col_payment_date":      "Date de paiement",
      "fin_col_type":              "Type",
      "fin_col_notes":             "Notes",
      "fin_current_month":         "Mois en cours",
      "fin_status_paid_full":      "Entièrement payé",
      "fin_status_paid_partial":   "Partiellement payé",
      "fin_status_unpaid":         "Non payé",
      "fin_status_disbursed":      "Versé",
      "fin_status_pending":        "En attente",
      "fin_no_record":             "Aucune entrée",
      "fin_amount_with_franc":     "{{value}} Francs",
      "fin_attendance_summary":    "Résumé de présence",
      "fin_grades_summary":        "Résumé des notes",
      "fin_assessment_type":       "Type d'évaluation",
      "fin_grade_label":           "Note",
      "fin_percentage":            "Pourcentage",
      "fin_subject_label":         "Matière",
      "fin_no_grades":             "Aucune note enregistrée",
      "fin_form_employee":         "Enseignant / Employé *",
      "fin_form_salary_type":      "Type de salaire *",
      "fin_form_amount":           "Montant *",
      "fin_form_month":            "Mois *",
      "fin_form_payment_date":     "Date de paiement",
      "fin_form_payment_method":   "Mode de paiement",
      "fin_form_notes":            "Notes",
      "fin_form_student":          "Élève *",
      "fin_form_fee_type":         "Type de frais *",
      "fin_form_total_amount":     "Montant total *",
      "fin_form_paid_amount":      "Montant payé",
      "fin_form_month_opt":        "Mois",
      "fin_form_due_date":         "Date d'échéance",
      "fin_form_expense_type":     "Type de dépense *",
      "fin_form_amount_required":  "Montant *",
      "fin_form_date_required":    "Date *",
      "fin_form_receipt_number":   "Numéro de reçu",
      "fin_form_description":      "Description *",

      // ─── Month names (used across finance/dashboards) ───
      // ─── P1 BATCH: ParentDashboard (additional) ───
      "pd_overview_title":         "Vue d'ensemble de tous les enfants",
      "pd_registered_count":       "{{count}} enfants inscrits",
      "pd_sibling_badge":          "Frère/Sœur",
      "pd_attendance_short":       "Présence",
      "pd_avg_short":              "Moyenne",
      "pd_remaining_short":        "Restant",
      "pd_settled_short":          "Réglé",
      "pd_view_details":           "Voir les détails",
      "pd_absences_count":         "{{count}} absence(s)",
      "pd_overall_summary":        "Résumé global pour tous les enfants",
      "pd_single_child":           "enfant",
      "pd_plural_children":        "enfants",
      "pd_my_children":            "Mes enfants",
      "pd_link_new_child":         "Associer un enfant",
      "pd_loading_data":           "Chargement des données...",
      "pd_welcome":                "Bienvenue !",
      "pd_no_children":            "Aucun enfant associé à votre compte pour le moment",
      "pd_msg_from_teachers":      "Messages des enseignants",
      "pd_no_messages":            "Aucun message",
      "pd_messages_hint":          "Les messages des enseignants concernant vos enfants apparaîtront ici",
      "pd_school_teacher":         "Enseignant",
      "pd_new_badge":              "Nouveau",
      "pd_select_child_hint":      "Veuillez sélectionner un enfant dans la barre latérale",
      "pd_siblings_count":         "{{count}} frères/sœurs",
      "pd_id_label":               "N° : {{value}}",
      "pd_overall_avg":            "Moyenne générale",
      "pd_attendance_rate":        "Taux de présence",
      "pd_absent_days":            "Jours d'absence",
      "pd_remaining_fees":         "Frais restants",
      "pd_recent_grades":          "Notes récentes",
      "pd_no_grades_short":        "Aucune note",
      "pd_recent_attendance":      "Présences récentes",
      "pd_no_records_short":       "Aucun enregistrement",
      "pd_attendance_for":         "Présence de {{name}}",
      "pd_attended":               "Présent",
      "pd_missed":                 "Absent",
      "pd_col_date":               "Date",
      "pd_col_status":             "Statut",
      "pd_col_notes":              "Notes",
      "pd_no_attendance_records":  "Aucun enregistrement de présence",
      "pd_grades_for":             "Notes de {{name}}",
      "pd_col_subject":            "Matière",
      "pd_col_assessment":         "Évaluation",
      "pd_col_type":               "Type",
      "pd_col_grade":              "Note",
      "pd_col_percentage":         "Pourcentage",
      "pd_no_grades_recorded":     "Aucune note enregistrée",
      "pd_fees_for":               "Frais de {{name}}",
      "pd_total_fees":             "Total des frais",
      "pd_paid":                   "Payé",
      "pd_remaining":              "Restant",
      "pd_col_month":              "Mois",
      "pd_col_amount":             "Montant",
      "pd_col_paid":               "Payé",
      "pd_fee_status_paid":        "Payé",
      "pd_fee_status_partial":     "Partiel",
      "pd_fee_status_unpaid":      "Non payé",
      "pd_no_fees_recorded":       "Aucun frais enregistré",
      "pd_assignments_for":        "Devoirs de {{name}}",
      "pd_overdue_badge":          "En retard",
      "pd_no_assignments":         "Aucun devoir pour le moment",
      "pd_link_dialog_title":      "Associer un enfant à votre compte",
      "pd_link_dialog_desc":       "Saisissez le numéro d'élève pour l'associer à votre compte. Vous pouvez l'obtenir auprès de l'administration de l'école.",
      "pd_link_by_school":         "Pour associer un enfant à votre compte, contactez l'administration de l'école : pour protéger les données des enfants, seule l'école peut lier un élève à un compte parent.",
      "pd_student_number_label":   "Numéro d'élève *",
      "pd_student_number_placeholder":"Ex. : 0001234",
      "pd_linking":                "Association en cours...",
      "pd_link_btn":               "Associer l'élève",

      // ─── P1 BATCH: StudentDashboard ───
      "sd_today_schedule":         "Emploi du temps d'aujourd'hui",
      "sd_no_classes_today":       "Pas de cours aujourd'hui",
      "sd_weekly_schedule":        "Mon emploi du temps hebdomadaire",
      "sd_no_classes":             "Aucun cours",
      "sd_no_classes_short":       "Aucun cours",
      "sd_today_chip":             "Aujourd'hui",
      "sd_free_period":            "Libre",
      "sd_prev_day":               "Jour précédent",
      "sd_next_day":               "Jour suivant",
      "sd_dashboard_subtitle": "Voici un aperçu rapide de vos résultats, de votre assiduité et de votre emploi du temps du jour.",
      "sd_no_grades_hint": "Aucune note n'est enregistrée pour vous pour ce trimestre pour le moment.",
      "sd_no_attendance_hint": "Aucun relevé de présence ou d'absence n'a encore été trouvé pour vous.",
      "sd_no_fees_hint": "Aucun frais n'a encore été enregistré à votre nom.",
      "sd_my_grades":              "Mes notes",
      "sd_finance_tab_title":      "Finances",
      "sd_teacher_feedback":       "Commentaires de l'enseignant",
      "sd_awaiting_grading":       "Soumis le {{date}} — En attente de correction",
      "sd_print_report":           "Imprimer le bulletin",
      "sd_loading_short":          "Chargement...",
      "sd_msg_inbox_hint":         "Les messages de vos enseignants apparaîtront ici",
      "student_not_linked_title":  "Votre compte n'est pas lié à un dossier élève",
      "student_not_linked_body":   "Votre compte n'est pas lié à un dossier d'élève dans la base de données. Veuillez contacter l'administration de l'école pour finaliser la liaison.",
      "student_fetch_failed_body": "Une erreur s'est produite lors du chargement des données de l'élève. Veuillez réessayer ou contacter l'administration.",
      "retry":                     "Réessayer",

      // ─── P1 BATCH: TeacherDashboard (additional) ───
      "td_msg_sent":               "Message envoyé avec succès",
      "td_msg_send_error":         "Erreur lors de l'envoi du message",
      "td_salaries_title":         "Historique des salaires et paiements",
      "td_view_payslip":           "Voir le bulletin",
      "td_issue_payslip":          "Émettre le bulletin",
      "td_no_salaries":            "Aucun enregistrement de salaire disponible",
      "td_salaries_hint":          "Vos salaires apparaîtront ici dès leur enregistrement",
      "td_record_attendance_title":"Enregistrement des présences",
      "td_all_present":            "Tous présents",
      "td_all_absent":             "Tous absents",
      "td_not_recorded":           "Non enregistré",
      "td_no_students_in_class":   "Aucun élève dans cette classe",
      "td_subjects_i_teach":       "Matières que j'enseigne :",
      "td_col_day":                "Jour",
      "td_col_time":               "Heure",
      "td_no_schedule_yet":        "Aucun emploi du temps assigné pour le moment",
      "td_schedule_admin_creates": "L'administrateur crée et assigne l'emploi du temps",
      "td_my_students_title":      "Mes élèves",
      "td_message_parent":         "Contacter le parent ({{name}})",
      "td_parent_not_linked":      "Parent non associé",
      "td_msg_to":                 "Message à : {{name}}",
      "td_msg_re":                 "Au sujet de : {{children}}",
      "td_msg_text":               "Texte du message",
      "td_previous_msgs":          "Messages précédents :",
      "td_send_msg":               "Envoyer le message",
      "teacher_no_classes_assigned":"Aucune classe ne vous a encore été assignée. Veuillez contacter l'administration de l'école pour assigner des classes, puis cliquez sur « Actualiser ».",

      // ─── P1 BATCH: GradesViewOnly ───
      "gvo_title":                 "Registre des notes",
      "gvo_subtitle":              "Vue d'ensemble des notes par classe, matière, évaluation et année scolaire",
      "gvo_count":                 "Nombre de notes",
      "gvo_passed":                "Réussites",
      "gvo_filter_results":        "Filtrer les résultats",
      "gvo_search_by_name":        "Rechercher par nom...",
      "gvo_all_classes":           "Toutes les classes",
      "gvo_all_subjects":          "Toutes les matières",
      "gvo_exam":                  "Évaluation",
      "gvo_all_exams":             "Toutes les évaluations",
      "gvo_academic_year_label":   "Année scolaire",
      "gvo_all_years":             "Toutes les années",
      "gvo_view_for":              "Vue complète : tous les élèves de {{cls}} en {{subject}} — {{exam}}{{year}}",
      "gvo_not_entered":           "Non saisie",
      "gvo_no_match":              "Aucune note ne correspond à la recherche",
      "gvo_try_filters":           "Essayez de modifier les filtres ou sélectionnez « Tous » pour tout afficher",
      "gvo_print_title":           "Relevé de notes",
      "gvo_print_class":           "Classe",
      "gvo_print_subject":         "Matière",
      "gvo_print_exam":            "Évaluation",
      "gvo_print_year":            "Année",
      "gvo_print_col_name":        "Nom de l'élève",
      "gvo_print_col_score":       "Note",
      "gvo_print_col_max":         "Sur",
      "gvo_print_col_pct":         "Pourcentage",
      "gvo_print_footer":          "Imprimé le : {{date}}",

      // ─── P1 BATCH: DetailViews ───
      "dv_img_max_5mb":            "L'image doit faire moins de 5 Mo",
      "dv_img_encoded_too_big":    "L'image encodée est trop volumineuse — choisissez une image plus petite",
      "dv_student_updated":        "Informations de l'élève mises à jour !",
      "dv_update_error":           "Erreur lors de la mise à jour",
      "dv_student_role_subtitle":  "Élève - {{cls}} - {{grade}}",
      "dv_username_readonly":      "Nom d'utilisateur (lecture seule)",
      "dv_address":                "Adresse",
      "dv_medical_info":           "Informations médicales",
      "dv_school_qr_card":         "Carte scolaire QR",
      "dv_qr_hint":                "Utilisez ce QR pour l'appel, la cafétéria ou le prêt de livres en bibliothèque. Il peut être imprimé sur la carte scolaire.",
      "dv_student_card_print":     "Carte élève",
      "dv_id_print":               "N° : {{value}}",
      "dv_print_card":             "Imprimer la carte",
      "dv_teacher_updated":        "Informations de l'enseignant mises à jour !",
      "dv_teacher_role_subtitle":  "Enseignant - {{spec}}",
      "dv_salaries_paid":          "Salaires payés",
      "dv_academic_subjects":      "Matières enseignées",
      "dv_add_custom_subject":     "Ajouter une matière absente de la liste...",
      "dv_academic_classes":       "Classes enseignées",
      "dv_no_subjects":            "Aucune matière définie",
      "dv_no_classes_assigned":    "Aucune classe assignée",
      "dv_no_notes":               "Sans notes",
      "dv_parent_updated":         "Informations du parent mises à jour !",
      "dv_rel_father":             "Père",
      "dv_rel_mother":             "Mère",
      "dv_rel_guardian":           "Tuteur",
      "dv_default_parent_label":   "Parent",
      "dv_children_count":         "{{count}} enfant(s)",
      "dv_relationship":           "Lien de parenté",
      "dv_link_more_children":     "Associer d'autres enfants (sélectionnez les élèves)",
      // [PHASE-4 2026-10] Profile drawers
      "pf_loading": "Chargement du profil…",
      "pf_load_error": "Impossible de charger ce profil.",
      "pf_retry": "Réessayer",
      "pf_attendance_rate": "Taux de présence",
      "pf_attendance_breakdown": "{{present}} présent · {{late}} en retard · {{absent}} absent · {{excused}} excusé",
      "pf_student_number": "N° d'élève",
      "pf_guardians": "Responsables légaux",
      "pf_no_guardians": "Aucun responsable lié",
      "pf_no_recent_grades": "Aucune note cette année",
      "pf_periods_per_week": "Séances par semaine",
      "pf_load_sub": "{{classes}} classes · {{subjects}} matières",
      "pf_latest_rating": "Dernière évaluation",
      "pf_no_rating": "Aucune évaluation pour l'instant",
      "pf_documents": "Documents au dossier",
      "pf_timetable": "Emploi du temps hebdomadaire",
      "pf_no_timetable": "Aucune séance prévue cette année",
      "pf_period": "Séance {{n}}",
      "pf_room": "Salle {{room}}",
      "dv_no_number":              "Sans numéro",
      "dv_children_label":         "Enfants ({{count}})",
      "dv_no_children_linked":     "Aucun enfant associé",

      // ─── P2 BATCH: SchoolAdminTeacherTasksView ───
      "sattv_status_reviewed":     "En revue",
      "sattv_load_submission_error":"Erreur lors du chargement de la soumission",
      "sattv_submission_approved": "Soumission acceptée",
      "sattv_submission_rejected": "Soumission rejetée",
      "sattv_review_error":        "Erreur lors de la revue",
      "sattv_task_added":          "Tâche ajoutée avec succès",
      "sattv_title":               "Tâches des enseignants",
      "sattv_search_placeholder":  "Rechercher un enseignant ou une tâche...",
      "sattv_add_task":            "Ajouter une tâche",
      "sattv_add_task_for_teacher":"Ajouter une tâche à l'enseignant",
      "sattv_add_task_desc":       "Saisissez les détails de la nouvelle tâche",
      "sattv_pick_teacher":        "Choisir l'enseignant *",
      "sattv_task_title_label":    "Titre de la tâche *",
      "sattv_task_title_placeholder":"Ex. : Préparer le plan des cours pour la semaine prochaine",
      "sattv_task_desc_label":     "Description",
      "sattv_task_desc_placeholder":"Détails de la tâche...",
      "sattv_due_date":            "Date d'échéance",
      "sattv_priority":            "Priorité",
      "sattv_priority_low":        "Basse",
      "sattv_priority_medium":     "Moyenne",
      "sattv_priority_high":       "Élevée",
      "sattv_add_task_btn":        "Ajouter la tâche",
      "sattv_admin_note":          "Note : ici vous attribuez des tâches administratives aux enseignants. Les devoirs des élèves sont gérés directement par l'enseignant.",
      "sattv_col_task":            "Tâche",
      "sattv_no_tasks":            "Aucune tâche pour le moment",
      "sattv_view_submission":     "Voir la soumission",
      "sattv_delete_confirm":      "Voulez-vous vraiment supprimer cette tâche ?",
      "sattv_submission_desc":     "Description de la soumission",
      "sattv_no_desc":             "(sans description)",
      "sattv_admin_feedback":      "Commentaires de l'administration",
      "sattv_admin_feedback_placeholder":"Écrivez vos commentaires pour l'enseignant...",
      "sattv_btn_reject":          "Rejeter",
      "sattv_btn_approve":         "Approuver",
      "sattv_task_details":        "Détails de la tâche",
      "sattv_task_title_field":    "Titre de la tâche",
      "sattv_submission_status":   "Statut de la soumission",
      "sattv_submitted_at":        "Soumis le",
      "sattv_open_review":         "Ouvrir la revue",

      // ─── P2 BATCH: MessagingSystem ───
      "ms_load_error":             "Erreur lors du chargement des messages",
      "ms_sent_to":                "Message envoyé à {{name}}",
      "ms_send_error":             "Erreur lors de l'envoi",
      "ms_broadcast_default_subject":"Message groupé",
      "ms_broadcast_ok":           "Diffusion envoyée",
      "ms_broadcast_error":        "Erreur lors de la diffusion",
      "ms_title":                  "Messages",
      "ms_unread_badge":           "{{count}} nouveau(x)",
      "ms_subtitle":               "Communiquez avec n'importe qui dans le système",
      "ms_compose":                "Nouveau message",
      "ms_sent_tab":               "Envoyés",
      "ms_broadcast_tab":          "Diffusion",
      "ms_inbox_empty":            "Aucun message dans la boîte de réception",
      "ms_broadcast_badge":        "Diffusion",
      "ms_contacts":               "Contacts",
      "ms_search":                 "Rechercher...",
      "ms_no_contacts":            "Aucun contact",
      "ms_to_with_name":           "À : {{name}}",
      "ms_pick_contact":           "Choisir un contact",
      "ms_subject_optional":       "Sujet (facultatif)",
      "ms_subject_placeholder":    "Sujet du message...",
      "ms_message_required":       "Texte du message *",
      "ms_message_placeholder":    "Écrivez votre message ici...",
      "ms_char_count":             "{{count}} caractères",
      "ms_no_sent":                "Aucun message envoyé",
      "ms_to_short":               "À :",
      "ms_broadcast_title":        "Message groupé",
      "ms_broadcast_desc":         "Envoyez un message unique à tous les membres d'un groupe",
      "ms_target_group":           "Groupe cible *",
      "ms_pick_group":             "Choisir le groupe...",
      "ms_role_all":               "{{role}} (tous)",
      "ms_broadcast_reach":        "Ce message sera envoyé à tous les {{role}} de votre école",
      "ms_subject":                "Sujet",
      "ms_subject_example":        "Ex. : Réunion des parents",
      "ms_broadcast_placeholder":  "Écrivez le texte du message groupé ici...",
      "ms_send_broadcast":         "Envoyer le message groupé",

      // ─── P2 BATCH: TeacherGradesEntry ───
      "tge_grade_updated":         "Note mise à jour !",
      "tge_grade_added":           "Note ajoutée !",
      "tge_save_error":            "Erreur lors de l'enregistrement",
      "tge_delete_confirm":        "Voulez-vous vraiment supprimer cette note ?",
      "tge_grade_deleted":         "Note supprimée !",
      "tge_delete_error":          "Erreur lors de la suppression",
      "tge_title":                 "Saisie des notes",
      "tge_add_grade":             "Ajouter une note",
      "tge_edit_grade_title":      "Modifier la note",
      "tge_add_grade_title":       "Ajouter une nouvelle note",
      "tge_student_required":      "Élève *",
      "tge_pick_student":          "Choisir l'élève",
      "tge_subject_required":      "Matière *",
      "tge_assessment_type_required":"Type d'évaluation *",
      "tge_type_quiz":             "Test rapide",
      "tge_type_exam":             "Examen",
      "tge_type_homework":         "Devoir",
      "tge_type_project":          "Projet",
      "assess_name_exam1":         "Premier examen",
      "assess_name_exam2":         "Deuxième examen",
      "assess_name_exam3":         "Troisième examen",
      "assess_name_oral":          "Examen oral",
      "assess_name_project":       "Projet",
      "assess_name_homework":      "Devoir",
      "class_grade1_primary":      "1re année primaire",
      "class_grade2_primary":      "2e année primaire",
      "class_grade3_primary":      "3e année primaire",
      "class_grade4_primary":      "4e année primaire",
      "class_grade5_primary":      "5e année primaire",
      "class_grade6_primary":      "6e année primaire",
      "class_grade1_middle":       "1re année moyenne",
      "class_grade2_middle":       "2e année moyenne",
      "class_grade3_middle":       "3e année moyenne",
      "class_grade1_high":         "1re année secondaire",
      "class_grade2_high":         "2e année secondaire",
      "class_grade3_high":         "3e année secondaire",
      "day_sunday_full":           "Dimanche",
      "day_monday_full":           "Lundi",
      "day_tuesday_full":          "Mardi",
      "day_wednesday_full":        "Mercredi",
      "day_thursday_full":         "Jeudi",
      "day_friday_full":           "Vendredi",
      "day_saturday_full":         "Samedi",
      "subject_math":              "Mathématiques",
      "subject_arabic":            "Langue arabe",
      "subject_french":            "Langue française",
      "subject_english":           "Langue anglaise",
      "subject_science":           "Sciences",
      "subject_history":           "Histoire-Géographie",
      "subject_islamic":           "Éducation islamique",
      "subject_pe":                "Éducation physique",
      "subject_art":               "Arts plastiques",
      "subject_computer":          "Informatique",
      "val_paid":                  "Payé",
      "val_unpaid":                "Non payé",
      "val_partial":               "Partiel",
      "val_present":               "Présent",
      "val_absent":                "Absent",
      "val_late":                  "En retard",
      "val_excused":               "Justifié",
      "val_single":                "Célibataire",
      "val_married":               "Marié(e)",
      "val_divorced":              "Divorcé(e)",
      "val_widowed":               "Veuf/Veuve",
      "val_bachelor":              "Licence",
      "val_master":                "Master",
      "val_phd":                   "Doctorat",
      "val_diploma":               "Diplôme",
      "val_highschool":            "Baccalauréat",
      "val_father":                "Père",
      "val_mother":                "Mère",
      "val_guardian":              "Tuteur",
      "gr_title":                  "Classement des élèves",
      "gr_tab":                    "Classement de classe",
      "gr_select_class":           "Choisir la classe",
      "gr_select_year":            "Toutes les années",
      "gr_all_types":              "Tous les types",
      "gr_show":                   "Afficher le classement",
      "gr_rank":                   "Rang",
      "gr_student":                "Élève",
      "gr_subjects":               "Matières",
      "gr_overall":                "Moyenne générale",
      "gr_no_data":                "Aucune donnée de classement",
      "gr_load_failed":            "Échec du chargement du classement",
      "tge_type_participation":    "Participation",
      "tge_assessment_name_required":"Nom de l'évaluation *",
      "tge_pick_assessment_name":  "Choisir le nom de l'évaluation",
      "tge_academic_year_required":"Année scolaire *",
      "tge_semester_required":     "Semestre *",
      "tge_semester_1":            "Premier semestre",
      "tge_semester_2":            "Deuxième semestre",
      "tge_semester_3":            "Troisième semestre",
      "tge_score_required":        "Note *",
      "tge_max_score_required":    "Note maximale *",
      "tge_notes":                 "Notes",

      // ─── P2 BATCH: SubscriptionManager ───
      "sm_plan_trial":             "Essai",
      "sm_plan_basic":             "Basique",
      "sm_plan_professional":      "Professionnel",
      "sm_plan_suspended":         "Suspendu",
      "sm_inactive":               "Inactif",
      "sm_trial_ended":            "Essai expiré",
      "sm_days_left":              "{{count}} jours restants",
      "sm_trial_with_days":        "Essai ({{days}} j)",
      "sm_edit_title":             "Mise à jour de l'abonnement — {{name}}",
      "sm_plan_type":              "Type de plan",
      "sm_free":                   "Gratuit",
      "sm_billing_cycle":          "Durée d'abonnement",
      "sm_semi_annual":            "Semestriel (6 mois)",
      "sm_annual":                 "Annuel (12 mois)",
      "sm_extend_trial_label":     "Prolonger l'essai (jours supplémentaires)",
      "sm_max_students_label":     "Limite d'élèves",
      "sm_max_teachers_label":     "Limite d'enseignants",
      "sm_account_status":         "Statut du compte",
      "sm_updated":                "Abonnement mis à jour",
      "sm_update_failed":          "Échec de la mise à jour",
      "sm_extended_90":            "Essai prolongé de 90 jours",
      "sm_extend_failed":          "Échec de la prolongation",
      "sm_kpi_total":              "Total des écoles",
      "sm_kpi_trial":              "En période d'essai",
      "sm_kpi_paid":               "Abonnement payant",
      "sm_kpi_expiring_soon":      "Expire bientôt",
      "sm_kpi_expired":            "Essai expiré",
      "sm_kpi_revenue":            "Revenus semestriels",
      "sm_filter_all":             "Tous",
      "sm_col_school":             "École",
      "sm_col_plan":               "Plan",
      "sm_col_trial_end":          "Fin de l'essai",
      "sm_col_limits":             "Limites",
      "sm_no_results":             "Aucun résultat",
      "sm_days_left_d":            "{{count}} jour(s) restant(s)",
      "sm_expired_ago":            "Expiré il y a {{count}} jour(s)",
      "sm_limits_inline":          "{{students}} élèves · {{teachers}} enseignants",
      "sm_edit_btn":               "Modifier l'abonnement",
      "sm_extend_btn_title":       "Prolonger de 90 jours",
      "sm_extend_short":           "Prolonger",

      // ─── P2 BATCH: TeacherMessaging ───
      "tm_pick_student_error":     "Choisissez un élève",
      "tm_content_error":          "Saisissez le contenu du message",
      "tm_sent_to_student_parent": "Message envoyé à l'élève et à son parent ✓",
      "tm_sent_to_student":        "Message envoyé à l'élève ✓",
      "tm_pick_class_error":       "Choisissez la classe",
      "tm_sent_ok":                "Envoyé avec succès",
      "tm_send_error":             "Erreur lors de l'envoi",
      "tm_target_all_students":    "Tous les élèves",
      "tm_target_all_parents":     "Tous les parents",
      "tm_target_class":           "Classe spécifique",
      "tm_title":                  "Envoyer un message",
      "tm_subtitle":               "Envoyez un message à un élève ou à un groupe d'élèves et de parents",
      "tm_mode_individual":        "Élève spécifique",
      "tm_mode_bulk":              "Message groupé",
      "tm_pick_student":           "Choisir l'élève *",
      "tm_pick_student_option":    "-- Choisir un élève --",
      "tm_notify_parent":          "Envoyer aussi une copie au parent",
      "tm_subject_label":          "Sujet",
      "tm_subject_placeholder":    "Sujet du message (facultatif)",
      "tm_message_text_label":     "Texte du message *",
      "tm_message_placeholder":    "Écrivez votre message ici...",
      "tm_char_count":             "{{count}} caractères",
      "tm_sending":                "Envoi en cours...",
      "tm_send_btn":               "Envoyer le message",
      "tm_targets":                "Destinataires",
      "tm_pick_class_option":      "-- Choisir la classe --",

      // ─── P2 BATCH: SchoolSettings ───
      "ss_no_school_id":           "Erreur : identifiant de l'école introuvable",
      "ss_saved":                  "Paramètres de l'école enregistrés",
      "ss_unknown_error":          "Erreur inconnue",
      "ss_save_error":             "Erreur lors de l'enregistrement : {{detail}}",
      "ss_title":                  "Paramètres de l'école",
      "ss_subtitle":               "Personnalisez votre école pour refléter son identité",
      "ss_currency_title":         "Devise de l'école",
      "ss_currency_label":         "Sélectionnez la devise utilisée par l'école",
      "ss_currency_hint":          "Cette devise sera utilisée pour les frais, salaires, dépenses, reçus, bulletins de paie, factures et tableaux de bord.",
      "ss_second_language_title": "Deuxième langue des documents",
      "ss_second_language_label": "Langue affichée à côté de l'arabe sur les relevés de notes et les certificats",
      "ss_second_language_choose": "Choisir la deuxième langue",
      "ss_second_language_fr": "Français",
      "ss_second_language_en": "Anglais",
      "ss_second_language_hint": "Les relevés de notes et les certificats seront imprimés en arabe et dans cette langue.",
      "ss_second_language_unset": "Aucune deuxième langue choisie : les relevés et certificats seront imprimés en arabe uniquement jusqu'à votre choix.",
      "ss_week_title":            "Jours d'école",
      "ss_week_hint":             "Choisissez les jours où votre école enseigne. Seuls ces jours apparaîtront lors de la création des emplois du temps, des examens et des présences. Toute combinaison est possible, y compris les semaines irrégulières (par ex. vendredi chômé, samedi travaillé).",
      "ss_week_presets":          "Modèles courants",
      "ss_week_days_label":       "Jours travaillés",
      "ss_week_none_selected":    "Aucun jour sélectionné — la modification ne sera pas enregistrée tant qu'au moins un jour n'est pas choisi.",
      "wd_preset_sat_wed":        "Samedi – Mercredi",
      "wd_preset_sun_thu":        "Dimanche – Jeudi",
      "wd_preset_mon_fri":        "Lundi – Vendredi",
      "wd_preset_mon_sat":        "Lundi – Samedi",
      "smc_time_range":           "Horaire du cours (de – à)",
      "smc_time_start":           "De",
      "smc_time_end":             "À",
      "smc_time_suggestions":     "Horaires suggérés",
      "smc_time_invalid":         "Horaire invalide ({{time}}) — l'heure de fin doit suivre l'heure de début.",
      "smc_subject_add_new":      "Ajouter une matière",
      "smc_subject_custom_placeholder": "Saisir le nom de la matière",
      "ss_saved_short":            "Enregistré",
      "ss_saving":                 "Enregistrement...",
      "ss_default_name":           "Nom de l'école",
      "ss_default_address":        "Adresse",
      "ss_basic_info":             "Informations de base",
      "ss_name_ar":                "Nom de l'école (arabe)",
      "ss_name_ar_placeholder":    "Ex. : École primaire Al-Nour",
      "ss_name_fr":                "Nom de l'école (français)",
      "ss_name_fr_placeholder":    "École Primaire Al-Nour",
      "ss_email":                  "Email",
      "ss_phone":                  "Téléphone",
      "ss_address":                "Adresse",
      "ss_address_placeholder":    "Bamako, Mali",
      "ss_theme_colors":           "Couleurs de l'interface",
      "ss_primary_color":          "Couleur principale",
      "ss_preview_label":          "Aperçu des couleurs :",
      "ss_btn_primary":            "Bouton principal",
      "ss_btn_outline":            "Bouton contour",
      "ss_tips_title":             "Conseils de personnalisation",
      "ss_tip_logo":               "• Utilisez un logo clair sur fond transparent (PNG)",
      "ss_tip_colors":             "• La couleur principale sert d'accent sur les reçus et les fiches de paie",
      // [PHASE-1b 2026-10] Settings audit
      "ss_section_identity": "Identité de l'école et documents imprimés",
      "ss_section_money_language": "Devise et langue",
      "ss_section_timetable": "Semaine scolaire et emploi du temps",
      "ss_section_teacher_files": "Dossiers des enseignants",
      "ss_address_on_receipt": "L'adresse est imprimée sur les reçus de frais.",
      "ss_custom_subjects_title": "Matières ajoutées",
      "ss_custom_subjects_hint": "Une matière s'ajoute ici automatiquement quand elle est attribuée à un enseignant. Elle ne peut être supprimée que si plus aucun enseignant ne l'enseigne.",
      "ss_custom_subjects_empty": "Aucune matière ajoutée pour le moment.",
      "ss_custom_subjects_remove": "Supprimer la matière",
      "ss_custom_subjects_confirm": "Supprimer la matière « {{subject}} » de la liste de l'école ?",
      "ss_custom_subjects_removed": "Matière supprimée.",
      "ss_primary_color_hint": "Sert d'accent sur les reçus et les fiches de paie. Ne change pas les couleurs de l'application.",
      "ss_logo_used_on": "Le logo et le nom en arabe figurent sur les reçus, les fiches de paie et les cartes d'identité.",

      // ─── P2 BATCH: AdminProfile ───
      "ap_profile_updated":        "Profil mis à jour avec succès",
      "ap_unknown_error":          "Erreur inconnue",
      "ap_save_error":             "Erreur lors de la mise à jour : {{detail}}",
      "ap_pwd_mismatch":           "Les nouveaux mots de passe ne correspondent pas",
      "ap_pwd_too_short":          "Le mot de passe doit contenir au moins 8 caractères",
      "ap_pwd_changed":            "Mot de passe modifié avec succès",
      "ap_pwd_change_error":       "Erreur lors du changement de mot de passe",
      "ap_title":                  "Profil",
      "ap_subtitle":               "Gérez vos informations personnelles et les paramètres de sécurité",
      "ap_personal_info":          "Informations personnelles",
      "ap_full_name":              "Nom complet",
      "ap_email":                  "Email",
      "ap_phone":                  "Téléphone",
      "ap_role":                   "Rôle",
      "ap_change_password":        "Changer le mot de passe",
      "ap_current_password":       "Mot de passe actuel",
      "ap_new_password":           "Nouveau mot de passe",
      "ap_confirm_password":       "Confirmer le mot de passe",
      "ap_security_tips_title":    "🔐 Conseils de sécurité",
      "ap_tip_strong":             "• Utilisez un mot de passe fort avec lettres, chiffres et symboles",
      "ap_tip_no_share":           "• Ne partagez votre mot de passe avec personne",
      "ap_tip_rotate":             "• Changez votre mot de passe régulièrement",
      "ap_tip_logout":             "• Pensez à vous déconnecter sur les appareils partagés",

      // ─── P2 BATCH: ReportsManager ───
      "rpm_load_error":            "Erreur lors du chargement du rapport",
      "rpm_export_pdf_toast":      "Préparation du rapport PDF...",
      "rpm_export_pdf_desc":       "Le fichier sera téléchargé sous peu",
      "rpm_title":                 " Rapports et statistiques",
      "rpm_subtitle":              "Rapports complets sur les performances de votre école",
      "rpm_period_monthly":        "Mensuel",
      "rpm_period_annual":         "Annuel",
      "rpm_export_pdf":            "Exporter en PDF",
      "rpm_kpi_students":          "Total des élèves",
      "rpm_kpi_teachers":          "Total des enseignants",
      "rpm_kpi_attendance":        "Taux de présence",
      "rpm_attendance_sub":        "{{present}} présents • {{absent}} absents",
      "rpm_kpi_avg":               "Moyenne générale",
      "rpm_avg_sub":               "Sur {{count}} évaluations",
      "rpm_kpi_revenue":           "Revenus",
      "rpm_kpi_expenses":          "Dépenses",
      "rpm_kpi_net":               "Bénéfice net",
      "rpm_class_perf_title":      "Performance des classes",
      "rpm_class_perf_sub":        "Moyenne des notes par classe",
      "rpm_no_grades_recorded":    "Aucune note enregistrée",
      "rpm_subject_perf_title":    "Performance par matière",
      "rpm_subject_perf_sub":      "Moyenne des notes par matière",
      "rpm_top_students_title":    "Meilleurs élèves",
      "rpm_top_students_sub":      "Les élèves les plus performants sur la période",
      "rpm_col_name":              "Nom de l'élève",
      "rpm_col_avg":               "Moyenne",
      "rpm_col_rating":            "Évaluation",
      "rpm_rating_excellent":      "Excellent",
      "rpm_rating_very_good":      "Très bien",
      "rpm_rating_good":           "Bien",
      "rpm_warn_attendance":       "Alerte : taux de présence faible ({{rate}}%)",
      "rpm_warn_attendance_desc":  "Surveillez les absences et contactez les parents concernés.",
      "rpm_warn_finance":          "Alerte : les dépenses dépassent les revenus",
      "rpm_warn_finance_desc":     "Examinez le rapport financier détaillé et vérifiez les frais en retard.",

      // ─── P2 BATCH: SchoolRegister ───
      "sr_school_name_required":   "Le nom de l'école est requis",
      "sr_pwd_mismatch":           "Les deux mots de passe ne correspondent pas",
      "sr_pwd_too_short":          "Le mot de passe doit contenir au moins 8 caractères",
      "sr_generic_error":          "Une erreur est survenue, réessayez",
      "sr_tagline":                "Inscrivez votre école et commencez l'essai gratuit",
      "sr_step_school":            "Informations de l'école",
      "sr_step_admin":             "Compte administrateur",
      "sr_school_name":            "Nom de l'école *",
      "sr_school_name_placeholder":"Ex. : École Primaire Al-Nour",
      "sr_phone_optional":         "Téléphone (facultatif)",
      "sr_trial_banner":           "90 jours gratuits — sans carte bancaire",
      "sr_next":                   "Suivant",
      "sr_back_landing":           "← Retour à l'accueil",
      "sr_admin_full_name":        "Nom complet de l'administrateur *",
      "sr_admin_full_name_placeholder":"Nom complet",
      "sr_admin_username":         "Nom d'utilisateur *",
      "sr_username_placeholder": "nom d'utilisateur",
      "sr_admin_email":            "Email",
      "sr_admin_password":         "Mot de passe *",
      "sr_admin_password_placeholder":"Au moins 8 caractères",
      "sr_admin_password_confirm": "Confirmer le mot de passe *",
      "sr_admin_password_confirm_placeholder":"Saisissez à nouveau le mot de passe",
      "sr_previous":               "← Précédent",
      "sr_creating":               "Création en cours...",
      "sr_create_account":         "Créer le compte",
      "sr_success_title":          "Inscription réussie",
      "sr_success_welcome":        "Bienvenue dans <strong>EduGate</strong> !",
      "sr_success_trial":          "Profitez de <strong>90 jours gratuits</strong> sans restriction.",
      "sr_login_info":             "Informations de connexion :",
      "sr_login_username":         "Nom d'utilisateur : <strong>{{username}}</strong>",
      "sr_login_role":             "Rôle : <strong>Administrateur d'école</strong>",
      "sr_goto_login":             "Aller à la page de connexion",

      // SchoolCalendar
      "sc_title":                  "Calendrier scolaire",
      "sc_subtitle":               "Examens • Vacances • Réunions • Activités",
      "sc_type_exam":              "Examen",
      "sc_type_holiday":           "Vacances",
      "sc_type_meeting":           "Réunion",
      "sc_type_activity":          "Activité",
      "sc_type_other":             "Autre",
      "sc_title_required":         "Le titre est requis",
      "sc_event_added":            "Événement ajouté",
      "sc_event_deleted":          "Événement supprimé",
      "sc_event_save_error":       "Impossible d'enregistrer l'événement — vérifiez la connexion et réessayez",
      "sc_more_events":            "+{{count}} autres",
      "sc_event_types":            "Types d'événements",
      "sc_upcoming":               "À venir",
      "sc_no_upcoming":            "Aucun événement à venir",
      "sc_add_event_header":       "Ajouter un événement — {{day}} {{month}} {{year}}",
      "sc_event_title_label":      "Titre de l'événement *",
      "sc_event_title_placeholder":"Ex. : Examen de mathématiques",
      "sc_event_type_label":       "Type",
      "sc_event_desc_label":       "Description (facultatif)",
      "sc_event_desc_placeholder": "Détails supplémentaires…",
      "day_sun_short":             "Di",
      "day_mon_short":             "Lu",
      "day_tue_short":             "Ma",
      "day_wed_short":             "Me",
      "day_thu_short":             "Je",
      "day_fri_short":             "Ve",
      "day_sat_short":             "Sa",

      // PrintableReport
      "pr_title":                  "Bulletin scolaire",
      "pr_student":                "Élève",
      "pr_class":                  "Classe",
      "pr_student_no": "N° élève",
      "pr_print_date":             "Date d'impression",
      "pr_grades":                 "Notes",
      "pr_subject":                "Matière",
      "pr_score":                  "Note",
      "pr_type":                   "Type",
      "pr_avg":                    "Moyenne générale",
      "pr_attendance":             "Registre de présence",
      "pr_att_rate":               "Taux de présence",
      "pr_fees":                   "Frais scolaires",
      "pr_total_fees":             "Total des frais",
      "pr_paid":                   "Payé",
      "pr_remaining":              "Restant",
      "pr_edugete_tagline":        "EduGate — Gestion scolaire",

      // SchoolAdminTrialBanner
      "tb_trial_expired":          "La période d'essai gratuite est terminée ! Contactez-nous pour activer votre abonnement.",
      "tb_trial_remaining":        "Il reste {{count}} jour sur la période d'essai gratuite (90 jours).",
      "tb_trial_remaining_plural": "Il reste {{count}} jours sur la période d'essai gratuite (90 jours).",
      "tb_upgrade":                "Mettre à niveau",
      "subscription_readonly_banner": "L'abonnement de votre école a expiré — accès en lecture seule. Contactez l'administration de la plateforme pour le renouveler.",
      "subscription_renew":           "Renouveler l'abonnement",
      "subscription_readonly_tooltip":"Indisponible — abonnement expiré",
      // App-wide messages: axios interceptors, API errors, password rules [I18N 2026-10]
      "app_rate_limited": "Trop de tentatives. Veuillez patienter un moment puis réessayer.",
      "app_server_unreachable": "Impossible de joindre le serveur après plusieurs tentatives — vérifiez votre connexion puis réessayez.",
      "app_readonly_toast": "L'abonnement de votre école a expiré — mode lecture seule.",
      "app_offline_queued": "Vous êtes hors ligne — cette action sera envoyée au retour de la connexion",
      "app_queued_sent": "Une action en attente a été envoyée ✓",
      "app_queued_failed": "L'envoi d'une action en attente a échoué — elle a été ignorée",
      "api_err_generic": "Une erreur est survenue, veuillez réessayer",
      "api_err_network": "Impossible de joindre le serveur — vérifiez que le système est en marche",
      "api_err_401": "Votre session a expiré — veuillez vous reconnecter",
      "api_err_403": "Vous n'avez pas l'autorisation d'effectuer cette action",
      "api_err_404": "Les données demandées sont introuvables",
      "api_err_422": "Les données envoyées sont invalides — vérifiez les champs",
      "api_err_429": "Trop de requêtes — patientez un instant puis réessayez",
      "api_err_5xx": "Erreur du serveur — veuillez réessayer plus tard",
      "pwd_rule_min_length": "Le mot de passe doit contenir au moins 8 caractères",
      "pwd_rule_letter": "Le mot de passe doit contenir au moins une lettre latine",
      "pwd_rule_digit": "Le mot de passe doit contenir au moins un chiffre",

      // PasswordStrength
      "pwd_strength_weak":         "Faible",
      "pwd_strength_fair":         "Moyen",
      "pwd_strength_good":         "Bon",
      "pwd_strength_strong":       "Très fort",

      // ErrorBoundary
      "eb_title":                  "Une erreur inattendue est survenue",
      "eb_message":                "Désolé pour ce désagrément. Vous pouvez recharger la page ou revenir à l'accueil.",
      "eb_reload":                 "Recharger",
      "eb_home":                   "Page d'accueil",

      // SessionTimeoutWarning
      "stw_expiring_now":          "Votre session va expirer !",
      "stw_warning_title":         "Avertissement : fin de session",
      "stw_urgent_message":        "La session va se fermer automatiquement dans quelques secondes. Sauvegardez votre travail immédiatement.",
      "stw_logout":                "Déconnexion",

      // PDFReports
      "pdfr_title":                "Exporter les rapports PDF",
      "pdfr_subtitle":             "Imprimez ou sauvegardez les rapports en PDF",
      "pdfr_roster":               "Liste des élèves",
      "pdfr_grades":               "Rapport des notes",
      "pdfr_attendance":           "Rapport de présence",
      "pdfr_generating":           "Génération du fichier...",
      "pdfr_roster_hint": "Liste de la classe (PDF)",
      "pdfr_grades_hint": "Relevé de notes (PDF)",
      "pdfr_attendance_hint": "Rapport de présence (PDF)",
      "pdfr_attendance_none": "Aucune présence saisie pour cette classe ce jour-là.",

      // ProgressChart

      // BulkMessaging
      "bm_title":                  "Messages en masse",
      "bm_subtitle":               "Envoyer un message à des centaines d'utilisateurs en une fois",
      "bm_target_all_parents":     "Tous les parents",
      "bm_target_all_teachers":    "Tous les enseignants",
      "bm_target_all_students":    "Tous les étudiants",
      "bm_target_class":           "Classe spécifique",
      "bm_subject":                "Objet",
      "bm_target":                 "Destinataires",
      "bm_message":                "Contenu du message",
      "bm_send":                   "Envoyer",
      "bm_sending":                "Envoi...",
      "bm_sent_to":                "Envoyé à {{count}} utilisateurs",
      "bm_chars":                  "caractères",

      // GlobalSearch
      "gs_quick_search":           "Recherche rapide...",
      "gs_placeholder":            "Rechercher par numéro, nom, identifiant...",
      "gs_start_typing":           "Tapez pour effectuer une recherche rapide...",
      "gs_no_results":             "Aucun résultat pour \"{{query}}\"",
      "gs_check_spelling":         "Vérifiez l'orthographe du nom ou de l'identifiant.",
      "gs_students":               "Élèves",
      "gs_teachers":               "Enseignants",
      "gs_parents":                "Parents",
      "gs_schools":                "Écoles",
      "gs_class_label":            "Classe",

      // StudentAnalyticsChart
      "sac_error_fetch":           "Erreur lors de la récupération des analyses de l'élève.",
      "sac_no_data":               "Aucune donnée trouvée",
      "sac_back":                  "Retour",
      "sac_class_label":           "Classe",
      "sac_continuous_eval":       "Évaluation intelligente continue",
      "sac_back_to_list":          "Retour à la liste",
      "sac_grades_analysis":       "Analyse des examens et devoirs",
      "sac_attendance_level":      "Présence et discipline",
      "sac_grade":                 "Note",
      "sac_attendance_points":     "Points de présence",
      "sac_not_enough":            "Pas encore assez de données pour tracer la courbe de performance de cet élève.",

      // SystemStatus
      "ssy_fetch_error":           "Échec de la récupération du statut système",
      "ssy_checking":              "Vérification du statut système...",
      "ssy_retry":                 "Réessayer",
      "ssy_health_label":          "Statut système",
      "ssy_stable":                "Stable",
      "ssy_problem":               "Problème détecté",
      "ssy_last_update":           "Dernière mise à jour",
      "ssy_db":                    "Base de données",
      "ssy_db_connected":          "Connectée",
      "ssy_db_disconnected":       "Déconnectée",
      "ssy_logins_24h":            "Connexions (24h)",
      "ssy_logins_success":        "{{count}} réussies",
      "ssy_failed_24h":            "Tentatives échouées (24h)",
      "ssy_logins_failed":         "{{count}} tentatives",
      "ssy_locked_24h":            "Comptes verrouillés (24h)",
      "ssy_locked_accounts":       "{{count}} comptes",
      "ssy_totals_title":          "Statistiques globales du système",
      "ssy_total_schools":         "Total des écoles actives",
      "ssy_total_students":        "Total des élèves",
      "ssy_total_teachers":        "Total des enseignants",
      "ssy_total_users":           "Total des utilisateurs",

      // EarlyWarningPanel — système d'alerte précoce [FEAT-2026-09]
      "nav_early_warning":         "Alerte précoce",
      "ew_title":                  "Système d'alerte précoce",
      "ew_subtitle":               "Les élèves à suivre dès maintenant — par ordre de priorité, avec les faits et les chiffres derrière chaque signal.",
      "ew_search":                 "Rechercher un élève ou une classe...",
      "ew_error":                  "Impossible de charger les alertes. Veuillez réessayer plus tard.",
      "ew_level_high":             "Priorité haute",
      "ew_level_medium":           "Priorité moyenne",
      "ew_level_low":              "À surveiller",
      "ew_count_high":             "{{n}} cas prioritaires",
      "ew_count_medium":           "{{n}} cas à priorité moyenne",
      "ew_empty_title":            "Aucun élève à signaler",
      "ew_empty_hint":             "Aucun signe d'absentéisme ni de baisse de résultats sur l'année scolaire en cours. Les cas apparaîtront ici automatiquement.",
      "ew_no_match":               "Aucun résultat pour cette recherche.",
      "ew_unnamed":                "Élève",
      "ew_reason_absence_rate":    "Taux d'absence de {{rate}} % ({{absent}} jours sur {{total}} enregistrés).",
      "ew_reason_absence_streak":  "{{days}} absences consécutives depuis le {{since}}.",
      "ew_reason_failing_average":"Moyenne annuelle de {{average}} % — sous la moyenne de passage de {{pass}} %.",
      "ew_reason_declining":       "Baisse de {{drop}} points : de {{before}} % au trimestre {{from}} à {{after}} % au trimestre {{to}}.",
      "ew_reason_unpaid_fees":     "Frais impayés d'un montant de {{amount}}.",

      // SmartRankings
      "smr_rankings_error":        "Erreur lors de la récupération du classement. Veuillez réessayer plus tard.",
      "smr_honor_roll":            "Tableau d'honneur",
      "smr_needs_improvement":     "À améliorer",
      "smr_good_level":            "Bon niveau",
      "smr_title":                 "Système intelligent d'évaluation et de classement des élèves",
      "smr_subtitle":              "Un classement qui combine la moyenne annuelle du carnet de notes et le taux de présence, avec les mêmes chiffres que le relevé de notes.",
      "smr_students_list":         "Liste des élèves",
      "smr_search_student_class":  "Rechercher un élève ou une classe...",
      "smr_rank":                  "Rang",
      "smr_student_name":          "Nom de l'élève",
      "smr_class":                 "Classe",
      "smr_category":              "Catégorie",
      "smr_smart_pct":             "Score intelligent",
      "smr_no_rankings":           "Aucun élève disponible pour le classement",
      // [PHASE-4 2026-10] Analytics: "How this is calculated"
      "an_how_title": "Comment ces chiffres sont-ils calculés ?",
      "an_how_grades": "Notes : la moyenne annuelle de l'élève issue du carnet de notes, le chiffre imprimé sur le relevé (notes pondérées, chacune rapportée à son barème, une note manquante n'est pas un zéro), en pourcentage de l'échelle /{{scale}}.",
      "an_how_attendance": "Taux de présence : (présent + retard) ÷ (présent + retard + absent). Les absences justifiées ne sont pas comptées ; sans jour compté, pas de taux.",
      "an_how_smart": "Score intelligent = {{gw}} % notes + {{aw}} % présence. Si l'un manque, l'autre compte seul. Arrondi à 2 décimales.",
      "an_how_labels": "Les catégories suivent le barème de mentions de l'école : tableau d'honneur dès {{top}} %, à améliorer sous la moyenne de passage de {{pass}} %.",
      "an_how_ranks": "Les scores égaux partagent le même rang (1, 2, 2, 4). Les élèves sans données sont listés en dernier, sans rang, avec « — ».",
      "an_no_data": "Pas de données",
      "smr_col_grades": "Moyenne annuelle",
      "smr_col_attendance": "Présence",
      "cav_how_class": "Le chiffre d'une classe est la moyenne des scores intelligents de ses élèves qui ont des données ; la classe est celle de l'élève cette année-là. Une classe sans données n'a pas de rang.",
      "cav_col_grades": "Moyenne des notes",
      "cav_col_attendance": "Taux de présence",
      "cav_scored": "{{n}} avec données",
      "ew_how_absence_rate": "Taux d'absence : absences ÷ jours comptés (présent, retard, absent) — à partir de {{rate}} %, +{{w}} points.",
      "ew_how_streak": "{{n}} absences ou plus depuis le dernier jour de présence : +{{w}} points.",
      "ew_how_failing": "Moyenne annuelle (carnet de notes) sous la moyenne de passage de {{pass}} % : +{{w}} points.",
      "ew_how_decline": "Dernier trimestre noté inférieur d'au moins {{points}} points de pourcentage au trimestre précédent : +{{w}} points.",
      "ew_how_fees": "Frais impayés (visibles par le personnel financier uniquement) : +{{w}} points.",
      "ew_how_levels": "Risque élevé à partir de {{high}} points, moyen à partir de {{medium}}.",
      "gr_how_subject": "La moyenne d'une matière sur un trimestre est la moyenne pondérée de ses notes, chacune rapportée à son barème, sur l'échelle /{{scale}}. Une note manquante n'est pas un zéro.",
      "gr_how_overall": "La moyenne générale est la moyenne des moyennes de matières arrondies ; l'année est la moyenne des trimestres. Arrondi à 2 décimales (au demi supérieur).",
      "gr_how_ranks": "Les moyennes égales partagent le même rang (1, 2, 2, 4) ; les élèves sans notes n'ont pas de rang et figurent en dernier.",

      // Generic joiner
      "term_and":                  "et",

      "month_jan": "Janvier",
      "month_feb": "Février",
      "month_mar": "Mars",
      "month_apr": "Avril",
      "month_may": "Mai",
      "month_jun": "Juin",
      "month_jul": "Juillet",
      "month_aug": "Août",
      "month_sep": "Septembre",
      "month_oct": "Octobre",
      "month_nov": "Novembre",
      "month_dec": "Décembre"
    ,
      // [TASK-2 2026-06] Domain-specific translation keys.
      // === Fee types ===
      "fee_type_tuition": "Frais de scolarité",
      "fee_type_registration": "Frais d'inscription",
      "fee_type_transport": "Frais de transport",
      "fee_type_meals": "Frais de restauration",
      "fee_type_uniform": "Frais de tenue scolaire",
      "fee_type_books": "Frais de manuels",
      "fee_type_activities": "Frais d'activités",
      "fee_type_exam": "Frais d'examens",
      "fee_type_other": "Autres frais",
      // === Salary types ===
      "salary_type_monthly": "Salaire mensuel",
      "salary_type_bonus": "Prime/Bonus",
      "salary_type_overtime": "Heures supplémentaires",
      "salary_type_advance": "Avance sur salaire",
      "salary_type_allowance": "Indemnité",
      "salary_type_deduction": "Déduction",
      "salary_type_annual": "Prime annuelle",
      // === Payment methods ===
      "payment_cash": "Espèces",
      "payment_bank_transfer": "Virement bancaire",
      "payment_mobile_money": "Mobile money",
      "payment_check": "Chèque",
      "payment_card": "Carte bancaire",
      "payment_online": "Paiement en ligne",
      // === Expense types ===
      "expense_type_maintenance": "Maintenance",
      "expense_type_electricity": "Électricité",
      "expense_type_water": "Eau",
      "expense_type_internet": "Internet",
      "expense_type_supplies": "Fournitures de bureau",
      "expense_type_furniture": "Mobilier",
      "expense_type_cleaning": "Nettoyage",
      "expense_type_security": "Sécurité",
      "expense_type_printing": "Impression et reprographie",
      "expense_type_events": "Événements et occasions",
      "expense_type_other": "Autres dépenses",
      // === Subjects (extra) ===
      "subject_physics": "Physique",
      "subject_chemistry": "Chimie",
      "subject_biology": "Biologie",
      "subject_music": "Éducation musicale",
      "subject_philosophy": "Philosophie",
      "subject_economics": "Économie",
      "subject_accounting": "Comptabilité",
      "subject_civic": "Éducation civique",
      // === Academic specializations ===
      "spec_science": "Sciences",
      "spec_literature": "Lettres",
      "spec_math": "Mathématiques",
      "spec_technical": "Technique",
      "spec_economics": "Économie et gestion",
      "spec_islamic": "Sciences islamiques",
      "spec_languages": "Langues étrangères",
      // === Education levels ===
      "edu_primary": "Primaire",
      "edu_middle": "Collège",
      "edu_high": "Lycée",
      "edu_university": "Universitaire",
      "edu_kindergarten": "Maternelle",
      // === Assessment types ===
      "assess_type_exam": "Examen",
      "assess_type_quiz": "Interrogation",
      "assess_type_homework": "Devoir",
      "assess_type_project": "Projet",
      "assess_type_oral": "Oral",
      "assess_type_practical": "Pratique",
      "assess_type_participation": "Participation",
      "assess_type_midterm": "Mi-trimestre",
      "assess_type_final": "Fin de trimestre",
      // === Terms / semesters ===
      "term_first": "Premier trimestre",
      "term_second": "Deuxième trimestre",
      "term_third": "Troisième trimestre",
      "term_annual": "Annuel",
      // === Gender ===
      "gender_male": "Masculin",
      "gender_female": "Féminin",
      // === Blood types ===
      "blood_a_pos": "A+",
      "blood_a_neg": "A-",
      "blood_b_pos": "B+",
      "blood_b_neg": "B-",
      "blood_ab_pos": "AB+",
      "blood_ab_neg": "AB-",
      "blood_o_pos": "O+",
      "blood_o_neg": "O-",
      // === Notification types ===
      "notif_type_grade": "Nouvelle note",
      "notif_type_absence": "Absence",
      "notif_type_payment": "Paiement",
      "notif_type_announcement": "Annonce",
      "notif_type_homework": "Nouveau devoir",
      "notif_type_task": "Nouvelle tâche",
      "notif_type_system": "Notification système",
      // === Common UI buttons / labels / messages ===
      "btn_view_all": "Voir tout",
      "btn_load_more": "Charger plus",
      "btn_go_back": "Retour",
      "btn_next": "Suivant",
      "btn_previous": "Précédent",
      "btn_finish": "Terminer",
      "btn_skip": "Ignorer",
      "btn_retry": "Réessayer",
      "msg_connection_error": "Erreur de connexion",
      "msg_try_again": "Veuillez réessayer",
      "msg_changes_saved": "Modifications enregistrées",
      "msg_are_you_sure": "Êtes-vous sûr ?",
      "msg_cannot_undo": "Cette action est irréversible",
      "lbl_optional": "Optionnel",
      "lbl_required": "Obligatoire",
      "lbl_all": "Tout",
      "lbl_none": "Aucun",
      "lbl_other": "Autre",
      "lbl_unknown": "Inconnu",
      "lbl_not_available": "Non disponible",
      "lbl_yes": "Oui",
      "lbl_no": "Non",
      // Shared labels, alt texts and shadcn/ui screen-reader text [I18N 2026-10]
      "lbl_na": "N/D",
      "list_separator": ", ",
      "alt_profile_photo": "Photo de profil",
      "alt_student_qr": "Code QR de l'élève",
      "alt_school_logo": "Logo de l'école",
      "idc_no_id": "— aucun identifiant —",
      "ui_breadcrumb": "Fil d'Ariane",
      "ui_more": "Plus",
      "ui_previous_slide": "Diapositive précédente",
      "ui_next_slide": "Diapositive suivante",
      "ui_pagination": "Pagination",
      "ui_previous_page": "Aller à la page précédente",
      "ui_next_page": "Aller à la page suivante",
      "ui_previous": "Précédent",
      "ui_next": "Suivant",
      "ui_more_pages": "Plus de pages",
    
      // [WIRE-2026-06] Backend-catalog mappings for finance dropdowns.
      // === Fee types — backend catalog (constants.FEE_TYPES) ===
      "fee_type_tuition_term1": "Frais de scolarité - 1er trimestre",
      "fee_type_tuition_term2": "Frais de scolarité - 2e trimestre",
      "fee_type_tuition_term3": "Frais de scolarité - 3e trimestre",
      "fee_type_labs": "Frais de laboratoire",
      "fee_type_exam_retake": "Frais d'examen de rattrapage",
      "fee_type_certificates": "Frais de certificats",
      "fee_type_late_fee": "Frais de retard",
      // === Salary types — backend catalog (constants.SALARY_TYPES) ===
      "salary_type_teacher": "Salaire enseignant",
      "salary_type_admin": "Salaire d'administratif",
      "salary_type_cleaner": "Salaire d'agent d'entretien",
      "salary_type_guard": "Salaire de gardien",
      "salary_type_driver": "Salaire de chauffeur",
      "salary_type_supervisor": "Salaire de superviseur",
      "salary_type_librarian": "Salaire de bibliothécaire",
      "salary_type_counselor": "Salaire de conseiller",
      "salary_type_accountant": "Salaire de comptable",
      "salary_type_secretary": "Salaire de secrétaire",
      // === Expense types — backend catalog (constants.EXPENSE_TYPES) ===
      "expense_type_salaries": "Salaires",
      "expense_type_maintenance_building": "Maintenance des bâtiments",
      "expense_type_maintenance_equipment": "Maintenance d'équipements",
      "expense_type_communications": "Internet et communications",
      "expense_type_school_equipment": "Équipement scolaire",
      "expense_type_teaching_materials": "Matériel pédagogique",
      "expense_type_books": "Livres et références",
      "expense_type_fuel_transport": "Carburant et transport",
      "expense_type_health_insurance": "Assurance santé",
      "expense_type_training": "Formation et conférences",
      "expense_type_advertising": "Publicité et marketing",
      // === Payment methods — backend catalog (constants.PAYMENT_METHODS) ===
      "payment_installment": "Paiement échelonné",
      "payment_salary_deduction": "Retenue sur salaire",
      // === [PHASE-5 2026-10] Student PIN login (WP-B) ===
      "pin_card_doc_title": "Cartes de connexion des élèves",
      "pin_card_title": "Carte de connexion",
      "pin_card_school_code": "Code de l'école",
      "pin_card_student_number": "N° d'élève",
      "pin_card_pin": "Code PIN",
      "pin_card_keep_secret": "Garde cette carte, ne montre ton code à personne",
      "pin_login_mode_password": "Identifiant et mot de passe",
      "pin_login_mode_pin": "N° d'élève et code PIN",
      "pin_login_help": "Élèves du primaire et du collège : utilise la carte remise par ton école.",
      "pin_login_school_code": "Code de l'école",
      "pin_login_school_code_hint": "Il figure sur ta carte et reste enregistré sur cet appareil.",
      "pin_login_change_school": "Changer d'école",
      "pin_login_student_number": "Numéro d'élève",
      "pin_login_pin": "Code PIN (4 chiffres)",
      "pin_login_show_pin": "Afficher le code",
      "pin_login_hide_pin": "Masquer le code",
      "pin_login_submit": "Se connecter",
      "pin_login_err_school_code": "Saisis le code de l'école (chiffres uniquement).",
      "pin_login_err_student_number": "Saisis ton numéro d'élève (chiffres uniquement).",
      "pin_login_err_pin": "Le code PIN comporte 4 chiffres.",
      "pin_login_invalid": "Identifiants incorrects. Vérifie le code de l'école, ton numéro d'élève et ton code PIN.",
      "pin_login_locked": "Trop de tentatives incorrectes. Réessaie dans {{minutes}} min ou demande à l'administration de l'école de débloquer le compte.",
      "pin_login_too_many": "Trop de tentatives. Patiente un peu puis réessaie.",
      "nav_student_pins": "Codes PIN des élèves",
      "pin_mgr_title": "Codes PIN des élèves",
      "pin_mgr_subtitle": "Les élèves du primaire et du collège se connectent avec le code de l'école, leur numéro et un code PIN à 4 chiffres. Le code n'est affiché qu'une fois, à sa création : imprimez les cartes tout de suite.",
      "pin_mgr_school_code": "Code de l'école : {{code}}",
      "pin_mgr_class": "Classe",
      "pin_mgr_all_classes": "Toutes les classes",
      "pin_mgr_generate": "Créer les codes manquants",
      "pin_mgr_regenerate_all": "Renouveler tous les codes de la classe",
      "pin_mgr_regenerate_confirm": "Tous les codes de cette classe seront remplacés et les sessions des élèves concernés fermées. Continuer ?",
      "pin_mgr_pick_class": "Choisissez d'abord une classe.",
      "pin_mgr_col_student": "Élève",
      "pin_mgr_col_number": "Numéro",
      "pin_mgr_col_class": "Classe",
      "pin_mgr_col_status": "État",
      "pin_mgr_col_actions": "Actions",
      "pin_mgr_status_set": "Code créé",
      "pin_mgr_status_none": "Aucun code",
      "pin_mgr_status_locked": "Bloqué jusqu'à {{time}}",
      "pin_mgr_status_not_enabled": "Mot de passe (niveau sans code PIN)",
      "pin_mgr_reset": "Nouveau code",
      "pin_mgr_reset_confirm": "Créer un nouveau code pour {{name}} ? L'ancien ne fonctionnera plus et ses sessions seront fermées.",
      "pin_mgr_unlock": "Débloquer",
      "pin_mgr_unlocked": "Compte débloqué.",
      "pin_mgr_generated": "{{count}} code(s) créé(s).",
      "pin_mgr_nothing_generated": "Aucun code créé : chaque élève en a déjà un ou son niveau n'utilise pas de code PIN.",
      "pin_mgr_skipped": "{{count}} élève(s) ignoré(s).",
      "pin_mgr_reason_has_pin": "a déjà un code",
      "pin_mgr_reason_grade_not_enabled": "niveau sans code PIN",
      "pin_mgr_reason_no_account": "sans compte actif",
      "pin_mgr_reason_inactive": "inactif",
      "pin_mgr_new_pins_title": "Nouveaux codes — affichés une seule fois",
      "pin_mgr_new_pins_hint": "Imprimez les cartes maintenant. Une fois la page quittée, ces codes ne peuvent plus être affichés : il faudra en créer de nouveaux.",
      "pin_mgr_print": "Imprimer les cartes",
      "pin_mgr_dismiss": "Masquer les codes",
      "pin_mgr_popup_blocked": "Le navigateur a bloqué la fenêtre d'impression. Autorisez les fenêtres pop-up puis réessayez.",
      "pin_mgr_empty": "Aucun élève.",
      "pin_mgr_more": "Afficher plus",
      "pin_mgr_count": "{{shown}} sur {{total}}",
      "pin_settings_title": "Connexion par numéro d'élève et code PIN",
      "pin_settings_hint": "Choisissez les niveaux dont les élèves se connectent avec un code PIN (en général primaire et collège). Les autres élèves gardent identifiant et mot de passe. Ce réglage s'enregistre seul, avec le bouton ci-dessous.",
      "pin_settings_default_note": "Réglage par défaut : primaire et collège.",
      "pin_settings_none_note": "Aucun niveau choisi : la connexion par code PIN est désactivée.",
      "pin_settings_add_placeholder": "Autre niveau, tel qu'écrit dans les noms de classes",
      "pin_settings_add": "Ajouter",
      "pin_settings_save": "Enregistrer les niveaux PIN",
      "pin_settings_saved": "Niveaux PIN enregistrés.",
      "pin_settings_use_default": "Revenir au réglage par défaut",
      // ─── [PHASE-2 2026-10] Grade grid, grading settings, transcripts, verification ───
      "gb_add": "Ajouter",
      "gb_add_column": "Ajouter une évaluation",
      "gb_change_count": "{{n}} modification(s) non enregistrée(s)",
      "gb_column_name": "Nom de l'évaluation",
      "gb_discard": "Annuler les modifications",
      "gb_discard_confirm": "Des notes ne sont pas enregistrées. Les abandonner ?",
      "gb_err_above_max": "Note supérieure au barème",
      "gb_err_bad_max": "Barème invalide",
      "gb_err_bad_weight": "Coefficient invalide",
      "gb_err_decimals": "Deux décimales au maximum",
      "gb_err_duplicate_column": "Une évaluation de même nom et type existe déjà",
      "gb_err_name_required": "Saisissez le nom de l'évaluation",
      "gb_err_not_a_number": "Note invalide",
      "gb_err_not_in_class": "L'élève n'est pas dans cette classe",
      "gb_error_count": "{{n}} case(s) en erreur",
      "gb_fix_errors_first": "Corrigez les cases en rouge avant d'enregistrer",
      "gb_keyboard_hint": "Entrée descend dans la colonne, Tab passe à l'évaluation suivante, Ctrl+S enregistre. Vous pouvez coller une colonne ou un tableau depuis Excel. Une case vide signifie « pas de note », pas zéro.",
      "gb_load_failed": "Impossible de charger les notes",
      "gb_locked_archived": "Année archivée : notes en lecture seule.",
      "gb_locked_results": "Les résultats sont verrouillés par l'administration : notes non modifiables.",
      "gb_max_score": "Barème",
      "gb_mixed_max": "Cette colonne mélange plusieurs barèmes",
      "gb_no_students": "Aucun élève dans cette classe pour cette année.",
      "gb_out_of": "sur",
      "gb_paste_clipped": "Le collage dépasse le tableau : {{n}} case(s) ignorée(s)",
      "gb_pick_class_subject": "Choisissez la classe et la matière.",
      "gb_save_failed": "Les notes n'ont pas été enregistrées",
      "gb_saved": "Notes enregistrées ({{n}})",
      "gb_saving": "Enregistrement...",
      "gb_student_left": "Parti",
      "gb_term_average": "Moyenne du trimestre",
      "gb_unsaved": "Modifications non enregistrées",
      "gb_weight": "Coefficient",
      "gr_term": "Période",
      "gs_band_add": "Ajouter une mention",
      "gs_band_bad_min": "Le seuil doit être entre 0 et 100",
      "gs_band_duplicate": "Seuil en double",
      "gs_band_label_required": "Saisissez la mention en arabe",
      "gs_band_min": "Seuil en pourcentage",
      "gs_band_need_zero": "Une mention doit commencer à 0 %",
      "gs_band_remove": "Supprimer la mention",
      "gs_bands": "Mentions",
      "gs_bands_hint": "Chaque mention commence à un pourcentage, appliqué à la moyenne arrondie ; l'équivalent sur /{{scale}} est affiché à côté.",
      "gs_certificate_grades": "Classes donnant lieu à une attestation",
      "gs_certificate_hint": "En général la fin de chaque cycle. L'attestation n'est proposée que pour ces classes.",
      "gs_from": "À partir de",
      "gs_intro": "S'applique à la grille de notes, au classement, aux relevés et aux attestations.",
      "gs_rules_title": "Comment les moyennes sont calculées",
      "gs_rules_1": "Une case vide n'est pas un zéro : elle n'entre pas dans le calcul. Une matière sans note ne compte pas, et une moyenne sans données s'affiche « — ».",
      "gs_rules_2": "Chaque note compte comme une fraction de son maximum (15/20 vaut 7,5/10), avec son poids, puis est ramenée au barème de l'école.",
      "gs_rules_3": "La moyenne générale d'un trimestre est la moyenne des moyennes de matières arrondies : chacun peut la recalculer à partir des lignes imprimées.",
      "gs_rules_4": "La moyenne annuelle d'une matière est la moyenne de ses moyennes trimestrielles existantes ; la moyenne générale annuelle se calcule à partir des moyennes annuelles des matières.",
      "gs_rules_5": "Arrondi à 2 décimales, la moitié vers le haut (12,345 donne 12,35) ; la mention se lit sur la valeur arrondie.",
      "gs_rules_6": "Les élèves à égalité ont le même rang (1, 2, 2, 4) ; un élève sans moyenne n'est pas classé.",
      "gs_label_ar": "En arabe",
      "gs_label_en": "En anglais",
      "gs_label_fr": "En français",
      "gs_principal": "Nom du directeur",
      "gs_principal_hint": "Imprimé sous la signature des relevés et attestations.",
      "gs_save": "Enregistrer les paramètres de notation",
      "gs_save_failed": "Paramètres de notation non enregistrés",
      "gs_saved": "Paramètres de notation enregistrés",
      "gs_scale": "Barème des moyennes",
      "gs_terms": "Nombre de périodes par an",
      "gs_terms_2": "2 semestres",
      "gs_terms_3": "3 trimestres",
      "gs_title": "Notes et documents",
      "ss_section_grades": "Notes et documents",
      "tr_archived_year": "L'année {{year}} est archivée : ses relevés peuvent être émis et imprimés, ses notes ne sont plus modifiables.",
      "tr_certificate_class": "Classe d'examen",
      "tr_doc_certificate": "Attestation",
      "tr_doc_transcript": "Relevé de notes",
      "tr_doc_type": "Type de document",
      "tr_failed": "Impossible de préparer le document",
      "tr_intro": "Chaque document émis porte un code de vérification. Réimprimer un document inchangé garde son code ; si les notes ont changé, un nouveau code est émis et l'ancien devient « remplacé ».",
      "tr_issue_print": "Émettre et imprimer ({{n}})",
      "tr_issued": "Nouveaux : {{created}} · inchangés : {{reused}} · remplacés : {{superseded}}",
      "tr_load_failed": "Impossible de charger les classes",
      "tr_no_classes": "Aucune classe avec des élèves pour cette année.",
      "tr_popup_blocked": "Le navigateur a bloqué la fenêtre d'impression ; autorisez les fenêtres pour ce site.",
      "tr_preview": "Aperçu",
      "tr_select_all": "Tous ({{n}} sur {{total}})",
      "tr_term_year": "Année complète",
      "tr_title": "Relevés et attestations",
      "tr_print_appreciation": "Mention",
      "tr_print_average": "Moyenne",
      "tr_print_birth": "Date de naissance",
      "tr_print_cert_text": "La direction de {{school}} atteste que l'élève {{name}}, né(e) le {{birth}}, a achevé la classe de {{className}} au cours de l'année scolaire {{year}} avec une moyenne générale de {{average}} sur {{scale}}, mention :",
      "tr_print_certificate": "Attestation",
      "tr_print_class": "Classe",
      "tr_print_draft": "Aperçu — document non émis, sans code de vérification",
      "tr_print_issued_on": "Délivré le",
      "tr_print_number": "Matricule",
      "tr_print_overall": "Moyenne générale",
      "tr_print_partial": "Remarque : certaines matières ou périodes n'ont pas de notes ; la moyenne porte sur les notes disponibles.",
      "tr_print_principal": "Le directeur",
      "tr_print_stamp": "Signature et cachet",
      "tr_print_student": "Élève",
      "tr_print_subject": "Matière",
      "tr_print_transcript": "Relevé de notes",
      "tr_print_verify": "Pour vérifier ce document, scannez le code ou ouvrez le lien :",
      "tr_print_year": "Année scolaire",
      "vd_check": "Vérifier",
      "vd_code_label": "Code de vérification",
      "vd_code_placeholder": "Code imprimé sur le document",
      "vd_compare_hint": "Comparez ces informations avec le document en main. Les notes ne sont pas affichées ici.",
      "vd_failed": "Vérification impossible pour le moment. Réessayez dans une minute.",
      "vd_genuine": "Document authentique",
      "vd_not_found": "Code inconnu",
      "vd_not_found_hint": "Aucun document n'a été émis avec ce code. Vérifiez qu'il est saisi tel qu'imprimé.",
      "vd_school": "École",
      "vd_student": "Élève",
      "vd_subtitle": "Vérifiez un relevé de notes ou une attestation émis par une école utilisant EduGate.",
      "vd_superseded": "Document remplacé",
      "vd_superseded_hint": "L'école a émis une version plus récente de ce document ; celle-ci n'est plus valable. Demandez la version actuelle à l'école.",
      "vd_title": "Vérification d'un document",
      "vd_year": "Année scolaire",
      "tt_print_class_kicker": "Emploi du temps de la classe",
      "tt_print_teacher_kicker": "Emploi du temps de l'enseignant(e)",
      "tt_print_class_title": "Emploi du temps {{cls}}",
      "tt_print_teacher_title": "Emploi du temps de {{name}}",
      "tt_print_school_title": "Emplois du temps de l'école",
      "tt_print_year": "Année scolaire {{year}}",
      "tt_lesson_col": "Cours",
      "tt_lesson_n": "Cours {{n}}",
      "tt_break_default": "Pause",
      "tt_room": "Salle {{room}}",
      "tt_weekly_total": "{{count}} cours par semaine",
      "tt_teacher_load": "Charge : {{count}} cours par semaine",
      "tt_other_times": "Cours hors de l'horaire :",
      "tt_printed_on": "Imprimé le {{date}}",
      "tt_print_class": "Imprimer la classe",
      "tt_print_school": "Imprimer toute l'école",
      "tt_print_teacher": "Imprimer un enseignant",
      "tt_pick_teacher": "Choisir l'enseignant(e)",
      "tt_print_mine": "Imprimer mon emploi du temps",
      "tt_popup_blocked": "Le navigateur a bloqué la fenêtre d'impression. Autorisez les fenêtres pour ce site, puis réessayez.",
      "tt_nothing_to_print": "Aucun emploi du temps à imprimer pour l'instant.",
      "ss_break_title": "Pauses",
      "ss_break_hint": "Récréation, déjeuner… Une pause n'a pas de numéro : l'ajouter ou la déplacer ne change ni le numéro des cours ni les emplois du temps enregistrés.",
      "ss_break_name": "Nom",
      "ss_break_name_placeholder": "Récréation",
      "ss_break_start": "Début de la pause",
      "ss_break_end": "Fin de la pause",
      "ss_break_remove": "Supprimer la pause",
      "ss_break_add": "Ajouter une pause",
      "ss_break_none": "Aucune pause.",
      "ss_break_max": "{{max}} pauses au maximum.",
      "ss_break_err_invalid": "Heures invalides : la fin doit suivre le début.",
      "ss_break_err_lesson": "Chevauche le cours {{n}}.",
      "ss_break_err_break": "Chevauche une autre pause.",
      "ss_break_preview": "La journée",
      "ss_bell_err_BELL_INVALID": "Chaque cours doit avoir une heure de début et de fin valides, la fin après le début.",
      "ss_bell_err_BELL_OVERLAP": "Deux cours se chevauchent.",
      "ss_bell_err_BELL_ORDER_MISMATCH": "Chaque cours doit commencer après le précédent. Modifiez les heures plutôt que l'ordre des cours.",
      "ss_bell_only_last_removable": "Seul le dernier cours peut être supprimé : en supprimer un au milieu renumérote les suivants. Modifiez plutôt ses heures.",
      "ss_bell_blocked": "Corrigez l'horaire des cours ou des pauses avant d'enregistrer.",
      "sb_conflict_unknown_period": "Ce cours n'existe pas dans l'horaire de l'école.",
      "sb_conflict_unknown_teacher": "Cet enseignant n'appartient pas à l'école.",
      "sb_conflict_duplicate_cell": "La classe a deux cours sur ce créneau.",
      "sb_conflict_teacher_busy": "L'enseignant est déjà en {{cls}} sur ce créneau.",
      "sb_conflict_room_busy": "La salle est déjà occupée par {{cls}}.",
      "sb_conflict_on_break": "Ce créneau est une pause, pas un cours.",
      "sb_conflict_bad_time": "L'heure du cours est invalide.",
      "sb_break_row": "Pause : aucun cours possible",
      "rm_cat_school_events": "Participation aux événements et programmes de l'école (bénévole)",
      "rm_cat_school_events_hint": "Critère bénévole : compté seulement s'il est noté ; son absence ne baisse pas la moyenne.",
      "rm_cat_legacy": "(ancienne catégorie)",
      "rm_voluntary": "Bénévole",
      "rm_subtitle_scale": "Suivi des performances et amélioration continue (de 1 à {{scale}})",
      "rm_rating_label_scale": "Note (1-{{scale}})",
      "rm_pick_required": "Choisissez d'abord la personne et la catégorie",
      "rm_overall_avg_sub": "Évaluations de la direction cette année",
      "rm_history_error": "Impossible de charger l'historique des évaluations",
      "rm_role_school_admin": "Directeur de l'école",
      "rm_role_admin_staff": "Personnel administratif",
      "rm_role_teacher": "Enseignant",
      "pf_rt_by_category": "Évaluation par catégorie",
      "pf_rt_count": "Évaluations : {{count}}",
      "pf_rt_latest": "Dernière : {{value}} · {{date}}",
      "pf_rt_none": "Aucune évaluation cette année",
      "rpt_te_title": "Évaluations des enseignants",
      "rpt_te_subtitle": "Évaluations de la direction pour l'année {{year}}, sur {{scale}}",
      "rpt_te_teacher": "Enseignant",
      "rpt_te_overall": "Ensemble",
      "rpt_te_other": "Anciennes catégories",
      "rpt_te_unnamed": "Enseignant introuvable",
      "rpt_te_empty": "Aucun enseignant à afficher",
      "rpt_te_count": "Évaluations : {{count}}",
      "rpt_te_load_error": "Impossible de charger les évaluations des enseignants",
      "rpt_te_method_scale": "Chaque note est lue sur sa propre échelle et exprimée sur {{scale}} (les anciennes notes sans échelle sont lues sur {{legacy}}).",
      "rpt_te_method_raters": "Seules les évaluations de la direction comptent ; la note d'un enseignant sur un collègue n'en est pas une.",
      "rpt_te_method_overall": "Ensemble = moyenne des moyennes (arrondies) des catégories que l'enseignant possède. Une catégorie sans note affiche « — » et ne compte pas pour zéro.",
      "rpt_te_method_voluntary": "La participation aux événements de l'école est bénévole : comptée seulement si elle est notée, son absence ne baisse pas l'ensemble.",
      "rpt_te_method_rounding": "Arrondi à 2 décimales, la moitié vers le haut.",
    }
  },
  en: {
    translation: {
      // ── Class fees in one request (bulk payments) ──
      "audit_action_fees_class_created": "Fees created for a class",
      "cf_open_btn": "Create class fees",
      "cf_title": "Create fees for a whole class",
      "cf_subtitle": "One fee is created for every student of the class in the current year, and it shows up right away in the bulk payment list. A student who already has this fee for this month is not billed twice.",
      "cf_pick_class": "Pick the class",
      "cf_amount": "Amount per student",
      "cf_due_date": "Due date (optional)",
      "cf_review_btn": "Preview",
      "cf_create_btn": "Create fees ({{count}} students)",
      "cf_will_create": "Fees to create",
      "cf_skipped": "Not duplicated for {{count}} student(s) who already have this fee this month:",
      "cf_nothing_to_create": "Every student of the class already has this fee for this month.",
      "cf_created": "{{count}} fees created. You can now record the bulk payment.",
      "cf_error": "Could not create the class fees.",
      "cf_empty_hint": "Only unpaid fees appear here. If this class's fees have not been created yet, create them for the whole class in one click.",
      "cf_err_class": "Pick the class.",
      "cf_err_fee_type": "Pick the fee type.",
      "cf_err_amount": "Enter a valid amount above zero.",
      "cf_err_month": "Pick the month.",
      // ── Activity log: one readable label per audit action ──
      "audit_action_academic_year_rollover": "Academic year rollover",
      "audit_action_academic_year_rollover_failed": "Academic year rollover failed",
      "audit_action_activate_academic_year": "Academic year activated",
      "audit_action_announcement_created": "Announcement published",
      "audit_action_announcement_deleted": "Announcement deleted",
      "audit_action_broadcast_sent": "Broadcast sent",
      "audit_action_bulk_attendance": "Bulk attendance recorded",
      "audit_action_bulk_payment": "Bulk fee payment",
      "audit_action_create_academic_year": "Academic year created",
      "audit_action_create_admin_staff": "Admin staff added",
      "audit_action_create_assignment": "Assignment added",
      "audit_action_create_attendance": "Attendance recorded",
      "audit_action_create_fee": "Fee added",
      "audit_action_create_grade": "Grade added",
      "audit_action_create_payment": "Payment recorded",
      "audit_action_deactivate_admin_staff": "Admin staff deactivated",
      "audit_action_delete_admin_staff_permanent": "Admin staff deleted",
      "audit_action_delete_assignment": "Assignment deleted",
      "audit_action_delete_grade": "Grade deleted",
      "audit_action_expense_added": "Expense added",
      "audit_action_expense_deleted": "Expense deleted",
      "audit_action_expense_updated": "Expense updated",
      "audit_action_fee_deleted": "Fee deleted",
      "audit_action_fee_paid": "Fee paid",
      "audit_action_grades_bulk_saved": "Class grades saved",
      "audit_action_homework_graded": "Homework graded",
      "audit_action_homework_submitted": "Homework submitted",
      "audit_action_invoice_created": "Invoice created",
      "audit_action_login_blocked_subscription": "Login refused: subscription expired",
      "audit_action_login_failure": "Failed login",
      "audit_action_login_locked": "Login locked after failures",
      "audit_action_login_success": "Signed in",
      "audit_action_logout": "Signed out",
      "audit_action_manual_rollover_rollback": "Rollover rolled back",
      "audit_action_message_sent": "Message sent",
      "audit_action_parent_created": "Parent added",
      "audit_action_parent_deleted": "Parent deleted",
      "audit_action_parent_updated": "Parent updated",
      "audit_action_password_changed": "Password changed",
      "audit_action_payroll_run": "Monthly payroll paid",
      "audit_action_payslip_generated": "Payslip issued",
      "audit_action_payslips_generated": "Payslips issued",
      "audit_action_pin_generated": "Student PIN created",
      "audit_action_pin_login_failure": "Failed PIN login",
      "audit_action_pin_login_locked": "PIN login locked",
      "audit_action_pin_login_success": "Student PIN login",
      "audit_action_pin_reset": "Student PIN reset",
      "audit_action_pin_settings_updated": "PIN settings updated",
      "audit_action_pin_unlocked": "Student PIN unlocked",
      "audit_action_platform_settings_updated": "Platform settings updated",
      "audit_action_profile_updated": "Profile updated",
      "audit_action_read_student_medical": "Student medical record viewed",
      "audit_action_receipt_generated": "Receipt issued",
      "audit_action_receipts_generated": "Receipts issued",
      "audit_action_register_school": "School registered",
      "audit_action_reset_password": "Password reset",
      "audit_action_salary_deleted": "Salary deleted",
      "audit_action_salary_recorded": "Salary recorded",
      "audit_action_salary_updated": "Salary updated",
      "audit_action_schedule_bulk_saved": "Class timetable saved",
      "audit_action_school_settings_updated": "School settings updated",
      "audit_action_school_subject_removed": "Subject removed",
      "audit_action_school_subject_added": "Subject added",
      "audit_action_class_created": "Class created",
      "audit_action_class_updated": "Class updated",
      "audit_action_class_deleted": "Class deleted",
      "audit_action_class_renamed": "Class renamed",
      "audit_action_support_ticket_created": "Support ticket opened",
      "audit_action_support_ticket_replied": "Support ticket answered",
      "audit_action_support_ticket_followed_up": "Support ticket followed up",
      "audit_action_support_ticket_status_changed": "Support ticket status changed",
      "sa_tab_support": "Support",
      "sup_button": "Support",
      "sup_title": "Technical support and emergencies",
      "sup_intro": "Describe the problem and the platform's administration is alerted at once. Your account and school details are attached automatically.",
      "sup_tab_new": "New message",
      "sup_tab_mine": "My tickets",
      "sup_category": "Kind of problem",
      "sup_cat_technical": "Technical fault",
      "sup_cat_emergency": "Emergency",
      "sup_cat_account": "Account problem",
      "sup_cat_other": "Other",
      "sup_urgency": "Priority",
      "sup_urgency_normal": "Normal",
      "sup_urgency_urgent": "Urgent",
      "sup_subject": "Subject",
      "sup_subject_ph": "e.g. grades are not saved",
      "sup_message": "Description",
      "sup_message_ph": "What were you doing? What did you see?",
      "sup_attached": "Attached automatically: your name, account, role, school, phone, e-mail and the screen you were on",
      "sup_send": "Send",
      "sup_sending": "Sending…",
      "sup_sent": "Ticket {{number}} sent. The answer will appear here and in your notifications.",
      "sup_send_error": "Could not send the message",
      "sup_too_short": "Write a subject (at least 3 characters) and a description (at least 10).",
      "sup_none": "No tickets yet.",
      "sup_load_error": "Could not load the tickets",
      "sup_status_open": "Open",
      "sup_status_in_progress": "In progress",
      "sup_status_resolved": "Resolved",
      "sup_support_team": "Support",
      "sup_follow_up_ph": "Add a detail or a reply…",
      "sup_follow_up_send": "Send",
      "sup_locked_note": "Replies appear here. To add something now, open a new ticket.",
      "sup_filter_all": "All",
      "sup_urgent_only": "Urgent only",
      "sup_search_ph": "Ticket number, school, name…",
      "sup_counts": "Open: {{open}} · In progress: {{in_progress}} · Urgent waiting: {{urgent}}",
      "sup_select_ticket": "Choose a ticket to see its details.",
      "sup_sender": "Sender",
      "sup_name": "Name",
      "sup_username": "Username",
      "sup_role": "Role",
      "sup_phone": "Phone",
      "sup_email": "E-mail",
      "sup_teacher_number": "Teacher number",
      "sup_permissions": "Permissions",
      "sup_school": "School",
      "sup_school_number": "School number",
      "sup_plan": "Plan",
      "sup_status_at_send": "Subscription when sent",
      "sup_status_now": "Subscription now",
      "sup_sub_active": "Active",
      "sup_sub_trial": "Trial",
      "sup_sub_expired": "Expired",
      "sup_sub_suspended": "Suspended",
      "sup_sub_none": "Unknown",
      "sup_account_now": "The account now",
      "sup_account_state": "State",
      "sup_active": "Active",
      "sup_inactive": "Deactivated",
      "sup_account_missing": "Account deleted",
      "sup_last_login": "Last sign-in",
      "sup_context": "Context",
      "sup_page": "Screen",
      "sup_device": "Device",
      "sup_alerts": "Alerts",
      "sup_alerts_off": "E-mail and Telegram not configured",
      "sup_alert_email": "E-mail",
      "sup_alert_telegram": "Telegram",
      "sup_alert_sent": "sent",
      "sup_alert_failed": "failed",
      "sup_alert_off": "not configured",
      "sup_reply_ph": "Your reply to the sender…",
      "sup_reply_send": "Send reply",
      "sup_mark": "Change status",
      "sup_call": "Call",
      "sup_whatsapp": "WhatsApp",
      "audit_action_class_subject_assigned": "Subject assigned in a class",
      "audit_action_class_subject_removed": "Subject removed from a class",
      "audit_action_student_created": "Student added",
      "audit_action_student_deleted": "Student deleted",
      "audit_action_student_linked": "Student linked to a parent",
      "audit_action_student_updated": "Student updated",
      "audit_action_students_bulk_imported": "Students imported",
      "audit_action_subscription_renewed": "Subscription renewed",
      "audit_action_subscription_suspended": "Subscription suspended",
      "audit_action_subscription_updated": "Subscription updated",
      "audit_action_superadmin_profile_update": "Super admin account updated",
      "audit_action_suspend_admin_staff": "Admin staff suspended",
      "audit_action_task_assigned": "Task assigned",
      "audit_action_task_deleted": "Task deleted",
      "audit_action_task_reviewed": "Task reviewed",
      "audit_action_task_submitted": "Task submitted",
      "audit_action_task_updated": "Task updated",
      "audit_action_teacher_created": "Teacher added",
      "audit_action_teacher_deleted": "Teacher deleted",
      "audit_action_teacher_document_deleted": "Teacher document deleted",
      "audit_action_teacher_document_downloaded": "Teacher document downloaded",
      "audit_action_teacher_document_types_updated": "Document types updated",
      "audit_action_teacher_document_uploaded": "Teacher document uploaded",
      "audit_action_teacher_rated": "Teacher rated",
      "audit_action_teacher_updated": "Teacher updated",
      "audit_action_token_refresh": "Session refreshed",
      "audit_action_transcripts_issued": "Transcripts issued",
      "audit_action_update_academic_calendar": "Academic calendar updated",
      "audit_action_update_academic_year_status": "Academic year status changed",
      "audit_action_update_admin_staff_info": "Admin staff updated",
      "audit_action_update_admin_staff_permissions": "Admin staff permissions changed",
      "audit_action_update_attendance": "Attendance updated",
      "audit_action_update_grade": "Grade updated",
      "audit_action_update_notification_preferences": "Notification preferences updated",
      "audit_action_schedule_duplicates_resolved": "Duplicate timetable periods merged",
      "audit_action_other": "Other activity",
      // ── Sessions, subscription lockout, desktop notice [PHASE-5 2026-10] ──
      "session_notice_max_age": "Your session ended 24 hours after you signed in. Sign in again to continue.",
      "session_notice_expired": "Your session has expired. Sign in again to continue.",
      "session_notice_revoked": "Your session was ended. Sign in again to continue.",
      "session_notice_subscription": "Your school's subscription has expired, so you cannot sign in right now. Please contact your school's administration.",
      "session_notice_dismiss": "Dismiss",
      "stw_session_ending_message": "A session ends 24 hours after sign-in and cannot be extended. Save your work, then sign in again.",
      "stw_dismiss": "OK",
      "renewal_title": "School subscription expired",
      "renewal_title_suspended": "School subscription suspended",
      "renewal_data_kept": "Nothing has been deleted: all of the school's data is kept and comes back as soon as it is renewed.",
      "renewal_ended_on": "Ended on {{date}}",
      "renewal_contact_title": "To renew, contact the platform administration",
      "renewal_phone": "Phone",
      "renewal_email": "Email",
      "renewal_whatsapp": "WhatsApp",
      "renewal_no_contact": "No contact details are set yet. Contact the platform operator.",
      "renewal_check_again": "Check again",
      "renewal_checking": "Checking...",
      "renewal_still_locked": "The subscription has not been renewed yet.",
      "renewal_restored": "Subscription renewed. Welcome back!",
      "renewal_check_failed": "Could not check right now. Try again.",
      "renewal_logout": "Sign out",
      "desktop_notice_title": "This interface is designed for a computer",
      "desktop_notice_body": "The administration dashboard is full of tables and forms and works best on a laptop or desktop computer. You can continue on this device, but some screens may be cramped.",
      "desktop_notice_continue": "Continue anyway",
      "ps_contact_phone": "Contact phone",
      "ps_contact_hint": "The phone and email are shown to a school's administrator when its subscription has expired.",
      "subscription_call": "Call",
      // ── Bulk finance [PHASE-3 2026-10] ──────────
      "fin_tab_bulk_fees": "Bulk payments",
      "fin_tab_payroll": "Monthly payroll",
      "bulk_fees_title": "Bulk fee payments",
      "bulk_fees_subtitle": "Pick the class or month, tick the students who paid, then confirm once.",
      "bulk_all_classes": "All classes",
      "bulk_all_fee_types": "All fee types",
      "bulk_pick_method": "Choose the payment method",
      "bulk_refresh": "Refresh",
      "bulk_download_list": "Download the list (Excel)",
      "bulk_import_excel": "Import payments from Excel",
      "bulk_import_hint": "Columns: student number, amount, month, fee type, reference. A row without an amount is not recorded.",
      "bulk_import_skipped": "{{count}} row(s) without an amount skipped",
      "fin_unpaid_all_years": "All years",
      "bulk_list_count": "{{shown}} of {{total}} unpaid fees",
      "bulk_list_truncated": "The list is cut short: narrow the filter to see the rest.",
      "bulk_selected_summary": "Selected: {{count}} · total",
      "bulk_review_btn": "Review and confirm",
      "bulk_select_all": "Select all",
      "bulk_col_pay_now": "Amount paid now",
      "bulk_nothing_unpaid": "No unpaid fees for this filter.",
      "bulk_amount_invalid": "Some amounts are invalid or exceed the balance (in red).",
      "bulk_import_preview_title": "Import preview",
      "bulk_import_ok_rows": "{{count}} valid row(s)",
      "bulk_import_partial_note": "Rows with errors will not be recorded. Fix them in the file and import them later.",
      "bulk_import_continue": "Continue with {{count}} row(s)",
      "bulk_import_no_header": "No student number column was found in the file.",
      "bulk_import_read_error": "The file could not be read.",
      "bulk_col_student_number": "student number",
      "bulk_col_amount": "amount",
      "bulk_col_month": "month",
      "bulk_col_fee_type": "fee type",
      "bulk_col_reference": "reference",
      "bulk_col_name_info": "name (for information)",
      "bulk_col_row": "Row",
      "bulk_confirm_title": "Confirm the bulk payment",
      "bulk_confirm_count": "Payments",
      "bulk_confirm_total": "Total",
      "bulk_confirm_note": "All payments are recorded together. If the connection drops, confirm again: no payment is ever counted twice.",
      "bulk_confirm_btn": "Record {{count}} payment(s)",
      "bulk_recorded": "{{count}} payment(s) recorded",
      "bulk_done_title": "Payments recorded",
      "bulk_print_receipts": "Print receipts",
      "bulk_rows_with_errors": "{{count}} row(s) with errors",
      "bulk_sheet_row": "Excel row {{row}}",
      "bulk_line": "Line {{n}}",
      "bulk_load_error": "Could not load the list",
      "bulk_save_error": "Could not record",
      "bulk_read_only": "This is an archived year: no payments can be recorded in it.",
      "bulk_err_invalid_row": "Invalid row",
      "bulk_err_fee_not_found": "Fee not found in this school",
      "bulk_err_student_not_found": "No student with number {{student_number}}",
      "bulk_err_no_unpaid_fee": "No matching unpaid fee for this student",
      "bulk_err_ambiguous_fee": "{{count}} fees match: give the month or fee type",
      "bulk_err_duplicate_fee": "The same fee appears twice",
      "bulk_err_year_archived": "Fee of an archived year ({{year}}): cannot be paid",
      "bulk_err_fee_already_paid": "Fee already paid in full",
      "bulk_err_exceeds_balance": "The amount exceeds the balance ({{remaining}})",
      "bulk_err_employee_not_found": "Employee not found or inactive in this school",
      "bulk_err_duplicate_employee": "Employee listed twice",
      "bulk_err_already_paid": "This month's salary is already paid",
      "bulk_err_multiple_rows": "{{count}} salaries recorded this month: settle them from the salaries table",
      "bulk_err_missing_number": "Missing student number",
      "bulk_err_bad_amount": "Invalid amount",
      "bulk_err_bad_month": "Invalid month (e.g. 2026-10)",
      "payroll_title": "Monthly payroll",
      "payroll_subtitle": "Every teacher and staff member with their last salary. Adjust the exceptions, then confirm once.",
      "payroll_print_month": "Print this month's paid payslips",
      "payroll_counts": "{{total}} employees · {{payable}} payable",
      "payroll_col_last": "Last salary",
      "payroll_col_amount": "This month's amount",
      "payroll_no_staff": "No active employees.",
      "payroll_type_teacher": "Teacher",
      "payroll_type_staff": "Administrative staff",
      "payroll_state_new": "Not recorded",
      "payroll_state_unpaid": "Recorded, unpaid",
      "payroll_state_paid": "Paid",
      "payroll_state_multiple": "Several salaries recorded",
      "payroll_amount_missing": "Enter an amount for every ticked employee (in red).",
      "payroll_confirm_title": "Confirm the payroll for {{month}}",
      "payroll_confirm_count": "Employees",
      "payroll_confirm_note": "The same month can never be paid twice, even if the confirmation is repeated.",
      "payroll_confirm_btn": "Pay {{count}} salary(ies)",
      "payroll_recorded": "{{count}} salary(ies) paid",
      "payroll_done_title": "Salaries paid",
      "payroll_print_payslips": "Print payslips",
      "fp_student_number": "Student no.",
      "fp_period": "Period",
      "fp_reference": "Reference",
      "fp_amount_received": "Amount received",
      "fp_fee_total": "Fee amount",
      "fp_paid_to_date": "Paid to date",
      "fp_remaining": "Balance",
      "fp_fee_status": "Fee status",
      "fp_signature_stamp": "Signature and stamp",
      "fp_employee": "Employee",
      "fp_employee_detail": "Specialty / role",
      "fp_employee_signature": "Employee signature",
      "fp_preparing": "Preparing the documents to print…",
      "fp_popup_blocked": "The browser blocked the print window. Allow pop-ups for this site.",
      // ── Fast schedule builder [FEAT fast-builder 2026-09] ──────────
      "smc_view_builder":           "Fast builder",
      "sb_title":                   "Block schedule builder",
      "sb_subtitle":                "Pick a block (subject + teacher), then click the cells it goes in. No times to type, and a clash cannot be created.",
      "sb_class":                   "Class",
      "sb_pick_class":              "Choose a class",
      "sb_pick_class_prompt":       "Choose a class to start building its schedule.",
      "sb_save":                    "Save schedule",
      "sb_saved":                   "Saved {{count}} periods in a single request",
      "sb_undo":                    "Undo",
      "sb_copy_to_class":           "Copy to another class",
      "sb_autofill":                "Fill the rest automatically",
      "sb_keyboard_hint":           "Shortcuts: keys 1-9 select a block, Esc deselects, Ctrl+Z undoes the last placement.",
      "sb_palette":                 "Blocks available for this class",
      "sb_no_blocks":               "No teacher is assigned to this class ({{cls}}). Add the class to the relevant teachers first.",
      "sb_block_remaining":         "{{count}} left",
      "sb_block_done":              "Complete",
      "sb_eraser":                  "Eraser",
      "sb_teachers_without_subjects": "Teachers with no subjects recorded, so they have no blocks: {{names}}",
      "sb_pick_block_first":        "Pick a block first, then click the cell.",
      "sb_period":                  "Period",
      "sb_period_n":                "Period {{n}}",
      "sb_grid_for":                "{{cls}} schedule",
      "sb_placed":                  "{{count}} periods placed",
      "sb_locked_tooltip":          "{{teacher}} is already teaching {{cls}} at this time",
      "sb_needs_teacher":           "Needs a teacher",
      "sb_busy_in":                 "busy with {{cls}}",
      "sb_problems":                "{{count}} cell(s) need attention before saving.",
      "sb_fix_problems_first":      "Fix {{count}} cell(s) before saving.",
      "sb_server_rejected":         "The server refused the save for these reasons; nothing was saved:",
      "sb_legacy_rows":             "{{count}} saved period(s) use times that do not match the current bell schedule, so they are not shown on this grid. Review them in the weekly view.",
      "sb_duplicate_cells":         "This class has more than one timetable on: {{days}}. The grid shows one version, and saving keeps only what you see. Resolve the duplicates flagged above first.",
      "sdup_title":                 "Duplicate timetables for one class and day",
      "sdup_intro":                 "{{count}} class-and-day cell(s) have more than one timetable. Their lessons stack in the weekly view and on print, and count twice in the School Directory. Choose the version to keep.",
      "sdup_version":               "Version {{n}} — {{count}} period(s)",
      "sdup_keep":                  "Keep this version",
      "sdup_merge":                 "Merge the versions",
      "sdup_conflict_slots":        "The versions disagree on: {{slots}}",
      "sdup_archived":              "Archived year — read-only",
      "sdup_resolved":              "One timetable remains for this class and day",
      "sdup_confirm_keep":          "The other versions of this day will be deleted (a copy is archived). Continue?",
      "sb_autofill_done":           "Placed {{count}} periods. Review and adjust before saving.",
      "sb_autofill_review_hint":    "Nothing is saved yet — use the Save button above.",
      "sb_unplaced_no_teacher":     "Could not place {{count}} {{subject}} period(s) — no teacher for that subject in this class.",
      "sb_unplaced_teacher_busy":   "Could not place {{count}} {{subject}} period(s) — {{names}} is busy in every remaining slot.",
      "sb_unplaced_grid_full":      "Could not place {{count}} {{subject}} period(s) — no free cells left on the grid.",
      "sb_copy_title":              "Copy schedule to another class",
      "sb_copy_hint":               "The whole week is copied; any cell whose teacher is already busy in the target class is cleared so you can pick a replacement.",
      "sb_copy_pick_target":        "Choose the target class",
      "sb_copy_confirm":            "Copy",
      "sb_copy_needs_teacher":      "{{count}} cell(s) need a different teacher in this class:",

      // ── Bell schedule + curriculum settings [2026-09] ──────────────
      "ss_bell_title":              "Period times (bell schedule)",
      "ss_bell_hint":               "Set the period times once for the whole school. After this nobody types a time while building a schedule. Any start time, any length, any number of periods.",
      "ss_bell_period_n":           "Period {{n}}",
      "ss_bell_start":              "Period start",
      "ss_bell_end":                "Period end",
      "ss_bell_add":                "Add a period",
      "ss_bell_remove":             "Remove period",
      "ss_bell_summary":            "{{count}} periods — {{minutes}} teaching minutes per day",
      "ss_bell_invalid_rows":       "Some rows are invalid (missing time, end before start, or overlapping) and will not be saved.",
      "ss_curriculum_title":        "Weekly curriculum (optional)",
      "ss_curriculum_hint":         "Periods per week for each subject in each grade. Powers the \"remaining\" counter on each block and the auto-fill button. Building schedules works fully without it.",
      "ss_curriculum_grade":        "Grade",
      "ss_curriculum_subject":      "Subject",
      "ss_curriculum_per_week":     "Periods/week",
      "ss_curriculum_add":          "Add a row",
      "ss_curriculum_remove":       "Remove row",
      "ss_curriculum_empty":        "No curriculum set — this is entirely optional.",

      // ── Teacher documents [FEAT teacher-docs 2026-09] ──────────────
      "td_docs_button":             "Teacher documents",
      "td_docs_title":              "{{name}}'s documents",
      "td_docs_privacy_note":       "Personal documents. Only this school's administration and the teacher themselves can see them, and every upload, download and deletion is logged.",
      "td_docs_type":               "Document type",
      "td_docs_pick_type":          "Choose the type",
      "td_docs_upload":             "Upload",
      "td_docs_uploaded":           "Document uploaded",
      "td_docs_upload_error":       "Upload failed",
      "td_docs_download_error":     "Download failed",
      "td_docs_delete_error":       "Delete failed",
      "td_docs_load_error":         "Could not load the documents",
      "td_docs_deleted":            "Document deleted",
      "td_docs_confirm_delete":     "Permanently delete \"{{name}}\"?",
      "td_docs_empty":              "No documents uploaded for this teacher yet.",
      "td_docs_rules":              "PDF or image (JPG/PNG) only, {{max}} maximum per file. Images are compressed automatically on upload.",
      "td_docs_too_big":            "The file is larger than the maximum ({{max}}).",
      "td_docs_missing_required":   "Required documents still missing: {{names}}",
      "td_docs_all_required_present": "All required documents are present.",
      "td_docs_type_inactive":      "Retired type",
      "td_docs_compressed_from":    "compressed from {{original}}",
      "ss_doctypes_title":          "Teacher document types",
      "ss_doctypes_hint":           "Define which documents your school requires from its teachers. Editable at any time.",
      "ss_doctypes_label_ar":       "Arabic label",
      "ss_doctypes_label_fr":       "French label",
      "ss_doctypes_label_en":       "English label",
      "ss_doctypes_required":       "Required",
      "ss_doctypes_add":            "Add a type",
      "ss_doctypes_remove":         "Remove type",
      "ss_doctypes_save":           "Save types",
      "ss_doctypes_saved":          "Document types saved",
      "ss_doctypes_save_error":     "Could not save the document types",
      "ss_doctypes_empty":          "No types defined yet.",
      "ss_doctypes_removal_note":   "Removing a type from the list does not delete any uploaded file; it keeps its former type label.",
      "ss_storage_title":           "Storage",
      "ss_storage_used":            "{{used}} of {{quota}}",
      "ss_storage_documents":       "{{count}} document(s)",
      "ss_storage_hint":            "Maximum {{max}} per file. Images are compressed automatically to save space.",
      "ssy_disk_title":             "Disk usage",
      "ssy_disk_used":              "{{used}} used of {{total}} ({{percent}}%)",
      "ssy_disk_free":              "{{free}} free",
      "ssy_disk_warning":           "The disk is {{percent}}% full (threshold {{threshold}}%). A full disk stops the database and the backups, not just document uploads.",
      "ssy_disk_by_school":         "Usage by school",
      "ssy_disk_documents":         "{{count}} document(s)",

      // Auth
      "exam_schedule_title": "Exam Schedule",
      "exam_add": "Add Exam",
      "exam_edit": "Edit Exam",
      "exam_print": "Print Schedule",
      "exam_created": "Exam created successfully",
      "exam_updated": "Exam updated successfully",
      "exam_deleted": "Exam deleted",
      "exam_confirm_delete": "Are you sure you want to delete this exam?",
      "exam_empty": "No exams scheduled yet",
      "exam_readonly_note": "This schedule is read-only",
      "exam_col_time": "Time",
      "exam_col_subject": "Subject",
      "exam_col_class": "Class",
      "exam_col_room": "Room No.",
      "exam_col_invigilator": "Invigilating Teacher",
      "exam_col_date": "Date",
      "exam_col_notes": "Notes",
      "exam_pick_subject": "Choose subject",
      "exam_pick_class": "Choose class",
      "exam_pick_teacher": "Choose invigilator",
      "exam_room_placeholder": "e.g. 101",
      "exam_start_time": "Start time",
      "exam_end_time": "End time",
      "exam_err_required": "Please fill in all required fields",
      "exam_err_time_range": "End time must be after start time",
      "exam_err_save": "Could not save the exam",
      "exam_err_delete": "Could not delete the exam",
      "exam_popup_blocked": "Popup blocked — please allow popups to print",
      "login": "Login",
      "logout": "Logout",
      "username": "Username",
      "password": "Password",
      "select_role": "Select Role",
      "remember_me": "Remember Me",
      "forgot_password": "Forgot Password?",
      "welcome_back": "Welcome Back",
      "login_subtitle": "EduGate — Smart School Management Platform",
      
      // Roles
      "super_admin": "Super Admin",
      "school_admin": "School Admin",
      "admin_staff": "Admin Staff",
      "teacher": "Teacher",
      "student": "Student",
      "parent": "Parent",
      
      // Navigation
      "dashboard": "Dashboard",
      "schools": "Schools",
      "students": "Students",
      "teachers": "Teachers",
      "parents": "Parents",
      "attendance": "Attendance",
      "grades": "Grades",
      "assignments": "Assignments",
      "fees": "Fees",
      "payments": "Payments",
      "settings": "Settings",
      
      // Actions
      "add": "Add",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "cancel": "Cancel",
      "search": "Search",
      "filter": "Filter",
      "export": "Export",
      "view": "View",
      "submit": "Submit",
      
      // Dashboard
      "total_schools": "Total Schools",
      "total_students": "Total Students",
      "total_teachers": "Total Teachers",
      "total_parents": "Total Parents",
      "present_today": "Present Today",
      "absent_today": "Absent Today",
      "total_fees": "Total Fees",
      "total_paid": "Total Paid",
      "total_pending": "Pending",
      
      // School Management
      "add_school": "Add School",
      "school_name": "School Name",
      "school_name_ar": "Name in Arabic",
      "school_name_fr": "Name in French",
      "address": "Address",
      "phone": "Phone",
      "email": "Email",
      "admin_info": "Admin Info",
      "admin_username": "Admin Username",
      "admin_password": "Admin Password",
      "admin_full_name": "Admin Full Name",
      
      // Student Management
      "add_student": "Add Student",
      "student_info": "Student Info",
      "full_name": "Full Name",
      "class": "Class",
      "grade": "Grade",
      "date_of_birth": "Date of Birth",
      "medical_info": "Medical Info",
      
      // Teacher Management
      "add_teacher": "Add Teacher",
      "teacher_info": "Teacher Info",
      "subjects": "Subjects",
      "classes": "Classes",
      "specialization": "Specialization",
      
      // Attendance
      "mark_attendance": "Mark Attendance",
      "date": "Date",
      "status": "Status",
      "present": "Present",
      "absent": "Absent",
      "late": "Late",
      "excused": "Excused",
      "notes": "Notes",
      
      // Grades
      "add_grade": "Add Grade",
      "subject": "Subject",
      "assessment_type": "Assessment Type",
      "assessment_name": "Assessment Name",
      "score": "Score",
      "max_score": "Max Score",
      "percentage": "Percentage",
      "exam": "Exam",
      "quiz": "Quiz",
      "homework": "Homework",
      "project": "Project",
      
      // Assignments
      "add_assignment": "Add Assignment",
      "title": "Title",
      "description": "Description",
      "due_date": "Due Date",
      "attachment": "Attachment",
      
      // Fees
      "add_fee": "Add Fee",
      "amount": "Amount",
      "fee_type": "Fee Type",
      "academic_year": "Academic Year",
      "semester": "Semester",
      "paid": "Paid",
      "pending": "Pending",
      "partial": "Partial",
      "overdue": "Overdue",
      "tuition": "Tuition",
      "transport": "Transport",
      "books": "Books",
      
      // Payments
      "add_payment": "Add Payment",
      "payment_method": "Payment Method",
      "reference_number": "Reference Number",
      "payment_date": "Payment Date",
      "cash": "Cash",
      "bank_transfer": "Bank Transfer",
      "online": "Online",
      
      // Messages
      "loading": "Loading...",
      "no_data": "No Data",
      "success": "Success",
      "error": "Error",
      "confirm_delete": "Confirm Delete?",
      
      // Language
      "language": "Language",
      "arabic": "Arabic",
      "french": "French",
      "english": "English",
      
      // Additional
      "active": "Active",
      "academic_years": "Academic Years",
      "archived": "Archived",
      "planned": "Planned",
      "read_only": "Read only",
      "ay_label_fees": "Student fee records",
      "ay_label_salaries": "Teacher salary records",
      "ay_label_expenses": "School expense records",
      "ay_label_reports": "Reports & statistics",
      "ay_label_schedule": "Class schedules",
      "ay_label_grades": "Grade records",
      "ay_label_calendar": "School calendar",
      "ay_label_records": "Records",
      "ay_year_suffix": "Academic year {{year}}",
      "ay_archive_banner": "You are viewing archived data from academic year {{year}} — read-only",
      "ay_help_button": "Academic Year Guide",
      "ay_help_title": "Academic Years — Guide",
      "ay_help_intro_h": "What is an academic year?",
      "ay_help_intro_p": "The academic year is the time frame that organizes all of your school's data (fees, salaries, grades, attendance, schedules, calendar). Every record is stored against a specific year, which keeps each year's data separate and clear.",
      "ay_help_sequence_h": "Required order of steps before a rollover",
      "ay_help_sequence_p": "Before a rollover will run, the current year must move through this sequence using the status buttons in the years table: (1) \"Active\" during the year. (2) Click \"Mark Ready\" (Ready for Promotion) at year-end. (3) Click \"Approve\". (4) Most important — click \"Lock Results\": this is a SEPARATE step from Approve. It means administration has approved and locked the final results; without it the system refuses the rollover with \"results are not approved and locked yet\". The \"Lock Results\" button sits next to the status buttons and also inside the rollover wizard. (5) Click \"Start Rollover Wizard\". Note: approving and locking results are two distinct actions — approving does NOT auto-lock the results.",
      "ay_help_rollover_h": "What does \"rollover\" mean?",
      "ay_help_rollover_p": "Rollover is the transition from one academic year to the next. When you start a new year you choose how the previous year's data is treated — no data is ever deleted, in either mode.",
      "ay_help_archive_h": "Mode 1: Archive & Continue",
      "ay_help_archive_p": "Last year's records (finance, messages, grades…) stay viewable in a clearly labeled, read-only archived view, while new records are entered under the new year. Best when you want easy access to last year's numbers.",
      "ay_help_fresh_h": "Mode 2: Fresh Start",
      "ay_help_fresh_p": "The new year starts with clean screens; the previous year's data is archived and not shown by default in current views. The archive is always reachable via the year selector, and nothing is deleted.",
      "ay_help_separation_h": "How is data separated between years?",
      "ay_help_separation_p": "Fees, salaries, expenses, grades, attendance, schedules and the calendar are separated by academic year. During the current year only current-year data is shown — never mixed with older years — and every screen carries a label showing which year it displays.",
      "ay_help_access_h": "How do students, teachers and parents see last year's data?",
      "ay_help_access_p": "A year-selector dropdown is available on the student, teacher and parent dashboards. By choosing a past year they can view (read-only) the grades, attendance and records from that year that they are allowed to see.",
      "ay_help_lock_h": "Why is the year locked when entering a date?",
      "ay_help_lock_p": "When entering any date (fees, salaries, expenses, grades, attendance, calendar), the year is fixed to the active academic year and you only pick the day and month. This is intentional, to prevent common mistakes like recording an amount in the wrong year. The system rejects any date outside the active year.",
      "ay_help_steps_h": "Steps to start a new academic year",
      "ay_help_step1": "Add the new academic year (format YYYY-YYYY) using the \"Add Academic Year\" button.",
      "ay_help_step2": "Click \"Start Rollover Wizard\" and choose the mode: Archive & Continue or Fresh Start.",
      "ay_help_step3": "Review the class mapping for promoted students and confirm; the previous year's data is not deleted.",
      "ay_help_step4": "The new year becomes active automatically; the previous year is archived and stays reachable via the year selector.",
      "ay_help_faq_h": "Frequently asked questions",
      "ay_help_faq_q1": "Is last year's data deleted on rollover?",
      "ay_help_faq_a1": "No. No data is ever deleted, in any mode; only what is shown by default changes, and every record stays reachable via the year selector.",
      "ay_help_faq_q2": "Can I edit data in an archived year?",
      "ay_help_faq_a2": "No. Archived years are read-only, with a clear banner telling you so. Data entry is only possible in the active year.",
      "ay_help_faq_q3": "I entered a date and the system rejected it — why?",
      "ay_help_faq_a3": "Because the date's year is outside the active academic year. Pick a day and month within the active year, or switch the active year first if you mean a different one.",
      // Academic-year manager (AcademicYearManager.jsx) [I18N 2026-10]
      "aym_backups_load_error": "Failed to load backups",
      "aym_invalid_year_format": "Invalid academic year format. Must be YYYY-YYYY",
      "aym_year_created": "Academic year created successfully",
      "aym_confirm_activate": "Are you sure you want to activate {{name}}? This will archive other active years.",
      "aym_year_activated": "Academic year {{name}} is now active",
      "aym_confirm_transition": "Are you sure you want to transition academic year {{year}} to ({{status}})?",
      "aym_status_updated": "Academic year status updated successfully",
      "aym_calendar_saved": "Academic calendar saved successfully",
      "aym_results_locked_toast": "Results phase locked. You can now start the rollover.",
      "aym_confirm_word_wrong": "Please type the confirmation word correctly",
      "aym_restore_success": "System database state successfully restored from snapshot",
      "aym_active_year_required": "An active academic year is required first",
      "aym_rollover_done": "Rollover completed! Promoted {{promoted}} and retained {{retained}} students.",
      "aym_phase_registration": "Student Registration",
      "aym_phase_study_exams": "Study & Weekly Schedule",
      "aym_phase_results": "Final Grade Entry & Results",
      "aym_phase_promotion_ready": "Rollover Preparation",
      "aym_status_planned": "Planned",
      "aym_status_active": "Active",
      "aym_status_ready": "Ready for Promotion",
      "aym_status_approved": "Approved",
      "aym_status_promoting": "Promoting...",
      "aym_status_archived": "Archived (Read Only)",
      "aym_title": "Academic Years & Rollover",
      "aym_subtitle": "Manage academic cycles, configure phase locks, and restore data backups.",
      "aym_add_year": "Add Academic Year",
      "aym_start_rollover": "Start Rollover Wizard",
      "aym_tab_cycles": "Academic Cycles & Calendar",
      "aym_tab_backups": "Snapshots & Data Recovery",
      "aym_cycles_title": "Academic Cycles",
      "aym_col_year": "Year",
      "aym_start_date": "Start Date",
      "aym_end_date": "End Date",
      "aym_col_actions": "Actions",
      "aym_btn_activate": "Activate",
      "aym_btn_mark_ready": "Mark Ready",
      "aym_btn_approve": "Approve",
      "aym_btn_lock_results": "Lock Results",
      "aym_btn_archive": "Archive",
      "aym_closed_history": "Closed History",
      "aym_workflow_title": "Academic Lifecycle Workflow",
      "aym_wf_planned": "Planned",
      "aym_wf_ready": "Ready",
      "aym_wf_archived": "Archived",
      "aym_calendar_locks_title": "Academic Calendar Phase Locks",
      "aym_locked": "Locked",
      "aym_unlocked": "Unlocked",
      "aym_save_calendar": "Save Calendar Settings",
      "aym_no_years": "No academic years configured",
      "aym_guidelines_title": "Data Integrity Guidelines",
      "aym_guidelines_isolation": "The system fully isolates student grades, timetables, and attendance logs on a per-academic-year basis.",
      "aym_guidelines_phase_locking": "Phase Locking:",
      "aym_guidelines_lock_registration": "Locking Registration prevents new student enrollments.",
      "aym_guidelines_lock_study": "Locking Study & Schedules prevents timetable modification.",
      "aym_guidelines_lock_grades": "Locking Grade Entry prevents teachers from updating scores.",
      "aym_snapshots_title": "Rollover Snapshot Recovery Logs",
      "aym_snapshots_desc": "System automatically stores fully-consistent checkpoints right before batch rollovers.",
      "aym_col_backup_id": "Backup ID",
      "aym_col_timestamp": "Timestamp",
      "aym_col_old_cycle": "Old Cycle ID",
      "aym_backup_committed": "Committed",
      "aym_backup_rolled_back": "Rolled Back",
      "aym_restore_btn": "Restore",
      "aym_already_restored": "Inactive checkpoint",
      "aym_no_backups": "No rollover snapshots recorded yet",
      "aym_create_title": "Create New Academic Year",
      "aym_create_desc": "Create a new planned academic year. Format must be YYYY-YYYY.",
      "aym_year_name_label": "Academic Year Name *",
      "aym_restore_title": "Restore Checkpoint Security Check",
      "aym_restore_warning": "Warning: Restoring will overwrite current timetables and students states back to the snapshot's state.",
      "aym_restore_type_word": "Please type the word \"ROLLBACK\" below to proceed:",
      "aym_restore_proceed": "Proceed Restore",
      "aym_wizard_title": "Academic Year Rollover Wizard",
      "aym_wizard_desc": "Rollover school data from {{year}} to the next cycle.",
      "aym_step_years": "Years",
      "aym_step_classes": "Classes",
      "aym_step_retentions": "Retentions",
      "aym_step_options": "Options",
      "aym_step_confirm": "Confirm",
      "aym_target_year_title": "Target Academic Cycle",
      "aym_requirements_title": "Rollover requirements",
      "aym_req_status": "Year status is Approved / Ready for Promotion — via the status buttons in the years table",
      "aym_req_results_locked": "Results phase locked (final results approved)",
      "aym_lock_results_now": "Lock Results now",
      "aym_current_active_year": "Current Active Year",
      "aym_target_year_label": "Target New Year *",
      "aym_class_mapping_title": "Class Promotion Rules",
      "aym_class_mapping_desc": "Specify the corresponding target class for students who pass their grades.",
      "aym_no_classes": "No classes found",
      "aym_retained_title": "Retained Students Selector",
      "aym_search_student_placeholder": "Search name or class...",
      "aym_retained_desc": "Selected students will repeat the year inside their current class level, rather than being promoted.",
      "aym_no_search_results": "No students match the search",
      "aym_retained_count": "Total repeating students selected: {{n}}.",
      "aym_options_title": "Additional Rollover Options",
      "aym_copy_schedules": "Duplicate Weekly Timetables",
      "aym_copy_schedules_desc": "The system will copy the current timetables into the new academic year.",
      "aym_schedule_copy_mode_title": "Where should each class's timetable be copied?",
      "aym_schedule_same_class": "Each class keeps its own",
      "aym_schedule_same_class_desc": "Grade 1 A's timetable is copied to next year's Grade 1 A. Best when each class's lessons stay the same.",
      "aym_schedule_follow": "It follows the students",
      "aym_schedule_follow_desc": "Grade 1 A's timetable moves to the class its students are promoted to (Grade 2 A); the new Grade 1 A starts with none.",
      "aym_enabled": "Enabled",
      "aym_disabled": "Disabled",
      "aym_allow_unpaid": "Allow Promoting Students with Pending Fees",
      "aym_allow_unpaid_desc": "Bypasses outstanding financial checks and allows promotion for all students regardless of unpaid fees.",
      "aym_mode_title": "How should the new year start?",
      "aym_mode_desc": "No data is ever deleted in either mode — only what screens show by default changes.",
      "aym_mode_archive": "Archive & Continue",
      "aym_mode_archive_desc": "Last year's records (finance, messages, grades) stay reachable read-only via the year selector.",
      "aym_mode_fresh": "Fresh Start",
      "aym_mode_fresh_desc": "Screens default to the new year only; old data stays stored and reachable via the year filter.",
      "aym_final_review_title": "Final Confirmation",
      "aym_final_warning": "Warning: This action initiates batch updates across the database.",
      "aym_final_archive_current": "The cycle ({{year}}) will be closed and archived.",
      "aym_final_activate_new": "The cycle ({{year}}) will be activated.",
      "aym_final_students": "Promoted students move to their new classes; retained students stay in the same class.",
      "aym_promoted_students": "Promoted Students",
      "aym_retained_students": "Retained Students",
      "aym_schedule_copy": "Schedule Copy",
      "aym_outstanding_fees": "Outstanding Fees",
      "aym_allowed": "Allowed",
      "aym_strict": "Strict Check",
      "aym_next_cycle": "Next Cycle",
      "aym_start_mode": "Start Mode",
      "aym_mode_archive_short": "Archive",
      "aym_prev": "Back",
      "aym_invalid_year_short": "Invalid year format",
      "aym_next": "Next",
      "aym_confirm_rollover": "Confirm final rollover",
      "inactive": "Inactive",
      "relationship": "Relationship",
      "father": "Father",
      "mother": "Mother",
      "guardian": "Guardian",
      "select_student": "Select Student",
      "select_students": "Select Students",
      "mark_attendance_for": "Mark Attendance For",
      "select_date": "Select Date",
      "today": "Today",
      "yesterday": "Yesterday",
      "this_week": "This Week",
      "this_month": "This Month",
      "all": "All",
      "select_class": "Select Class",
      "select_subject": "Select Subject",
      "enter_score": "Enter Score",
      "out_of": "out of",
      "weight": "Weight",
      "first_semester": "First Semester",
      "second_semester": "Second Semester",
      "payment_history": "Payment History",
      "pay_now": "Pay Now",
      "discount": "Discount",
      "scholarship": "Scholarship",
      "create_assignment": "Create Assignment",
      "due_in": "Due In",
      "submitted": "Submitted",
      "not_submitted": "Not Submitted",
      "graded": "Graded",

      // Announcement Board
      "ann_board_title": "Announcement Board",
      "ann_board_subtitle": "School and class announcements",
      "ann_new": "New Announcement",
      "ann_title_placeholder": "Announcement title",
      "ann_content_placeholder": "Announcement content...",
      "ann_priority": "Priority",
      "ann_priority_normal": "Normal",
      "ann_priority_important": "Important",
      "ann_priority_urgent": "Urgent",
      "ann_target": "Target audience",
      "ann_target_all": "Everyone",
      "ann_target_parents": "Parents",
      "ann_target_students": "Students",
      "ann_target_class": "Specific class",
      "ann_select_class": "-- Select class --",
      "ann_publish": "Publish Announcement",
      "ann_publishing": "Publishing...",
      "ann_empty": "No announcements yet",
      "ann_written_by": "By",
      "ann_class_label": "Class",
      "ann_delete_success": "Announcement deleted",
      "ann_delete_error": "Failed to delete announcement",
      "ann_post_success": "Announcement published",
      "ann_post_error": "Error publishing announcement",
      "ann_load_error": "Failed to load announcements",
      "ann_validation": "Fill in the title and content",

      // Sidebar nav
      "nav_dashboard": "Dashboard",
      "nav_students": "Students",
      "nav_teachers": "Teachers",
      "nav_parents": "Parents",
      "nav_attendance": "Attendance",
      "nav_grades": "Grades",
      "nav_fees": "School Fees",
      "nav_schedule": "Schedule",
      "nav_excel": "Excel Import",
      "nav_reports": "Reports",
      "nav_pdf_reports": "PDF reports",
      "nav_bulk_attendance": "Bulk Attendance",
      "nav_staff_attendance": "Staff attendance",
      "nav_student_attendance": "Student attendance",
      "nav_announcements": "Announcements",
      "nav_homework": "Homework",
      "nav_section_people": "People",
      "nav_section_academic": "Academic",
      "nav_section_finance": "Finance",
      "nav_section_communication": "Communication",
      "nav_section_reports": "Reports",
      "nav_section_control_panel": "Control Panel",
      "nav_group_community": "Community",
      "nav_group_academic": "Academic",
      "nav_group_communications": "Communications",
      "nav_group_finance": "Finance",
      "nav_group_scheduling": "Scheduling",
      "nav_group_staff": "Staff",
      "nav_group_settings": "Settings",
      "dash_total_parents": "Parents",
      "dash_attendance_rate": "Attendance Rate",
      "dash_welcome_admin": "Welcome {{name}}",
      "dash_welcome_subtitle": "Your school's overview for today",
      "dash_welcome_teacher": "Welcome {{name}} — teacher",
      "dash_welcome_student": "Welcome {{name}}",
      "dash_welcome_parent": "Welcome {{name}} — parent",
      "empty_no_data_title": "No data yet",
      "empty_no_data_action": "Start by adding a new item",
      "dash_unread_messages": "Unread Messages",
      "dash_quick_actions": "Quick Actions",
      "dash_quick_add_student": "Add Student",
      "dash_quick_announcement": "Send Announcement",
      "dash_quick_add_teacher": "Add Teacher",
      "dash_quick_attendance": "Record Attendance",
      "dash_weekly_attendance": "Weekly Attendance",
      "dash_recent_activity": "Recent Activity",
      "dash_activity_empty": "No activity yet",
      "dash_alerts": "Alerts",
      "dash_alert_absences": "Students with 3+ absences",
      "dash_alert_unpaid_fees": "Unpaid fees",
      "dash_alert_pending_tasks": "Pending teacher tasks",
      "comm_title": "Communications",
      "comm_tab_direct": "Direct Messages",
      "comm_tab_broadcast": "Broadcast",
      "comm_compose": "Compose",
      "comm_inbox": "Inbox",
      "comm_sent": "Sent",
      "comm_recipient_type": "Recipient type",
      "comm_recipient_admin": "School admin",
      "comm_recipient_student": "Student",
      "comm_recipient_parent": "Parent",
      "comm_pick_student": "Select student",
      "comm_pick_parent": "Select parent",
      "comm_pick_class": "Select class",
      "comm_admin_hint": "This message will go straight to the school principal.",
      "comm_subject": "Subject",
      "comm_subject_placeholder": "Message subject (optional)",
      "comm_message": "Message body",
      "comm_message_placeholder": "Write your message here...",
      "comm_chars": "chars",
      "comm_notify_parent": "Also send a copy to the parent",
      "comm_send": "Send",
      "comm_sending": "Sending...",
      "comm_sent_ok": "Message sent ✓",
      "comm_broadcast_ok": "Broadcast sent ✓",
      "comm_target": "Target",
      "comm_broadcast_class": "Class",
      "comm_broadcast_student": "Specific student",
      "comm_broadcast_admins": "School admin",
      "comm_broadcast_send": "Send broadcast",
      "comm_broadcast_history": "Broadcast history",
      "comm_broadcast_badge": "Broadcast",
      "comm_history_empty": "No broadcasts yet",
      "comm_inbox_empty": "No messages in inbox",
      "comm_sent_empty": "No messages sent yet",
      "comm_unknown": "Unknown",
      "comm_new": "New",
      "comm_validation_message": "Write the message body",
      "comm_validation_pick_student": "Pick a student",
      "comm_validation_pick_parent": "Pick a parent",
      "comm_validation_pick_class": "Pick a class",
      "acct_title": "Account Settings",
      "acct_subtitle": "Manage your profile picture and password in one place",
      "acct_profile_picture": "Profile picture",
      "acct_change_password": "Change password",
      "acct_image_hint": "Click the picture to pick a new one, then press Save.",
      "acct_image_size_hint": "JPG or PNG, 2 MB max.",
      "acct_image_choose": "Choose image",
      "acct_image_unsaved": "Unsaved new picture — click Save.",
      "acct_save_image": "Save picture",
      "acct_image_saved": "Profile picture updated ✓",
      "acct_image_too_big": "Image must be under 2 MB",
      "acct_image_encoded_too_big": "Encoded image is too large — pick a smaller one",
      "acct_pwd_current": "Current password",
      "acct_pwd_new": "New password",
      "acct_pwd_confirm": "Confirm password",
      "acct_pwd_min_hint": "At least 8 characters for the new password.",
      "acct_pwd_all_required": "All fields are required",
      "acct_pwd_mismatch": "New passwords don't match",
      "acct_pwd_too_short": "Password must be at least 8 characters",
      "acct_pwd_saved": "Password changed ✓",
      "acct_pwd_error": "Failed to change password",
      "acct_save_password": "Save password",
      "acct_saved": "Saved",
      "acct_saving": "Saving...",
      "staff_title": "Admin Staff",
      "staff_subtitle": "Create accounts for administrative staff with specific permissions",
      "staff_add": "Add staff member",
      "staff_save": "Save",
      "staff_saving": "Saving...",
      "staff_added": "Staff account created ✓",
      "staff_perms_updated": "Permissions updated ✓",
      "staff_deactivated": "Account deactivated",
      "staff_full_name": "Full name",
      "staff_username": "Username",
      "staff_password": "Password",
      "staff_pwd_hint": "At least 8 characters",
      "staff_permissions": "Granted permissions",
      "staff_col_name": "Name",
      "staff_col_username": "Username",
      "staff_col_permissions": "Permissions",
      "staff_col_last_active": "Last active",
      "staff_col_status": "Status",
      "staff_col_actions": "Actions",
      "staff_active": "Active",
      "staff_inactive": "Disabled",
      "staff_edit_perms": "Edit permissions",
      "staff_view_activity": "View activity",
      "staff_deactivate": "Deactivate",
      "staff_activity": "Activity",
      "staff_empty": "No staff yet — add the first one",
      "staff_validation_required": "Name, username and password are required",
      "staff_validation_pwd_short": "Password must be at least 8 characters",
      "staff_validation_marital": "Invalid marital status",
      "staff_phone": "Phone",
      "staff_position": "Position",
      "staff_position_placeholder": "e.g. secretary, accountant",
      "staff_marital_status": "Marital status",
      "staff_address": "Address",
      "staff_col_position": "Position",
      "staff_col_phone": "Phone",
      "staff_email": "Email",
      "staff_edit_info": "Edit info",
      "staff_info_updated": "Info updated ✓",
      "staff_suspend": "Suspend",
      "staff_unsuspend": "Reactivate",
      "staff_suspended": "Suspended",
      "staff_unsuspended": "Account reactivated ✓",
      "staff_confirm_suspend": "Suspend {{name}}'s account? They won't be able to log in.",
      "staff_confirm_unsuspend": "Reactivate {{name}}'s account?",
      "staff_delete_permanent": "Delete permanently",
      "staff_delete_warning": "{{name}}'s account will be removed permanently.",
      "staff_delete_irreversible": "This action cannot be undone.",
      "staff_delete_confirm": "Confirm delete",
      "staff_deleting": "Deleting...",
      "staff_deleted": "Permanently deleted",
      "attendance_stats_title": "Attendance statistics",
      "attendance_overall_rate": "Overall attendance rate",
      "attendance_total_days": "School days",
      "attendance_present": "Present",
      "attendance_absent": "Absent",
      "attendance_late": "Late",
      "attendance_excused": "Excused",
      "td_my_students": "My Students",
      "td_present_today": "Present Today",
      "td_absent_today": "Absent Today",
      "td_assignments": "Assignments",
      "td_my_subjects": "Subjects I teach",
      "td_my_classes": "Classes I teach",
      "td_no_subjects": "No subjects assigned",
      "td_no_classes": "No classes assigned",
      "td_quick_actions": "Quick Actions",
      "td_choose_class_hint": "Please choose a class from the list above to see its students and take attendance.",
      "td_record_attendance": "Record Attendance",
      "td_enter_grades": "Enter Grades",
      "td_add_assignment": "Add Assignment",
      "td_my_schedule": "My Schedule",
      "td_my_salaries": "My Salaries",
      "td_load_error": "Failed to load data",
      "td_attendance_saved": "Attendance saved",
      "td_attendance_save_error": "Failed to save attendance",
      "td_all_marked_present": "All students marked present",
      "td_all_marked_absent": "All students marked absent",
      "marital_single": "Single",
      "marital_married": "Married",
      "marital_divorced": "Divorced",
      "marital_widowed": "Widowed",
      "id_card_my_card": "My card",
      "id_card_print": "Print card",
      "id_card_print_hint": "Click \"Print card\" above to print at credit-card size.",
      "id_card_hide_photo": "Hide photo",
      "id_card_show_photo": "Show photo",
      "acct_image_remove": "Remove photo",
      "acct_image_remove_confirm": "Are you sure you want to remove your profile photo?",
      "acct_image_removed": "Profile photo removed ✓",
      "id_card_academic_year": "Academic year",
      "id_card_student_number": "Student ID",
      "id_card_teacher_number": "Employee ID",
      "id_card_position": "Position",
      "id_card_subjects": "Subjects",
      "id_card_class": "Class",
      "id_card_grade": "Grade",
      "id_card_specialization": "Specialty",
      "staff_confirm_deactivate": "Deactivate account {{name}}? They won't be able to log in anymore.",
      "staff_welcome": "Welcome {{name}} — admin staff account",
      "staff_dashboard_subtitle": "Your permissions decide what you can manage. Ask the school admin for more.",
      "staff_recent_activity": "Recent activity",
      "staff_no_activity": "No recent activity to show",
      "staff_activity_unknown": "Unknown activity",
      "staff_last_login": "Last sign-in",
      "staff_menu_title": "Menu",
      "close_menu": "Close menu",
      "staff_role_label": "Admin staff",
      "staff_no_permissions": "No permissions granted yet",
      "staff_denied": "You don't have permission for this action",
      "perm_manage_students": "Manage students",
      "perm_manage_teachers": "Manage teachers",
      "perm_manage_parents": "Manage parents",
      "perm_manage_finance": "Finance",
      "perm_manage_schedule": "Schedules",
      "perm_manage_attendance": "Attendance",
      "perm_manage_grades": "Grades & evaluations",
      "perm_manage_assignments": "Teacher assignments",
      "perm_view_reports": "Reports & analytics",
      "perm_send_announcements": "Announcements",
      "nav_settings": "Settings",
      "nav_my_schedule": "My Schedule",
      "nav_my_grades": "My Grades",
      "nav_my_assignments": "My Assignments",
      "nav_my_attendance": "My Attendance",
      "nav_my_fees": "My Fees",
      "nav_my_students": "My Students",
      "nav_my_parents": "Parent Contacts",
      "nav_manage_homework": "Manage Homework",
      "nav_change_photo": "Change Photo",
      "nav_change_password": "Change Password",

      // Dashboard stats
      "stat_total_students": "Total Students",
      "stat_total_teachers": "Total Teachers",
      "stat_present_today": "Present Today",
      "stat_absent_today": "Absent Today",
      "stat_avg_grade": "Average Grade",
      "stat_attendance_rate": "Attendance Rate",
      "stat_total_fees": "Total Fees",
      "stat_paid_fees": "Paid",
      "stat_pending_fees": "Remaining",
      "stat_assignments": "Assignments",
      "stat_warnings": "Warnings",

      // Table headers
      "th_name": "Name",
      "th_class": "Class",
      "th_status": "Status",
      "th_date": "Date",
      "th_subject": "Subject",
      "th_score": "Score",
      "th_actions": "Actions",
      "th_amount": "Amount",
      "th_phone": "Phone",
      "th_email": "Email",
      "th_type": "Type",
      "th_month": "Month",

      // Common
      "add_new": "Add New",
      "close": "Close",
      "confirm": "Confirm",
      "back": "Back",
      "refresh": "Refresh",
      "no_records": "No Records",
      "welcome": "Welcome,",
      "your_school": "Your School",
      "change_lang": "Change Language",
      "trial_expires": "Trial expires in",
      "days": "days",
      "upgrade_now": "Upgrade Now ↑",
      "today_schedule": "Today's Schedule",
      "no_classes_today": "No classes today",
      "recent_grades": "Recent Grades",
      "weekly_schedule": "Weekly Schedule",
      "no_schedule": "No classes",
      "my_subjects": "Subjects I Teach",
      "send_message": "Send Message",
      "message_placeholder": "Write your message here...",
      "sending": "Sending...",
      "message_sent": "Message sent successfully",

      // Attendance statuses
      "status_present": "Present ✓",
      "status_absent": "Absent ✗",
      "status_late": "Late",
      "status_excused": "Excused",
      "mark_all_present": "All Present",
      "mark_all_absent": "All Absent",
      "save_attendance": "Save Attendance",
      "select_class_first": "Select a class first",
      "no_students_in_class": "No students in this class",
      "select_class_to_show": "Select a class to show students",
      "total_label": "Total",

      // Homework
      "hw_title": "Homework",
      "hw_subtitle": "Track assignments and tasks",
      "hw_new": "New Assignment",
      "hw_title_ph": "Assignment title *",
      "hw_subject_ph": "Subject",
      "hw_desc_ph": "Assignment details...",
      "hw_filter_all": "All",
      "hw_filter_pending": "Pending",
      "hw_filter_overdue": "Overdue",
      "hw_due_today": "Today",
      "hw_days_left": "day(s)",
      "hw_overdue_label": "Overdue",
      "hw_add": "Add Assignment",
      "hw_saving": "Saving...",
      "hw_due_date": "Due Date",
      "hw_empty": "No assignments yet",

      // Fees
      "fee_total": "Total Fees",
      "fee_paid_label": "Paid",
      "fee_remaining": "Remaining",
      "fee_fully_paid": "Fully Paid",
      "fee_partial": "Partially Paid",
      "fee_unpaid": "Unpaid",
      "cfa_currency": "CFA Franc",

      // Profile
      "profile_photo": "Change Profile Photo",
      "choose_photo": "Choose Photo",
      "uploading": "Uploading...",
      "current_password": "Current Password",
      "new_password": "New Password",
      "confirm_password": "Confirm Password",

      // Login page — inline strings replaced by t() [M-1]
      "login_access_subtitle": "Sign in to access your dashboard",
      "login_too_many": "Too many login attempts. Please wait a minute.",
      "login_attempts_warning": "Warning: {{n}} attempts remaining before lockout",
      "secure_connection": "Secure and encrypted connection",

      // Password reset — inline strings replaced by t() [M-1]
      "reset_title": "Recover Password",
      "reset_step1": "Enter Username",
      "reset_step2": "Enter Reset Code",
      "reset_request": "Request Code",
      "reset_confirm": "Change Password",
      "reset_code_ph": "Temporary Code (6 digits)",
      "reset_info": "A temporary code will be generated. Contact your school admin to get it.",
      "reset_success_msg": "Password changed successfully!",
      "reset_back": "Back to Login",
      "reset_have_code": "Already have a code?",

      // Extra sidebar keys
      "nav_ratings": "Teacher Ratings",
      "nav_teacher_tasks": "Teacher Tasks",
      "nav_profile": "Profile",
      "nav_messages": "Messages",
      "nav_calendar": "Calendar",
      "nav_reset_codes": "Reset Codes",
      "nav_smart_rankings": "Smart Rankings",
      "nav_class_analytics": "Class Analytics",

      // PWA / Offline
      "skip": "Skip",
      "offline_banner": "Offline mode — data may be stale",
      "pwa_install_title": "Install EduGate",
      "pwa_install_subtitle": "Add it to your home screen and open it like any app — no app store needed!",
      "pwa_install_action": "Install",
      "pwa_install_browser_hint": "Use Chrome or Edge to install the app",
      "pwa_ios_title": "Install EduGate on iPhone",
      "pwa_ios_steps": "Tap the Share button, then choose \"Add to Home Screen\"",
      "pwa_ios_share": "Share",
      "pwa_ios_add": "Add",
      "pwa_update_available": "A new version is available",
      "pwa_update_action": "Reload",

      // Mobile / nav
      "menu": "Menu",
      "open_menu": "Open menu",

      // Excel import/export
      "excel_export_title": "Export data",
      "excel_import_title": "Import data",
      "excel_export_students": "Export students",
      "excel_export_teachers": "Export teachers",
      "excel_export_grades": "Export grades",
      "excel_export_attendance": "Export attendance",
      "excel_export_fees": "Export fees",
      "excel_download_template": "Download Excel template",
      "excel_help_toggle":        "Which columns are needed?",
      "excel_help_title":         "Import file format",
      "excel_help_intro":         "Put the column names in the first row exactly as shown below, then one row per person. Easiest route: download the template and fill it in.",
      "excel_help_col_header":    "Column name",
      "excel_help_col_required":  "Required?",
      "excel_help_col_format":    "Format",
      "excel_help_col_example":   "Example",
      "excel_help_required":      "Required",
      "excel_help_optional":      "Optional",
      "excel_help_note_headers":  "Optional columns may be left out entirely. Column order does not matter — only the names do.",
      "excel_help_note_dates":    "Date: write it as YYYY-MM-DD (e.g. 2010-05-15). A cell formatted as a date in Excel is also read correctly.",
      "excel_help_note_lists":    "Subjects and classes: separate them with a comma (e.g. Mathematics, Physics).",
      "excel_help_note_detect":   "The file type (students or teachers) is detected automatically from the column names and shown before import so you can check it.",
      "excel_help_note_duplicates": "Usernames must be unique. Duplicates are shown as a warning in the preview before anything is imported.",
      "excel_detected_kind":      "Detected file type",
      "excel_detected_kind_hint": "Check the type before confirming — records will be created in this section.",
      "excel_fmt_text":     "Text",
      "excel_fmt_username": "Latin letters and digits, no spaces",
      "excel_fmt_password": "At least 8 characters",
      "excel_fmt_class":    "Class name as stored in the system",
      "excel_fmt_date":     "YYYY-MM-DD",
      "excel_fmt_list":     "Comma-separated list",
      "excel_fmt_phone":    "Digits, may start with +",
      "excel_fmt_email":    "Valid e-mail address",
      "excel_upload": "Upload Excel file",
      "excel_importing": "Importing...",
      "excel_preview": "Preview before import",
      "excel_confirm_import": "Confirm import",
      "excel_cancel_import": "Cancel",
      "excel_empty_file": "File is empty or improperly formatted",
      "excel_file_too_large": "The file is too large (maximum {{max}} MB). Split it into smaller files.",
      "excel_read_error": "Error reading file",
      "excel_row_incomplete": "Incomplete row",
      "excel_duplicate_warning": "Already exists",
      "excel_field_too_long": "Field \"{{field}}\" is too long ({{length}} of {{max}} characters)",
      "excel_password_too_short": "Password must be at least {{min}} characters",
      "excel_password_too_long": "Password must be at most {{max}} characters",
      "excel_invalid_email": "Invalid email address: {{value}}",
      "excel_too_many_items": "Too many entries in \"{{field}}\" ({{count}} of {{max}})",
      "excel_rate_limited": "Rate limit reached — wait a minute and try again",
      "excel_no_server_result": "The server returned no result for this row",
      "excel_created_count": "Created",
      "excel_skipped_count": "Skipped",
      "excel_reason": "Reason",
      "excel_sheet_template": "Template",
      "excel_sheet_failed": "Failed rows",
      "excel_download_failed_rows": "Download failed rows",
      "excel_importing_progress": "Importing… {{done}} of {{total}}",
      "excel_teacher_pacing_note": "Teachers are imported one row at a time to stay under the request limit; this will take about {{seconds}} seconds. Do not close the page.",
      "excel_success_count": "Succeeded",
      "excel_failed_count": "Failed",
      "excel_more_errors": "more errors",
      "excel_school_name_header": "School",
      "excel_export_date": "Export date",
      "excel_col_index": "#",
      "excel_col_student_number": "Student number",
      "excel_col_teacher_number": "Teacher number",
      "excel_col_full_name": "Full name",
      "excel_col_username": "Username",
      "excel_col_class": "Class",
      "excel_col_grade_level": "Grade level",
      "excel_col_dob": "Date of birth",
      "excel_col_status": "Status",
      "excel_col_subjects": "Subjects",
      "excel_col_classes": "Classes",
      "excel_col_specialization": "Specialization",
      "excel_col_student_name": "Student name",
      "excel_col_subject": "Subject",
      "excel_col_assessment_type": "Assessment type",
      "excel_col_assessment_name": "Assessment name",
      "excel_col_score": "Score",
      "excel_col_max_score": "Max score",
      "excel_col_percent": "Percentage",
      "excel_col_academic_year": "Academic year",
      "excel_col_date": "Date",
      "excel_col_attendance_status": "Status",
      "excel_col_notes": "Notes",
      "excel_col_amount": "Amount",
      "excel_col_paid": "Paid",
      "excel_col_remaining": "Remaining",
      "excel_col_fee_type": "Fee type",

      // Dark mode
      "switch_to_dark": "Switch to dark mode",
      "switch_to_light": "Switch to light mode",

      // Super-admin platform overview
      "sa_tab_platform":      "Platform",
      "sa_tab_schools":       "Schools",
      "sa_tab_subscriptions": "Subscriptions",
      "sa_tab_messages":      "Messages",
      "sa_tab_system":        "System status",
      "sa_tab_reset_codes":   "Reset codes",
      "ay_current_year":      "Current year",
      "ay_archived_label":    "archived",
      "sa_tab_settings":      "Platform settings",
      "sa_tab_account":       "My account",
      "sa_stat_total_schools":  "Total schools",
      "sa_stat_total_students": "Total students",
      "sa_stat_total_teachers": "Total teachers",
      "sa_stat_revenue_mtd":    "Revenue this month",
      "sa_active":              "active",
      "sa_trial":               "trial",
      "sa_expired":             "expired",
      "sa_suspended":           "suspended",
      "sa_alerts_title":          "Alerts",
      "sa_alert_expiring_7":      "expiring in 7 days",
      "sa_alert_expiring_30":     "expiring in 30 days",
      "sa_alert_new_mtd":         "new school(s) this month",
      "sa_no_alerts":             "No active alerts.",
      "sa_search_school":         "Search a school...",
      "sa_all_plans":             "All plans",
      "sa_plan_free": "Free",
      "sa_plan_basic": "Basic",
      "sa_plan_pro": "Pro",
      "sa_plan_enterprise": "Enterprise",
      "sa_all_status":            "All statuses",
      "sa_status_active":    "Active",
      "sa_status_trial":     "Trial",
      "sa_status_expired":   "Expired",
      "sa_status_suspended": "Suspended",
      "sa_status_cancelled": "Cancelled",
      "sa_col_name":      "School",
      "sa_col_plan":      "Plan",
      "sa_col_status":    "Status",
      "sa_col_students":  "Students",
      "sa_col_teachers":  "Teachers",
      "sa_col_end_date":  "Subscription end",
      "sa_col_revenue":   "Amount",
      "sa_col_actions":   "Actions",
      "sa_no_schools":    "No matching schools",

      // Platform settings
      "ps_title":                  "Platform settings",
      "ps_general":                "General",
      "ps_subscriptions":          "Subscriptions & reminders",
      "ps_welcome_email":          "Welcome email",
      "ps_platform_name":          "Platform name",
      "ps_contact_email":          "Contact email",
      "ps_support_whatsapp":       "Support WhatsApp",
      "ps_default_currency":       "Default currency for new schools",
      "ps_maintenance_mode":       "Enable maintenance mode",
      "ps_maintenance_active":     "Maintenance mode is active — banner shown on school dashboards.",
      "ps_trial_days":             "Trial duration (days)",
      "ps_trial_reminder_days":    "Trial-expiry reminder (days before)",
      "ps_payment_reminder_days":  "Payment reminder (days before due)",
      "ps_welcome_subject":        "Subject",
      "ps_welcome_body":           "Body",
      "ps_save":                   "Save settings",
      "ps_saved":                  "Settings saved",
      "ps_save_failed":            "Save failed",
      "ps_load_failed":            "Could not load settings",

      // Invoice
      "invoice_number_label":      "Invoice no.",
      "print_invoice":             "Print invoice",
      "invoice_subtitle":          "School management platform",
      "invoice_official":          "Official invoice",
      "invoice_billed_to":         "Billed to",
      "invoice_issued_at":         "Issue date",
      "invoice_due_date":          "Due date",
      "invoice_item_description":  "Service",
      "invoice_item_qty":          "Qty",
      "invoice_item_unit":         "Unit price",
      "invoice_item_total":        "Total",
      "invoice_subtotal":          "Subtotal",
      "invoice_tax":               "Tax",
      "invoice_total":             "Total",
      "invoice_payment_methods":   "Payment methods",
      "invoice_payment_instructions": "Bank transfer · Mobile money · Cash on delivery",
      "invoice_thank_you":         "Thank you for choosing EduGate",
      "invoice_status_label":      "Status",
      "invoice_print_hint":        "A4 portrait, single page",
      "invoice_load_failed":       "Could not load invoice",

      // ── Actions ─────────────────────────────────────────────────────
      "action_save":     "Save",          "action_cancel":   "Cancel",
      "action_edit":     "Edit",          "action_delete":   "Delete",
      "action_add":      "Add",           "action_create":   "Create",
      "action_update":   "Update",        "action_search":   "Search",
      "action_confirm":  "Confirm",       "action_print":    "Print",
      "action_export":   "Export",        "action_download": "Download",
      "action_upload":   "Upload",        "action_close":    "Close",
      "action_view":     "View",          "action_refresh":  "Refresh",
      "action_submit":   "Submit",        "action_send":     "Send",
      "action_reset":    "Reset",         "action_back":     "Back",
      "action_next":     "Next",          "action_previous": "Previous",
      "action_yes":      "Yes",           "action_no":       "No",
      "action_ok":       "OK",            "action_select":   "Select",
      "action_choose":   "Choose",        "action_open":     "Open",
      "action_copy":     "Copy",          "action_share":    "Share",
      "action_apply":    "Apply",         "action_clear":    "Clear",

      // ── Status ──────────────────────────────────────────────────────
      "status_active":   "Active",        "status_inactive": "Inactive",
      "status_suspended":"Suspended",     "status_expired":  "Expired",
      "status_trial":    "Trial",         "status_paid":     "Paid",
      "status_unpaid":   "Unpaid",        "status_pending":  "Pending",
      "status_approved": "Approved",      "status_rejected": "Rejected",
      "status_reviewed": "Reviewed",      "status_completed":"Completed",
      "status_in_progress":"In progress",
      "status_overdue":  "Overdue",
      "status_draft":    "Draft",         "status_sent":     "Sent",
      "status_cancelled":"Cancelled",     "status_submitted":"Submitted",
      "status_graded":   "Graded",        "status_not_submitted":"Not submitted",

      // ── Educational ─────────────────────────────────────────────────
      "term_student":    "Student",       "term_students":   "Students",
      "term_teacher":    "Teacher",       "term_teachers":   "Teachers",
      "term_parent":     "Parent",        "term_parents":    "Parents",
      "term_admin":      "Administrator", "term_staff":      "Staff",
      "term_class":      "Class",         "term_classes":    "Classes",
      "term_grade":      "Grade",         "term_subject":    "Subject",
      "term_subjects":   "Subjects",      "term_score":      "Score",
      "term_attendance": "Attendance",    "term_absence":    "Absence",
      "term_homework":   "Homework",      "term_assignment": "Assignment",
      "term_assignments":"Assignments",   "term_schedule":   "Schedule",
      "term_rating":     "Rating",        "term_ratings":    "Ratings",
      "term_task":       "Task",          "term_tasks":      "Tasks",
      "term_announcement":"Announcement", "term_announcements":"Announcements",
      "term_message":    "Message",       "term_messages":   "Messages",
      "term_school":     "School",        "term_schools":    "Schools",
      "term_date":       "Date",          "term_time":       "Time",
      "term_due_date":   "Due date",      "term_priority":   "Priority",
      "term_description":"Description",   "term_notes":      "Notes",
      "term_title":      "Title",         "term_name":       "Name",
      "term_full_name":  "Full name",     "term_phone":      "Phone",
      "term_email":      "Email",         "term_address":    "Address",
      "term_gender":     "Gender",        "term_birth_date": "Date of birth",

      // ── Finance ─────────────────────────────────────────────────────
      "finance_fees":    "Fees",          "finance_fee":     "Fee",
      "finance_salary":  "Salary",        "finance_salaries":"Salaries",
      "finance_expense": "Expense",       "finance_expenses":"Expenses",
      "finance_invoice": "Invoice",       "finance_invoices":"Invoices",
      "finance_receipt": "Receipt",       "finance_payslip": "Payslip",
      "finance_subscription":"Subscription","finance_payment":"Payment",
      "finance_payments":"Payments",      "finance_amount":  "Amount",
      "finance_total":   "Total",         "finance_subtotal":"Subtotal",
      "finance_tax":     "Tax",           "finance_currency":"Currency",
      "finance_paid_amount":"Paid amount","finance_due_amount":"Due amount",
      "finance_discount":"Discount",

      // ── Messages / Toasts ───────────────────────────────────────────
      "msg_saved":       "Saved successfully",
      "msg_deleted":     "Deleted successfully",
      "msg_updated":     "Updated successfully",
      "msg_created":     "Created successfully",
      "msg_save_error":  "Save error",
      "msg_delete_error":"Delete error",
      "msg_load_error":  "Load error",
      "msg_generic_error":"An error occurred",
      "msg_fill_required":"Please fill all required fields",
      "msg_confirm_delete":"Confirm deletion?",
      "msg_confirm_action":"Are you sure?",
      "msg_no_data":     "No data",
      "msg_loading":     "Loading...",
      "msg_success":     "Success",
      "msg_failed":      "Operation failed",
      "msg_unauthorized":"Unauthorized",
      "msg_not_found":   "Not found",
      "msg_network_error":"Network error",
      "msg_session_expired":"Session expired",
      "msg_permission_denied":"Permission denied",

      // ── Form & UI labels ────────────────────────────────────────────
      "label_required":  "Required",      "label_optional":  "Optional",
      "label_search_placeholder":"Search...",
      "label_select_option":"Select...",
      "label_no_results":"No results",    "label_show_more": "Show more",
      "label_show_less": "Show less",     "label_page":      "Page",
      "label_of":        "of",             "label_total":     "Total",
      "label_count":     "Count",          "label_filters":   "Filters",
      "label_filter_by": "Filter by",      "label_sort_by":   "Sort by",
      "label_all":       "All",            "label_none":      "None",
      "label_today":     "Today",          "label_yesterday": "Yesterday",
      "label_this_week": "This week",      "label_this_month":"This month",
      "label_last_30_days":"Last 30 days",
      "label_actions":   "Actions",        "label_details":   "Details",
      "label_summary":   "Summary",        "label_overview":  "Overview",
      "label_settings":  "Settings",       "label_profile":   "Profile",
      "label_logout":    "Logout",         "label_login":     "Login",
      "label_dashboard": "Dashboard",      "label_reports":   "Reports",
      "label_notifications":"Notifications",

      // ── Days ────────────────────────────────────────────────────────
      "day_monday":    "Monday",    "day_tuesday":  "Tuesday",
      "day_wednesday": "Wednesday", "day_thursday": "Thursday",
      "day_friday":    "Friday",    "day_saturday": "Saturday",
      "day_sunday":    "Sunday",

      // ── Dialog headings ─────────────────────────────────────────────
      "dialog_add_title":   "Add",
      "dialog_edit_title":  "Edit",
      "dialog_delete_title":"Confirm deletion",
      "dialog_view_title":  "Details",

      // ── Component-specific keys ─────────────────────────────────────
      "nav_activity_log":   "Activity log",
      "td_choose_class":        "Select class",
      "td_message_placeholder": "Write your message here... Example: I noticed your child needs extra support in mathematics...",
      "td_sending":             "Sending...",
      "sd_unknown_sender":      "Unknown sender",
      "sd_school_admin":        "School administration",
      "pd_link_success":        "Child {{name}} linked successfully!",
      "pd_link_error":          "Error: please verify the student number",
      "pd_total_children":      "Total children",
      "pd_avg_attendance":      "Average attendance",
      "pd_avg_grades":          "Average grade",
      "pd_total_unpaid_fees":   "Total unpaid fees",
      "fin_tab_student_fees":   "Student fees",
      "fin_tab_teacher_salaries":"Teacher salaries",
      "fin_search_student":     "Search a student...",
      "fin_search_teacher":     "Search a teacher...",
      "fin_issue_receipt":      "Issue receipt",
      "fin_issue_payslip":      "Issue payslip",
      "pd_nav_overview":    "Overview",
      "pd_nav_child_summary":"Child summary",
      "lbl_grades":         "Grades",
      "sd_submit_homework": "Submit homework",
      "ttp_empty":          "No administrative tasks yet.",
      "ttp_submit_task":    "Submit task",
      "ttp_submitted_at":   "Submitted on",
      "ttp_admin_feedback": "Administration feedback",
      "nav_my_tasks":       "My administrative tasks",

      // SchoolAdmin views (Students / Teachers / Parents / Dashboard)
      "sav_student_added":          "Student added successfully! - Student number: {{number}}",
      "sav_add_student_desc":       "Enter the new student's information",
      "sav_student_number":         "Student number",
      "sav_validation_error":       "Validation error:\n{{errors}}",
      "sav_grade_placeholder":      "Example: 9th grade",
      "sav_confirm_delete_student": "Are you sure you want to delete this student?",
      "sav_teacher_added":          "Teacher added successfully! - Teacher number: {{number}}",
      "sav_add_teacher_desc":       "Enter the new teacher's information",
      "sav_academic_level":         "Academic level",
      "sav_choose_academic_level":  "Choose academic level...",
      "sav_marital_status":         "Marital status",
      "sav_choose_marital_status":  "Choose marital status...",
      "sav_multi_select_hint":      "(multiple selections allowed)",
      "sav_multi_select_classes_hint":"(multiple selections allowed)",
      "sav_classes_label":          "Classes",
      "sav_add_custom_subject":     "Add a subject not in the list...",
      "sav_serial_number":          "Serial number",
      "sav_confirm_delete_teacher": "Are you sure you want to delete this teacher?",
      "sav_parent_updated":         "Parent updated successfully!",
      "sav_parent_added":           "Parent added successfully!",
      "sav_add_error":              "Error while adding",
      "sav_search_parent":          "Search a parent...",
      "sav_add_parent":             "Add parent",
      "sav_edit_parent":            "Edit parent",
      "sav_add_parent_desc":        "Enter the new parent's information",
      "sav_edit_parent_desc":       "Update the parent and link or edit their children",
      "sav_password_unchanged":     "Leave empty to keep unchanged",
      "sav_link_children":          "Link children (select students)",
      "sav_currently_linked":       "Currently linked:",
      "sav_no_number":              "No number",
      "sav_name":                   "Name",
      "sav_children":               "Children",
      "sav_phone":                  "Phone",
      "sav_children_count":         "{{count}} children",
      "sav_confirm_delete_parent":  "Are you sure you want to delete this parent?",
      "sav_time_now":               "just now",
      "sav_time_min_ago":           "{{count}}m ago",
      "sav_time_hour_ago":          "{{count}}h ago",
      "edu_bachelor":   "Bachelor's",
      "edu_master":     "Master's",
      "edu_phd":        "PhD",
      "edu_diploma":    "Diploma",
      "edu_other":      "Other",

      // Batch 2 admin tools (EN)
      "rcp_title":       "Password Reset Requests",
      "rcp_subtitle":    "Share this code with the user who requested the reset",
      "rcp_empty":       "No pending reset requests",
      "rcp_expires":     "Expires",
      "rcp_copy":        "Copy code",
      "rcp_copied":      "Copied!",
      "rcp_refresh":     "Refresh",
      "rcp_user":        "User",
      "rcp_code":        "Temporary code",
      "rcp_instruction": "Share this code with the user. They should go to Login → Forgot Password → Enter Code.",

      "alv_cat_all":         "All",
      "alv_cat_attendance":  "Attendance",
      "alv_cat_grades":      "Grades",
      "alv_cat_finance":     "Finance",
      "alv_cat_users":       "Users",
      "alv_cat_messages":    "Messages",
      "alv_cat_settings":    "Settings",
      "alv_cat_submissions": "Submissions",
      "alv_cat_auth":        "Authentication",
      "alv_load_error":      "Failed to load activity log",
      "alv_export_error":    "Export failed",
      "alv_verify_ok":       "Entry valid — hash matches",
      "alv_verify_fail":     "Warning: hash mismatch — entry may have been modified",
      "alv_verify_error":    "Verification failed",
      "alv_today_events":    "Today's events",
      "alv_last_7_days":     "Last 7 days",
      "alv_most_active":     "Most active",
      "alv_last_event":      "Last event",
      "alv_from_date":       "From date",
      "alv_to_date":         "To date",
      "alv_actor":           "Actor",
      "alv_search":          "Search",
      "alv_search_placeholder":"name, action, description...",
      "alv_total_summary":   "Total {{total}} events — showing {{from}}-{{to}}",
      "alv_no_events":       "0 events",
      "alv_export_csv":      "Export CSV",
      "alv_no_events_filter":"No events for current filters.",
      "alv_th_time":         "Time",
      "alv_th_action":       "Action",
      "alv_th_entity":       "Entity",
      "alv_th_description":  "Description",
      "alv_th_details":      "Details",
      "alv_dt_category":     "Category:",
      "alv_dt_before":       "Before:",
      "alv_dt_after":        "After:",
      "alv_dt_hash": "Hash:",
      "alv_verify":          "Verify",
      "alv_prev":            "Previous",
      "alv_next":            "Next",
      "alv_page":            "Page {{num}}",

      "rm_load_error":       "Failed to load ratings",
      "rm_added":            "Rating added successfully",
      "rm_cat_teaching":      "Teaching",
      "rm_cat_discipline":    "Discipline",
      "rm_cat_cooperation":   "Cooperation",
      "rm_cat_commitment":    "Commitment",
      "rm_cat_creativity":    "Creativity",
      "rm_cat_academic":      "Academic performance",
      "rm_cat_behavior":      "Behavior",
      "rm_cat_participation": "Participation",
      "rm_cat_homework":      "Homework",
      "rm_cat_attendance":    "Attendance",
      "rm_rating_excellent": "Excellent",
      "rm_rating_very_good": "Very good",
      "rm_rating_good":      "Good",
      "rm_rating_fair":      "Fair",
      "rm_rating_weak":      "Weak",
      "rm_title_teachers":   "Teacher ratings",
      "rm_title_students":   "Student ratings",
      "rm_search_name":      "Search by name...",
      "rm_add_rating":       "Add rating",
      "rm_new_rating":       "New rating",
      "rm_choose_teacher":   "Choose teacher",
      "rm_choose_student":   "Choose student",
      "rm_choose":           "Choose...",
      "rm_category":         "Category",
      "rm_choose_category":  "Choose category",
      "rm_notes":            "Notes",
      "rm_notes_placeholder":"Add your notes here...",
      "rm_save_rating":      "Save rating",
      "rm_overall_avg":      "Overall average",
      "rm_ratings_count":    "Ratings count",
      "rm_rated_persons":    "Rated persons",
      "rm_ratings_count_label":"Ratings count:",
      "rm_no_ratings_yet":   "No ratings yet",
      "rm_view_history":     "View full history ({{count}})",
      "rm_full_history":     "Full ratings history",
      "rm_rater":            "Rater:",
      "rm_date":             "Date:",
      "rm_no_data":          "No data to rate",

      "smc_updated":         "Schedule updated successfully",
      "smc_added":           "Schedule added successfully",
      "smc_confirm_delete":  "Are you sure you want to delete this schedule?",
      "smc_deleted":         "Schedule deleted successfully!",
      "smc_unspecified":     "Unspecified",
      "smc_conflict_confirm":"Warning: this schedule has {{count}} conflict(s)! Save anyway?",
      "smc_conflict_teacher_two":"Teacher {{name}} has two classes at the same time",
      "smc_conflict_class_two":  "Class {{name}} has two periods at the same time",
      "smc_teacher_busy":    "Teacher {{name}} is busy in {{cls}} - {{subject}}",
      "smc_time_used_twice": "The same time {{time}} is used in two periods",
      "smc_pick_class":      "Pick a class to view its weekly schedule",
      "smc_conflicts_in":    "Conflicts in {{cls}} ({{count}})",
      "smc_class_weekly":    "Weekly schedule for {{cls}}",
      "smc_print":           "Print",
      "smc_room":            "Room {{num}}",
      "smc_conflict":        "Conflict",
      "smc_title":           "Class schedules",
      "dir_title": "School directory",
      // [CLASSES-PORTAL 2026-10]
      "nav_classes": "Classes",
      "nav_subjects": "Subjects",
      "cp_title": "Classes",
      "cp_subtitle": "Every class of the school: its students, teachers, subjects and timetable",
      "cp_search": "Search a class...",
      "cp_classes_count": "{{count}} classes",
      "cp_students_total": "{{count}} students",
      "cp_students": "Students",
      "cp_teachers": "Teachers",
      "cp_subjects": "Subjects",
      "cp_periods_week": "periods a week",
      "cp_no_timetable": "No timetable",
      "cp_tab_students": "Students",
      "cp_tab_subjects": "Subjects and teachers",
      "cp_tab_timetable": "Timetable",
      "cp_col_number": "No.",
      "cp_col_name": "Name",
      "cp_col_subject": "Subject",
      "cp_col_teacher": "Teacher",
      "cp_col_periods": "Periods / week",
      "cp_col_planned": "Planned in curriculum",
      "cp_no_students": "No students in this class",
      "cp_no_subjects": "No subjects for this class yet",
      "cp_no_timetable_long": "This class's timetable has not been built yet",
      "cp_assigned_teachers": "Teachers assigned to the class",
      "cp_not_scheduled": "not in the timetable yet",
      "cp_load_error": "Could not load the classes",
      "cp_archived_note": "Archived year: students in their class of that year, teachers from its timetable",
      "cp_empty": "No classes yet",
      "sp_title": "Subjects",
      "sp_subtitle": "The school's subjects: who teaches them, in which class, and their periods",
      "sp_search": "Search a subject...",
      "sp_custom": "School's own",
      "sp_classes": "Classes",
      "sp_tab_overview": "Teachers and classes",
      "sp_tab_slots": "Its periods",
      "sp_col_day": "Day",
      "sp_col_period": "Period",
      "sp_col_time": "Time",
      "sp_col_class": "Class",
      "sp_col_room": "Room",
      "sp_no_slots": "This subject has no periods in the timetable",
      "sp_on_record_only": "on record, not in the timetable",
      "sp_no_teachers": "No teachers for this subject",
      "sp_empty": "No subjects yet",
      "sp_load_error": "Could not load the subjects",
      "cp_add_class": "Add a class",
      "cp_new_class": "New class",
      "cp_new_class_hint": "Pick a name from the list or type a free name, then describe the class if you wish.",
      "cp_from_list": "From the list",
      "cp_free_name": "Free name",
      "cp_free_name_ph": "e.g. Grade 1 - Boys",
      "cp_class_name": "Class name",
      "cp_choose_class": "Choose the class",
      "cp_grade_level": "Grade level",
      "cp_no_grade": "No grade level",
      "cp_label": "Class type",
      "cp_gender_none": "Not set",
      "cp_gender_boys": "Boys",
      "cp_gender_girls": "Girls",
      "cp_gender_mixed": "Mixed",
      "cp_filter_all": "All",
      "cp_create": "Create",
      "cp_created": "Class created",
      "cp_saved": "Saved",
      "cp_save_error": "Could not save",
      "cp_delete_class": "Delete class",
      "cp_delete_confirm": "Delete class “{{name}}”?",
      "cp_deleted": "Class deleted",
      "cp_boys_girls": "Boys {{boys}} · Girls {{girls}}",
      "cp_col_gender": "Gender",
      "cp_gender_clash": "Does not match the class type",
      "cp_col_assigned": "Assigned teacher",
      "cp_col_scheduled": "In the timetable",
      "cp_no_teacher": "No teacher",
      "cp_has_subject": "teaches it",
      "cp_add_subject": "Add a subject to the class",
      "cp_choose_subject": "Choose the subject",
      "cp_add": "Add",
      "cp_remove": "Remove",
      "cp_assigned_saved": "Subject assigned",
      "cp_subject_removed": "Subject removed from the class",
      "cp_name_required": "Type the class name",
      "cp_rename": "Rename",
      "cp_new_name": "New class name",
      "cp_renamed": "Class renamed",
      "cp_rename_hint": "The name changes for the students, the timetable, grades, attendance, fees, homework and exams of this year. Archived years and issued transcripts keep the old name.",
      "sp_add_subject": "Add subject",
      "sp_new_subject_ph": "New subject name",
      "sp_added": "Subject added",
      "sp_delete": "Delete subject",
      "sp_delete_confirm": "Remove subject “{{subject}}” from the school's list?",
      "sp_deleted": "Subject deleted",
      "gender_unset": "Not set",
      "sav_gender_clash": "Note: this class is labelled “{{label}}”. You can save, but check the choice.",
      "dir_subtitle": "Ask the timetable and the classes: who teaches a subject, to which classes and when; the teacher assigned to each subject; what is on during a period of a day; each class's students (boys and girls) and its subjects with no teacher.",
      "dir_all_labels": "All types",
      "dir_classes_title": "Classes",
      "dir_classes_count": "{{count}} classes",
      "dir_col_boys_girls": "Boys / Girls",
      "dir_col_open_subjects": "Subjects with no teacher",
      "dir_not_timetabled": "not in the timetable yet",
      "dir_assigned_differs": "The assigned teacher is not the timetable's",
      "dir_tab_search": "Search",
      "dir_tab_cover": "Substitute",
      "dir_tab_load": "Teacher load",
      "dir_tab_gaps": "To follow up",
      "dir_cover_mode_slot": "A given lesson",
      "dir_cover_mode_absent": "An absent teacher",
      "dir_choose_day": "Choose the day",
      "dir_choose_period": "Choose the period",
      "dir_any_subject": "Any subject",
      "dir_any_class": "Any class",
      "dir_choose_teacher": "Choose the absent teacher",
      "dir_cover_hint": "Choose the day and period to see the free teachers. The subject and class rank the best fit first.",
      "dir_cover_hint_absent": "Choose the day and the absent teacher to see their lessons and who can cover each.",
      "dir_cover_free": "Free: {{count}}",
      "dir_cover_busy": "Busy at this period: {{count}}",
      "dir_teaches_subject": "Teaches the subject",
      "dir_teaches_class": "Teaches this class",
      "dir_not_in_today": "No lessons that day",
      "dir_periods_today": "Lessons today: {{n}}",
      "dir_periods_week": "Per week: {{n}}",
      "dir_no_free": "No teacher is free at this period",
      "dir_no_lessons": "This teacher has no lessons that day",
      "dir_show_all": "Show all ({{count}})",
      "dir_show_less": "Show less",
      "dir_load_teachers": "Teachers",
      "dir_load_total": "Total periods",
      "dir_load_average": "Average per teacher",
      "dir_load_heavy": "Heaviest first",
      "dir_load_light": "Lightest first",
      "dir_load_inactive": "left",
      "dir_col_periods_week": "Periods a week",
      "dir_col_classes": "Classes",
      "dir_col_subjects": "Subjects",
      "dir_col_not_timetabled": "Assigned, not timetabled",
      "dir_col_issue": "Issue",
      "dir_col_detail": "Detail",
      "dir_filter_all_gaps": "All ({{count}})",
      "dir_gaps_none": "Nothing to follow up: every subject has a teacher and every class a timetable.",
      "dir_gaps_note": "From the classes of the chosen year. Assignments show in the active year only.",
      "dir_gap_no_teacher": "Subject with no teacher",
      "dir_gap_teacher_mismatch": "Assigned ≠ timetable",
      "dir_gap_no_timetable": "Class with no timetable",
      "dir_gap_periods_short": "Fewer periods than planned",
      "dir_gap_periods_over": "More periods than planned",
      "dir_gap_not_timetabled": "Assigned, not timetabled",
      "dir_gap_assigned": "Assigned: {{name}}",
      "dir_gap_scheduled": "Timetable: {{names}}",
      "dir_gap_planned": "Planned {{planned}} · timetable {{actual}}",
      "dir_search_placeholder": "Search a teacher, subject or class",
      "dir_all_subjects": "All subjects",
      "dir_all_teachers": "All teachers",
      "dir_all_classes": "All classes",
      "dir_all_days": "All days",
      "dir_all_periods": "All periods",
      "dir_clear": "Clear",
      "dir_slots_title": "Timetable slots",
      "dir_slots_count": "{{count}} periods",
      "dir_weekly_title": "Periods per week by subject and class",
      "dir_weekly_note": "Counted over the whole week; picking a day or period does not change it.",
      "dir_subject_total": "{{count}} periods a week in total",
      "dir_col_day": "Day",
      "dir_col_period": "Period",
      "dir_col_class": "Class",
      "dir_col_subject": "Subject",
      "dir_col_teacher": "Teacher",
      "dir_col_room": "Room",
      "dir_col_per_week": "Periods / week",
      "dir_period_n": "Period {{n}}",
      "dir_no_results": "No matching periods in the timetable.",
      "dir_truncated": "Too many results: only part is shown. Narrow the search.",
      "dir_load_error": "Could not load the school directory",
      "smc_subtitle":        "Comprehensive schedule management | Period = 1 hour",
      "smc_conflicts_count": "{{count}} conflict(s)",
      "smc_no_conflicts":    "No conflicts",
      "smc_view_list":       "List",
      "smc_view_weekly":     "Weekly",
      "smc_add_schedule":    "Add schedule",
      "smc_conflicts_found": "Conflicts detected ({{count}})",
      "smc_teacher_conflict":"Teacher conflict",
      "smc_class_conflict":  "Class conflict",
      "smc_class_count":     "Classes count",
      "smc_total_schedules": "Total schedules",
      "smc_teachers_count":  "Teachers count",
      "smc_week_days":       "Week days",
      "smc_filter_class":    "Filter by class:",
      "smc_all_classes":     "All classes",
      "smc_clear_filter":    "Clear filter",
      "smc_print_schedule":  "Print schedule for {{cls}}",
      "smc_on_day":          "Day {{day}}",
      "smc_no_schedules":    "No schedules registered",
      "smc_schedule_singular":"schedule",
      "smc_day":             "Day",
      "smc_choose_day":      "Choose day",
      "smc_form_warn":       "Warning: {{count}} conflict(s)!",
      "smc_period_n":        "• Period {{n}}",
      "smc_periods_header":  "Periods (each period = 1 hour)",
      "smc_add_period":      "Add period",
      "smc_period_num":      "Period {{n}}",
      "smc_time_full_hour":  "Time (full hour)",
      "smc_choose_time":     "Choose time",
      "smc_subject":         "Subject",
      "smc_choose_subject":  "Choose subject",
      "smc_teacher_label":   "Teacher",
      "smc_choose_teacher":  "Choose teacher",
      "smc_room_number":     "Room number",
      "smc_room_placeholder":"e.g. 101",
      "smc_no_periods_yet":  "No periods added yet",
      "smc_save_with_conflict":"Save despite conflict ({{count}})",
      "smc_save_schedule":   "Save schedule",

      // LandingPage
      "lp_nav_features":      "Features",
      "lp_nav_roles":         "Roles",
      "lp_nav_pricing":       "Pricing",
      "lp_nav_faq":           "FAQ",
      "lp_nav_login":         "Login",
      "lp_nav_start_free":    "Start free",
      "lp_lang_switch_title": "Change language",
      "lp_mobile_start_free_90": "Start free — 90 days",
      "lp_hero_badge":        "The leading school-management platform in the region",
      "lp_hero_title_1":      "Run your school",
      "lp_hero_title_2":      "simply and smartly",
      "lp_hero_subtitle":     "EduGate brings everything your school needs — students, teachers, grades, attendance, fees and communication — into one place, from any device.",
      "lp_hero_cta_trial":    "Free trial — 90 days",
      "lp_hero_cta_login":    "I have an account — Login",
      "lp_hero_check_1":      "90 days completely free",
      "lp_hero_check_2":      "No credit card required",
      "lp_hero_check_3":      "Cancel anytime",
      "lp_stat_schools":      "Schools trust us",
      "lp_stat_students":     "Students managed",
      "lp_stat_uptime":       "Uptime",
      "lp_stat_trial":        "Free trial",
      "lp_stat_days_suffix":  "days",
      "lp_section_features_eyebrow":  "FEATURES",
      "lp_section_features_title":    "Everything you need in one platform",
      "lp_section_features_subtitle": "EduGate is built to meet the needs of modern schools of every size.",
      "lp_section_roles_eyebrow":     "WHO IS IT FOR?",
      "lp_section_roles_title":       "A platform for the whole school community",
      "lp_section_roles_subtitle":    "Every member of the school has their own dashboard, designed for their needs.",
      "lp_feat_users_title":    "Student & teacher management",
      "lp_feat_users_desc":     "Complete records, detailed profiles, and automatic links between student, parent and teacher.",
      "lp_feat_reports_title":  "Monthly & annual reports",
      "lp_feat_reports_desc":   "Print-ready PDF reports: grades, attendance, finance, per-class performance statistics.",
      "lp_feat_schedule_title": "Schedules & calendar",
      "lp_feat_schedule_desc":  "Auto-build schedules with conflict detection, plus a full school calendar of events.",
      "lp_feat_comm_title":     "Direct communication",
      "lp_feat_comm_desc":      "Instant messaging between all parties — teachers, students and parents.",
      "lp_feat_attend_title":   "Smart attendance",
      "lp_feat_attend_desc":    "Daily attendance with instant parent alerts on absence.",
      "lp_feat_finance_title":  "Financial system",
      "lp_feat_finance_desc":   "Manage fees and payments with detailed monthly and annual financial reports.",
      "lp_feat_export_title":   "PDF & Excel export",
      "lp_feat_export_desc":    "Export student lists, grades and reports as PDF and Excel in a single click.",
      "lp_feat_pwa_title":      "PWA mobile app",
      "lp_feat_pwa_desc":       "Install the app on your phone directly — works offline and pushes notifications.",
      "lp_feat_notif_title":    "Instant notifications",
      "lp_feat_notif_desc":     "Never miss a thing — notifications for grades, absences, messages and events.",
      "lp_role_super_title":    "Super Admin",
      "lp_role_super_desc":     "Oversees the entire system — manages subscribed schools and tracks subscriptions and global statistics.",
      "lp_role_super_features": ["Manage all schools", "Track subscriptions and trials", "System-wide statistics", "Message school directors"],
      "lp_role_admin_title":    "School Director",
      "lp_role_admin_desc":     "Runs their school end-to-end — students, teachers, finances and monthly/annual reports.",
      "lp_role_admin_features": ["Manage students and teachers", "Detailed monthly and annual reports", "Manage fees and payments", "School calendar and announcements"],
      "lp_role_teacher_title":  "Teacher",
      "lp_role_teacher_desc":   "Focuses on teaching — enters grades and attendance and communicates directly with parents.",
      "lp_role_teacher_features":["Enter grades and assessments", "Daily attendance", "Message parents", "Their weekly schedule"],
      "lp_role_student_title":  "Student",
      "lp_role_student_desc":   "Follows their studies easily — sees grades and schedule and chats with teachers from any device.",
      "lp_role_student_features":["View grades and assessments", "Weekly schedule", "Personal attendance history", "Receive teacher notifications"],
      "lp_role_parent_title":   "Parent",
      "lp_role_parent_desc":    "Participates in their children's education — tracks grades and attendance and chats with teachers.",
      "lp_role_parent_features":["Real-time grade tracking", "Immediate absence alerts", "Direct messaging with teachers", "Confirm fee payments"],
      "lp_reports_eyebrow":     "Reports & analytics",
      "lp_reports_title":       "Smart reports for the school director",
      "lp_reports_subtitle":    "Get a complete real-time view of your school — automatic monthly and annual reports on academic performance, attendance and finances.",
      "lp_report_acad_title":   "Academic performance report",
      "lp_report_acad_desc":    "Averages by class, subject and teacher",
      "lp_report_attend_title": "Monthly attendance report",
      "lp_report_attend_desc":  "Attendance/absence rates with identification of the most-absent students",
      "lp_report_finance_title":"Annual financial report",
      "lp_report_finance_desc": "Total revenue, outstanding amounts, and collected fees",
      "lp_report_top_title":    "Top performers report",
      "lp_report_top_desc":     "Top 10 students and most-distinguished teachers",
      "lp_reports_card_school": "Al-Nour School • April 2025",
      "lp_reports_card_title":  "Monthly report",
      "lp_reports_stat_students":"Total students",
      "lp_reports_stat_attend": "Attendance rate",
      "lp_reports_stat_avg":    "Average grade",
      "lp_reports_stat_fees":   "Fees collected",
      "lp_reports_this_month":  "this month",
      "lp_reports_class_perf":  "Class performance — average",
      "lp_reports_export_label":"Instant export",
      "lp_pricing_eyebrow":     "PRICING",
      "lp_pricing_title":       "Transparent and simple pricing",
      "lp_pricing_subtitle":    "Start free for 3 full months, then pick what fits your school.",
      "lp_plan_trial_name":     "Trial",
      "lp_plan_trial_price":    "Free",
      "lp_plan_trial_period":   "90 full days",
      "lp_plan_trial_features": ["Up to 100 students", "Up to 10 teachers", "All core features", "PDF reports", "Email support"],
      "lp_plan_basic_name":     "Basic",
      "lp_plan_basic_period":   "/ 6 months — 90,000 FCFA / year",
      "lp_plan_basic_features": ["Up to 500 students", "Up to 30 teachers", "Monthly and annual reports", "Excel import", "Fast 24/7 support"],
      "lp_plan_pro_name":       "Professional",
      "lp_plan_pro_period":     "/ 6 months — 190,000 FCFA / year",
      "lp_plan_pro_features":   ["Unlimited students", "Unlimited teachers", "PWA mobile app", "Advanced reports", "Dedicated 24/7 support"],
      "lp_plan_popular_badge":  "Most popular",
      "lp_plan_cta":            "Start now",
      "lp_faq_eyebrow":         "FAQ",
      "lp_faq_title":           "Frequently asked questions",
      "lp_faq_card_q":          "Do I need a credit card for the trial?",
      "lp_faq_card_a":          "No, the 90-day free trial is full, with no card and no financial commitment.",
      "lp_faq_limits_q":        "How many students does the system support?",
      "lp_faq_limits_a":        "The Professional plan supports unlimited students and teachers.",
      "lp_faq_secure_q":        "Is the data protected and secure?",
      "lp_faq_secure_a":        "Yes, all data is encrypted and stored safely with automatic daily backups.",
      "lp_faq_langs_q":         "Does the system work only in Arabic?",
      "lp_faq_langs_a":         "The system supports Arabic, French and English, with full RTL support.",
      "lp_faq_import_q":        "How do I transfer my existing school data?",
      "lp_faq_import_a":        "You can import student data from Excel files in one click. Our team helps you for free.",
      "lp_cta_title":           "Start today — 90 days free",
      "lp_cta_subtitle":        "Join the schools managed smartly with EduGate.\nNo credit card, no commitments.",
      "lp_cta_button":          "Register your school now — Free",
      "lp_cta_hint":            "Registration takes less than 2 minutes",
      "lp_footer_rights":       "All rights reserved. Built for the schools of tomorrow.",

      // ─── Batch 3: TaskSubmissionModal ───
      "tsm_max_files":          "Maximum {{count}} files per submission",
      "tsm_unsupported_file":   "Unsupported file type: {{name}}",
      "tsm_file_too_large":     "File exceeds 10MB: {{name}}",
      "tsm_video_too_long":     "Video longer than 5 minutes: {{name}}",
      "tsm_file_read_failed":   "Failed to read file: {{name}}",
      "tsm_describe_required":  "Please enter a description of what you did",
      "tsm_submitted_ok":       "Submitted successfully",
      "tsm_unexpected_error":   "Unexpected error",
      "tsm_describe_label":     "Describe what you did *",
      "tsm_answer_label":       "Answer or work description",
      "tsm_describe_placeholder":"Write a detailed description of the completed work...",
      "tsm_answer_placeholder": "Write your answer here...",
      "tsm_attachments_label":  "Attachments (optional) — images / video / PDF",
      "tsm_attachments_hint":   "Up to {{count}} files, max 10MB each, videos ≤ 5 minutes",
      "tsm_pick_files":         "Choose files to upload",
      "tsm_submitting":         "Submitting...",
      "tsm_submit":             "Submit",

      // ─── Batch 3: AssignmentSubmissionsView ───
      "asv_load_error":         "Loading error",
      "asv_invalid_grade":      "Invalid grade",
      "asv_graded_ok":          "Assignment graded",
      "asv_grading_error":      "Grading error",
      "asv_title":              "Assignment submissions",
      "asv_stats_summary":      "{{submitted}} of {{total}} students submitted",
      "asv_graded_count":       "{{count}} graded",
      "asv_not_submitted":      "Not submitted",
      "asv_col_student":        "Student",
      "asv_col_status":         "Status",
      "asv_col_date":           "Submission date",
      "asv_col_grade":          "Grade",
      "asv_col_actions":        "Actions",
      "asv_detail_title":       "Submission: {{name}}",
      "asv_text_answer":        "Text answer",
      "asv_attachments_count":  "Attachments ({{count}})",
      "asv_grade_label":        "Grade",
      "asv_max_label":          "Maximum",
      "asv_notes":              "Notes",
      "asv_notes_placeholder":  "Notes for the student...",
      "asv_grade_btn":          "Grade",

      // ─── Batch 3: TeacherAssignmentsManager ───
      "tam_update_ok":          "Assignment updated!",
      "tam_add_ok":             "Assignment added!",
      "tam_save_err":           "Error saving assignment",
      "tam_delete_confirm":     "Are you sure you want to delete this assignment?",
      "tam_delete_ok":          "Assignment deleted!",
      "tam_delete_err":         "Error deleting assignment",
      "tam_page_title":         "Assignments",
      "tam_add_btn":            "Add assignment",
      "tam_view_submissions":   "View submissions",
      "tam_due":                "Due: {{date}}",
      "tam_score_unit":         "{{score}} points",
      "tam_empty":              "No assignments added yet",
      "tam_edit_title":         "Edit assignment",
      "tam_add_title":          "Add new assignment",
      "tam_title_label":        "Assignment title *",
      "tam_title_placeholder":  "e.g.: Solve unit 2 exercises",
      "tam_subject_label":      "Subject *",
      "tam_subject_select":     "Select subject",
      "tam_class_label":        "Class *",
      "tam_class_select":       "Select class",
      "tam_due_label":          "Due date *",
      "tam_score_label":        "Score",
      "tam_desc_label":         "Assignment description *",
      "tam_desc_placeholder":   "Write assignment details here...",

      // ─── Batch 4: AccountSettings (SMS prefs) ───
      "acct_prefs_saved":       "Preferences saved",
      "acct_notification_prefs":"Notification preferences",
      "acct_notification_prefs_desc":"Pick additional channels to receive absence, grade, fee, and urgent announcement notifications. No messages are sent without your consent.",
      "acct_sms_unavailable":   "Messaging is not enabled on the server yet. You can save your preferences now; they'll be activated automatically when the service becomes available.",
      "acct_pref_sms":          "SMS notifications",
      "acct_pref_whatsapp":     "WhatsApp notifications",
      "acct_pref_phone":        "Phone number (international format, e.g. +21234567890)",
      "acct_pref_optin_note":   "You can opt out at any time.",

      // ─── Batch 4: NotificationBell ───
      "nb_title":               "Notifications",
      "nb_read_all":            "Mark all read",
      "nb_empty":               "No notifications",
      "nb_marked_all_read":     "All marked as read",
      "nb_error":               "An error occurred",
      "nb_new_default":         "New notification",
      "nb_just_now":            "Just now",
      "nb_minutes_ago":         "{{count}} min ago",
      "nb_hours_ago":           "{{count}} h ago",

      // ─── Batch 4: ReceiptCard ───
      "rc_load_failed":         "Could not load the receipt",
      "rc_receipt_number":      "Receipt no.",
      "rc_print_btn":           "Print receipt",
      "rc_title":               "Payment receipt",
      "rc_field_student":       "Student",
      "rc_field_class":         "Class",
      "rc_field_fee_type":      "Fee type",
      "rc_field_payment_method":"Payment method",
      "rc_field_payment_date":  "Payment date",
      "rc_issued_by":           "Issued by",
      "rc_print_hint":          "Click Print: the receipt takes half an A4 sheet, two receipts per sheet.",

      // ─── Batch 4: PayslipCard ───
      "slip_load_failed":         "Could not load the payslip",
      "slip_payslip_number":      "Payslip no.",
      "slip_print_btn":           "Print payslip",
      "slip_title":               "Payslip",
      "slip_field_month":         "Month",
      "slip_field_salary_type":   "Salary type",
      "slip_basic_salary":        "Basic salary",
      "slip_bonuses":             "Bonuses",
      "slip_deductions":          "Deductions",
      "slip_net_salary":          "Net salary",
      "slip_print_hint":          "Click Print: the payslip takes half an A4 sheet, two per sheet.",

      // ─── Batch 5: SuperAdminDashboard ───
      "sad_school_updated_ok":   "School updated successfully!",
      "sad_update_error":        "Error while updating",
      "sad_account_required":    "Enter at least a new username or new password",
      "sad_password_mismatch":   "Password and confirmation do not match",
      "sad_account_updated":     "Account details updated",
      "sad_account_error":       "Error while updating the account",
      "sad_search_school":       "Search for a school...",
      "sad_add_school_desc":     "Enter the new school's details below.",
      "sad_serial_number":       "Serial number",
      "sad_actions":             "Actions",
      "sad_delete_school_confirm":"Are you sure you want to delete this school? All linked users will be disabled.",
      "sad_school_deleted":      "School deleted successfully!",
      "sad_delete_error":        "Error while deleting",
      "sad_account_settings_title":"Account settings",
      "sad_account_settings_desc":"Change your username or password",
      "sad_new_username_label":  "New username",
      "sad_keep_current_username":"(leave empty to keep the current one)",
      "sad_current_username_placeholder":"Current username",
      "sad_keep_current_password":"(leave empty to keep the current one)",
      "sad_save_changes":        "Save changes",
      "sad_edit_school_title":   "Edit school information",
      "sad_edit_school_desc":    "Edit the school's information. Leave password fields empty to keep them unchanged.",
      "sad_keep_password_blank": "Leave empty to keep the current password",

      // ─── Batch 6: SchoolAdminClassAnalyticsView ───
      "cav_load_error":         "An error occurred while loading classes.",
      "cav_title":              "Class performance analysis",
      "cav_desc":               "Classes compared by their students' smart score (year average and attendance) in the selected academic year.",
      "cav_no_data":            "Not enough data yet to display class analysis.",
      "cav_chart_title":        "Class comparison chart",
      "cav_smart_avg":          "Smart average",
      "cav_legend_best":        "Honor roll ({{top}}% and above)",
      "cav_legend_good":        "Good level",
      "cav_legend_weak":        "Needs improvement (below {{pass}}%)",
      "cav_col_rank":           "Rank",
      "cav_col_class":          "Class",
      "cav_col_students":       "Students",
      "cav_col_avg":            "Smart average",
      "cav_col_category":       "Category",
      "cav_student_unit":       "student(s)",
      "cav_badge_best":         "Honor roll",
      "cav_badge_good":         "Good",
      "cav_badge_weak":         "Needs improvement",
      "cav_badge_no_data":      "No data",

      // ─── Batch 6: SchoolAdminStaffAttendanceView ───
      "sav_load_error":         "Error",
      "sav_recorded_ok":        "Attendance recorded",
      "sav_updated_ok":         "Attendance updated",
      "sav_record_err":         "Error recording attendance",
      "sav_title":              "Staff attendance",
      "sav_search_placeholder": "Search for a teacher...",
      "sav_record_btn":         "Record attendance",
      "sav_edit_title":         "Edit attendance",
      "sav_add_title":          "Record attendance",
      "sav_select_teacher":     "Choose teacher",
      "sav_label_teacher":      "Teacher",
      "sav_label_date":         "Date",
      "sav_label_status":       "Status",
      "sav_status_present":     "Present",
      "sav_status_absent":      "Absent",
      "sav_col_teacher":        "Teacher",
      "sav_col_date":           "Date",
      "sav_col_status":         "Status",
      "sav_col_notes":          "Notes",
      "sav_col_actions":        "Actions",
      "sav_delete_confirm":     "Are you sure you want to delete this record?",
      "sav_deleted_ok":         "Deleted successfully",
      "sav_delete_err":         "Error while deleting",
      "sav_no_records":         "No attendance records",

      // ─── P1 BATCH: FinanceSystemDetailed ───
      "fin_main_title":            "Comprehensive finance system",
      "fin_partial_load_error":    "Some finance data could not be loaded — parts of this screen may be incomplete.",
      "fin_main_subtitle":         "Full management of salaries, expenses and fees with a 12-month detailed view",
      "fin_expected_fees":         "Expected student fees",
      "fin_currency_franc":        "Franc",
      "fin_collected_from_students":"Collected from students",
      "fin_total_salaries_card":   "Total salaries",
      "fin_total_expenses_card":   "Total expenses",
      "fin_summary_title":         "Financial summary",
      "fin_expected_revenue":      "Expected revenue:",
      "fin_total_outflows":        "Total expenses:",
      "fin_expected_net":          "Expected net:",
      "fin_unpaid_fees":           "Unpaid fees:",
      "fin_fees_records_title":    "Student fee records — School year {{year}}",
      "fin_add_fees_btn":          "Add fee",
      "fin_col_student":           "Student",
      "fin_col_class":             "Class",
      "fin_col_total":             "Total",
      "fin_col_paid":              "Paid",
      "fin_col_remaining":         "Remaining",
      "fin_salaries_records_title":"Teacher salary records — School year {{year}}",
      "fin_add_salary_btn":        "Add salary",
      "fin_col_teacher":           "Teacher",
      "fin_col_specialization":    "Specialization",
      "fin_col_salaries_count":    "Salary count",
      "fin_default_teacher_label": "Teacher",
      "fin_total_expenses_inline": "Total expenses:",
      "fin_items_count":           "Items:",
      "fin_print_report":          "Print report",
      "fin_add_expense_btn":       "Add expense",
      "fin_col_date":              "Date",
      "fin_col_expense_type":      "Expense type",
      "fin_col_description":       "Description",
      "fin_col_amount":            "Amount",
      "fin_col_payment_method":    "Payment method",
      "fin_col_actions":           "Actions",
      "fin_no_expenses":           "No expenses recorded",
      "fin_role_student_label":    "Student - {{class}}",
      "fin_role_teacher_label":    "Teacher - {{spec}}",
      "fin_personal_info":         "Personal information",
      "fin_label_full_name":       "Full name",
      "fin_label_email":           "Email",
      "fin_label_phone":           "Phone",
      "fin_label_class":           "Class",
      "fin_label_level":           "Level",
      "fin_label_dob":             "Date of birth",
      "fin_label_specialization":  "Specialization",
      "fin_label_subjects":        "Subjects",
      "fin_label_classes":         "Classes",
      "fin_summary_card_title":    "Financial summary",
      "fin_total_fees":            "Total fees",
      "fin_total_salaries":        "Total salaries",
      "fin_salaries_count":        "Salary count",
      "fin_12months_title":        "12-month detailed record — School year {{year}}",
      "fin_col_month":             "Month",
      "fin_col_status":            "Status",
      "fin_col_payment_date":      "Payment date",
      "fin_col_type":              "Type",
      "fin_col_notes":             "Notes",
      "fin_current_month":         "Current month",
      "fin_status_paid_full":      "Paid in full",
      "fin_status_paid_partial":   "Partially paid",
      "fin_status_unpaid":         "Unpaid",
      "fin_status_disbursed":      "Disbursed",
      "fin_status_pending":        "Pending",
      "fin_no_record":             "No record",
      "fin_amount_with_franc":     "{{value}} francs",
      "fin_attendance_summary":    "Attendance summary",
      "fin_grades_summary":        "Grades summary",
      "fin_assessment_type":       "Assessment type",
      "fin_grade_label":           "Grade",
      "fin_percentage":            "Percentage",
      "fin_subject_label":         "Subject",
      "fin_no_grades":             "No grades recorded",
      "fin_form_employee":         "Teacher / Employee *",
      "fin_form_salary_type":      "Salary type *",
      "fin_form_amount":           "Amount *",
      "fin_form_month":            "Month *",
      "fin_form_payment_date":     "Payment date",
      "fin_form_payment_method":   "Payment method",
      "fin_form_notes":            "Notes",
      "fin_form_student":          "Student *",
      "fin_form_fee_type":         "Fee type *",
      "fin_form_total_amount":     "Total amount *",
      "fin_form_paid_amount":      "Paid amount",
      "fin_form_month_opt":        "Month",
      "fin_form_due_date":         "Due date",
      "fin_form_expense_type":     "Expense type *",
      "fin_form_amount_required":  "Amount *",
      "fin_form_date_required":    "Date *",
      "fin_form_receipt_number":   "Receipt number",
      "fin_form_description":      "Description *",

      // ─── Month names (used across finance/dashboards) ───
      // ─── P1 BATCH: ParentDashboard (additional) ───
      "pd_overview_title":         "Overview of all children",
      "pd_registered_count":       "{{count}} children registered",
      "pd_sibling_badge":          "Sibling",
      "pd_attendance_short":       "Attendance",
      "pd_avg_short":              "Average",
      "pd_remaining_short":        "Remaining",
      "pd_settled_short":          "Settled",
      "pd_view_details":           "View details",
      "pd_absences_count":         "{{count}} absence(s)",
      "pd_overall_summary":        "Overall summary for all children",
      "pd_single_child":           "child",
      "pd_plural_children":        "children",
      "pd_my_children":            "My Children",
      "pd_link_new_child":         "Link a new child",
      "pd_loading_data":           "Loading data...",
      "pd_welcome":                "Welcome!",
      "pd_no_children":            "No children linked to your account yet",
      "pd_msg_from_teachers":      "Messages from teachers",
      "pd_no_messages":            "No messages",
      "pd_messages_hint":          "Messages from teachers about your children will appear here",
      "pd_school_teacher":         "School teacher",
      "pd_new_badge":              "New",
      "pd_select_child_hint":      "Please select a child from the sidebar",
      "pd_siblings_count":         "{{count}} siblings",
      "pd_id_label":               "ID: {{value}}",
      "pd_overall_avg":            "Overall average",
      "pd_attendance_rate":        "Attendance rate",
      "pd_absent_days":            "Absent days",
      "pd_remaining_fees":         "Remaining fees",
      "pd_recent_grades":          "Recent grades",
      "pd_no_grades_short":        "No grades",
      "pd_recent_attendance":      "Recent attendance",
      "pd_no_records_short":       "No records",
      "pd_attendance_for":         "Attendance for {{name}}",
      "pd_attended":               "Present",
      "pd_missed":                 "Absent",
      "pd_col_date":               "Date",
      "pd_col_status":             "Status",
      "pd_col_notes":              "Notes",
      "pd_no_attendance_records":  "No attendance records",
      "pd_grades_for":             "Grades for {{name}}",
      "pd_col_subject":            "Subject",
      "pd_col_assessment":         "Assessment",
      "pd_col_type":               "Type",
      "pd_col_grade":              "Grade",
      "pd_col_percentage":         "Percentage",
      "pd_no_grades_recorded":     "No grades recorded",
      "pd_fees_for":               "Fees for {{name}}",
      "pd_total_fees":             "Total fees",
      "pd_paid":                   "Paid",
      "pd_remaining":              "Remaining",
      "pd_col_month":              "Month",
      "pd_col_amount":             "Amount",
      "pd_col_paid":               "Paid",
      "pd_fee_status_paid":        "Paid",
      "pd_fee_status_partial":     "Partial",
      "pd_fee_status_unpaid":      "Unpaid",
      "pd_no_fees_recorded":       "No fees recorded",
      "pd_assignments_for":        "Assignments for {{name}}",
      "pd_overdue_badge":          "Overdue",
      "pd_no_assignments":         "No assignments at the moment",
      "pd_link_dialog_title":      "Link a child to your account",
      "pd_link_dialog_desc":       "Enter the student number to link them to your account. You can obtain the student number from the school administration.",
      "pd_link_by_school":         "To add a child to your account, contact the school administration: to protect children's data, only the school can link a student to a parent account.",
      "pd_student_number_label":   "Student number *",
      "pd_student_number_placeholder":"e.g.: 0001234",
      "pd_linking":                "Linking...",
      "pd_link_btn":               "Link student",

      // ─── P1 BATCH: StudentDashboard ───
      "sd_today_schedule":         "Today's schedule",
      "sd_no_classes_today":       "No classes today",
      "sd_weekly_schedule":        "My weekly schedule",
      "sd_no_classes":             "No classes",
      "sd_no_classes_short":       "No classes",
      "sd_today_chip":             "Today",
      "sd_free_period":            "Free",
      "sd_prev_day":               "Previous day",
      "sd_next_day":               "Next day",
      "sd_dashboard_subtitle": "Here is a quick look at your performance, attendance and today's schedule.",
      "sd_no_grades_hint": "You have no grades recorded for this term yet.",
      "sd_no_attendance_hint": "No attendance records have been found for you yet.",
      "sd_no_fees_hint": "No fees have been recorded in your name yet.",
      "sd_my_grades":              "My grades",
      "sd_finance_tab_title":      "Finance",
      "sd_teacher_feedback":       "Teacher feedback",
      "sd_awaiting_grading":       "Submitted on {{date}} — Awaiting grading",
      "sd_print_report":           "Print report",
      "sd_loading_short":          "Loading...",
      "sd_msg_inbox_hint":         "Messages from your teachers will appear here",
      "student_not_linked_title":  "Your account is not linked to a student record",
      "student_not_linked_body":   "Your account is not linked to a student record in the database. Please contact the school administration to complete the linkage.",
      "student_fetch_failed_body": "An error occurred while loading student data. Please try again or contact the administration.",
      "retry":                     "Retry",

      // ─── P1 BATCH: TeacherDashboard (additional) ───
      "td_msg_sent":               "Message sent successfully",
      "td_msg_send_error":         "Error sending message",
      "td_salaries_title":         "Salaries and payments history",
      "td_view_payslip":           "View payslip",
      "td_issue_payslip":          "Issue payslip",
      "td_no_salaries":            "No salary records available yet",
      "td_salaries_hint":          "Your salaries will appear here once recorded",
      "td_record_attendance_title":"Record attendance",
      "td_all_present":            "All present",
      "td_all_absent":             "All absent",
      "td_not_recorded":           "Not recorded",
      "td_no_students_in_class":   "No students in this class",
      "td_subjects_i_teach":       "Subjects I teach:",
      "td_col_day":                "Day",
      "td_col_time":               "Time",
      "td_no_schedule_yet":        "No schedule assigned yet",
      "td_schedule_admin_creates": "The administrator creates and assigns the schedule",
      "td_my_students_title":      "My Students",
      "td_message_parent":         "Message parent ({{name}})",
      "td_parent_not_linked":      "Parent not linked",
      "td_msg_to":                 "Message to: {{name}}",
      "td_msg_re":                 "Regarding: {{children}}",
      "td_msg_text":               "Message text",
      "td_previous_msgs":          "Previous messages:",
      "td_send_msg":               "Send message",
      "teacher_no_classes_assigned":"No classes assigned to you yet. Please contact the school administration to assign classes, then click \"Refresh\".",

      // ─── P1 BATCH: GradesViewOnly ───
      "gvo_title":                 "Grades record",
      "gvo_subtitle":              "Comprehensive view of grades by class, subject, assessment and academic year",
      "gvo_count":                 "Grades count",
      "gvo_passed":                "Passed",
      "gvo_filter_results":        "Filter results",
      "gvo_search_by_name":        "Search by student name...",
      "gvo_all_classes":           "All classes",
      "gvo_all_subjects":          "All subjects",
      "gvo_exam":                  "Assessment",
      "gvo_all_exams":             "All assessments",
      "gvo_academic_year_label":   "Academic year",
      "gvo_all_years":             "All years",
      "gvo_view_for":              "Full view: all {{cls}} students in {{subject}} — {{exam}}{{year}}",
      "gvo_not_entered":           "Not entered yet",
      "gvo_no_match":              "No grades match the search",
      "gvo_try_filters":           "Try changing the filters or pick \"All\" to show everything",
      "gvo_print_title":           "Grade report",
      "gvo_print_class":           "Class",
      "gvo_print_subject":         "Subject",
      "gvo_print_exam":            "Assessment",
      "gvo_print_year":            "Year",
      "gvo_print_col_name":        "Student name",
      "gvo_print_col_score":       "Score",
      "gvo_print_col_max":         "Out of",
      "gvo_print_col_pct":         "Percentage",
      "gvo_print_footer":          "Printed on: {{date}}",

      // ─── P1 BATCH: DetailViews ───
      "dv_img_max_5mb":            "Image must be under 5MB",
      "dv_img_encoded_too_big":    "Encoded image is too large — please pick a smaller one",
      "dv_student_updated":        "Student details updated!",
      "dv_update_error":           "Error updating details",
      "dv_student_role_subtitle":  "Student - {{cls}} - {{grade}}",
      "dv_username_readonly":      "Username (read-only)",
      "dv_address":                "Address",
      "dv_medical_info":           "Medical info",
      "dv_school_qr_card":         "School QR card",
      "dv_qr_hint":                "Use this QR for attendance, cafeteria, or library book loans. It can be printed on the school card.",
      "dv_student_card_print":     "Student card",
      "dv_id_print":               "ID: {{value}}",
      "dv_print_card":             "Print card",
      "dv_teacher_updated":        "Teacher details updated!",
      "dv_teacher_role_subtitle":  "Teacher - {{spec}}",
      "dv_salaries_paid":          "Salaries paid",
      "dv_academic_subjects":      "Subjects taught",
      "dv_add_custom_subject":     "Add a subject not in the list...",
      "dv_academic_classes":       "Classes taught",
      "dv_no_subjects":            "No subjects set",
      "dv_no_classes_assigned":    "No classes assigned",
      "dv_no_notes":               "No notes",
      "dv_parent_updated":         "Parent details updated!",
      "dv_rel_father":             "Father",
      "dv_rel_mother":             "Mother",
      "dv_rel_guardian":           "Guardian",
      "dv_default_parent_label":   "Parent",
      "dv_children_count":         "{{count}} child(ren)",
      "dv_relationship":           "Relationship",
      "dv_link_more_children":     "Link more children (select students)",
      // [PHASE-4 2026-10] Profile drawers
      "pf_loading": "Loading profile…",
      "pf_load_error": "Could not load this profile.",
      "pf_retry": "Retry",
      "pf_attendance_rate": "Attendance rate",
      "pf_attendance_breakdown": "{{present}} present · {{late}} late · {{absent}} absent · {{excused}} excused",
      "pf_student_number": "Student number",
      "pf_guardians": "Guardians",
      "pf_no_guardians": "No guardian linked",
      "pf_no_recent_grades": "No grades this year",
      "pf_periods_per_week": "Periods per week",
      "pf_load_sub": "{{classes}} classes · {{subjects}} subjects",
      "pf_latest_rating": "Latest evaluation",
      "pf_no_rating": "No evaluation yet",
      "pf_documents": "Documents on file",
      "pf_timetable": "Weekly timetable",
      "pf_no_timetable": "No periods scheduled this year",
      "pf_period": "Period {{n}}",
      "pf_room": "Room {{room}}",
      "dv_no_number":              "No number",
      "dv_children_label":         "Children ({{count}})",
      "dv_no_children_linked":     "No children linked",

      // ─── P2 BATCH: SchoolAdminTeacherTasksView ───
      "sattv_status_reviewed":     "In review",
      "sattv_load_submission_error":"Error loading submission",
      "sattv_submission_approved": "Submission accepted",
      "sattv_submission_rejected": "Submission rejected",
      "sattv_review_error":        "Review error",
      "sattv_task_added":          "Task added successfully",
      "sattv_title":               "Teacher tasks",
      "sattv_search_placeholder":  "Search a teacher or task...",
      "sattv_add_task":            "Add task",
      "sattv_add_task_for_teacher":"Add a task for the teacher",
      "sattv_add_task_desc":       "Enter the details of the new task",
      "sattv_pick_teacher":        "Choose teacher *",
      "sattv_task_title_label":    "Task title *",
      "sattv_task_title_placeholder":"e.g.: Prepare lesson plan for next week",
      "sattv_task_desc_label":     "Description",
      "sattv_task_desc_placeholder":"Task details...",
      "sattv_due_date":            "Due date",
      "sattv_priority":            "Priority",
      "sattv_priority_low":        "Low",
      "sattv_priority_medium":     "Medium",
      "sattv_priority_high":       "High",
      "sattv_add_task_btn":        "Add the task",
      "sattv_admin_note":          "Note: this is where you assign administrative tasks to teachers. Student homework is managed by the teacher directly.",
      "sattv_col_task":            "Task",
      "sattv_no_tasks":            "No tasks yet",
      "sattv_view_submission":     "View submission",
      "sattv_delete_confirm":      "Are you sure you want to delete this task?",
      "sattv_submission_desc":     "Submission description",
      "sattv_no_desc":             "(no description)",
      "sattv_admin_feedback":      "Admin feedback",
      "sattv_admin_feedback_placeholder":"Write your feedback to the teacher...",
      "sattv_btn_reject":          "Reject",
      "sattv_btn_approve":         "Approve",
      "sattv_task_details":        "Task details",
      "sattv_task_title_field":    "Task title",
      "sattv_submission_status":   "Submission status",
      "sattv_submitted_at":        "Submitted on",
      "sattv_open_review":         "Open review",

      // ─── P2 BATCH: MessagingSystem ───
      "ms_load_error":             "Error loading messages",
      "ms_sent_to":                "Message sent to {{name}}",
      "ms_send_error":             "Error sending message",
      "ms_broadcast_default_subject":"Broadcast message",
      "ms_broadcast_ok":           "Broadcast sent",
      "ms_broadcast_error":        "Error sending broadcast",
      "ms_title":                  "Messages",
      "ms_unread_badge":           "{{count}} new",
      "ms_subtitle":               "Communicate with anyone in the system",
      "ms_compose":                "New message",
      "ms_sent_tab":               "Sent",
      "ms_broadcast_tab":          "Broadcast",
      "ms_inbox_empty":            "No messages in your inbox",
      "ms_broadcast_badge":        "Broadcast",
      "ms_contacts":               "Contacts",
      "ms_search":                 "Search...",
      "ms_no_contacts":            "No contacts",
      "ms_to_with_name":           "To: {{name}}",
      "ms_pick_contact":           "Choose a contact",
      "ms_subject_optional":       "Subject (optional)",
      "ms_subject_placeholder":    "Message subject...",
      "ms_message_required":       "Message text *",
      "ms_message_placeholder":    "Write your message here...",
      "ms_char_count":             "{{count}} characters",
      "ms_no_sent":                "No sent messages",
      "ms_to_short":               "To:",
      "ms_broadcast_title":        "Broadcast message",
      "ms_broadcast_desc":         "Send a single message to all members of a group",
      "ms_target_group":           "Target group *",
      "ms_pick_group":             "Choose the group...",
      "ms_role_all":               "{{role}} (all)",
      "ms_broadcast_reach":        "This message will reach every {{role}} in your school",
      "ms_subject":                "Subject",
      "ms_subject_example":        "e.g.: Parents meeting",
      "ms_broadcast_placeholder":  "Write your broadcast message here...",
      "ms_send_broadcast":         "Send broadcast",

      // ─── P2 BATCH: TeacherGradesEntry ───
      "tge_grade_updated":         "Grade updated!",
      "tge_grade_added":           "Grade added!",
      "tge_save_error":            "Error saving grade",
      "tge_delete_confirm":        "Are you sure you want to delete this grade?",
      "tge_grade_deleted":         "Grade deleted!",
      "tge_delete_error":          "Error deleting grade",
      "tge_title":                 "Grade entry",
      "tge_add_grade":             "Add grade",
      "tge_edit_grade_title":      "Edit grade",
      "tge_add_grade_title":       "Add new grade",
      "tge_student_required":      "Student *",
      "tge_pick_student":          "Choose student",
      "tge_subject_required":      "Subject *",
      "tge_assessment_type_required":"Assessment type *",
      "tge_type_quiz":             "Quiz",
      "tge_type_exam":             "Exam",
      "tge_type_homework":         "Homework",
      "tge_type_project":          "Project",
      "assess_name_exam1":         "First exam",
      "assess_name_exam2":         "Second exam",
      "assess_name_exam3":         "Third exam",
      "assess_name_oral":          "Oral exam",
      "assess_name_project":       "Project",
      "assess_name_homework":      "Homework",
      "class_grade1_primary":      "Grade 1 (Primary)",
      "class_grade2_primary":      "Grade 2 (Primary)",
      "class_grade3_primary":      "Grade 3 (Primary)",
      "class_grade4_primary":      "Grade 4 (Primary)",
      "class_grade5_primary":      "Grade 5 (Primary)",
      "class_grade6_primary":      "Grade 6 (Primary)",
      "class_grade1_middle":       "Grade 1 (Middle)",
      "class_grade2_middle":       "Grade 2 (Middle)",
      "class_grade3_middle":       "Grade 3 (Middle)",
      "class_grade1_high":         "Grade 1 (High)",
      "class_grade2_high":         "Grade 2 (High)",
      "class_grade3_high":         "Grade 3 (High)",
      "day_sunday_full":           "Sunday",
      "day_monday_full":           "Monday",
      "day_tuesday_full":          "Tuesday",
      "day_wednesday_full":        "Wednesday",
      "day_thursday_full":         "Thursday",
      "day_friday_full":           "Friday",
      "day_saturday_full":         "Saturday",
      "subject_math":              "Mathematics",
      "subject_arabic":            "Arabic Language",
      "subject_french":            "French Language",
      "subject_english":           "English Language",
      "subject_science":           "Sciences",
      "subject_history":           "History & Geography",
      "subject_islamic":           "Islamic Education",
      "subject_pe":                "Physical Education",
      "subject_art":               "Arts",
      "subject_computer":          "Computer Science",
      "val_paid":                  "Paid",
      "val_unpaid":                "Unpaid",
      "val_partial":               "Partial",
      "val_present":               "Present",
      "val_absent":                "Absent",
      "val_late":                  "Late",
      "val_excused":               "Excused",
      "val_single":                "Single",
      "val_married":               "Married",
      "val_divorced":              "Divorced",
      "val_widowed":               "Widowed",
      "val_bachelor":              "Bachelor's",
      "val_master":                "Master's",
      "val_phd":                   "PhD",
      "val_diploma":               "Diploma",
      "val_highschool":            "High School",
      "val_father":                "Father",
      "val_mother":                "Mother",
      "val_guardian":              "Guardian",
      "gr_title":                  "Student Rankings",
      "gr_tab":                    "Class Rankings",
      "gr_select_class":           "Select class",
      "gr_select_year":            "All years",
      "gr_all_types":              "All types",
      "gr_show":                   "Show ranking",
      "gr_rank":                   "Rank",
      "gr_student":                "Student",
      "gr_subjects":               "Subjects",
      "gr_overall":                "Overall average",
      "gr_no_data":                "No ranking data",
      "gr_load_failed":            "Failed to load ranking",
      "tge_type_participation":    "Participation",
      "tge_assessment_name_required":"Assessment name *",
      "tge_pick_assessment_name":  "Choose assessment name",
      "tge_academic_year_required":"Academic year *",
      "tge_semester_required":     "Semester *",
      "tge_semester_1":            "First semester",
      "tge_semester_2":            "Second semester",
      "tge_semester_3":            "Third semester",
      "tge_score_required":        "Score *",
      "tge_max_score_required":    "Maximum score *",
      "tge_notes":                 "Notes",

      // ─── P2 BATCH: SubscriptionManager ───
      "sm_plan_trial":             "Trial",
      "sm_plan_basic":             "Basic",
      "sm_plan_professional":      "Professional",
      "sm_plan_suspended":         "Suspended",
      "sm_inactive":               "Inactive",
      "sm_trial_ended":            "Trial ended",
      "sm_days_left":              "{{count}} days left",
      "sm_trial_with_days":        "Trial ({{days}} d)",
      "sm_edit_title":             "Update subscription — {{name}}",
      "sm_plan_type":              "Plan type",
      "sm_free":                   "Free",
      "sm_billing_cycle":          "Billing cycle",
      "sm_semi_annual":            "Semi-annual (6 months)",
      "sm_annual":                 "Annual (12 months)",
      "sm_extend_trial_label":     "Extend trial (extra days)",
      "sm_max_students_label":     "Student limit",
      "sm_max_teachers_label":     "Teacher limit",
      "sm_account_status":         "Account status",
      "sm_updated":                "Subscription updated",
      "sm_update_failed":          "Failed to update subscription",
      "sm_extended_90":            "Trial extended by 90 days",
      "sm_extend_failed":          "Extension failed",
      "sm_kpi_total":              "Total schools",
      "sm_kpi_trial":              "On trial",
      "sm_kpi_paid":               "Paid subscriptions",
      "sm_kpi_expiring_soon":      "Expiring soon",
      "sm_kpi_expired":            "Trial expired",
      "sm_kpi_revenue":            "Semi-annual revenue",
      "sm_filter_all":             "All",
      "sm_col_school":             "School",
      "sm_col_plan":               "Plan",
      "sm_col_trial_end":          "Trial end",
      "sm_col_limits":             "Limits",
      "sm_no_results":             "No results",
      "sm_days_left_d":            "{{count}} day(s) left",
      "sm_expired_ago":            "Expired {{count}} day(s) ago",
      "sm_limits_inline":          "{{students}} students · {{teachers}} teachers",
      "sm_edit_btn":               "Edit subscription",
      "sm_extend_btn_title":       "Extend 90 days",
      "sm_extend_short":           "Extend",

      // ─── P2 BATCH: TeacherMessaging ───
      "tm_pick_student_error":     "Please pick a student",
      "tm_content_error":          "Please enter the message",
      "tm_sent_to_student_parent": "Message sent to student and parent ✓",
      "tm_sent_to_student":        "Message sent to student ✓",
      "tm_pick_class_error":       "Please pick a class",
      "tm_sent_ok":                "Sent successfully",
      "tm_send_error":             "Error sending message",
      "tm_target_all_students":    "All students",
      "tm_target_all_parents":     "All parents",
      "tm_target_class":           "Specific class",
      "tm_title":                  "Send a message",
      "tm_subtitle":               "Send a message to one student or to a group of students and parents",
      "tm_mode_individual":        "Single student",
      "tm_mode_bulk":              "Bulk message",
      "tm_pick_student":           "Pick student *",
      "tm_pick_student_option":    "-- Pick a student --",
      "tm_notify_parent":          "Also send a copy to the parent",
      "tm_subject_label":          "Subject",
      "tm_subject_placeholder":    "Message subject (optional)",
      "tm_message_text_label":     "Message text *",
      "tm_message_placeholder":    "Write your message here...",
      "tm_char_count":             "{{count}} characters",
      "tm_sending":                "Sending...",
      "tm_send_btn":               "Send message",
      "tm_targets":                "Recipients",
      "tm_pick_class_option":      "-- Pick the class --",

      // ─── P2 BATCH: SchoolSettings ───
      "ss_no_school_id":           "Error: school ID not found",
      "ss_saved":                  "School settings saved",
      "ss_unknown_error":          "Unknown error",
      "ss_save_error":             "Error saving settings: {{detail}}",
      "ss_title":                  "School settings",
      "ss_subtitle":               "Customize your school to reflect its identity",
      "ss_currency_title":         "School currency",
      "ss_currency_label":         "Select the currency used by the school",
      "ss_currency_hint":          "This currency will be used for fees, salaries, expenses, receipts, payslips, invoices, and dashboards.",
      "ss_second_language_title": "Second document language",
      "ss_second_language_label": "Language shown next to Arabic on transcripts and certificates",
      "ss_second_language_choose": "Choose the second language",
      "ss_second_language_fr": "French",
      "ss_second_language_en": "English",
      "ss_second_language_hint": "Transcripts and certificates will be printed in Arabic and in this language.",
      "ss_second_language_unset": "No second language chosen yet: transcripts and certificates print in Arabic only until you choose one.",
      "ss_week_title":            "School week",
      "ss_week_hint":             "Choose the days your school teaches. Only these days appear when building schedules, exams and attendance. Any combination works, including irregular weeks (e.g. Friday off, Saturday taught).",
      "ss_week_presets":          "Common patterns",
      "ss_week_days_label":       "Working days",
      "ss_week_none_selected":    "No days selected — the change will not be saved until at least one day is chosen.",
      "wd_preset_sat_wed":        "Saturday – Wednesday",
      "wd_preset_sun_thu":        "Sunday – Thursday",
      "wd_preset_mon_fri":        "Monday – Friday",
      "wd_preset_mon_sat":        "Monday – Saturday",
      "smc_time_range":           "Period time (from – to)",
      "smc_time_start":           "From",
      "smc_time_end":             "To",
      "smc_time_suggestions":     "Suggested times",
      "smc_time_invalid":         "Invalid time ({{time}}) — the end time must be after the start time.",
      "smc_subject_add_new":      "Add a new subject",
      "smc_subject_custom_placeholder": "Type the subject name",
      "ss_saved_short":            "Saved",
      "ss_saving":                 "Saving...",
      "ss_default_name":           "School name",
      "ss_default_address":        "Address",
      "ss_basic_info":             "Basic information",
      "ss_name_ar":                "School name (Arabic)",
      "ss_name_ar_placeholder":    "e.g. Al-Nour Primary School",
      "ss_name_fr":                "School name (French)",
      "ss_name_fr_placeholder":    "École Primaire Al-Nour",
      "ss_email":                  "Email",
      "ss_phone":                  "Phone",
      "ss_address":                "Address",
      "ss_address_placeholder":    "Bamako, Mali",
      "ss_theme_colors":           "Theme colors",
      "ss_primary_color":          "Primary color",
      "ss_preview_label":          "Color preview:",
      "ss_btn_primary":            "Primary button",
      "ss_btn_outline":            "Outline button",
      "ss_tips_title":             "Customization tips",
      "ss_tip_logo":               "• Use a clear logo with a transparent background (PNG)",
      "ss_tip_colors":             "• The primary colour is the accent on receipts and payslips",
      // [PHASE-1b 2026-10] Settings audit
      "ss_section_identity": "School identity and printed documents",
      "ss_section_money_language": "Currency and language",
      "ss_section_timetable": "School week and timetable",
      "ss_section_teacher_files": "Teacher files",
      "ss_address_on_receipt": "The address is printed on fee receipts.",
      "ss_custom_subjects_title": "Added subjects",
      "ss_custom_subjects_hint": "A subject is added here automatically when it is assigned to a teacher. It can be removed only once no teacher teaches it.",
      "ss_custom_subjects_empty": "No added subjects yet.",
      "ss_custom_subjects_remove": "Remove subject",
      "ss_custom_subjects_confirm": "Remove the subject \"{{subject}}\" from the school list?",
      "ss_custom_subjects_removed": "Subject removed.",
      "ss_primary_color_hint": "Used as the accent on receipts and payslips. It does not change the app's colours.",
      "ss_logo_used_on": "The logo and Arabic name appear on receipts, payslips and ID cards.",

      // ─── P2 BATCH: AdminProfile ───
      "ap_profile_updated":        "Profile updated successfully",
      "ap_unknown_error":          "Unknown error",
      "ap_save_error":             "Error updating profile: {{detail}}",
      "ap_pwd_mismatch":           "New passwords do not match",
      "ap_pwd_too_short":          "Password must be at least 8 characters",
      "ap_pwd_changed":            "Password changed successfully",
      "ap_pwd_change_error":       "Error changing password",
      "ap_title":                  "Profile",
      "ap_subtitle":               "Manage your personal information and security settings",
      "ap_personal_info":          "Personal information",
      "ap_full_name":              "Full name",
      "ap_email":                  "Email",
      "ap_phone":                  "Phone",
      "ap_role":                   "Role",
      "ap_change_password":        "Change password",
      "ap_current_password":       "Current password",
      "ap_new_password":           "New password",
      "ap_confirm_password":       "Confirm password",
      "ap_security_tips_title":    "🔐 Security tips",
      "ap_tip_strong":             "• Use a strong password with letters, numbers, and symbols",
      "ap_tip_no_share":           "• Never share your password with anyone",
      "ap_tip_rotate":             "• Change your password regularly",
      "ap_tip_logout":             "• Always sign out on shared devices",

      // ─── P2 BATCH: ReportsManager ───
      "rpm_load_error":            "Error loading report data",
      "rpm_export_pdf_toast":      "Preparing PDF report...",
      "rpm_export_pdf_desc":       "The file will download shortly",
      "rpm_title":                 " Reports and statistics",
      "rpm_subtitle":              "Comprehensive reports on your school's performance",
      "rpm_period_monthly":        "Monthly",
      "rpm_period_annual":         "Annual",
      "rpm_export_pdf":            "Export PDF",
      "rpm_kpi_students":          "Total students",
      "rpm_kpi_teachers":          "Total teachers",
      "rpm_kpi_attendance":        "Attendance rate",
      "rpm_attendance_sub":        "{{present}} present • {{absent}} absent",
      "rpm_kpi_avg":               "Average grade",
      "rpm_avg_sub":               "Across {{count}} assessments",
      "rpm_kpi_revenue":           "Revenue",
      "rpm_kpi_expenses":          "Expenses",
      "rpm_kpi_net":               "Net profit",
      "rpm_class_perf_title":      "Class performance",
      "rpm_class_perf_sub":        "Average grades per class",
      "rpm_no_grades_recorded":    "No grades recorded",
      "rpm_subject_perf_title":    "Subject performance",
      "rpm_subject_perf_sub":      "Average grades per subject",
      "rpm_top_students_title":    "Top students",
      "rpm_top_students_sub":      "Best performers in this period",
      "rpm_col_name":              "Student name",
      "rpm_col_avg":               "Average",
      "rpm_col_rating":            "Rating",
      "rpm_rating_excellent":      "Excellent",
      "rpm_rating_very_good":      "Very good",
      "rpm_rating_good":           "Good",
      "rpm_warn_attendance":       "Warning: attendance rate is low ({{rate}}%)",
      "rpm_warn_attendance_desc":  "Track absences and contact the affected parents.",
      "rpm_warn_finance":          "Alert: expenses exceed revenue",
      "rpm_warn_finance_desc":     "Review the detailed financial report and check overdue fees.",

      // ─── P2 BATCH: SchoolRegister ───
      "sr_school_name_required":   "School name is required",
      "sr_pwd_mismatch":           "Passwords do not match",
      "sr_pwd_too_short":          "Password must be at least 8 characters",
      "sr_generic_error":          "Something went wrong, please try again",
      "sr_tagline":                "Register your school and start the free trial",
      "sr_step_school":            "School information",
      "sr_step_admin":             "Admin account",
      "sr_school_name":            "School name *",
      "sr_school_name_placeholder":"e.g.: Success Primary School",
      "sr_phone_optional":         "Phone (optional)",
      "sr_trial_banner":           "90 days free — no credit card required",
      "sr_next":                   "Next",
      "sr_back_landing":           "← Back to landing",
      "sr_admin_full_name":        "Admin full name *",
      "sr_admin_full_name_placeholder":"Full name",
      "sr_admin_username":         "Username *",
      "sr_username_placeholder": "username",
      "sr_admin_email":            "Email",
      "sr_admin_password":         "Password *",
      "sr_admin_password_placeholder":"At least 8 characters",
      "sr_admin_password_confirm": "Confirm password *",
      "sr_admin_password_confirm_placeholder":"Re-enter the password",
      "sr_previous":               "← Previous",
      "sr_creating":               "Registering...",
      "sr_create_account":         "Create account",
      "sr_success_title":          "Registration successful",
      "sr_success_welcome":        "Welcome to <strong>EduGate</strong>!",
      "sr_success_trial":          "Enjoy <strong>90 free days</strong> with no restrictions.",
      "sr_login_info":             "Login details:",
      "sr_login_username":         "Username: <strong>{{username}}</strong>",
      "sr_login_role":             "Role: <strong>School admin</strong>",
      "sr_goto_login":             "Go to login",

      // SchoolCalendar
      "sc_title":                  "School calendar",
      "sc_subtitle":               "Exams • Holidays • Meetings • Activities",
      "sc_type_exam":              "Exam",
      "sc_type_holiday":           "Holiday",
      "sc_type_meeting":           "Meeting",
      "sc_type_activity":          "Activity",
      "sc_type_other":             "Other",
      "sc_title_required":         "Title is required",
      "sc_event_added":            "Event added",
      "sc_event_deleted":          "Event deleted",
      "sc_event_save_error":       "Could not save the event — check your connection and try again",
      "sc_more_events":            "+{{count}} more",
      "sc_event_types":            "Event types",
      "sc_upcoming":               "Upcoming",
      "sc_no_upcoming":            "No upcoming events",
      "sc_add_event_header":       "Add event — {{day}} {{month}} {{year}}",
      "sc_event_title_label":      "Event title *",
      "sc_event_title_placeholder":"E.g. Math exam",
      "sc_event_type_label":       "Type",
      "sc_event_desc_label":       "Description (optional)",
      "sc_event_desc_placeholder": "Additional details…",
      "day_sun_short":             "Su",
      "day_mon_short":             "Mo",
      "day_tue_short":             "Tu",
      "day_wed_short":             "We",
      "day_thu_short":             "Th",
      "day_fri_short":             "Fr",
      "day_sat_short":             "Sa",

      // PrintableReport
      "pr_title":                  "School Report Card",
      "pr_student":                "Student",
      "pr_class":                  "Class",
      "pr_student_no": "Student No.",
      "pr_print_date":             "Print Date",
      "pr_grades":                 "Grades",
      "pr_subject":                "Subject",
      "pr_score":                  "Score",
      "pr_type":                   "Type",
      "pr_avg":                    "Overall Average",
      "pr_attendance":             "Attendance Record",
      "pr_att_rate":               "Attendance Rate",
      "pr_fees":                   "School Fees",
      "pr_total_fees":             "Total Fees",
      "pr_paid":                   "Paid",
      "pr_remaining":              "Remaining",
      "pr_edugete_tagline":        "EduGate — School Management",

      // SchoolAdminTrialBanner
      "tb_trial_expired":          "Your free trial has expired! Contact us to activate your subscription.",
      "tb_trial_remaining":        "{{count}} day left in your free trial (90 days).",
      "tb_trial_remaining_plural": "{{count}} days left in your free trial (90 days).",
      "tb_upgrade":                "Upgrade account",
      "subscription_readonly_banner": "Your school's subscription has expired — read-only access. Contact the platform administration to renew.",
      "subscription_renew":           "Renew subscription",
      "subscription_readonly_tooltip":"Unavailable — subscription expired",
      // App-wide messages: axios interceptors, API errors, password rules [I18N 2026-10]
      "app_rate_limited": "Too many attempts. Please wait a moment and try again.",
      "app_server_unreachable": "Could not reach the server after several attempts — check your connection and try again.",
      "app_readonly_toast": "Your school's subscription has expired — read-only mode.",
      "app_offline_queued": "You are offline — this action will be sent when the connection is back",
      "app_queued_sent": "A pending action was sent ✓",
      "app_queued_failed": "A pending action could not be sent — it was discarded",
      "api_err_generic": "Something went wrong, please try again",
      "api_err_network": "Could not reach the server — make sure the system is running",
      "api_err_401": "Your session has expired — please sign in again",
      "api_err_403": "You are not allowed to perform this action",
      "api_err_404": "The requested data was not found",
      "api_err_422": "The submitted data is invalid — check the fields",
      "api_err_429": "Too many requests — wait a moment and try again",
      "api_err_5xx": "Server error — please try again later",
      "pwd_rule_min_length": "The password must be at least 8 characters long",
      "pwd_rule_letter": "The password must contain at least one Latin letter",
      "pwd_rule_digit": "The password must contain at least one digit",

      // PasswordStrength
      "pwd_strength_weak":         "Weak",
      "pwd_strength_fair":         "Fair",
      "pwd_strength_good":         "Good",
      "pwd_strength_strong":       "Strong",

      // ErrorBoundary
      "eb_title":                  "An unexpected error occurred",
      "eb_message":                "Sorry for the inconvenience. You can reload the page or return to the home page.",
      "eb_reload":                 "Reload",
      "eb_home":                   "Home page",

      // SessionTimeoutWarning
      "stw_expiring_now":          "Your session is about to expire!",
      "stw_warning_title":         "Warning: session ending",
      "stw_urgent_message":        "The session will close automatically in seconds. Save your work immediately.",
      "stw_logout":                "Sign out",

      // PDFReports
      "pdfr_title":                "Export PDF reports",
      "pdfr_subtitle":             "Print or save reports as PDF",
      "pdfr_roster":               "Student roster",
      "pdfr_grades":               "Grades report",
      "pdfr_attendance":           "Attendance report",
      "pdfr_generating":           "Generating file...",
      "pdfr_roster_hint": "Class roster PDF",
      "pdfr_grades_hint": "Grades report PDF",
      "pdfr_attendance_hint": "Attendance PDF",
      "pdfr_attendance_none": "No attendance recorded for this class on this day.",

      // ProgressChart

      // BulkMessaging
      "bm_title":                  "Bulk messaging",
      "bm_subtitle":               "Send one message to hundreds of users at once",
      "bm_target_all_parents":     "All parents",
      "bm_target_all_teachers":    "All teachers",
      "bm_target_all_students":    "All students",
      "bm_target_class":           "Specific class",
      "bm_subject":                "Subject",
      "bm_target":                 "Recipients",
      "bm_message":                "Message content",
      "bm_send":                   "Send message",
      "bm_sending":                "Sending...",
      "bm_sent_to":                "Sent to {{count}} users",
      "bm_chars":                  "chars",

      // GlobalSearch
      "gs_quick_search":           "Quick search...",
      "gs_placeholder":            "Search by number, name, ID...",
      "gs_start_typing":           "Type to quickly search the system...",
      "gs_no_results":             "No results match \"{{query}}\"",
      "gs_check_spelling":         "Check the spelling of the name or ID.",
      "gs_students":               "Students",
      "gs_teachers":               "Teachers",
      "gs_parents":                "Parents",
      "gs_schools":                "Schools",
      "gs_class_label":            "Class",

      // StudentAnalyticsChart
      "sac_error_fetch":           "Failed to fetch student analytics data.",
      "sac_no_data":               "No data found",
      "sac_back":                  "Back",
      "sac_class_label":           "Class",
      "sac_continuous_eval":       "Continuous smart evaluation",
      "sac_back_to_list":          "Back to list",
      "sac_grades_analysis":       "Exam & assignment performance",
      "sac_attendance_level":      "Attendance & discipline",
      "sac_grade":                 "Grade",
      "sac_attendance_points":     "Attendance points",
      "sac_not_enough":            "Not enough data yet to plot this student's performance curve.",

      // SystemStatus
      "ssy_fetch_error":           "Failed to fetch system status",
      "ssy_checking":              "Checking system status...",
      "ssy_retry":                 "Retry",
      "ssy_health_label":          "System status",
      "ssy_stable":                "Healthy",
      "ssy_problem":               "Issue detected",
      "ssy_last_update":           "Last update",
      "ssy_db":                    "Database",
      "ssy_db_connected":          "Connected",
      "ssy_db_disconnected":       "Disconnected",
      "ssy_logins_24h":            "Logins (24h)",
      "ssy_logins_success":        "{{count}} successful",
      "ssy_failed_24h":            "Failed attempts (24h)",
      "ssy_logins_failed":         "{{count}} attempts",
      "ssy_locked_24h":            "Locked accounts (24h)",
      "ssy_locked_accounts":       "{{count}} accounts",
      "ssy_totals_title":          "System-wide statistics",
      "ssy_total_schools":         "Total active schools",
      "ssy_total_students":        "Total students",
      "ssy_total_teachers":        "Total teachers",
      "ssy_total_users":           "Total users",

      // EarlyWarningPanel — early-warning system [FEAT-2026-09]
      "nav_early_warning":         "Early warning",
      "ew_title":                  "Early warning",
      "ew_subtitle":               "Students who need follow-up now — highest priority first, with the facts and figures behind each flag.",
      "ew_search":                 "Search a student or class...",
      "ew_error":                  "Could not load the early-warning list. Please try again later.",
      "ew_level_high":             "High priority",
      "ew_level_medium":           "Medium priority",
      "ew_level_low":              "Worth watching",
      "ew_count_high":             "{{n}} high priority",
      "ew_count_medium":           "{{n}} medium priority",
      "ew_empty_title":            "Nobody needs following up",
      "ew_empty_hint":             "No student is showing absence or grade-decline signals for the current academic year. Cases appear here automatically as soon as they are detected.",
      "ew_no_match":               "No results for that search.",
      "ew_unnamed":                "Student",
      "ew_reason_absence_rate":    "{{rate}}% absence rate ({{absent}} of {{total}} recorded days).",
      "ew_reason_absence_streak":  "{{days}} consecutive absences since {{since}}.",
      "ew_reason_failing_average":"Year average {{average}}% — below the {{pass}}% pass mark.",
      "ew_reason_declining":       "Down {{drop}} points: {{before}}% in term {{from}} → {{after}}% in term {{to}}.",
      "ew_reason_unpaid_fees":     "Unpaid fees totalling {{amount}}.",

      // SmartRankings
      "smr_rankings_error":        "Failed to fetch rankings. Please try again later.",
      "smr_honor_roll":            "Honor roll",
      "smr_needs_improvement":     "Needs improvement",
      "smr_good_level":            "Good standing",
      "smr_title":                 "Smart student evaluation and ranking system",
      "smr_subtitle":              "A ranking that combines the gradebook year average and the attendance rate, with the same figures the transcript prints.",
      "smr_students_list":         "Student list",
      "smr_search_student_class":  "Search a student or class...",
      "smr_rank":                  "Rank",
      "smr_student_name":          "Student name",
      "smr_class":                 "Class",
      "smr_category":              "Category",
      "smr_smart_pct":             "Smart score",
      "smr_no_rankings":           "No students available for ranking yet",
      // [PHASE-4 2026-10] Analytics: "How this is calculated"
      "an_how_title": "How this is calculated",
      "an_how_grades": "Grades: the student's year average from the gradebook, the figure the transcript prints (weighted marks, each out of its maximum, a missing mark is not zero), as a percentage of the /{{scale}} scale.",
      "an_how_attendance": "Attendance rate: (present + late) ÷ (present + late + absent). Excused days are not counted; with no counted day there is no rate.",
      "an_how_smart": "Smart score = {{gw}}% grades + {{aw}}% attendance. When one is missing, the other counts alone. Rounded to 2 decimals.",
      "an_how_labels": "Labels follow the school's grade bands: honor roll from {{top}}%, needs improvement below the {{pass}}% pass mark.",
      "an_how_ranks": "Equal scores share a rank (1, 2, 2, 4). Students with no data are listed last, unranked, shown as \"—\".",
      "an_no_data": "No data",
      "smr_col_grades": "Year average",
      "smr_col_attendance": "Attendance",
      "cav_how_class": "A class's figure is the mean of the smart scores of its students who have data; the class is each student's class in that year. A class with no data is unranked.",
      "cav_col_grades": "Grades average",
      "cav_col_attendance": "Attendance rate",
      "cav_scored": "{{n}} with data",
      "ew_how_absence_rate": "Absence rate: absences ÷ counted days (present, late, absent) — {{rate}}% or more adds {{w}} points.",
      "ew_how_streak": "{{n}} or more absences since the last day present adds {{w}} points.",
      "ew_how_failing": "A year average (gradebook) below the {{pass}}% pass mark adds {{w}} points.",
      "ew_how_decline": "The latest term with grades at least {{points}} percentage points below the previous one adds {{w}} points.",
      "ew_how_fees": "Unpaid fees (shown to finance staff only) add {{w}} points.",
      "ew_how_levels": "High risk from {{high}} points, medium from {{medium}}.",
      "gr_how_subject": "A subject's term average is the weighted mean of its marks, each out of its maximum, on the /{{scale}} scale. A missing mark is not zero.",
      "gr_how_overall": "The overall average is the mean of the rounded subject averages; the year is the mean of the terms. Rounded half up to 2 decimals.",
      "gr_how_ranks": "Equal averages share a rank (1, 2, 2, 4); students without grades are unranked and listed last.",

      // Generic joiner
      "term_and":                  "and",

      "month_jan": "January",
      "month_feb": "February",
      "month_mar": "March",
      "month_apr": "April",
      "month_may": "May",
      "month_jun": "June",
      "month_jul": "July",
      "month_aug": "August",
      "month_sep": "September",
      "month_oct": "October",
      "month_nov": "November",
      "month_dec": "December"
    ,
      // [TASK-2 2026-06] Domain-specific translation keys.
      // === Fee types ===
      "fee_type_tuition": "Tuition fees",
      "fee_type_registration": "Registration fees",
      "fee_type_transport": "Transport fees",
      "fee_type_meals": "Meal fees",
      "fee_type_uniform": "Uniform fees",
      "fee_type_books": "Book fees",
      "fee_type_activities": "Activity fees",
      "fee_type_exam": "Exam fees",
      "fee_type_other": "Other fees",
      // === Salary types ===
      "salary_type_monthly": "Monthly salary",
      "salary_type_bonus": "Bonus",
      "salary_type_overtime": "Overtime",
      "salary_type_advance": "Salary advance",
      "salary_type_allowance": "Allowance",
      "salary_type_deduction": "Deduction",
      "salary_type_annual": "Annual bonus",
      // === Payment methods ===
      "payment_cash": "Cash",
      "payment_bank_transfer": "Bank transfer",
      "payment_mobile_money": "Mobile money",
      "payment_check": "Check",
      "payment_card": "Bank card",
      "payment_online": "Online payment",
      // === Expense types ===
      "expense_type_maintenance": "Maintenance",
      "expense_type_electricity": "Electricity",
      "expense_type_water": "Water",
      "expense_type_internet": "Internet",
      "expense_type_supplies": "Office supplies",
      "expense_type_furniture": "Furniture",
      "expense_type_cleaning": "Cleaning",
      "expense_type_security": "Security",
      "expense_type_printing": "Printing",
      "expense_type_events": "Events",
      "expense_type_other": "Other expenses",
      // === Subjects (extra) ===
      "subject_physics": "Physics",
      "subject_chemistry": "Chemistry",
      "subject_biology": "Biology",
      "subject_music": "Music",
      "subject_philosophy": "Philosophy",
      "subject_economics": "Economics",
      "subject_accounting": "Accounting",
      "subject_civic": "Civic Education",
      // === Academic specializations ===
      "spec_science": "Science",
      "spec_literature": "Literature",
      "spec_math": "Mathematics",
      "spec_technical": "Technical",
      "spec_economics": "Economics & Management",
      "spec_islamic": "Islamic Studies",
      "spec_languages": "Foreign Languages",
      // === Education levels ===
      "edu_primary": "Primary",
      "edu_middle": "Middle School",
      "edu_high": "High School",
      "edu_university": "University",
      "edu_kindergarten": "Kindergarten",
      // === Assessment types ===
      "assess_type_exam": "Exam",
      "assess_type_quiz": "Quiz",
      "assess_type_homework": "Homework",
      "assess_type_project": "Project",
      "assess_type_oral": "Oral",
      "assess_type_practical": "Practical",
      "assess_type_participation": "Participation",
      "assess_type_midterm": "Midterm",
      "assess_type_final": "Final",
      // === Terms / semesters ===
      "term_first": "First Term",
      "term_second": "Second Term",
      "term_third": "Third Term",
      "term_annual": "Annual",
      // === Gender ===
      "gender_male": "Male",
      "gender_female": "Female",
      // === Blood types ===
      "blood_a_pos": "A+",
      "blood_a_neg": "A-",
      "blood_b_pos": "B+",
      "blood_b_neg": "B-",
      "blood_ab_pos": "AB+",
      "blood_ab_neg": "AB-",
      "blood_o_pos": "O+",
      "blood_o_neg": "O-",
      // === Notification types ===
      "notif_type_grade": "New grade",
      "notif_type_absence": "Absence",
      "notif_type_payment": "Payment",
      "notif_type_announcement": "Announcement",
      "notif_type_homework": "New homework",
      "notif_type_task": "New task",
      "notif_type_system": "System notification",
      // === Common UI buttons / labels / messages ===
      "btn_view_all": "View all",
      "btn_load_more": "Load more",
      "btn_go_back": "Go back",
      "btn_next": "Next",
      "btn_previous": "Previous",
      "btn_finish": "Finish",
      "btn_skip": "Skip",
      "btn_retry": "Retry",
      "msg_connection_error": "Connection error",
      "msg_try_again": "Please try again",
      "msg_changes_saved": "Changes saved",
      "msg_are_you_sure": "Are you sure?",
      "msg_cannot_undo": "This action cannot be undone",
      "lbl_optional": "Optional",
      "lbl_required": "Required",
      "lbl_all": "All",
      "lbl_none": "None",
      "lbl_other": "Other",
      "lbl_unknown": "Unknown",
      "lbl_not_available": "Not available",
      "lbl_yes": "Yes",
      "lbl_no": "No",
      // Shared labels, alt texts and shadcn/ui screen-reader text [I18N 2026-10]
      "lbl_na": "N/A",
      "list_separator": ", ",
      "alt_profile_photo": "Profile photo",
      "alt_student_qr": "Student QR code",
      "alt_school_logo": "School logo",
      "idc_no_id": "— no id —",
      "ui_breadcrumb": "Breadcrumb",
      "ui_more": "More",
      "ui_previous_slide": "Previous slide",
      "ui_next_slide": "Next slide",
      "ui_pagination": "Pagination",
      "ui_previous_page": "Go to previous page",
      "ui_next_page": "Go to next page",
      "ui_previous": "Previous",
      "ui_next": "Next",
      "ui_more_pages": "More pages",
    
      // [WIRE-2026-06] Backend-catalog mappings for finance dropdowns.
      // === Fee types — backend catalog (constants.FEE_TYPES) ===
      "fee_type_tuition_term1": "Tuition fees - Term 1",
      "fee_type_tuition_term2": "Tuition fees - Term 2",
      "fee_type_tuition_term3": "Tuition fees - Term 3",
      "fee_type_labs": "Lab fees",
      "fee_type_exam_retake": "Exam retake fees",
      "fee_type_certificates": "Certificate fees",
      "fee_type_late_fee": "Late fee",
      // === Salary types — backend catalog (constants.SALARY_TYPES) ===
      "salary_type_teacher": "Teacher salary",
      "salary_type_admin": "Admin salary",
      "salary_type_cleaner": "Cleaner salary",
      "salary_type_guard": "Guard salary",
      "salary_type_driver": "Driver salary",
      "salary_type_supervisor": "Supervisor salary",
      "salary_type_librarian": "Librarian salary",
      "salary_type_counselor": "Counselor salary",
      "salary_type_accountant": "Accountant salary",
      "salary_type_secretary": "Secretary salary",
      // === Expense types — backend catalog (constants.EXPENSE_TYPES) ===
      "expense_type_salaries": "Salaries",
      "expense_type_maintenance_building": "Building maintenance",
      "expense_type_maintenance_equipment": "Equipment maintenance",
      "expense_type_communications": "Internet & communications",
      "expense_type_school_equipment": "School equipment",
      "expense_type_teaching_materials": "Teaching materials",
      "expense_type_books": "Books & references",
      "expense_type_fuel_transport": "Fuel & transport",
      "expense_type_health_insurance": "Health insurance",
      "expense_type_training": "Training & conferences",
      "expense_type_advertising": "Advertising & marketing",
      // === Payment methods — backend catalog (constants.PAYMENT_METHODS) ===
      "payment_installment": "Installments",
      "payment_salary_deduction": "Salary deduction",
      // === [PHASE-5 2026-10] Student PIN login (WP-B) ===
      "pin_card_doc_title": "Student login cards",
      "pin_card_title": "Login card",
      "pin_card_school_code": "School code",
      "pin_card_student_number": "Student no.",
      "pin_card_pin": "PIN",
      "pin_card_keep_secret": "Keep this card; never show your PIN to anyone",
      "pin_login_mode_password": "Username and password",
      "pin_login_mode_pin": "Student number and PIN",
      "pin_login_help": "Primary and middle school pupils: use the card your school gave you.",
      "pin_login_school_code": "School code",
      "pin_login_school_code_hint": "It is printed on your card and remembered on this device.",
      "pin_login_change_school": "Change school",
      "pin_login_student_number": "Student number",
      "pin_login_pin": "PIN (4 digits)",
      "pin_login_show_pin": "Show PIN",
      "pin_login_hide_pin": "Hide PIN",
      "pin_login_submit": "Sign in",
      "pin_login_err_school_code": "Enter the school code (digits only).",
      "pin_login_err_student_number": "Enter your student number (digits only).",
      "pin_login_err_pin": "The PIN has 4 digits.",
      "pin_login_invalid": "Incorrect details. Check the school code, your student number and your PIN.",
      "pin_login_locked": "Too many wrong attempts. Try again in {{minutes}} min, or ask the school office to unlock the account.",
      "pin_login_too_many": "Too many attempts. Wait a moment, then try again.",
      "nav_student_pins": "Student PINs",
      "pin_mgr_title": "Student login PINs",
      "pin_mgr_subtitle": "Primary and middle school pupils sign in with the school code, their student number and a 4-digit PIN. A PIN is shown only once, when it is created, so print the cards straight away.",
      "pin_mgr_school_code": "School code: {{code}}",
      "pin_mgr_class": "Class",
      "pin_mgr_all_classes": "All classes",
      "pin_mgr_generate": "Create missing PINs",
      "pin_mgr_regenerate_all": "Renew every PIN in the class",
      "pin_mgr_regenerate_confirm": "Every PIN in this class will be replaced and those pupils signed out. Continue?",
      "pin_mgr_pick_class": "Choose a class first.",
      "pin_mgr_col_student": "Student",
      "pin_mgr_col_number": "Number",
      "pin_mgr_col_class": "Class",
      "pin_mgr_col_status": "Status",
      "pin_mgr_col_actions": "Actions",
      "pin_mgr_status_set": "PIN set",
      "pin_mgr_status_none": "No PIN",
      "pin_mgr_status_locked": "Locked until {{time}}",
      "pin_mgr_status_not_enabled": "Password (grade not using PINs)",
      "pin_mgr_reset": "New PIN",
      "pin_mgr_reset_confirm": "Create a new PIN for {{name}}? The old one stops working and their sessions end.",
      "pin_mgr_unlock": "Unlock",
      "pin_mgr_unlocked": "Unlocked.",
      "pin_mgr_generated": "{{count}} PIN(s) created.",
      "pin_mgr_nothing_generated": "No PIN created: every pupil already has one, or their grade does not use PINs.",
      "pin_mgr_skipped": "{{count}} pupil(s) skipped.",
      "pin_mgr_reason_has_pin": "already has a PIN",
      "pin_mgr_reason_grade_not_enabled": "grade without PINs",
      "pin_mgr_reason_no_account": "no active account",
      "pin_mgr_reason_inactive": "inactive",
      "pin_mgr_new_pins_title": "New PINs — shown only once",
      "pin_mgr_new_pins_hint": "Print the cards now. Once you leave this page these PINs cannot be shown again; new ones would have to be created.",
      "pin_mgr_print": "Print the cards",
      "pin_mgr_dismiss": "Hide the PINs",
      "pin_mgr_popup_blocked": "The browser blocked the print window. Allow pop-ups, then try again.",
      "pin_mgr_empty": "No pupils.",
      "pin_mgr_more": "Show more",
      "pin_mgr_count": "{{shown}} of {{total}}",
      "pin_settings_title": "Student number and PIN login",
      "pin_settings_hint": "Choose the grades whose pupils sign in with a PIN (usually primary and middle school). Other pupils keep their username and password. This setting is saved on its own, with the button below.",
      "pin_settings_default_note": "Using the default: primary and middle school.",
      "pin_settings_none_note": "No grade selected: PIN login is off.",
      "pin_settings_add_placeholder": "Another grade, as written in class names",
      "pin_settings_add": "Add",
      "pin_settings_save": "Save PIN grades",
      "pin_settings_saved": "PIN grades saved.",
      "pin_settings_use_default": "Back to the default",
      // ─── [PHASE-2 2026-10] Grade grid, grading settings, transcripts, verification ───
      "gb_add": "Add",
      "gb_add_column": "Add assessment",
      "gb_change_count": "{{n}} unsaved change(s)",
      "gb_column_name": "Assessment name",
      "gb_discard": "Discard changes",
      "gb_discard_confirm": "Some grades are not saved. Discard them?",
      "gb_err_above_max": "Score is above the maximum",
      "gb_err_bad_max": "Invalid maximum",
      "gb_err_bad_weight": "Invalid weight",
      "gb_err_decimals": "At most two decimals",
      "gb_err_duplicate_column": "An assessment with this name and type already exists",
      "gb_err_name_required": "Enter the assessment name",
      "gb_err_not_a_number": "Not a valid score",
      "gb_err_not_in_class": "The student is not in this class",
      "gb_error_count": "{{n}} cell(s) with errors",
      "gb_fix_errors_first": "Fix the red cells before saving",
      "gb_keyboard_hint": "Enter moves down the column, Tab to the next assessment, Ctrl+S saves. You can paste a column or a table from Excel. An empty cell means no grade, not zero.",
      "gb_load_failed": "Could not load the grades",
      "gb_locked_archived": "Archived year: grades are read-only.",
      "gb_locked_results": "Results are locked by the school: grades cannot be changed.",
      "gb_max_score": "Maximum score",
      "gb_mixed_max": "This column mixes several maximums",
      "gb_no_students": "No students in this class for this year.",
      "gb_out_of": "out of",
      "gb_paste_clipped": "The paste ran past the grid: {{n}} cell(s) ignored",
      "gb_pick_class_subject": "Choose the class and the subject.",
      "gb_save_failed": "The grades were not saved",
      "gb_saved": "Grades saved ({{n}})",
      "gb_saving": "Saving...",
      "gb_student_left": "Left",
      "gb_term_average": "Term average",
      "gb_unsaved": "Unsaved changes",
      "gb_weight": "Weight",
      "gr_term": "Period",
      "gs_band_add": "Add a band",
      "gs_band_bad_min": "The minimum must be between 0 and 100",
      "gs_band_duplicate": "Duplicate minimum",
      "gs_band_label_required": "Enter the Arabic label",
      "gs_band_min": "Minimum percentage",
      "gs_band_need_zero": "One band must start at 0%",
      "gs_band_remove": "Remove band",
      "gs_bands": "Grade bands",
      "gs_bands_hint": "Each band starts at a percentage, applied to the rounded average; the equivalent on /{{scale}} is shown beside it.",
      "gs_certificate_grades": "Classes that receive a certificate",
      "gs_certificate_hint": "Usually the end of each stage. Certificates are offered for these classes only.",
      "gs_from": "From",
      "gs_intro": "Applies to the grade grid, rankings, transcripts and certificates.",
      "gs_rules_title": "How averages are calculated",
      "gs_rules_1": "An empty cell is not a zero: it is left out. A subject with no grades does not count, and an average with no data shows \"—\".",
      "gs_rules_2": "Each grade counts as a fraction of its maximum (15/20 equals 7.5/10), with its weight, then is shown on the school's scale.",
      "gs_rules_3": "A term's overall average is the mean of the rounded subject averages, so anyone can recompute it from the printed lines.",
      "gs_rules_4": "A subject's year average is the mean of its term averages that exist; the year's overall average is computed from the subjects' year averages.",
      "gs_rules_5": "Rounded to 2 decimals, half up (12.345 becomes 12.35); the band is read on the rounded value.",
      "gs_rules_6": "Students with equal averages share a rank (1, 2, 2, 4); a student with no average is not ranked.",
      "gs_label_ar": "Arabic",
      "gs_label_en": "English",
      "gs_label_fr": "French",
      "gs_principal": "Principal's name",
      "gs_principal_hint": "Printed under the signature on transcripts and certificates.",
      "gs_save": "Save grading settings",
      "gs_save_failed": "Grading settings were not saved",
      "gs_saved": "Grading settings saved",
      "gs_scale": "Grading scale",
      "gs_terms": "Terms per year",
      "gs_terms_2": "2 terms",
      "gs_terms_3": "3 terms",
      "gs_title": "Grades & documents",
      "ss_section_grades": "Grades & documents",
      "tr_archived_year": "{{year}} is archived: its transcripts can be issued and printed, its grades can no longer change.",
      "tr_certificate_class": "Certificate class",
      "tr_doc_certificate": "Certificate",
      "tr_doc_transcript": "Transcript",
      "tr_doc_type": "Document type",
      "tr_failed": "Could not prepare the document",
      "tr_intro": "Every issued document carries a verification code. Reprinting an unchanged document keeps its code; if the grades changed, a new code is issued and the old one becomes \"superseded\".",
      "tr_issue_print": "Issue and print ({{n}})",
      "tr_issued": "New: {{created}} · unchanged: {{reused}} · superseded: {{superseded}}",
      "tr_load_failed": "Could not load the classes",
      "tr_no_classes": "No classes with students for this year.",
      "tr_popup_blocked": "The browser blocked the print window; allow pop-ups for this site.",
      "tr_preview": "Preview",
      "tr_select_all": "All ({{n}} of {{total}})",
      "tr_term_year": "Whole year",
      "tr_title": "Transcripts & certificates",
      "tr_print_appreciation": "Grade",
      "tr_print_average": "Average",
      "tr_print_birth": "Date of birth",
      "tr_print_cert_text": "The administration of {{school}} certifies that {{name}}, born on {{birth}}, completed {{className}} during the {{year}} school year with an overall average of {{average}} out of {{scale}}, grade:",
      "tr_print_certificate": "Certificate",
      "tr_print_class": "Class",
      "tr_print_draft": "Preview — not an issued document, no verification code",
      "tr_print_issued_on": "Issued on",
      "tr_print_number": "Student no.",
      "tr_print_overall": "Overall average",
      "tr_print_partial": "Note: some subjects or terms have no grades; the average covers the available grades only.",
      "tr_print_principal": "Principal",
      "tr_print_stamp": "Signature and stamp",
      "tr_print_student": "Student",
      "tr_print_subject": "Subject",
      "tr_print_transcript": "Transcript",
      "tr_print_verify": "To verify this document, scan the code or open the link:",
      "tr_print_year": "School year",
      "vd_check": "Check",
      "vd_code_label": "Verification code",
      "vd_code_placeholder": "Code printed on the document",
      "vd_compare_hint": "Compare these details with the document in your hand. Grades are not shown here.",
      "vd_failed": "Could not check right now. Try again in a minute.",
      "vd_genuine": "Genuine document",
      "vd_not_found": "Unknown code",
      "vd_not_found_hint": "No document was issued with this code. Check it is typed exactly as printed.",
      "vd_school": "School",
      "vd_student": "Student",
      "vd_subtitle": "Check a transcript or certificate issued by a school using EduGate.",
      "vd_superseded": "Superseded document",
      "vd_superseded_hint": "The school issued a newer version of this document; this one is no longer valid. Ask the school for the current version.",
      "vd_title": "Verify a document",
      "vd_year": "School year",
      "tt_print_class_kicker": "Class timetable",
      "tt_print_teacher_kicker": "Teacher timetable",
      "tt_print_class_title": "Timetable {{cls}}",
      "tt_print_teacher_title": "Timetable of {{name}}",
      "tt_print_school_title": "School timetables",
      "tt_print_year": "School year {{year}}",
      "tt_lesson_col": "Lesson",
      "tt_lesson_n": "Lesson {{n}}",
      "tt_break_default": "Break",
      "tt_room": "Room {{room}}",
      "tt_weekly_total": "{{count}} lessons a week",
      "tt_teacher_load": "Teaching load: {{count}} lessons a week",
      "tt_other_times": "Lessons outside the bell schedule:",
      "tt_printed_on": "Printed on {{date}}",
      "tt_print_class": "Print this class",
      "tt_print_school": "Print the whole school",
      "tt_print_teacher": "Print a teacher",
      "tt_pick_teacher": "Choose a teacher",
      "tt_print_mine": "Print my timetable",
      "tt_popup_blocked": "The browser blocked the print window. Allow pop-ups for this site, then try again.",
      "tt_nothing_to_print": "There is no timetable to print yet.",
      "ss_break_title": "Breaks",
      "ss_break_hint": "Recess, lunch… A break has no number: adding or moving one never changes the lesson numbers or the saved timetables.",
      "ss_break_name": "Name",
      "ss_break_name_placeholder": "Recess",
      "ss_break_start": "Break start",
      "ss_break_end": "Break end",
      "ss_break_remove": "Remove break",
      "ss_break_add": "Add a break",
      "ss_break_none": "No breaks.",
      "ss_break_max": "At most {{max}} breaks.",
      "ss_break_err_invalid": "Invalid times: the end must come after the start.",
      "ss_break_err_lesson": "Overlaps lesson {{n}}.",
      "ss_break_err_break": "Overlaps another break.",
      "ss_break_preview": "The school day",
      "ss_bell_err_BELL_INVALID": "Each lesson needs a valid start and end time, ending after it starts.",
      "ss_bell_err_BELL_OVERLAP": "Two lessons overlap.",
      "ss_bell_err_BELL_ORDER_MISMATCH": "Each lesson must start after the one before it. Change the times rather than the order of lessons.",
      "ss_bell_only_last_removable": "Only the last lesson can be removed: removing one in the middle renumbers the ones after it. Change its times instead.",
      "ss_bell_blocked": "Fix the lesson times or the breaks before saving.",
      "sb_conflict_unknown_period": "This lesson is not in the school's bell schedule.",
      "sb_conflict_unknown_teacher": "This teacher does not belong to the school.",
      "sb_conflict_duplicate_cell": "The class has two lessons in this slot.",
      "sb_conflict_teacher_busy": "The teacher is already in {{cls}} at this time.",
      "sb_conflict_room_busy": "The room is already used by {{cls}}.",
      "sb_conflict_on_break": "This slot is a break, not a lesson.",
      "sb_conflict_bad_time": "The lesson time is invalid.",
      "sb_break_row": "Break: no lesson can go here",
      "rm_cat_school_events": "Participation in school events and programmes (voluntary)",
      "rm_cat_school_events_hint": "Voluntary criterion: counted only when rated; not having it never lowers the average.",
      "rm_cat_legacy": "(old category)",
      "rm_voluntary": "Voluntary",
      "rm_subtitle_scale": "Performance follow-up and continuous improvement (1 to {{scale}})",
      "rm_rating_label_scale": "Rating (1-{{scale}})",
      "rm_pick_required": "Choose the person and the category first",
      "rm_overall_avg_sub": "Evaluations by the school this year",
      "rm_history_error": "Could not load the rating history",
      "rm_role_school_admin": "School administrator",
      "rm_role_admin_staff": "Administrative staff",
      "rm_role_teacher": "Teacher",
      "pf_rt_by_category": "Evaluation by category",
      "pf_rt_count": "Ratings: {{count}}",
      "pf_rt_latest": "Latest: {{value}} · {{date}}",
      "pf_rt_none": "No evaluation this year",
      "rpt_te_title": "Teacher evaluations",
      "rpt_te_subtitle": "Evaluations by the school for {{year}}, out of {{scale}}",
      "rpt_te_teacher": "Teacher",
      "rpt_te_overall": "Overall",
      "rpt_te_other": "Old categories",
      "rpt_te_unnamed": "Teacher no longer on file",
      "rpt_te_empty": "No teachers to show",
      "rpt_te_count": "Ratings: {{count}}",
      "rpt_te_load_error": "Could not load the teacher evaluations",
      "rpt_te_method_scale": "Each rating is read on its own scale and expressed out of {{scale}} (older ratings without a scale are read out of {{legacy}}).",
      "rpt_te_method_raters": "Only evaluations by the school's administration count; a teacher's rating of a colleague is not one.",
      "rpt_te_method_overall": "Overall = the mean of the (rounded) averages of the categories the teacher HAS. A category with no rating shows \"—\" and never counts as zero.",
      "rpt_te_method_voluntary": "Participation in school events is voluntary: it counts only where rated, and not having it never lowers the overall.",
      "rpt_te_method_rounding": "Rounded to 2 decimal places, half up.",
    }
  }
};

// [I18N 2026-10] Every user-visible string now goes through this catalogue —
// the inline `isRTL ? 'عربي' : 'English'` ternaries (no French branch at all)
// are gone. Two tests keep it that way: __tests__/noHardcodedStrings.test.js
// (no literal UI text in JSX, toasts or language ternaries) and
// __tests__/i18nParity.test.js (ar/fr/en carry the same keys, and every
// t('key') in the code exists in all three). Add new keys to all three.

// Map language code → <html dir>. Arabic is RTL; everything else is LTR.
const RTL_LANGS = new Set(['ar']);
export const SUPPORTED_LANGUAGES = ['ar', 'fr', 'en'];

const applyDocumentDirection = (lng) => {
  if (typeof document === 'undefined') return;
  const dir = RTL_LANGS.has(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
};

// [UI-PREFS 2026-10-31] The language is decided ONCE, by the inline
// #edugate-boot script in public/index.html, before the first paint; i18next
// starts from that answer. There is no detector here: a second one would
// disagree with the first paint, and the old browser-detector plugin also
// wrote its own pick to localStorage on every first visit, so nobody could
// tell a choice from an accident. An explicit choice goes through
// lib/preferences.setLanguage. Without the boot answer (it always runs in the
// page), keep whatever <html lang> already says.
const bootLanguage = () => {
  if (typeof window === 'undefined') return 'fr';
  const boot = window.__EDUGATE_BOOT__;
  if (boot && SUPPORTED_LANGUAGES.includes(boot.lang)) return boot.lang;
  const tag = typeof document !== 'undefined' ? document.documentElement.lang : '';
  return SUPPORTED_LANGUAGES.includes(tag) ? tag : 'fr';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: bootLanguage(),
    // [L-8] A key missing in the current language falls back to English.
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
  });

applyDocumentDirection(i18n.language);
// …and again every time the language changes from anywhere in the app.
i18n.on('languageChanged', applyDocumentDirection);

export default i18n;
